import { __rest, __assign, __spreadArray, __awaiter, __generator } from 'tslib';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { faCancel, faEdit, faPlus, faFileExport, faArrowRight, faCircle, faArrowPointer, faFileCode, faUser, faSackDollar, faBadgeCheck, faInfoCircle, faTrashCan, faAdd, faCheck, faArrowUpFromBracket, faEllipsisVertical, faWindowRestore, faClipboardCheck, faChartArea, faGraduationCap, faCarSide, faPiggyBank, faUmbrella, faCreditCard, faTags, faCircleNotch, faPipe, faFilter, faSearch as faSearch$1, faCaretUp, faCaretDown, faCopy as faCopy$1, faChevronUp, faChevronDown, faLandmark, faHouse, faCoins, faDownload, faChartPie, faEngine, faLock, faScrewdriverWrench, faHome, faSquareUser, faUserAlt, faList, faChartLine, faComputerMouse, faFilterCircleDollar, faLockKeyhole, faPaste, faClone as faClone$1, faRotate, faTrash as faTrash$1, faRocket, faSeedling, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Intent, Button, AnchorButton, Spinner as Spinner$1, Classes, MenuItem as MenuItem$1, Menu, TextArea, Dialog, NonIdealState, Tabs, Tab, Card, Elevation, Checkbox, NumericInput, Switch, DrawerSize, SpinnerSize, Drawer, Callout, Toaster as Toaster$1, Position, RangeSlider, Tag, Collapse, RadioGroup, Radio, H4, H5, H6, H2, Navbar, Alignment, Popover, H3, MultistepDialog, DialogStep, ButtonGroup } from '@blueprintjs/core';
import classNames from 'classnames';
import { Tooltip2, MenuItem2, Popover2, Popover2InteractionKind } from '@blueprintjs/popover2';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useGetSubAccountsQuery, useSampleDemandContractFinancials, createDemandContract, deleteDemandContract, useGetSubAccountsByIdQuery, queries, createOfferCatalogProduct, updateCurrentProduct, updateCommunication, useGetDemandContractsQuery, createBulkDemandSubAccountInventoryCap, updateDemandSubAccountInventoryCap, deleteBulkDemandSubAccountInventoryCap, createBulkSupplyDemandSubAccountInventoryCap, updateSupplyDemandSubAccountInventoryCap, deleteBulkSupplyDemandSubAccountInventoryCap, useGetOffersCatalogOffers, useGetFinanceAccountsQuery, createOfferCatalogProductOffer, updateProduct, createOfferRule, updateOfferRule, deleteOfferRule, updateOffer } from '@portal/api-client';
import { DateTime } from 'luxon';
import * as React from 'react';
import React__default, { useState, useMemo, useEffect, useRef, useCallback, Fragment as Fragment$1, forwardRef, useImperativeHandle, useContext, createElement, memo, createContext } from 'react';
import { useFieldArray, useForm, Controller, useController, useFormContext, useWatch, FormProvider } from 'react-hook-form';
import { DateInput, DateRangePicker, DateRangeInput } from '@blueprintjs/datetime';
import { createSerializedItemPredicate, toDate, formatDate as formatDate$1, supplyTemplateProductTypeToProductTypeMap, serialize as serialize$1, RevenueClauseType, getRevenueClauseTypeDisplayText, isNullDateTuple, moneyFormatter, percentFormatter, DELETE_CONTRACT_CONFIRMATION_MESSAGE, formatDateTimeShort, UserField, DemandMVPOfferManagementRoute, InternalRoutes, formatPercentWithPrecision, PayoutClauseType, nonLegacyPayoutClauses, payoutClauseProductTypeSorter, payoutClauseToProductTypeMap, getActiveDemandContract, filterInventoryCapsByStatus } from '@portal/common';
import { MultiSelect as MultiSelect$1, Select as Select$1, Suggest as Suggest$1, Suggest2 } from '@blueprintjs/select';
import _, { keyBy, startCase, isEqual, isNumber, isString, sortBy, isObject, upperFirst, lowerCase, toNumber, cloneDeep, uniqBy, truncate, difference, isEmpty, camelCase, orderBy as orderBy$1, uniq, omitBy, omit, isNil, has } from 'lodash';
import { faAngleDown, faSquareDashed, faUpRightFromSquare, faClone, faPenToSquare, faTrash, faCircleCheck, faCircleX, faCopy, faSearch, faAngleLeft, faEnvelope, faFlag, faBook, faEnvelopeOpenDollar, faLightbulb, faCircleQuestion, faBell, faBan, faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import kebabCase from 'lodash/kebabCase';
import { createSerializedItemPredicate as createSerializedItemPredicate$1, sortByName, createMemoizedSerialize, serialize } from '@portal/common/dist/utils';
import { useList, useDebounce, usePrevious as usePrevious$1, useUpdateEffect, useToggle, useSet } from 'react-use';
import Menu$1 from 'antd/lib/menu';
import { useRouter } from 'next/router';
import { SupplyTemplateProductType, InclusionReason, ProductType, SupplyTemplateApplicationStrategy, CompetitionType, EmploymentStatus, EmploymentPayFrequency, LoanPurpose, ProvidedCreditRating, AccountTierType } from '@evenfinancial/originator-client';
import { faCircleExclamation, faFileTimes, faCircle as faCircle$1 } from '@fortawesome/pro-thin-svg-icons';
import { DemandPlatformFeeConfigType, DemandPlatformFeeConfigPercentOf, DataShareType, CreditBucket, PropertyItemType, PropertyFormatType, ProductPropertyType, OperationType, Experience, UsStatesEnum, MilitaryStatus, stateNameToAbbreviation, PartnerType, Roles } from '@portal/api-models';
import { SubAccountType, SupplySubAccountIntegrationType, ProductType as ProductType$1, AdjustmentReason, AccountTierType as AccountTierType$1 } from '@evenfinancial/finance-client';
import CopyToClipboard from 'react-copy-to-clipboard';
import numeral from 'numeral';
import { Avatar, Timeline, message, Menu as Menu$2, Empty } from 'antd';
import { AgGridReact } from 'ag-grid-react';
import { produce, enableMapSet } from 'immer';
import { createAction, createReducer } from 'typesafe-actions';
import 'ag-grid-enterprise';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import { CapType } from '@evenfinancial/inventory-client';
import { isDateString, isUUID, isURL } from 'class-validator';
import orderBy from 'lodash/orderBy';
import isEqual$1 from 'lodash/isEqual';
import startCase$1 from 'lodash/startCase';
import { ProductSubType, ProductType as ProductType$2 } from '@evenfinancial/lead-client';
import { internalRoleObjectArray, supplyRoleObjectArray, SupplyFlatRolesForMulti, demandRoleObjectArray, DemandFlatRolesForMulti, isInternalUserType, UserRolesWithAllAccountAccess } from '@portal/common/dist/access-control';
import { faArrowRightFromLine, faArrowLeftToLine } from '@fortawesome/pro-light-svg-icons';
import camelCase$1 from 'lodash/camelCase';
import { getUserFullName } from '@portal/store/dist/user/util';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { object, string, mixed, date, array, boolean } from 'yup';
import { CreditScoreOptions } from '@evenfinancial/even-ts-static';
import Papa from 'papaparse';
import moment from 'moment';
import { UserField as UserField$1 } from '@portal/common/dist/users';
import { moneyFormatter as moneyFormatter$1, formatPercentWithPrecision as formatPercentWithPrecision$1, formatWithPadding } from '@portal/common/dist/utils/string-formatters';
import { serialize as serialize$2 } from '@portal/common/dist/utils/serialize';

var EvenButton = function (_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, outlined = _a.outlined, cln = _a.className, loading = _a.loading, children = _a.children, _c = _a.intent, intent = _c === void 0 ? Intent.PRIMARY : _c, _d = _a.tertiary, tertiary = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, props = __rest(_a, ["onClick", "outlined", "className", "loading", "children", "intent", "tertiary", "disabled"]);
    var className = classNames(cln, tertiary && 'tertiary');
    return (jsx(Button, __assign({ className: className, disabled: disabled, intent: intent, loading: loading, outlined: outlined, onClick: onClick }, props, { children: children })));
};

var CancelButton = function (_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, loading = _a.loading;
    return (jsx(EvenButton, __assign({ outlined: true, icon: jsx(FontAwesomeIcon, { icon: faCancel, size: "xs" }), loading: loading, onClick: onClick }, { children: "Cancel" })));
};

var ClearAllButton = function (props) {
    var gridRef = props.gridRef, buttonProps = __rest(props, ["gridRef"]);
    var handleClearAllFilters = function () {
        var _a, _b;
        (_a = gridRef === null || gridRef === void 0 ? void 0 : gridRef.current) === null || _a === void 0 ? void 0 : _a.api.setFilterModel(null);
        (_b = gridRef === null || gridRef === void 0 ? void 0 : gridRef.current) === null || _b === void 0 ? void 0 : _b.columnApi.applyColumnState({
            defaultState: { sort: null },
        });
    };
    return (jsx(EvenButton, __assign({ outlined: true, intent: Intent.PRIMARY, onClick: handleClearAllFilters }, buttonProps, { children: "Clear All Filters" })));
};

var EditButton = function (_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, loading = _a.loading, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.children, children = _d === void 0 ? 'Edit' : _d;
    return (jsx(EvenButton, __assign({ outlined: true, disabled: disabled, icon: jsx(FontAwesomeIcon, { icon: faEdit, size: "xs" }), loading: loading, onClick: onClick }, { children: children })));
};

var EvenAnchorButton = function (_a) {
    var loading = _a.loading, outlined = _a.outlined, children = _a.children, _b = _a.intent, intent = _b === void 0 ? 'primary' : _b, props = __rest(_a, ["loading", "outlined", "children", "intent"]);
    return (jsx(AnchorButton, __assign({}, props, { intent: intent, loading: loading, outlined: outlined }, { children: children })));
};

var EvenCreateNewButton = function (_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, children = _a.children, rest = __rest(_a, ["onClick", "children"]);
    return (jsx(EvenButton, __assign({ icon: jsx(FontAwesomeIcon, { icon: faPlus, size: "xs" }), intent: Intent.SUCCESS, onClick: onClick }, rest, { children: children !== null && children !== void 0 ? children : 'Create New' })));
};

var ExportButton = function (_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, loading = _a.loading;
    return (jsx(EvenButton, __assign({ outlined: true, icon: jsx(FontAwesomeIcon, { icon: faFileExport, size: "xs" }), loading: loading, onClick: onClick }, { children: "Export" })));
};

var ExportCSVButton = function (props) {
    var gridRef = props.gridRef, csvExportParams = props.csvExportParams;
    var getDataAsCSV = function () {
        var _a, _b;
        (_b = (_a = gridRef === null || gridRef === void 0 ? void 0 : gridRef.current) === null || _a === void 0 ? void 0 : _a.api) === null || _b === void 0 ? void 0 : _b.exportDataAsCsv(csvExportParams);
    };
    return (jsxs(EvenButton, __assign({ outlined: true, intent: Intent.PRIMARY, onClick: getDataAsCSV }, { children: [jsx(FontAwesomeIcon, { icon: faFileExport }), " Export"] })));
};

var ViewMoreButton = function (_a) {
    var _b = _a.children, children = _b === void 0 ? 'View More' : _b, rest = __rest(_a, ["children"]);
    return (jsx(EvenButton, __assign({ outlined: true, rightIcon: jsx(FontAwesomeIcon, { icon: faArrowRight, size: "xs" }) }, rest, { children: children })));
};

var styles$k = {"dots":"Dots-module_dots__jSs7x","dots-dot":"Dots-module_dots-dot__Js7dj","dots-dot-active":"Dots-module_dots-dot-active__2srn7"};

var Dots = function (_a) {
    var activeIndex = _a.activeIndex, className = _a.className, size = _a.size;
    var dots = new Array(size).fill(0).map(function (_, i) {
        var _a;
        return (jsx(FontAwesomeIcon, { className: classNames(styles$k['dots-dot'], (_a = {},
                _a[styles$k['dots-dot-active']] = i === activeIndex,
                _a)), fontSize: 8, icon: faCircle }, i));
    });
    return jsx("nav", __assign({ className: classNames(styles$k.dots, className) }, { children: dots }));
};

var FontAwesomeKitIcon = function (_a) {
    var _b;
    var icon = _a.icon, color = _a.color, _c = _a.size, size = _c === void 0 ? 'lg' : _c, inverse = _a.inverse, fixedWidth = _a.fixedWidth, className = _a.className, style = _a.style, pull = _a.pull;
    return (jsx("i", { className: classNames('fak', (_b = {},
            _b["fa-".concat(icon)] = icon,
            _b["fa-".concat(size)] = size,
            _b["fa-pull-".concat(pull)] = pull,
            _b['fa-fw'] = fixedWidth,
            _b['fa-inverse'] = inverse,
            _b), className), color: color, style: style }));
};

var IconNames;
(function (IconNames) {
    IconNames["Accout"] = "file-invoice";
    IconNames["AddressBook"] = "address-book";
    IconNames["AddressCard"] = "address-card";
    IconNames["AnalyticsInsights"] = "chart-pie";
    IconNames["ApiDocumentation"] = "plug";
    IconNames["Channels"] = "home";
    IconNames["Circle"] = "circle";
    IconNames["ContactUs"] = "phone-alt";
    IconNames["Contracts"] = "file-contract";
    IconNames["CreditCards"] = "credit-card";
    IconNames["CustomOffers"] = "tags";
    IconNames["Dashboard"] = "tachometer-alt";
    IconNames["FeedbackBugs"] = "lightbulb";
    IconNames["FinancialServices"] = "file-invoice-dollar";
    IconNames["Forum"] = "comments";
    IconNames["Home"] = "home";
    IconNames["IntegrationEmbed"] = "cube";
    IconNames["IntegrationNative"] = "code";
    IconNames["IntegrationPartnerPage"] = "display-code";
    IconNames["Integrations"] = "object-group";
    IconNames["Invoices"] = "receipt";
    IconNames["KnowlegdeBase"] = "book-open";
    IconNames["Leads"] = "users";
    IconNames["LifeInsurance"] = "umbrella";
    IconNames["Lock"] = "lock";
    IconNames["Mortgage"] = "house-user";
    IconNames["Network"] = "globe";
    IconNames["PerformanceSummary"] = "chart-line";
    IconNames["PersonalLoans"] = "hand-holding-usd";
    IconNames["PlanGrowth"] = "seedling";
    IconNames["PlanStarter"] = "rocket";
    IconNames["Savings"] = "piggy-bank";
    IconNames["Spiner"] = "spinner";
    IconNames["StudentLoanRefi"] = "graduation-cap";
    IconNames["TutorialsGuides"] = "desktop";
    IconNames["Users"] = "user-alt";
    IconNames["YieldOptimizer"] = "dollar-sign";
})(IconNames || (IconNames = {}));
var KitIconNames;
(function (KitIconNames) {
    KitIconNames["ApiSolid"] = "api-solid";
    KitIconNames["AppStore"] = "app-store";
    KitIconNames["BadgeDollarSign"] = "badge-dollar-sign-solid";
    KitIconNames["BottomCardAngled"] = "bottom-card-angled";
    KitIconNames["CaretUpDown"] = "caret-up-down-custom";
    KitIconNames["CircleDot"] = "circle-dot-regular";
    KitIconNames["CompanyLogo"] = "engine-logo";
    KitIconNames["CompanyLogoFavicon"] = "engine-logo-favicon";
    KitIconNames["CompanyLogoHorizontal"] = "engine-control-center-logo-horizontal";
    KitIconNames["CompanyLogoVertical"] = "engine-control-center-logo-vertical";
    KitIconNames["FaPcPlay"] = "fa-pc-play";
    KitIconNames["FileInvoiceDollar"] = "file-invoice-dollar-solid";
    KitIconNames["FinancialOffers"] = "financial-offers";
    KitIconNames["InProgress"] = "in-progress";
    KitIconNames["MailSent"] = "mail-sent";
    KitIconNames["MenuFold"] = "menu-fold";
    KitIconNames["MenuUnfold"] = "menu-unfold";
    KitIconNames["NullStateBenchmarkReport"] = "null-state-benchmark-report";
    KitIconNames["NullStateCustomOffers"] = "null-state-custom-offers";
    KitIconNames["NullStateEmptyPage"] = "null-state-empty-page";
    KitIconNames["NullStateLockedPage"] = "null-state-locked-page";
    KitIconNames["NullStateNoData"] = "null-state-no-data";
    KitIconNames["NullStateRevenueReporting"] = "null-state-revenue-reporting";
    KitIconNames["NullStateWorkingOnPage"] = "null-state-working-on-page";
    KitIconNames["Questionnaire"] = "questionnaire";
    KitIconNames["RevenueReport"] = "revenue-report";
    KitIconNames["SealCheckSolid"] = "seal-check-solid";
    KitIconNames["Signal"] = "signal-solid";
    KitIconNames["SquareSelectedRegular"] = "square-selected-regular";
    KitIconNames["StarShield"] = "star-shield";
    KitIconNames["ToggleOff"] = "toogle-off";
    KitIconNames["ToggleOn"] = "toogle-on";
    KitIconNames["UserSearchSolid"] = "user-search-solid";
})(KitIconNames || (KitIconNames = {}));
var IconTypes;
(function (IconTypes) {
    IconTypes["BRANDS"] = "brands";
    IconTypes["DUOTONE"] = "duotone";
    IconTypes["LIGHT"] = "light";
    IconTypes["REGULAR"] = "regular";
    IconTypes["SOLID"] = "solid";
    IconTypes["THIN"] = "thin";
})(IconTypes || (IconTypes = {}));

var ClicksIcon = function (props) { return (jsx(FontAwesomeIcon, __assign({ icon: faArrowPointer, mask: faCircle, transform: "shrink-6 right-1" }, props))); };
var ApplicationsIcon = function (props) { return (jsx(FontAwesomeIcon, __assign({ icon: faFileCode, mask: faCircle, transform: "shrink-7" }, props))); };
var LeadsIcon = function (props) { return (jsx(FontAwesomeIcon, __assign({ icon: faUser, mask: faCircle, transform: "shrink-7" }, props))); };
var FundedIcon = function (props) { return (jsx(FontAwesomeIcon, __assign({ icon: faSackDollar, mask: faCircle, transform: "shrink-7" }, props))); };
var PreApprovedIcon = function (props) { return (jsx(FontAwesomeIcon, __assign({ icon: faBadgeCheck, mask: faCircle, transform: "shrink-6" }, props))); };

var Spinner = function (_a) {
    var _b = _a.intent, intent = _b === void 0 ? Intent.PRIMARY : _b, props = __rest(_a, ["intent"]);
    return jsx(Spinner$1, __assign({}, props, { intent: intent }));
};

var RoundedCard = function (_a) {
    var children = _a.children, className = _a.className, headerContent = _a.headerContent, loading = _a.loading, title = _a.title;
    var hasHeader = Boolean(title) || Boolean(headerContent);
    return (jsxs("div", __assign({ className: classNames('rounded-card-container', className) }, { children: [hasHeader ? (jsxs("div", __assign({ className: "rounded-card-header" }, { children: [jsx("span", __assign({ className: "title" }, { children: title })), jsx("div", __assign({ className: "header-content" }, { children: headerContent }))] }))) : undefined, loading ? (jsx("div", __assign({ className: "rounded-card-content" }, { children: jsx(Spinner, {}) }))) : (jsx("div", __assign({ className: "body" }, { children: children })))] })));
};
RoundedCard.Content = function (_a) {
    var children = _a.children, className = _a.className;
    return (jsx("div", __assign({ className: classNames('rounded-card-content', className) }, { children: children })));
};
RoundedCard.Footer = function (props) {
    var showSaveChangesButton = props.showSaveChangesButton, onSaveChanges = props.onSaveChanges;
    return (jsx("div", __assign({ className: "rounded-card-footer" }, { children: showSaveChangesButton ? (jsx(Button, __assign({ intent: Intent.PRIMARY, onClick: onSaveChanges }, { children: "Save Changes" }))) : null })));
};

var TagHeader = function (_a) {
    var id = _a.id, text = _a.text;
    return (jsx("div", __assign({ className: "tag-header" }, { children: jsxs("div", __assign({ className: "tag-header-right-section" }, { children: [jsx("div", __assign({ className: "portal-plist-title" }, { children: text })), jsx("div", __assign({ className: "tag-header-right-section-id" }, { children: id }))] })) })));
};

var InfoToolTip = function (_a) {
    var content = _a.content;
    return (jsx(Tooltip2, __assign({ className: "field-tooltip", content: jsx("div", __assign({ style: { maxWidth: '350px' } }, { children: content })) }, { children: jsx(FontAwesomeIcon, { icon: faInfoCircle }) })));
};

/**
 * Truncates text with tooltip to view full text.
 */
var Truncate = function (_a) {
    var text = _a.text;
    return (jsx("div", __assign({ className: "truncate" }, { children: jsx(Tooltip2, __assign({ content: text }, { children: jsx("span", __assign({ className: "truncate-text" }, { children: text })) })) })));
};

var FieldLayout;
(function (FieldLayout) {
    FieldLayout["Horizontal"] = "horizontal";
    FieldLayout["HorizontalStart"] = "horizontal-start";
    FieldLayout["Vertical"] = "vertical";
})(FieldLayout || (FieldLayout = {}));
var Field = function (props) {
    var children = props.children, className = props.className, error = props.error, extra = props.extra, inputId = props.inputId, label = props.label, _a = props.layout, layout = _a === void 0 ? FieldLayout.Vertical : _a, _b = props.show, show = _b === void 0 ? true : _b, showAsterisk = props.showAsterisk, tooltip = props.tooltip, postfix = props.postfix, _c = props.useFieldWrapper, useFieldWrapper = _c === void 0 ? true : _c;
    if (!show) {
        return null;
    }
    if (!useFieldWrapper) {
        return jsx(Fragment, { children: children });
    }
    return (jsxs("div", __assign({ className: classNames(className, 'field', "field-".concat(layout)) }, { children: [label && (jsxs("label", __assign({ className: "field-label", htmlFor: inputId }, { children: [label, ' ', showAsterisk ? jsx("span", __assign({ style: { color: 'red' } }, { children: "*" })) : null, ' ', tooltip && jsx(InfoToolTip, { content: tooltip }), postfix && jsx("span", __assign({ className: "field-postfix" }, { children: postfix }))] }))), jsxs("div", __assign({ className: classNames({
                    'field-input-wrapper': true,
                    'is-error': error,
                }) }, { children: [children, extra && jsx("div", __assign({ className: "field-extra" }, { children: extra })), error && jsx("div", __assign({ className: "field-error" }, { children: error }))] }))] })));
};

var MoneyInput = function (_a) {
    var ariaLabel = _a.ariaLabel, name = _a.name, onChange = _a.onChange, value = _a.value, disabled = _a.disabled;
    var _b = React.useState(value || ''), internalValue = _b[0], setInternalValue = _b[1];
    var _c = React.useState(null), error = _c[0], setError = _c[1];
    var validateAndParseValue = function (inputValue) {
        var _a;
        if (disabled) {
            return inputValue;
        } // Skip validation if disabled
        var matches = inputValue.match(/[\d.]+/);
        var parsedValue = (_a = matches === null || matches === void 0 ? void 0 : matches[0]) !== null && _a !== void 0 ? _a : '';
        // Check if decimal precision exceeds 4 places.
        var decimalMatch = parsedValue.match(/\.(\d+)/);
        if (decimalMatch && decimalMatch[1].length > 4) {
            setError('Value cannot have more than 4 decimal places');
        }
        else {
            setError(null);
            onChange(parsedValue);
        }
        return parsedValue;
    };
    var handleChange = function (e) {
        if (disabled) {
            return;
        } // Prevent input changes when disabled
        var rawValue = e.currentTarget.value.replace(/[^0-9.]/g, ''); // Remove non-numeric characters except '.'
        setInternalValue(rawValue);
        validateAndParseValue(rawValue);
    };
    return (jsxs("div", __assign({ style: { display: 'flex', flexDirection: 'column' } }, { children: [jsx("input", { "aria-label": ariaLabel, className: Classes.INPUT, disabled: disabled, name: name, role: "textbox", value: disabled ? "$".concat(value) : "$".concat(internalValue), onChange: handleChange }), !disabled && error && (jsx("span", __assign({ style: { color: 'red', fontSize: '12px', marginTop: '4px' } }, { children: error })))] })));
};

var MultiSelect = function (props) {
    var allowCreate = props.allowCreate, createNewItem = props.createNewItem, items = props.items, itemRemoveFilter = props.itemRemoveFilter, controlledItems = props.selectedItems, controlledValues = props.selectedValues, valueKey = props.valueKey, disabled = props.disabled, onValueKeyChange = props.onValueKeyChange, onChange = props.onChange, noResultsMessage = props.noResultsMessage, multiSelectProps = __rest(props, ["allowCreate", "createNewItem", "items", "itemRemoveFilter", "selectedItems", "selectedValues", "valueKey", "disabled", "onValueKeyChange", "onChange", "noResultsMessage"]);
    var _a = useState([]), itemsState = _a[0], setItemsState = _a[1];
    var _b = useState([]), valuesState = _b[0], setValuesState = _b[1];
    var itemsByValue = useMemo(function () {
        if (valueKey) {
            return keyBy(items, valueKey);
        }
        return {};
    }, [items.length, valueKey]);
    var getItemsFromValues = function (values) {
        if (valueKey) {
            return values.map(function (value) { return itemsByValue[String(value)]; });
        }
        return [];
    };
    var selectedItems = valueKey ? getItemsFromValues(valuesState) : itemsState;
    var updateItems = function (nextItemsState) {
        if (disabled) {
            return;
        }
        if (valueKey) {
            var nextValuesState = nextItemsState.map(function (item) { return item[valueKey]; });
            setValuesState(nextValuesState);
            onValueKeyChange === null || onValueKeyChange === void 0 ? void 0 : onValueKeyChange(nextValuesState);
        }
        setItemsState(nextItemsState);
        onChange === null || onChange === void 0 ? void 0 : onChange(nextItemsState);
    };
    var addItem = function (itemToAdd) {
        if (!selectedItems.includes(itemToAdd)) {
            updateItems(__spreadArray(__spreadArray([], selectedItems, true), [itemToAdd], false));
        }
    };
    var removeItem = function (itemToRemove) {
        updateItems(selectedItems.filter(function (item) {
            return itemRemoveFilter
                ? itemRemoveFilter(item, itemToRemove)
                : item !== itemToRemove;
        }));
    };
    var controlledItemsDep = valueKey
        ? controlledItems === null || controlledItems === void 0 ? void 0 : controlledItems.map(function (item) { return item[valueKey]; }).join(',')
        : JSON.stringify(controlledItems);
    var controlledValuesDep = controlledValues === null || controlledValues === void 0 ? void 0 : controlledValues.join(',');
    useEffect(function () {
        if (controlledItems) {
            if (valueKey) {
                throw new Error('"valueKey" cannot be set when using selectedItems.');
            }
            setItemsState(controlledItems);
        }
    }, [controlledItemsDep]);
    useEffect(function () {
        if (controlledValues) {
            if (!valueKey) {
                throw new Error('"valueKey" must be set when using selectedValues.');
            }
            setValuesState(controlledValues);
        }
    }, [controlledValuesDep]);
    var handleCreateItem = function (query) {
        if (!createNewItem) {
            throw new Error('Item creation is not supported.');
        }
        return createNewItem(query);
    };
    var createItemRenderer = function (query, active, handleClick) { return (jsx(MenuItem$1, { active: active, icon: "add", roleStructure: "listoption", shouldDismissPopover: false, text: "Create ".concat(query), onClick: handleClick })); };
    return (jsx(MultiSelect$1, __assign({ className: "blue-print-multiselect", createNewItemFromQuery: allowCreate ? handleCreateItem : undefined, createNewItemRenderer: allowCreate ? createItemRenderer : undefined, items: items, noResults: jsx(Fragment, { children: noResultsMessage !== null && noResultsMessage !== void 0 ? noResultsMessage : "No accounts available" }), popoverProps: { minimal: true }, selectedItems: selectedItems, onItemSelect: addItem, onRemove: removeItem }, multiSelectProps)));
};

var RepeaterItem = function (props) {
    var index = props.index, item = props.item, _a = props.repeaterProps, itemNoun = _a.itemNoun, itemRenderer = _a.itemRenderer, isCondensed = _a.isCondensed, onRemove = _a.onRemove;
    var removeButton = (jsx(Button, __assign({ "aria-label": "Remove ".concat(itemNoun), onClick: function () { return onRemove(index); } }, { children: jsx(FontAwesomeIcon, { icon: faTrashCan }) })));
    var content = (jsx("div", __assign({ className: "item-content" }, { children: itemRenderer(item, index) })));
    if (isCondensed) {
        return (jsxs("div", __assign({ className: "item is-condensed" }, { children: [content, removeButton] })));
    }
    return (jsxs("div", __assign({ className: "item" }, { children: [jsxs("div", __assign({ className: "item-header" }, { children: [jsxs("h4", __assign({ className: "item-title" }, { children: [itemNoun, " #", index + 1] })), removeButton] })), content] })));
};

var Repeater = function (props) {
    var className = props.className, hideOnMaxItems = props.hideOnMaxItems, itemKey = props.itemKey, _a = props.itemNoun, itemNoun = _a === void 0 ? 'Item' : _a, items = props.items, maxItems = props.maxItems, onAdd = props.onAdd;
    var maxItemsReached = maxItems ? items.length >= maxItems : false;
    var hideAddButton = hideOnMaxItems && maxItemsReached;
    return (jsxs("div", __assign({ className: classNames('repeater', className) }, { children: [items.map(function (item, index) { return (jsx(RepeaterItem, { index: index, item: item, repeaterProps: props }, itemKey(item))); }), !hideAddButton && (jsxs(Button, __assign({ "aria-label": "Add ".concat(itemNoun), className: "add-item-button", disabled: maxItemsReached, icon: jsx(FontAwesomeIcon, { icon: faAdd }), onClick: function () { return onAdd(); } }, { children: ["Add ", itemNoun] })))] })));
};

var RepeaterController = function (_a) {
    var control = _a.control, defaultValue = _a.defaultValue, itemRenderer = _a.itemRenderer, name = _a.name, onAdd = _a.onAdd, repeaterProps = __rest(_a, ["control", "defaultValue", "itemRenderer", "name", "onAdd"]);
    var fieldArray = useFieldArray({
        control: control,
        name: name,
    });
    var handleAdd = function () {
        fieldArray.append(defaultValue);
        onAdd === null || onAdd === void 0 ? void 0 : onAdd();
    };
    return (jsx(Repeater, __assign({}, repeaterProps, { itemKey: function (field) { return field.id; }, itemRenderer: function (field, index) { return itemRenderer(field.id, index); }, items: fieldArray.fields, onAdd: handleAdd, onRemove: fieldArray.remove })));
};

/**
 * Maintain previous value of a given variable.
 */
var usePrevious = function (value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    }, [value]);
    return ref.current;
};

var SelectItem = function (props) {
    var ariaLabel = props.ariaLabel, currentItem = props.currentItem, handleClick = props.handleClick, _a = props.modifiers, active = _a.active, matchesPredicate = _a.matchesPredicate, disabled = _a.disabled, _b = props.selectedItems, selectedItems = _b === void 0 ? [] : _b, text = props.text;
    if (!matchesPredicate) {
        return null;
    }
    var selectedItemsSet = new Set(selectedItems);
    var showCheckmark = currentItem ? selectedItemsSet.has(currentItem) : false;
    return (jsx(EvenButton, { minimal: true, "aria-label": ariaLabel, className: classNames('select-item', {
            'is-active': active || showCheckmark,
            'is-disabled': disabled,
        }), "data-qa": "".concat(kebabCase(text), "-option"), disabled: disabled, icon: showCheckmark ? (jsx(FontAwesomeIcon, { className: "select-item-check", icon: faCheck })) : undefined, role: "option", text: text, onClick: handleClick }));
};

var defaultGroupSorter = function (a, b) { return a.localeCompare(b); };
var getItemsByGroup = function (items, itemGroup) {
    return items.reduce(function (accum, item) {
        var group = itemGroup(item);
        if (!(accum === null || accum === void 0 ? void 0 : accum[group])) {
            accum[group] = [];
        }
        accum[group].push(item);
        return accum;
    }, {});
};
var SelectList$1 = function (_a) {
    var filteredItems = _a.filteredItems, itemGroup = _a.itemGroup, _b = _a.groupSorter, groupSorter = _b === void 0 ? defaultGroupSorter : _b, renderItem = _a.renderItem;
    if (itemGroup) {
        var filteredItemsByGroup_1 = getItemsByGroup(filteredItems, itemGroup);
        return (jsx(Menu, __assign({ className: "cc-select-list" }, { children: Object.keys(filteredItemsByGroup_1)
                .sort(groupSorter)
                .map(function (group) { return (jsxs(React.Fragment, { children: [jsx("span", __assign({ className: "group-heading" }, { children: group })), jsx("div", __assign({ className: "group-items" }, { children: filteredItemsByGroup_1[group].map(renderItem) }))] }, group)); }) })));
    }
    return jsx(Menu, { children: filteredItems.map(renderItem) });
};

var Select = function (props) {
    var _a = props["data-testid"], testId = _a === void 0 ? '' : _a, activeItem = props.activeItem, ariaLabel = props.ariaLabel, disabled = props.disabled, groupSorter = props.groupSorter, itemGroup = props.itemGroup, itemKey = props.itemKey, itemLabel = props.itemLabel, itemPredicateOverride = props.itemPredicate, items = props.items, onItemSelect = props.onItemSelect, _b = props.placeholder, placeholder = _b === void 0 ? 'Select' : _b, _c = props.filterable, filterable = _c === void 0 ? true : _c, selectProps = __rest(props, ['data-testid', "activeItem", "ariaLabel", "disabled", "groupSorter", "itemGroup", "itemKey", "itemLabel", "itemPredicate", "items", "onItemSelect", "placeholder", "filterable"]);
    var prevActiveItem = usePrevious(activeItem);
    var _d = useState(activeItem), internalActiveItem = _d[0], setInternalActiveItem = _d[1];
    var handleItemSelect = function (item) {
        setInternalActiveItem(item);
        onItemSelect(item);
    };
    useEffect(function () {
        if (prevActiveItem !== activeItem) {
            setInternalActiveItem(activeItem);
        }
    }, [activeItem]);
    var itemPredicate = itemPredicateOverride
        ? itemPredicateOverride
        : createSerializedItemPredicate(function (item) { return itemLabel(item); });
    return (jsx("div", __assign({ "data-testid": testId }, { children: jsx(Select$1, __assign({ activeItem: internalActiveItem, disabled: disabled, filterable: filterable, itemListRenderer: function (props) { return (jsx(SelectList$1, __assign({ groupSorter: groupSorter, itemGroup: itemGroup }, props))); }, itemPredicate: itemPredicate, itemRenderer: function (item, props) {
                var label = itemLabel(item);
                return (jsx(SelectItem, __assign({ ariaLabel: label, text: label }, props), itemKey(item)));
            }, items: items, popoverProps: { minimal: true }, onItemSelect: handleItemSelect }, selectProps, { children: jsxs(Button, __assign({ "aria-label": ariaLabel, className: classNames('cc-select', Classes.INPUT, {
                    'is-disabled': disabled,
                }), disabled: disabled, role: "combobox" }, { children: [jsx("span", { children: internalActiveItem
                            ? itemLabel(internalActiveItem)
                            : "-- ".concat(placeholder, " --") }), jsx(FontAwesomeIcon, { className: "cc-select-caret", icon: faAngleDown, size: "lg", style: { paddingLeft: '5px' } })] })) })) })));
};

var Suggest = function (props) {
    var onChange = props.onChange, onValueKeyChange = props.onValueKeyChange, selectedItem = props.selectedItem, selectedValue = props.selectedValue, valueKey = props.valueKey, _a = props.items, allItems = _a === void 0 ? [] : _a, _b = props.noResultsMessage, noResultsMessage = _b === void 0 ? 'No results available' : _b, suggestProps = __rest(props, ["onChange", "onValueKeyChange", "selectedItem", "selectedValue", "valueKey", "items", "noResultsMessage"]);
    var _c = useState(selectedItem !== null && selectedItem !== void 0 ? selectedItem : undefined), item = _c[0], setItem = _c[1];
    var updateItem = function (nextItem) {
        setItem(nextItem);
        onChange === null || onChange === void 0 ? void 0 : onChange(nextItem);
        if (valueKey) {
            onValueKeyChange === null || onValueKeyChange === void 0 ? void 0 : onValueKeyChange(nextItem[valueKey]);
        }
    };
    useEffect(function () {
        if (selectedItem) {
            setItem(selectedItem);
        }
    }, [JSON.stringify(selectedItem)]);
    useEffect(function () {
        if (!selectedValue || !valueKey) {
            return;
        }
        setItem(allItems.find(function (x) { return x[valueKey] === selectedValue; }));
    }, [selectedValue]);
    return (jsx(Suggest$1, __assign({ resetOnSelect: true, className: "suggest-input", "data-testid": "accountSuggest", items: allItems, noResults: noResultsMessage, popoverProps: { minimal: true }, selectedItem: item, onItemSelect: updateItem }, suggestProps)));
};

var styles$j = {"upload-table":"index-module_upload-table__bh7Nj","upload-item":"index-module_upload-item__R39lg","upload-img":"index-module_upload-img__7nuwB","upload-icon":"index-module_upload-icon__aElDk","upload-tooltip":"index-module_upload-tooltip__ePJSO"};

var Upload = function (_a) {
    var multiple = _a.multiple, accept = _a.accept, disabled = _a.disabled, handleChange = _a.handleChange, _b = _a.large, large = _b === void 0 ? true : _b, tooltip = _a.tooltip;
    var uploadInput = useRef(null);
    var _c = useState(), fileList = _c[0], setFileList = _c[1];
    return (jsxs("div", __assign({ className: styles$j.container }, { children: [jsx("input", { ref: uploadInput, hidden: true, accept: accept, multiple: multiple, type: "file", onChange: function (e) {
                    if (e.target.files) {
                        setFileList(Object.values(e.target.files));
                        handleChange(e.target.files);
                    }
                } }), jsxs(EvenButton, __assign({ outlined: true, disabled: disabled, large: large, onClick: function () { var _a; return (_a = uploadInput.current) === null || _a === void 0 ? void 0 : _a.click(); } }, { children: [jsx(FontAwesomeIcon, { className: styles$j['upload-icon'], icon: faArrowUpFromBracket }), ' ', "Upload"] })), !!tooltip && (jsx("div", __assign({ className: styles$j['upload-tooltip'] }, { children: jsx(InfoToolTip, { content: tooltip }) }))), jsx("table", __assign({ className: styles$j['upload-table'] }, { children: fileList === null || fileList === void 0 ? void 0 : fileList.map(function (item) {
                    var name = item.name, type = item.type;
                    var mimeType = type.split('/')[0];
                    return (jsxs("tr", __assign({ className: styles$j['upload-item'] }, { children: [mimeType === 'image' && (jsx("td", { children: jsx("img", { className: styles$j['upload-img'], sizes: "small", src: URL.createObjectURL(item) }) })), jsx("td", { children: name })] }), name));
                }) }))] })));
};

var TextAreaWithCharacterLimit = function (_a) {
    var onChange = _a.onChange, onFocus = _a.onFocus, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.value, value = _c === void 0 ? '' : _c, _d = _a.limit, limit = _d === void 0 ? 250 : _d, className = _a.className, _e = _a.placeholder, placeholder = _e === void 0 ? '' : _e;
    var _f = useState(value.slice(0, limit)), content = _f[0], setContent = _f[1];
    var onChangeInternal = useCallback(function (text) {
        var textFormatted = text.slice(0, limit);
        setContent(textFormatted);
        onChange(textFormatted);
    }, [limit, setContent]);
    // Necessary for external control of the component, such as with hook form controller
    useEffect(function () {
        setContent(value.slice(0, limit));
    }, [value]);
    return (jsxs(Fragment, { children: [jsx(TextArea, { fill: true, className: classNames('text-area-character-limit', Classes.INPUT, className), disabled: disabled, placeholder: placeholder, value: content, onChange: function (evt) {
                    return onChangeInternal(evt.target.value);
                }, onFocus: onFocus }), jsxs("p", __assign({ className: 'text-area-character-limit-info' }, { children: [content.length, "/", limit, " characters"] }))] }));
};

var toAccountMetadataForm = function (accountMetadata) {
    var form = {};
    var personalLoansDashboardMinDate = accountMetadata.personalLoansDashboardMinDate;
    if (personalLoansDashboardMinDate) {
        form.personalLoansDashboardMinDate = toDate(personalLoansDashboardMinDate);
    }
    return form;
};
var toAccountMetadata = function (form) {
    var accountMetadata = {};
    var personalLoansDashboardMinDate = form.personalLoansDashboardMinDate;
    if (personalLoansDashboardMinDate) {
        accountMetadata.personalLoansDashboardMinDate = DateTime.fromJSDate(personalLoansDashboardMinDate).toISODate();
    }
    return accountMetadata;
};

var AccountMetadataCard = function (_a) {
    var accountMetadata = _a.accountMetadata, onUpdate = _a.onUpdate;
    var _b = useForm(), control = _b.control, handleSubmit = _b.handleSubmit, reset = _b.reset;
    var handleUpdate = function (form) {
        onUpdate(toAccountMetadata(form));
    };
    useEffect(function () {
        if (accountMetadata) {
            reset(toAccountMetadataForm(accountMetadata));
        }
    }, [accountMetadata]);
    return (jsx(RoundedCard, __assign({ title: "Account Metadata" }, { children: jsxs("div", __assign({ style: { margin: '0 auto', padding: '24px', width: '75%' } }, { children: [jsx(Field, __assign({ label: "Personal Loans Dashboard Date Restriction", layout: FieldLayout.Horizontal, tooltip: "Restrict account from viewing personal loans dashboard data prior to specified date." }, { children: jsx(Controller, { control: control, name: "personalLoansDashboardMinDate", render: function (_a) {
                            var field = _a.field;
                            return (jsx(DateInput, { formatDate: formatDate$1, parseDate: toDate, value: field.value, onChange: field.onChange }));
                        } }) })), jsx("div", __assign({ style: { display: 'flex', justifyContent: 'flex-end' } }, { children: jsx(EvenButton, __assign({ onClick: handleSubmit(handleUpdate) }, { children: "Save changes" })) }))] })) })));
};

var filterByUuid = function (a, b) {
    return a.uuid !== b.uuid;
};

var NO_RESULTS_TEXT$2 = 'No Accounts Available';
var AccountMultiSelect = function (_a) {
    var accounts = _a.accounts, multiSelectProps = __rest(_a, ["accounts"]);
    return (jsx(MultiSelect, __assign({ itemPredicate: createSerializedItemPredicate$1(function (_a) {
            var name = _a.name;
            return name;
        }), itemRemoveFilter: filterByUuid, itemRenderer: function (_a, props) {
            var name = _a.name;
            return jsx(SelectItem, __assign({ text: name }, props));
        }, items: sortByName(__spreadArray([], accounts, true)), noResults: NO_RESULTS_TEXT$2, popoverProps: { minimal: true }, tagRenderer: function (_a) {
            var name = _a.name;
            return name;
        } }, multiSelectProps)));
};

var NO_RESULTS_TEXT$1 = 'No Accounts Available';
var serializeQuery = createMemoizedSerialize();
var AccountSuggest = function (_a) {
    var accounts = _a.accounts, multiSelectProps = __rest(_a, ["accounts"]);
    var serializedAccountNamesByAccountId = React.useMemo(function () {
        return new Map(accounts.map(function (account) { return [account.id, serialize(account.name)]; }));
    }, [accounts.length]);
    return (jsx(Suggest, __assign({ inputValueRenderer: function (_a) {
            var name = _a.name;
            return name;
        }, itemPredicate: function (query, account) {
            var serializedAccountName = serializedAccountNamesByAccountId.get(account.id);
            return (serializedAccountName || '').includes(serializeQuery(query));
        }, itemRenderer: function (_a, props) {
            var name = _a.name;
            return (jsx(SelectItem, __assign({ text: name }, props), name));
        }, items: sortByName(__spreadArray([], accounts, true)), noResults: NO_RESULTS_TEXT$1, popoverProps: { minimal: true } }, multiSelectProps)));
};

// Variables should correspond with color variables from '_variables.scss'
// In the future, we should try and make this file auth-generated.
var colors = {
    celticBlue: '#36c',
    cistern: '#abb0b6',
    clearChill: '#1890ff',
    daphne: '#125ea0',
    kellyGreen: '#52c41a',
    tempGreen2: '#0ca678',
    themeGray11: '#222',
    themeGray3: '#f3f3f3',
    themeGray7: '#6b7580',
    themeGreen: '#0bb89b',
    themeOrange: '#f90',
    themeRed: '#c00',
    white: '#fff',
};

var ActionMenuItem = function (props) {
    var _a;
    var href = props.href, icon = props.icon, onClick = props.onClick, preset = props.preset, text = props.text;
    var presetToIcon = new Map([
        ['view', faUpRightFromSquare],
        ['duplicate', faClone],
        ['edit', faPenToSquare],
        ['delete', faTrash],
        ['activate', faCircleCheck],
        ['deactivate', faCircleX],
    ]);
    var presetToText = new Map([
        ['view', 'View'],
        ['duplicate', 'Duplicate'],
        ['edit', 'Edit'],
        ['delete', 'Delete'],
        ['activate', 'Activate'],
        ['deactivate', 'Deactivate'],
    ]);
    var presetIcon = preset ? presetToIcon.get(preset) : null;
    var presetText = preset ? presetToText.get(preset) : null;
    return (jsx(MenuItem2, { className: "action-menu-item", href: href, icon: jsx(FontAwesomeIcon, { color: colors.themeGray7, icon: (_a = icon !== null && icon !== void 0 ? icon : presetIcon) !== null && _a !== void 0 ? _a : faSquareDashed }), text: text !== null && text !== void 0 ? text : presetText, onClick: onClick }));
};

var ActionMenu = function (props) {
    var popoverProps = props.popoverProps, children = props.children;
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    return (jsx(Popover2, __assign({ lazy: true, minimal: true, className: "action-menu-container", content: jsx(Menu, __assign({ className: "action-menu" }, { children: children })), interactionKind: Popover2InteractionKind.CLICK, onClosing: function () { return setOpen(false); }, onOpening: function () { return setOpen(true); } }, popoverProps, { children: jsx(FontAwesomeIcon, { className: classNames('dots', { 'is-open': open }), color: colors.themeGray7, "data-testid": "internal-accounts-table-actions", fontSize: 16, icon: faEllipsisVertical }) })));
};
ActionMenu.Item = ActionMenuItem;

var NonIdealLayout = function (_a) {
    var children = _a.children, footer = _a.footer;
    return (jsxs("article", __assign({ className: "non-ideal-layout" }, { children: [jsx("div", __assign({ className: "body" }, { children: children })), footer && jsx("footer", __assign({ className: "footer" }, { children: footer }))] })));
};

var styles$i = {"container":"index-module_container__Ua6Zq","content":"index-module_content__pHvG0","actions":"index-module_actions__5tVA4"};

var EvenDialog = function (props) {
    var _a = props.cancelText, cancelText = _a === void 0 ? 'No' : _a, message = props.message, _b = props.okText, okText = _b === void 0 ? 'Yes' : _b, onCancel = props.onCancel, onOk = props.onOk, _c = props.title, title = _c === void 0 ? 'Are you sure?' : _c, visible = props.visible;
    return (jsxs(Dialog, __assign({ usePortal: true, isCloseButtonShown: false, isOpen: visible, portalClassName: styles$i.container, title: title, onClose: onCancel }, { children: [jsx("div", __assign({ className: styles$i.content }, { children: message })), jsxs("div", __assign({ className: styles$i.actions }, { children: [jsx(EvenButton, __assign({ outlined: true, onClick: onCancel }, { children: cancelText })), jsx(EvenButton, __assign({ onClick: onOk }, { children: okText }))] }))] })));
};

var styles$h = {"container":"ConfirmableAction-module_container__NeXjK","content":"ConfirmableAction-module_content__Lwjle","actions":"ConfirmableAction-module_actions__hEETd"};

var ConfirmableAction = function (_a) {
    var _b = _a.cancelText, cancelText = _b === void 0 ? 'No' : _b, children = _a.children, className = _a.className, _c = _a.disabled, disabled = _c === void 0 ? false : _c, message = _a.message, okText = _a.okText, onCancel = _a.onCancel, _d = _a.onOk, onOk = _d === void 0 ? 'Yes' : _d, _e = _a.title, title = _e === void 0 ? 'Are you sure?' : _e;
    var _f = useState(false), visible = _f[0], setVisible = _f[1];
    var handleOpen = function () {
        setVisible(true);
    };
    var handleOk = function () {
        onOk === null || onOk === void 0 ? void 0 : onOk();
        setVisible(false);
    };
    var handleCancel = function () {
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        setVisible(false);
    };
    return (jsxs("div", __assign({ className: classNames(styles$h.container, className) }, { children: [jsx("div", __assign({ onClick: disabled ? function () { } : handleOpen }, { children: children })), jsx(EvenDialog, { cancelText: cancelText, message: message, okText: okText, title: title, visible: visible, onCancel: handleCancel, onOk: handleOk })] })));
};

var NonIdealLayoutWithAction = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Product Vertical' : _b, sendEmail = _a.sendEmail, _c = _a.displayContactUs, displayContactUs = _c === void 0 ? true : _c, footer = _a.footer;
    var action = useMemo(function () {
        if (!displayContactUs) {
            return jsx(Fragment, {});
        }
        return (jsx(ConfirmableAction, __assign({ cancelText: "Cancel", message: "After you submit your request, you will be contacted by our team for next steps.", okText: "Submit Request", title: "Contact Us", onOk: sendEmail }, { children: jsx(EvenButton, __assign({ intent: Intent.SUCCESS }, { children: "Contact Us" })) })));
    }, [displayContactUs, sendEmail]);
    return (jsxs("article", __assign({ className: "non-ideal-layout" }, { children: [jsx("div", __assign({ className: "body" }, { children: jsx(NonIdealState, { action: action, description: jsxs("span", { children: ["We are currently working on adding this product vertical to Control Center. ", jsx("br", {}), "In the meantime, let us know if you have any questions."] }), icon: jsx(FontAwesomeKitIcon, { color: colors.cistern, icon: KitIconNames.NullStateWorkingOnPage, size: "1x" }), title: jsxs(Fragment, { children: [jsxs("strong", { children: [title, ","] }), " Coming Soon!"] }) }) })), footer && jsx("footer", __assign({ className: "footer" }, { children: footer }))] })));
};

var SupplyFreeNavbarRoutes;
(function (SupplyFreeNavbarRoutes) {
    SupplyFreeNavbarRoutes["Compliance"] = "/compliance";
    SupplyFreeNavbarRoutes["Integrations"] = "/integrations";
    SupplyFreeNavbarRoutes["PerformanceSummary"] = "/performance-summary";
})(SupplyFreeNavbarRoutes || (SupplyFreeNavbarRoutes = {}));
var Channels = function (_a) {
    var onRouteChange = _a.onRouteChange, props = __rest(_a, ["onRouteChange"]);
    return (jsxs(Menu$1.ItemGroup, __assign({ title: jsx("strong", __assign({ style: { textTransform: 'uppercase' } }, { children: "Channels" })) }, props, { children: [jsx(MenuItem, { icon: jsx(SidebarIcon, { icon: faWindowRestore }), itemText: "Integrations", route: SupplyFreeNavbarRoutes.Integrations, onRouteChange: onRouteChange }, "integrations"), jsx(MenuItem, { icon: jsx(SidebarIcon, { icon: faClipboardCheck }), itemText: "Compliance", route: SupplyFreeNavbarRoutes.Compliance, onRouteChange: onRouteChange }, "compliance"), jsx(MenuItem, { icon: jsx(SidebarIcon, { icon: faChartArea }), itemText: "Performance Summary", route: SupplyFreeNavbarRoutes.PerformanceSummary, onRouteChange: onRouteChange }, "performance-summary")] })));
};

var OfferManagementRoute;
(function (OfferManagementRoute) {
    OfferManagementRoute["AutoLoanRefi"] = "/offer-management/financial-services/auto-loan-refinance";
    OfferManagementRoute["CreditCards"] = "/offer-management/financial-services/credit-cards";
    OfferManagementRoute["CustomOffers"] = "/offer-management/custom-offers";
    OfferManagementRoute["PersonalLoans"] = "/offer-management/financial-services/personal-loans";
    OfferManagementRoute["Savings"] = "/offer-management/financial-services/savings";
    OfferManagementRoute["StudentLoanRefi"] = "/offer-management/financial-services/student-loan-refinance";
})(OfferManagementRoute || (OfferManagementRoute = {}));
// Self-Service/Starter/Scale Offer Management Subnav
var OfferManagement = function (_a) {
    var onRouteChange = _a.onRouteChange, props = __rest(_a, ["onRouteChange"]);
    return (jsxs(Menu$1.ItemGroup, __assign({ title: jsx("strong", __assign({ style: { textTransform: 'uppercase' } }, { children: "Offer Management" })) }, props, { children: [jsxs(Menu$1.SubMenu, __assign({ icon: jsx(SidebarIcon, { icon: KitIconNames.FinancialOffers }), title: "Financial Services" }, { children: [jsx(MenuItem, { showWrenchIcon: true, icon: jsx(SidebarIcon, { icon: faSackDollar }), itemText: "Personal Loans", route: OfferManagementRoute.PersonalLoans, onRouteChange: onRouteChange }, "personal-loans"), jsx(MenuItem, { showBadgeDollarIcon: true, icon: jsx(SidebarIcon, { icon: faGraduationCap }), itemText: "Student Loan Refi", route: OfferManagementRoute.StudentLoanRefi, onRouteChange: onRouteChange }, "student-loan-refi"), jsx(MenuItem, { showBadgeDollarIcon: true, icon: jsx(SidebarIcon, { icon: faCarSide }), itemText: "Auto Loan Refi", route: OfferManagementRoute.AutoLoanRefi, onRouteChange: onRouteChange }, "auto-loan-refi"), jsx(MenuItem, { showBadgeDollarIcon: true, icon: jsx(SidebarIcon, { icon: faPiggyBank }), itemText: "Savings", route: OfferManagementRoute.Savings, onRouteChange: onRouteChange }, "savings"), jsx(MenuItem, { showBadgeDollarIcon: true, icon: jsx(SidebarIcon, { icon: faUmbrella }), itemText: "Life Insurance", route: OfferManagementRoute.PersonalLoans, onRouteChange: onRouteChange }, "life-insurance"), jsx(MenuItem, { showBadgeDollarIcon: true, icon: jsx(SidebarIcon, { icon: faCreditCard }), itemText: "Credit Cards", route: OfferManagementRoute.CreditCards, onRouteChange: onRouteChange }, "credit-cards")] }), "financial-services"), jsx(MenuItem, { icon: jsx(SidebarIcon, { icon: faTags }), itemText: "Custom Offers", route: OfferManagementRoute.CustomOffers, onRouteChange: onRouteChange }, "custom-offers")] })));
};

var StarterNavbar = function (_a) {
    var onRouteChange = _a.onRouteChange, props = __rest(_a, ["onRouteChange"]);
    return (jsxs(SideNav, { children: [jsx(BasicNav, { accountUuid: "0000-0000-0000-0000" }), jsx(Channels, __assign({ onRouteChange: onRouteChange }, props)), jsx(OfferManagement, __assign({ onRouteChange: onRouteChange }, props))] }));
};

var TemplateField;
(function (TemplateField) {
    TemplateField["DemandSubAccounts"] = "demandSubAccounts";
    TemplateField["Description"] = "description";
    TemplateField["Name"] = "name";
    TemplateField["Offers"] = "offers";
    TemplateField["ProductType"] = "productType";
})(TemplateField || (TemplateField = {}));
var TabIds$1;
(function (TabIds) {
    TabIds["DemandApi"] = "demand-api";
    TabIds["DemandApi2L"] = "demand-api-2l";
    TabIds["OfferCatalogOffers"] = "offer-catalog-offers";
    TabIds["Offers"] = "offers";
    TabIds["Offers2L"] = "offers-2l";
})(TabIds$1 || (TabIds$1 = {}));

var useDemandApisForTemplateCenter = function (_a) {
    var control = _a.control, _b = _a.demandApis, demandApis = _b === void 0 ? [] : _b, _c = _a.demandSubAccounts, demandSubAccounts = _c === void 0 ? [] : _c, productTypeSelected = _a.productTypeSelected;
    var demandSubAccountsFieldArray = useFieldArray({
        control: control,
        name: TemplateField.DemandSubAccounts,
    });
    var demandApisWithActiveStatus = useMemo(function () {
        var _a;
        var activeDemandSubAccounts = new Set(demandSubAccounts.map(function (_a) {
            var demandSubAccountId = _a.demandSubAccountId;
            return demandSubAccountId;
        }));
        return (_a = demandApis === null || demandApis === void 0 ? void 0 : demandApis.filter(function (_a) {
            var subAccountProductType = _a.subAccountProductType;
            return supplyTemplateProductTypeToProductTypeMap.get(productTypeSelected) ===
                subAccountProductType;
        })) === null || _a === void 0 ? void 0 : _a.map(function (demandApi) { return (__assign(__assign({}, demandApi), { isActive: activeDemandSubAccounts.has(demandApi.subAccountId) })); });
    }, [demandApis, demandSubAccounts, productTypeSelected]);
    var demandApisForTemplateCenter = demandApisWithActiveStatus.filter(function (demandSubAccount) { return demandSubAccount.isSecondLook === false; });
    var secondLooksForTemplateCenter = useMemo(function () {
        var _a;
        var activeDemandSubAccounts = new Set(demandSubAccounts.map(function (_a) {
            var demandSubAccountId = _a.demandSubAccountId;
            return demandSubAccountId;
        }));
        return (_a = demandApis === null || demandApis === void 0 ? void 0 : demandApis.filter(function (_a) {
            var isSecondLook = _a.isSecondLook;
            return isSecondLook === true;
        })) === null || _a === void 0 ? void 0 : _a.map(function (demandApi) { return (__assign(__assign({}, demandApi), { isActive: activeDemandSubAccounts.has(demandApi.subAccountId) })); });
    }, [demandApis, demandSubAccounts, productTypeSelected]);
    var handleDemandApiToggle = useCallback(function (isActive, demandSubAccountId) {
        var index = demandSubAccounts.findIndex(function (demandSubAccount) {
            return demandSubAccount.demandSubAccountId === demandSubAccountId;
        });
        if (isActive && index === -1) {
            // Append item if is active and an existing entry is not already found.
            demandSubAccountsFieldArray.append({ demandSubAccountId: demandSubAccountId });
        }
        else if (index !== -1) {
            // Append item if is not active and an existing entry is found.
            demandSubAccountsFieldArray.remove(index);
        }
    }, [demandSubAccounts, demandSubAccountsFieldArray]);
    return {
        demandApisForTemplateCenter: demandApisForTemplateCenter,
        handleDemandApiToggle: handleDemandApiToggle,
        secondLooksForTemplateCenter: secondLooksForTemplateCenter,
    };
};

var DemandInclusionsSettings = function (_a) {
    var _b;
    var canSelectProductType = _a.canSelectProductType, control = _a.control, productTypeSelected = _a.productTypeSelected, readOnly = _a.readOnly, demandApis = _a.demandApis, demandSubAccounts = _a.demandSubAccounts, dispatch = _a.dispatch, offerData = _a.offerData, offerData2L = _a.offerData2L, offerState = _a.offerState;
    var _c = useState(TabIds$1.DemandApi), selectedTabId = _c[0], setSelectedTabId = _c[1];
    var offerTabRef = React__default.useRef(null);
    var offer2LTabRef = React__default.useRef(null);
    var offerCatalogTabRef = React__default.useRef(null);
    var demandApiTabRef = React__default.useRef(null);
    var secondLookTabRef = React__default.useRef(null);
    var _d = useDemandApisForTemplateCenter({
        control: control,
        demandApis: demandApis,
        demandSubAccounts: demandSubAccounts,
        productTypeSelected: productTypeSelected,
    }), demandApisForTemplateCenter = _d.demandApisForTemplateCenter, handleDemandApiToggle = _d.handleDemandApiToggle, secondLooksForTemplateCenter = _d.secondLooksForTemplateCenter;
    var tabRefMap = (_b = {},
        _b[TabIds$1.DemandApi] = demandApiTabRef,
        _b[TabIds$1.DemandApi2L] = secondLookTabRef,
        _b[TabIds$1.Offers] = offerTabRef,
        _b[TabIds$1.Offers2L] = offer2LTabRef,
        _b[TabIds$1.OfferCatalogOffers] = offerCatalogTabRef,
        _b);
    var getCurrentTabRef = function () { return tabRefMap[selectedTabId]; };
    var getCurrentExportParams = function () {
        return selectedTabId === TabIds$1.DemandApi ||
            selectedTabId === TabIds$1.DemandApi2L
            ? {}
            : {
                columnKeys: [
                    'isActive',
                    'demandSubAccountId',
                    'demandSubAccountName',
                    'offerId',
                    'offerName',
                    'offerRulesForExport',
                ],
            };
    };
    var handleTabChange = function (newTabId) {
        setSelectedTabId(newTabId);
    };
    return (jsxs(Fragment, { children: [jsx(DetailHeader, { className: "demand-inclusions-section is-borderless title", nextToTitleContent: jsxs("div", __assign({ className: "button-group" }, { children: [jsx(ClearAllButton, { gridRef: getCurrentTabRef() }), jsx(ExportCSVButton, { csvExportParams: getCurrentExportParams(), gridRef: getCurrentTabRef() })] })), title: "Demand Inclusions" }), jsxs(Tabs, __assign({ selectedTabId: selectedTabId, onChange: handleTabChange }, { children: [jsx(Tab, { id: TabIds$1.DemandApi, panel: canSelectProductType && !productTypeSelected ? (jsx(NoData, { description: "In order to make inclusion selections, first select a product type above" })) : (jsx("section", __assign({ className: "ag-theme-alpine", style: { height: 600 } }, { children: jsx(TemplateCenterDemandApisPanel, { demandApis: demandApisForTemplateCenter, readOnly: readOnly, refObj: demandApiTabRef, onDemandApiToggle: handleDemandApiToggle }) }))), title: "Demand APIs" }), jsx(Tab, { id: TabIds$1.Offers, panel: canSelectProductType && !productTypeSelected ? (jsx(NoData, { description: "In order to make inclusion selections, first select a product type above" })) : (jsx("section", __assign({ className: "ag-theme-alpine", style: { height: 600 } }, { children: jsx(TemplateCenterOffersPanel, { dispatch: dispatch, offerData: offerData, offerState: offerState, readOnly: readOnly, refObj: offerTabRef }) }))), title: "Offers" }), jsx(Tab, { id: TabIds$1.DemandApi2L, panel: canSelectProductType && !productTypeSelected ? (jsx(NoData, { description: "In order to make inclusion selections, first select a product type above" })) : (jsx("section", __assign({ className: "ag-theme-alpine", style: { height: 600 } }, { children: jsx(TemplateCenterDemandApisPanel, { demandApis: secondLooksForTemplateCenter, readOnly: readOnly, refObj: secondLookTabRef, onDemandApiToggle: handleDemandApiToggle }) }))), title: "Demand APIs 2L" }), jsx(Tab, { id: TabIds$1.Offers2L, panel: canSelectProductType && !productTypeSelected ? (jsx(NoData, { description: "In order to make inclusion selections, first select a product type above" })) : (jsx("section", __assign({ className: "ag-theme-alpine", style: { height: 600 } }, { children: jsx(TemplateCenterOffersPanel, { dispatch: dispatch, offerData: offerData2L, offerState: offerState, readOnly: readOnly, refObj: offer2LTabRef }) }))), title: "Offers 2L" }), jsx(Tab, { id: TabIds$1.OfferCatalogOffers, panel: canSelectProductType && !productTypeSelected ? (jsx(NoData, { description: "No Offer Catalog Offers were found" })) : (jsx(Tab, { id: TabIds$1.OfferCatalogOffers, panel: jsx(OfferCatalogPanel, { dispatch: dispatch, offerState: offerState, readOnly: readOnly, refObj: offerCatalogTabRef }), title: "Offer Catalog Offers" })), title: "Offer Catalog Offers" })] }))] }));
};

var TemplateDetails = function (_a) {
    var _b;
    var canSelectProductType = _a.canSelectProductType, control = _a.control, errors = _a.errors, readOnly = _a.readOnly, register = _a.register, templateData = _a.templateData, templateNames = _a.templateNames;
    var templateNamesSerialized = templateNames === null || templateNames === void 0 ? void 0 : templateNames.map(serialize$1);
    return (jsx(CollapseCard, __assign({ isOpen: true, expandButtonLabel: "Template Details" }, { children: !canSelectProductType && !templateData ? (jsx(Spinner, {})) : (jsxs(Fragment, { children: [jsxs("div", __assign({ className: "details-form" }, { children: [jsx(Field, __assign({ error: (_b = errors[TemplateField.Name]) === null || _b === void 0 ? void 0 : _b.message, extra: "The name needs to be unique for each template", label: "Template Name", layout: FieldLayout.Vertical }, { children: jsx("input", __assign({ className: Classes.INPUT, disabled: readOnly }, register(TemplateField.Name, {
                                required: 'required',
                                validate: function (value) {
                                    if (templateNamesSerialized === null || templateNamesSerialized === void 0 ? void 0 : templateNamesSerialized.includes(serialize$1(value))) {
                                        return 'That name is already taken. Please try another one.';
                                    }
                                    return true;
                                },
                            }))) })), jsx(Controller, { control: control, name: TemplateField.ProductType, render: function (_a) {
                                var _b;
                                var _c = _a.field, value = _c.value, onChange = _c.onChange;
                                return (jsx(Field, __assign({ error: (_b = errors[TemplateField.ProductType]) === null || _b === void 0 ? void 0 : _b.type, label: "Product Type" }, { children: jsx(Select, { activeItem: value, disabled: !canSelectProductType, filterable: false, itemKey: function (item) { return item; }, itemLabel: startCase, items: Object.values(SupplyTemplateProductType), onItemSelect: onChange }) })));
                            }, rules: { required: true } }), jsx(Controller, { control: control, name: TemplateField.Description, render: function (_a) {
                                var _b = _a.field, value = _b.value, onChange = _b.onChange;
                                return (jsx(Field, __assign({ label: "Description" }, { children: jsx(TextAreaWithCharacterLimit, { disabled: readOnly, limit: 1000, value: value, onChange: onChange }) })));
                            } })] })), readOnly && templateData && (jsxs("div", __assign({ className: "details-info" }, { children: [jsxs("div", { children: [jsx(Field, __assign({ label: "ID" }, { children: templateData.id })), jsx(Field, __assign({ label: "Last Activity" }, { children: formatDate$1(templateData.updatedAt) }))] }), jsxs("div", { children: [jsx(Field, __assign({ label: "Created By" }, { children: templateData.createdBy })), jsx(Field, __assign({ label: "Created At" }, { children: formatDate$1(templateData.createdAt) }))] })] })))] })) })));
};

var TemplateCenter = function (props) {
    var canSelectProductType = props.canSelectProductType, demandApis = props.demandApis, dispatch = props.dispatch, hideTemplateDetails = props.hideTemplateDetails, form = props.form, formButtons = props.formButtons, offerData = props.offerData, offerData2L = props.offerData2L, offerState = props.offerState, readOnly = props.readOnly, templateData = props.templateData, templateNames = props.templateNames, title = props.title;
    React.useEffect(function () {
        if (templateData) {
            dispatch(actions.setOffers(templateData.offers));
        }
    }, [templateData]);
    var watch = form.watch, control = form.control, reset = form.reset, errors = form.formState.errors, register = form.register;
    var push = useRouter().push;
    var productTypeSelected = watch(TemplateField.ProductType);
    var demandSubAccounts = watch(TemplateField.DemandSubAccounts);
    useEffect(function () {
        if (templateData) {
            // sets the form data after loading
            reset(templateData);
        }
    }, [templateData, reset]);
    return (jsxs("div", __assign({ className: "template-center" }, { children: [jsx(DetailTopBar, { actions: readOnly ? formButtons : undefined, backText: "Demand Inclusion Templates", onBack: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                    return [2 /*return*/, push('/channels/template-center')];
                }); }); } }), !readOnly && (jsx(HeaderWithActions, __assign({ className: "title", title: title }, { children: formButtons }))), !hideTemplateDetails && (jsx(TemplateDetails, { canSelectProductType: canSelectProductType, control: control, errors: errors, readOnly: readOnly, register: register, templateData: templateData, templateNames: templateNames })), jsx(DemandInclusionsSettings, { canSelectProductType: canSelectProductType, control: control, demandApis: demandApis, demandSubAccounts: demandSubAccounts, dispatch: dispatch, offerData: offerData, offerData2L: offerData2L, offerState: offerState, productTypeSelected: productTypeSelected, readOnly: readOnly })] })));
};

var TableLayout = function (props) {
    var children = props.children, csvExportParams = props.csvExportParams, gridRef = props.gridRef, isLoading = props.isLoading, onCreate = props.onCreate, _a = props.showClearAllButton, showClearAllButton = _a === void 0 ? false : _a, _b = props.showCreateButton, showCreateButton = _b === void 0 ? false : _b, _c = props.showExportButton, showExportButton = _c === void 0 ? false : _c, title = props.title;
    return (jsxs("div", __assign({ className: "even-table-container" }, { children: [jsxs("div", __assign({ className: "even-table-action-bar" }, { children: [jsx("span", __assign({ className: "even-table-action-bar-title" }, { children: title })), jsxs("div", __assign({ className: "even-table-action-bar-buttons" }, { children: [showExportButton ? (jsx(ExportCSVButton, { csvExportParams: csvExportParams, gridRef: gridRef })) : null, showClearAllButton ? jsx(ClearAllButton, { gridRef: gridRef }) : null, showCreateButton ? (jsx(EvenCreateNewButton, __assign({ onClick: onCreate }, { children: "Create" }))) : null] }))] })), isLoading ? jsx(LoadingState, {}) : children] })));
};

var BenchmarkReports = function (_a) {
    var link = _a.link;
    var action = useMemo(function () {
        return (jsx(EvenButton, __assign({ intent: Intent.SUCCESS, onClick: function () { return window.open(link, '_blank'); } }, { children: "Go to Reports" })));
    }, [link]);
    return (jsx(NonIdealLayout, __assign({ footer: jsxs(Fragment, { children: [jsx("span", { children: "For any questions get in touch with our support via" }), jsx("br", {}), jsx("a", __assign({ href: "mailto:partnersupport@engine.tech" }, { children: "partnersupport@engine.tech" }))] }) }, { children: jsx(NonIdealState, { action: action, description: jsx("span", { children: "Benchmark reports are analytics that we provide to our Financial Services Partners, allowing them to understand comparative performance against other Partners on our network." }), icon: jsx(FontAwesomeKitIcon, { color: colors.cistern, icon: KitIconNames.NullStateBenchmarkReport, size: "1x" }), title: jsx(Fragment, { children: jsx("strong", { children: "Benchmark Reports" }) }) }) })));
};

var ComingSoon = function (_a) {
    var text = _a.text, title = _a.title;
    return (jsx(Card, __assign({ className: "bp4-non-ideal-state", elevation: Elevation.TWO }, { children: jsx(NonIdealState, { description: text || "We're working hard on this feature. It will be coming soon!", icon: "build", title: title }) })));
};

var DemandCustomOffers = function (_a) {
    var sendEmail = _a.sendEmail, _b = _a.displayContactUs, displayContactUs = _b === void 0 ? true : _b;
    var action = useMemo(function () {
        if (!displayContactUs) {
            return jsx(Fragment, {});
        }
        return (jsx(ConfirmableAction, __assign({ cancelText: "Cancel", message: "After you submit your request, you will be contacted by our team for next steps.", okText: "Submit Request", title: "Contact Us", onOk: sendEmail }, { children: jsx(EvenButton, __assign({ intent: Intent.SUCCESS }, { children: "Contact Us" })) })));
    }, [displayContactUs, sendEmail]);
    return (jsx(NonIdealState, { action: action, description: jsx("span", { children: "Custom offers enable partners to stand up additional product offerings from outside the Even network. This includes additional first party offerings or custom offerings from partnerships. Please contact us for any questions or requests to set up custom offers." }), icon: jsx(FontAwesomeKitIcon, { color: colors.cistern, icon: KitIconNames.NullStateCustomOffers, size: "1x" }), title: jsx(Fragment, { children: jsx("strong", { children: "Custom Offers" }) }) }));
};

var DemandInvoices = function () {
    return (jsx(NonIdealState, { action: jsx(EvenAnchorButton, __assign({ href: "mailto:partnersupport@engine.tech", intent: "success", target: "_blank" }, { children: "Contact Us" })), description: jsx("span", { children: "We are currently working on adding this functionality to Control Center. In the meantime, let us know if you have any questions." }), icon: jsx(FontAwesomeKitIcon, { color: colors.cistern, icon: KitIconNames.NullStateWorkingOnPage, size: "1x" }), title: jsxs(Fragment, { children: [jsx("strong", { children: "Invoices" }), ", Coming Soon!"] }) }));
};

var ErrorState = function (props) {
    var _a = props.description, description = _a === void 0 ? 'Sorry, it seems an error has occurred. Please try again later. If the issue persists, kindly report the bug through the feedback form.' : _a;
    return (jsx(NonIdealState, { description: description, icon: jsx(FontAwesomeIcon, { color: colors.cistern, icon: faCircleExclamation }), title: "Uh oh!" }));
};

var FinancialServicesProduct = function (_a) {
    var onCreateNewClick = _a.onCreateNewClick, productName = _a.productName, showIntegrationCreateButton = _a.showIntegrationCreateButton;
    var action = useMemo(function () {
        if (showIntegrationCreateButton) {
            return jsx(EvenCreateNewButton, { onClick: function () { return onCreateNewClick(); } });
        }
        return jsx(Fragment, {});
    }, [onCreateNewClick, showIntegrationCreateButton]);
    var copy = useMemo(function () {
        if (showIntegrationCreateButton) {
            return "You don't have any ".concat(productName, " integrations yet. To get started\n            with ").concat(productName, ", select the button below to create your first\n            integration.");
        }
        return (jsxs(Fragment, { children: ["You don't have any ", productName, " integrations yet. To get started with\u00A0", productName, ", please contact\u00A0", jsx("a", __assign({ href: "mailto:partnersupport@engine.tech" }, { children: "partnersupport@engine.tech" })), "."] }));
    }, [showIntegrationCreateButton, productName]);
    return (jsx(NonIdealLayout, { children: jsx(NonIdealState, { action: action, description: jsx("span", { children: copy }), icon: jsx(FontAwesomeKitIcon, { color: colors.cistern, icon: KitIconNames.NullStateEmptyPage, size: "1x" }), title: jsxs("span", { children: [jsx("strong", { children: productName }), " Integrations"] }) }) }));
};

var LoadingState = function () {
    return (jsx("div", __assign({ className: "loading-wrapper" }, { children: jsx(Spinner, {}) })));
};

var styles$g = {"container":"NoData-module_container__FOkvs"};

var NoData = function (_a) {
    var className = _a.className, _b = _a.description, description = _b === void 0 ? 'No Data' : _b, size = _a.size;
    return (jsx("div", __assign({ className: classNames(styles$g.container, className) }, { children: jsx(NonIdealState, { description: description, icon: jsx(FontAwesomeKitIcon, { icon: KitIconNames.NullStateNoData, size: size }) }) })));
};

var SinglePayable = function (_a) {
    var action = _a.action;
    return (jsx(NonIdealState, { action: action, description: jsx("span", { children: "Please try signing out and back in. If that doesn't work, kindly\n          report the bug through Feedback form or control-center-requests slack\n          channel" }), icon: jsx(FontAwesomeIcon, { icon: faFileTimes, size: "2x" }), title: jsxs(Fragment, { children: [jsx("strong", { children: "Doh!" }), " Something went wrong."] }) }));
};

var useInputController = function (props) {
    var _a;
    var control = props.control, name = props.name, defaultValue = props.defaultValue, rules = props.rules, label = props.label, tooltip = props.tooltip, layout = props.layout, showAsterisk = props.showAsterisk, useFieldWrapper = props.useFieldWrapper, inputProps = __rest(props, ["control", "name", "defaultValue", "rules", "label", "tooltip", "layout", "showAsterisk", "useFieldWrapper"]);
    var _b = useController({ control: control, defaultValue: defaultValue, name: name, rules: rules }), _c = _b.field, value = _c.value, onChange = _c.onChange, fieldState = _b.fieldState;
    var error = (_a = fieldState.error) === null || _a === void 0 ? void 0 : _a.message;
    var fieldProps = {
        error: error,
        label: label,
        layout: layout,
        showAsterisk: showAsterisk || Boolean(rules === null || rules === void 0 ? void 0 : rules.required),
        tooltip: tooltip,
        useFieldWrapper: useFieldWrapper,
    };
    return {
        fieldProps: fieldProps,
        inputProps: inputProps,
        name: name,
        onChange: onChange,
        value: value,
    };
};

var makeInputController = function (Component) {
    return function (props) {
        var inputControllerProps = useInputController(props);
        return jsx(Component, __assign({}, inputControllerProps));
    };
};

var CheckboxController = function (props) {
    var _a = useInputController(props), fieldProps = _a.fieldProps, inputProps = _a.inputProps, value = _a.value, onChange = _a.onChange;
    return (jsx(Field, __assign({}, fieldProps, { children: jsx(Checkbox, __assign({ checked: value, onChange: onChange }, inputProps)) })));
};

var dateInputFormat$1 = function (date) {
    return DateTime.fromJSDate(date).toISODate();
};
var parseDate$1 = function (dateString) {
    if (dateString) {
        var date = DateTime.fromISO(dateString);
        if (date.isValid) {
            return date.toJSDate();
        }
    }
    return false;
};
var DateInputController = function (props) {
    var _a = useInputController(props), fieldProps = _a.fieldProps, inputProps = _a.inputProps, value = _a.value, onChange = _a.onChange;
    return (jsx(Field, __assign({}, fieldProps, { children: jsx(DateInput, __assign({}, inputProps, { formatDate: dateInputFormat$1, parseDate: parseDate$1, value: parseDate$1(value) || undefined, onChange: function (date) { return onChange(date ? dateInputFormat$1(date) : ''); } })) })));
};

var Input = function (props) {
    var ariaLabel = props.ariaLabel, disabled = props.disabled, formatValue = props.formatValue, inputRef = props.inputRef, onChange = props.onChange, onEnter = props.onEnter, onKeyDown = props.onKeyDown, _a = props.parseValue, parseValue = _a === void 0 ? function (value) { return value; } : _a, placeholder = props.placeholder, value = props.value;
    var _b = useState(), valueState = _b[0], setValueState = _b[1];
    var _c = useState(), parsedValue = _c[0], setParsedValue = _c[1];
    var updateValue = function (nextValue) {
        try {
            var nextParsedValue = parseValue(nextValue);
            setValueState(nextValue);
            setParsedValue(nextParsedValue);
            onChange === null || onChange === void 0 ? void 0 : onChange({
                parsedValue: nextParsedValue,
                value: nextValue,
            });
        }
        catch (e) {
            console.error('Parsing error: ', e);
        }
    };
    var handleInputChange = function (e) {
        updateValue(e.currentTarget.value);
    };
    var handleKeyDown = function (e) {
        if (e.key && e.key === 'Enter') {
            onEnter === null || onEnter === void 0 ? void 0 : onEnter();
        }
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown();
    };
    useEffect(function () {
        updateValue(String(value));
    }, [value]);
    return (jsxs("div", __assign({ className: classNames('input-wrapper', { disabled: disabled }) }, { children: [jsx("input", { ref: inputRef, "aria-label": ariaLabel, className: classNames(Classes.INPUT, 'input', {
                    invisible: formatValue,
                }), disabled: disabled, placeholder: placeholder, type: "string", value: valueState, onChange: handleInputChange, onKeyDown: handleKeyDown }), formatValue ? (jsx("div", __assign({ className: "formatted-value" }, { children: parsedValue ? formatValue(parsedValue) : '' }))) : null] })));
};

var PercentInput = function (_a) {
    var ariaLabel = _a.ariaLabel, _b = _a.mantissa, mantissa = _b === void 0 ? 4 : _b, disabled = _a.disabled, onChange = _a.onChange, value = _a.value;
    var _c = React.useState(value || ''), internalValue = _c[0], setInternalValue = _c[1];
    var _d = React.useState(null), error = _d[0], setError = _d[1];
    var handleValueChange = function (valueAsNumber, valueAsString) {
        if (disabled) {
            return;
        } // Skip validation if disabled
        setInternalValue(valueAsString); // Perserve the string value even if invalid
        if (isNaN(valueAsNumber)) {
            return;
        }
        var decimalMatch = valueAsString.match(/\.(\d+)/);
        if (decimalMatch && decimalMatch[1].length > mantissa) {
            setError("Value cannot have more than ".concat(mantissa, " decimal place").concat(mantissa > 1 ? 's' : ''));
            return;
        }
        if (valueAsNumber > 100) {
            setError("Value cannot exceed 100.".concat('0'.repeat(mantissa), "%"));
        }
        else {
            setError(null);
            var roundedValue = Number(valueAsNumber.toFixed(mantissa));
            onChange === null || onChange === void 0 ? void 0 : onChange(roundedValue);
        }
    };
    return (jsxs("div", __assign({ style: { display: 'flex', flexDirection: 'column' } }, { children: [jsx(NumericInput, { "aria-label": ariaLabel, disabled: disabled, majorStepSize: Math.pow(10, -mantissa + 1), max: 100, min: 0, minorStepSize: Math.pow(10, -mantissa), rightElement: jsx("span", __assign({ style: {
                        fontSize: '1em',
                        lineHeight: '1.8',
                        paddingRight: '8px',
                    } }, { children: "%" })), stepSize: Math.pow(10, -mantissa), value: disabled ? value : internalValue, onValueChange: handleValueChange }), !disabled && error && (jsx("span", __assign({ style: { color: 'red', fontSize: '12px', marginTop: '4px' } }, { children: error })))] })));
};

var SelectList = function (props) {
    var filteredItems = props.filteredItems, renderItem = props.renderItem;
    var _a = useState(200), maxItemsToDisplay = _a[0], setMaxItemsToDisplay = _a[1];
    var showLoadMore = maxItemsToDisplay < filteredItems.length;
    var memoFilteredItems = useMemo(function () {
        return filteredItems
            .slice(0, maxItemsToDisplay)
            .map(function (item, index) { return renderItem(item, index); });
    }, [filteredItems, maxItemsToDisplay]);
    if (filteredItems.length === 0) {
        return jsx("div", __assign({ className: "select-list-empty" }, { children: "No items found" }));
    }
    return (jsxs("div", __assign({ className: "select-list" }, { children: [memoFilteredItems, showLoadMore ? (jsx("div", __assign({ className: "select-list-show-more" }, { children: jsx(Button, __assign({ onClick: function () { return setMaxItemsToDisplay(maxItemsToDisplay + 200); } }, { children: "Show More" })) }))) : null] })));
};

var isSubAccount = function (subAccount) {
    return isObject(subAccount) && 'uuid' in subAccount;
};
var SubAccountMultiSelect = function (_a) {
    var _b = _a.accounts, accounts = _b === void 0 ? [] : _b, enableSubAccountsFromApi = _a.enableSubAccountsFromApi, _c = _a.showOnlyDemandSubAccounts, showOnlyDemandSubAccounts = _c === void 0 ? false : _c, _d = _a.showOnlySupplySubAccounts, showOnlySupplySubAccounts = _d === void 0 ? false : _d, subAccountsFromProps = _a.subAccounts, selectedItemsFromProps = _a.selectedItems, onChange = _a.onChange, multiSelectProps = __rest(_a, ["accounts", "enableSubAccountsFromApi", "showOnlyDemandSubAccounts", "showOnlySupplySubAccounts", "subAccounts", "selectedItems", "onChange"]);
    var accountIdsSet = new Set(accounts.map(function (_a) {
        var id = _a.id;
        return id;
    }));
    var _e = useState(), selectedItems = _e[0], setSelectedItems = _e[1];
    var subAccountsFromApi = useGetSubAccountsQuery({}, { enabled: enableSubAccountsFromApi }).data;
    var subAccounts = enableSubAccountsFromApi
        ? subAccountsFromApi
        : subAccountsFromProps;
    var filteredSubAccounts = useMemo(function () {
        return subAccounts === null || subAccounts === void 0 ? void 0 : subAccounts.filter(function (_a) {
            var accountId = _a.accountId, subAccountTypeKey = _a.subAccountTypeKey;
            var accountFilter = accountIdsSet.size
                ? accountIdsSet.has(accountId)
                : true;
            var supplyFilter = showOnlySupplySubAccounts
                ? subAccountTypeKey == SubAccountType.SupplySource
                : true;
            var demandFilter = showOnlyDemandSubAccounts
                ? subAccountTypeKey === SubAccountType.DemandSource
                : true;
            return accountFilter && supplyFilter && demandFilter;
        });
    }, [
        accountIdsSet.size,
        subAccounts === null || subAccounts === void 0 ? void 0 : subAccounts.length,
        showOnlySupplySubAccounts,
        showOnlyDemandSubAccounts,
    ]);
    var filteredSubAccountsUuids = useMemo(function () { return filteredSubAccounts === null || filteredSubAccounts === void 0 ? void 0 : filteredSubAccounts.map(function (_a) {
        var uuid = _a.uuid;
        return uuid;
    }); }, [filteredSubAccounts]);
    var setSelectedIds = function (ids) {
        var _a;
        var nextSubAccounts = (_a = subAccounts === null || subAccounts === void 0 ? void 0 : subAccounts.filter(function (_a) {
            var id = _a.id;
            return ids.includes(id);
        })) !== null && _a !== void 0 ? _a : [];
        setSelectedItems(nextSubAccounts);
        onChange === null || onChange === void 0 ? void 0 : onChange(nextSubAccounts);
    };
    var setSelectedUuids = function (uuids) {
        var _a;
        var nextSubAccounts = (_a = subAccounts === null || subAccounts === void 0 ? void 0 : subAccounts.filter(function (_a) {
            var uuid = _a.uuid;
            return uuids.includes(uuid);
        })) !== null && _a !== void 0 ? _a : [];
        setSelectedItems(nextSubAccounts);
        onChange === null || onChange === void 0 ? void 0 : onChange(nextSubAccounts);
    };
    useEffect(function () {
        if (!selectedItemsFromProps ||
            isEqual(selectedItemsFromProps, selectedItems)) {
            return;
        }
        if (selectedItemsFromProps.every(isNumber)) {
            setSelectedIds(selectedItemsFromProps);
        }
        else if (selectedItemsFromProps.every(isString)) {
            setSelectedUuids(selectedItemsFromProps);
        }
        else if (selectedItemsFromProps.every(isSubAccount)) {
            var allValidSubaccounts = selectedItemsFromProps.filter(function (subaccount) {
                return filteredSubAccountsUuids === null || filteredSubAccountsUuids === void 0 ? void 0 : filteredSubAccountsUuids.includes(subaccount.uuid);
            });
            setSelectedItems(allValidSubaccounts);
        }
    }, [selectedItemsFromProps]);
    return (jsx(MultiSelect, __assign({ resetOnSelect: true, itemListPredicate: function (query, items) {
            var filteredItems = items;
            if (query) {
                filteredItems = items.filter(function (_a) {
                    var name = _a.name;
                    return serialize(name).includes(serialize(query));
                });
            }
            return filteredItems;
        }, itemListRenderer: function (_a) {
            var filteredItems = _a.filteredItems, renderItem = _a.renderItem;
            return (jsx(SelectList, { filteredItems: filteredItems, renderItem: renderItem }));
        }, itemRemoveFilter: filterByUuid, itemRenderer: function (_a, props) {
            var name = _a.name, uuid = _a.uuid;
            return (jsx(SelectItem, __assign({ text: name }, props), uuid));
        }, items: sortBy(filteredSubAccounts, 'name'), itemsEqual: function (a, b) { return a.uuid === b.uuid; }, noResults: "No Sub Accounts Available", popoverProps: { minimal: true }, selectedItems: selectedItems, tagRenderer: function (_a) {
            var name = _a.name;
            return name;
        }, onChange: onChange }, multiSelectProps)));
};

var SubAccountSuggest = function (props) {
    var disabled = props.disabled, onItemSelect = props.onItemSelect, selectedItem = props.selectedItem, showOnlyDemandSubAccounts = props.showOnlyDemandSubAccounts, productType = props.productType, showOnlySupplySubAccounts = props.showOnlySupplySubAccounts;
    var query = useMemo(function () {
        if (showOnlyDemandSubAccounts) {
            if (productType) {
                return {
                    productType: productType,
                    subAccountTypeKey: SubAccountType.DemandSource,
                };
            }
            return { subAccountTypeKey: SubAccountType.DemandSource };
        }
        if (showOnlySupplySubAccounts) {
            return { subAccountTypeKey: SubAccountType.SupplySource };
        }
        return {};
    }, [showOnlyDemandSubAccounts, showOnlySupplySubAccounts]);
    var _a = useGetSubAccountsQuery(query).data, subAccounts = _a === void 0 ? [] : _a;
    return (jsx(Suggest2, { activeItem: selectedItem, disabled: disabled, inputValueRenderer: function (_a) {
            var name = _a.name;
            return name;
        }, itemListPredicate: function (query, items) {
            var filteredItems = items;
            if (query) {
                filteredItems = items.filter(function (_a) {
                    var name = _a.name;
                    return serialize$1(name).includes(serialize$1(query));
                });
            }
            return filteredItems;
        }, itemListRenderer: function (_a) {
            var filteredItems = _a.filteredItems, renderItem = _a.renderItem;
            return (jsx(SelectList, { filteredItems: filteredItems, renderItem: renderItem }));
        }, itemRenderer: function (_a, props) {
            var name = _a.name, uuid = _a.uuid;
            return (jsx(SelectItem, __assign({ text: name }, props), uuid));
        }, items: sortBy(subAccounts, 'name'), itemsEqual: "uuid", noResults: "No Sub Accounts Available", resetOnQuery: false, selectedItem: selectedItem, onItemSelect: onItemSelect }));
};

var HiddenInputController = function (_a) {
    var control = _a.control, name = _a.name, defaultValue = _a.defaultValue;
    return (jsx(Controller, { control: control, defaultValue: defaultValue, name: name, render: function (_a) {
            var field = _a.field;
            return (jsx("input", { hidden: true, "aria-label": name, value: field.value }));
        } }));
};

var InputController = function (props) {
    var _a = useInputController(props), fieldProps = _a.fieldProps, _b = _a.inputProps, copyable = _b.copyable, onCopy = _b.onCopy, inputProps = __rest(_b, ["copyable", "onCopy"]), value = _a.value, onChange = _a.onChange, name = _a.name;
    var handleCopy = function () { };
    return (jsx(Field, __assign({}, fieldProps, { children: jsxs("div", __assign({ style: {
                alignItems: 'flex-start',
                display: 'flex',
                gap: '10px',
                justifyContent: 'space-between',
            } }, { children: [jsx("div", __assign({ style: { flex: 'auto' } }, { children: jsx("input", __assign({}, inputProps, { "aria-label": name, value: value, onChange: onChange })) })), copyable ? (jsx("div", { children: jsx(CopyToClipboard, __assign({ text: value, onCopy: onCopy }, { children: jsx(Button, { icon: jsx(FontAwesomeIcon, { icon: faCopy }), onClick: handleCopy }) })) })) : null] })) })));
};

var makeId$1 = function () { return Math.random().toString(16).slice(2); };
var ListInputController = makeInputController(function (_a) {
    var inputProps = _a.inputProps, fieldProps = _a.fieldProps, onChange = _a.onChange, value = _a.value;
    var _b = useList([]), items = _b[0], _c = _b[1], push = _c.push, removeAt = _c.removeAt, updateAt = _c.updateAt, set = _c.set;
    var itemValues = items.map(function (item) { return item.value; });
    var itemsStr = itemValues.join(',');
    useEffect(function () {
        onChange(itemValues);
    }, [itemsStr]);
    useEffect(function () {
        if (Array.isArray(value) && itemValues.join(',') !== (value === null || value === void 0 ? void 0 : value.join(','))) {
            set(value === null || value === void 0 ? void 0 : value.map(function (itemValue) { return ({ id: makeId$1(), value: itemValue }); }));
        }
    }, [value === null || value === void 0 ? void 0 : value.join(',')]);
    return (jsx(Field, __assign({}, fieldProps, { children: jsx(Repeater, __assign({}, inputProps, { isCondensed: true, itemKey: function (item) { return item.id; }, itemNoun: "Item", itemRenderer: function (item, index) { return (jsx(Input, { value: item.value, onChange: function (_a) {
                    var parsedValue = _a.parsedValue;
                    return updateAt(index, { id: item.id, value: parsedValue });
                } })); }, items: items, onAdd: function () { return push({ id: makeId$1(), value: '' }); }, onRemove: removeAt })) })));
});

var MoneyInputController = function (props) {
    var _a = useInputController(props), fieldProps = _a.fieldProps, inputProps = _a.inputProps, value = _a.value, onChange = _a.onChange, name = _a.name;
    return (jsx(Field, __assign({}, fieldProps, { children: jsx(MoneyInput, __assign({}, inputProps, { ariaLabel: name, value: value, onChange: onChange })) })));
};

var MultiSelectController = function (props) {
    var _a = useInputController(props), fieldProps = _a.fieldProps, inputProps = _a.inputProps, value = _a.value, onChange = _a.onChange;
    return (jsx(Field, __assign({}, fieldProps, { children: jsx(MultiSelect, __assign({}, inputProps, { selectedItems: value, onChange: onChange })) })));
};

var NumericInputController = function (props) {
    var _a = useInputController(props), fieldProps = _a.fieldProps, inputProps = _a.inputProps, value = _a.value, onChange = _a.onChange, name = _a.name;
    var handleValueChange = function (valueAsNumber, valueAsString) {
        if (valueAsString === '') {
            onChange(undefined);
        }
        else {
            onChange(valueAsNumber);
        }
    };
    return (jsx(Field, __assign({}, fieldProps, { children: jsx(NumericInput, __assign({}, inputProps, { "aria-label": name, value: value !== null && value !== void 0 ? value : '', onChange: onChange, onValueChange: handleValueChange })) })));
};

var makeId = function () { return Math.random().toString(16).slice(2); };
var NumericListInputController = makeInputController(function (_a) {
    var inputProps = _a.inputProps, fieldProps = _a.fieldProps, onChange = _a.onChange, value = _a.value;
    var _b = useList([]), items = _b[0], _c = _b[1], push = _c.push, removeAt = _c.removeAt, updateAt = _c.updateAt, set = _c.set;
    var itemValues = items.map(function (item) { return item.value; });
    var itemsStr = itemValues.join(',');
    useEffect(function () {
        onChange(itemValues);
    }, [itemsStr]);
    useEffect(function () {
        if (Array.isArray(value) && itemValues.join(',') !== (value === null || value === void 0 ? void 0 : value.join(','))) {
            set(value.map(function (itemValue) { return ({
                id: makeId(),
                value: itemValue,
            }); }));
        }
    }, [value === null || value === void 0 ? void 0 : value.join(',')]);
    return (jsx(Field, __assign({}, fieldProps, { children: jsx(Repeater, __assign({}, inputProps, { isCondensed: true, itemKey: function (item) { return item.id; }, itemNoun: "Item", itemRenderer: function (item, index) { return (jsx(NumericInput, { value: item.value, onValueChange: function (valueAsNumber) {
                    return updateAt(index, {
                        id: item.id,
                        value: isNaN(valueAsNumber) ? 0 : valueAsNumber,
                    });
                } })); }, items: items, onAdd: function () { return push({ id: makeId(), value: 0 }); }, onRemove: removeAt })) })));
});

var PercentInputController = function (_a) {
    var _b;
    var control = _a.control, defaultValue = _a.defaultValue, label = _a.label, name = _a.name, required = _a.required, tooltip = _a.tooltip, disabled = _a.disabled, mantissa = _a.mantissa;
    var rules = {};
    if (required) {
        rules = { required: "".concat(name, " is required.") };
    }
    var _c = useController({
        control: control,
        defaultValue: defaultValue,
        name: name,
        rules: rules,
    }), field = _c.field, fieldState = _c.fieldState;
    return (jsx(Field, __assign({ error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, label: label, tooltip: tooltip }, { children: jsx(PercentInput, { ariaLabel: name, disabled: disabled, mantissa: mantissa, value: field.value, onChange: field.onChange }) })));
};

var SelectController = function (props) {
    var _a = useInputController(props), fieldProps = _a.fieldProps, inputProps = _a.inputProps, value = _a.value, onChange = _a.onChange;
    return (jsx(Field, __assign({}, fieldProps, { children: jsx(Select, __assign({}, inputProps, { activeItem: value, onItemSelect: onChange })) })));
};

var SubAccountSuggestController = function (props) {
    var _a = useInputController(props), fieldProps = _a.fieldProps, inputProps = _a.inputProps, value = _a.value, onChange = _a.onChange;
    return (jsx(Field, __assign({}, fieldProps, { children: jsx(SubAccountSuggest, __assign({}, inputProps, { selectedItem: value, onItemSelect: onChange })) })));
};

var SwitchController = function (props) {
    var _a = useInputController(props), fieldProps = _a.fieldProps, inputProps = _a.inputProps, value = _a.value, onChange = _a.onChange, name = _a.name;
    // Set to false by default
    useEffect(function () {
        if (value === undefined) {
            onChange(false);
        }
    }, []);
    return (jsx(Field, __assign({}, fieldProps, { children: jsx(Switch, __assign({ "aria-label": name, checked: value, onChange: onChange }, inputProps)) })));
};

var TextAreaController = function (props) {
    var _a = useInputController(props), fieldProps = _a.fieldProps, _b = _a.inputProps, copyable = _b.copyable, onCopy = _b.onCopy, inputProps = __rest(_b, ["copyable", "onCopy"]), value = _a.value, onChange = _a.onChange, name = _a.name;
    var handleCopy = function () { };
    return (jsx(Field, __assign({}, fieldProps, { children: jsxs("div", __assign({ style: {
                alignItems: 'flex-start',
                display: 'flex',
                gap: '10px',
                justifyContent: 'space-between',
            } }, { children: [jsx("div", __assign({ style: { flex: 'auto' } }, { children: jsx("textarea", __assign({}, inputProps, { "aria-label": name, value: value, onChange: onChange })) })), copyable ? (jsx("div", { children: jsx(CopyToClipboard, __assign({ text: value, onCopy: onCopy }, { children: jsx(Button, { icon: jsx(FontAwesomeIcon, { icon: faCopy }), onClick: handleCopy }) })) })) : null] })) })));
};

var styles$f = {"container":"DrawerForm-module_container__OWsal","actions":"DrawerForm-module_actions__yYPMP"};

var DrawerForm = function (_a) {
    var _b = _a.cancelText, cancelText = _b === void 0 ? 'Cancel' : _b, children = _a.children, className = _a.className, confirmationMessage = _a.confirmationMessage, _c = _a.disableCloseOnMouseDown, disableCloseOnMouseDown = _c === void 0 ? false : _c, _d = _a.isSubmitting, isSubmitting = _d === void 0 ? false : _d, onClose = _a.onClose, onSubmit = _a.onSubmit, requireConfirmation = _a.requireConfirmation, _e = _a.size, size = _e === void 0 ? DrawerSize.SMALL : _e, _f = _a.submitText, submitText = _f === void 0 ? 'Submit' : _f, _g = _a.submittingText, submittingText = _g === void 0 ? 'Submitting...' : _g, title = _a.title, visible = _a.visible;
    var handleClose = function (e) {
        if (disableCloseOnMouseDown && e.type === 'mousedown') {
            return;
        }
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var submittingContent = (jsxs("div", __assign({ style: { display: 'flex' } }, { children: [jsx("span", __assign({ style: { paddingRight: '10px' } }, { children: jsx(Spinner, { size: SpinnerSize.SMALL }) })), jsx("span", { children: submittingText })] })));
    var submitContent = isSubmitting ? submittingContent : submitText;
    return (jsx(Drawer, __assign({ className: className, isOpen: visible, size: size, title: title, onClose: handleClose }, { children: jsxs("form", __assign({ className: styles$f.container }, { children: [children, jsxs("div", __assign({ className: styles$f.actions }, { children: [requireConfirmation ? (jsx(ConfirmableAction, __assign({ message: confirmationMessage, onOk: onSubmit }, { children: jsx(EvenButton, __assign({ disabled: isSubmitting }, { children: submitContent })) }))) : (jsx(EvenButton, __assign({ disabled: isSubmitting, onClick: onSubmit }, { children: submitContent }))), jsx(EvenButton, __assign({ outlined: true, onClick: handleClose }, { children: cancelText }))] }))] })) })));
};

var MoneyField = function (_a) {
    var control = _a.control, name = _a.name, _b = _a.label, label = _b === void 0 ? 'Amount' : _b, rules = _a.rules;
    var labelSentenceCase = upperFirst(lowerCase(label));
    var defaultRule = { required: "".concat(labelSentenceCase, " is required.") };
    return (jsx(Controller, { control: control, name: name, render: function (_a) {
            var _b = _a.field, value = _b.value, onChange = _b.onChange, error = _a.fieldState.error;
            return (jsx(Field, __assign({ error: error === null || error === void 0 ? void 0 : error.message, label: label, tooltip: "".concat(labelSentenceCase, " in USD.") }, { children: jsx(MoneyInput, { ariaLabel: name, value: value, onChange: onChange }) })));
        }, rules: rules !== null && rules !== void 0 ? rules : defaultRule }));
};

var StringField = function (_a) {
    var name = _a.name, label = _a.label, control = _a.control, rules = _a.rules, tooltip = _a.tooltip, _b = _a.defaultValue, defaultValue = _b === void 0 ? '' : _b, disabled = _a.disabled;
    return (jsx(Controller, { control: control, name: name, render: function (_a) {
            var _b = _a.field, value = _b.value, onChange = _b.onChange, error = _a.fieldState.error;
            return (jsx(Field, __assign({ error: error === null || error === void 0 ? void 0 : error.message, label: label, tooltip: tooltip }, { children: jsx("input", { "aria-label": name, className: Classes.INPUT, defaultValue: defaultValue, disabled: disabled, value: value ? value : defaultValue, onChange: onChange }) })));
        }, rules: rules }));
};

var Labels;
(function (Labels) {
    Labels["ADB_COST"] = "ADB Cost";
    Labels["BASE_PERCENT"] = "Default Percent %";
    Labels["CAMPAIGN_DATE"] = "Campaign Date";
    Labels["COST"] = "Amount";
    Labels["DEFAULT_COST"] = "Default Amount";
    Labels["DEMAND_SUB_ACCOUNT"] = "Demand Sub Account";
    Labels["DEMAND_SUB_ACCOUNT_ID"] = "Demand Sub Account ID";
    Labels["EFFECTIVE_AT"] = "Effective At";
    Labels["OFFER_ID"] = "Offer ID";
    Labels["PERCENT"] = "Percent %";
    Labels["PRICING_MODEL"] = "Pricing Model";
    Labels["PROCESSING_FEE_PERCENT"] = "Processing Fee %";
    Labels["REVENUE_SHARE_PERCENT"] = "Revenue Share %";
    Labels["SALESFORCE_OPPORTUNITY_LINK"] = "Salesforce Opportunity Link";
    Labels["SHARE"] = "Share %";
    Labels["SUB_ACCOUNT"] = "Sub Account";
    Labels["SUB_ID_KEY"] = "Sub ID Key";
    Labels["SUB_ID_VALUE"] = "Sub ID Value";
})(Labels || (Labels = {}));
var Tooltips;
(function (Tooltips) {
    Tooltips["REVENUE_SHARE"] = "Revenue share % is applied to the payout after deducting the processing fees. Please see the tooltip for Processing fee % for detailed example on how this works.";
})(Tooltips || (Tooltips = {}));

var creditRatings = ['excellent', 'fair', 'good', 'poor', 'limited'];
var deviceTypes = ['desktop', 'mobile'];
var scores = [
    [1, 'one'],
    [2, 'two'],
    [3, 'three'],
    [4, 'four'],
    [5, 'five'],
    [6, 'six'],
];
var creditRatingsAndDeviceTypes = creditRatings.flatMap(function (creditRating) {
    return deviceTypes.map(function (deviceType) { return "".concat(creditRating).concat(upperFirst(deviceType)); });
});
var dateInputFormat = function (date) {
    return DateTime.fromJSDate(date).toISODate();
};
var parseDate = function (dateString) {
    if (dateString) {
        var date = DateTime.fromISO(dateString);
        if (date.isValid) {
            return date.toJSDate();
        }
    }
    return false;
};
var matchesDate = function (date1, date2) {
    if (date1 && date2) {
        var parsedDate1 = DateTime.fromISO(date1).toISODate();
        var parsedDate2 = DateTime.fromISO(date2).toISODate();
        return parsedDate1 === parsedDate2;
    }
    return false;
};
var subIdKeyRules = { required: "".concat(Labels.SUB_ID_KEY, " is required.") };
var salesforceUrlPattern = /^https:\/\/enginebymoneylion\.lightning\.force\.com\/lightning\/r\/Opportunity\/[A-Za-z0-9]{15}(?:[A-Za-z0-9]{3})?\/view$/;
var salesforceUrlValidator = function (url, contractType) {
    if (!url) {
        if (contractType === 'supply') {
            return "".concat(Labels.SALESFORCE_OPPORTUNITY_LINK, " is required.");
        }
        return;
    }
    if (!salesforceUrlPattern.test(url)) {
        return "Must be a valid Salesforce URL: https://enginebymoneylion.lightning.force.com/lightning/r/Opportunity/<id>/view";
    }
};
var effectiveAtValidator = function (effectiveAt, currentEffectiveAt) {
    if (!effectiveAt) {
        return 'Effective date is required.';
    }
    if (!DateTime.fromFormat(effectiveAt, 'yyyy-MM-dd').isValid) {
        return 'Effective date must be formatted as YYYY-MM-DD.';
    }
    if (matchesDate(effectiveAt, currentEffectiveAt)) {
        return 'Effective date already exists for a previous supply contract.';
    }
};
var getFieldNames = function (basePath) {
    var field = function (name) { return "".concat(basePath, ".").concat(name); };
    return {
        ADB_COST_NAME: field('adbCost'),
        BASE_PERCENTAGE_NAME: field('basePercentage'),
        CAMPAIGN_DATE_NAME: field('campaignDate'),
        COST_NAME: field('cost'),
        COST_PER_DEMAND_SUB_ACCOUNT_ID_NAME: field('costPerDemandSubAccountId'),
        COST_PER_OFFER_ID_NAME: field('costPerOfferId'),
        COST_PER_VALUE_NAME: field('costPerValue'),
        DEFAULT_COST_NAME: field('defaultCost'),
        DEMAND_EXCLUSIONS_NAME: field('excludedDemandSubAccountIds'),
        KEY_NAME: field('key'),
        PERCENT_BY_DEMAND_SUB_ACCOUNT_ID_NAME: field('percentByDemandSubAccountId'),
        PERCENT_NAME: field('percent'),
        SHARE_NAME: field('share'),
        SUB_ID_KEY_NAME: field('subIdKey'),
    };
};

var calculatePayout = function (inputData) {
    var threshold = inputData.threshold, revenueAmount = inputData.revenueAmount, fundedAmount = inputData.fundedAmount, demandPlatformFeePercent = inputData.demandPlatformFeePercent, thresholdNetworkPayoutPercent = inputData.thresholdNetworkPayoutPercent, networkPayoutPercent = inputData.networkPayoutPercent;
    if (threshold !== undefined) {
        return calculateThresholdPayout({
            demandPlatformFeePercent: demandPlatformFeePercent,
            fundedAmount: fundedAmount,
            networkPayoutPercent: networkPayoutPercent,
            threshold: threshold,
            thresholdNetworkPayoutPercent: thresholdNetworkPayoutPercent,
        });
    }
    else if (revenueAmount !== undefined) {
        return calculateFixedAmountPayout({
            demandPlatformFeePercent: demandPlatformFeePercent,
            revenueAmount: revenueAmount,
        });
    }
    else {
        return calculatePercentagePayout({
            demandPlatformFeePercent: demandPlatformFeePercent,
            fundedAmount: fundedAmount,
            networkPayoutPercent: networkPayoutPercent,
        });
    }
};
var calculateFixedAmountPayout = function (inputData) {
    var revenueAmount = toNumber(inputData.revenueAmount);
    var demandPlatformFeePercent = toNumber(inputData.demandPlatformFeePercent);
    var demandPlatformFee = revenueAmount * (demandPlatformFeePercent / 100);
    return {
        demandPlatformFee: demandPlatformFee,
        revenueAmount: revenueAmount,
        totalReceivable: revenueAmount + demandPlatformFee,
    };
};
var calculatePercentagePayout = function (inputData) {
    var fundedAmount = toNumber(inputData.fundedAmount);
    var networkPayoutPercent = toNumber(inputData.networkPayoutPercent);
    var demandPlatformFeePercent = toNumber(inputData.demandPlatformFeePercent);
    var networkPayout = fundedAmount * (networkPayoutPercent / 100);
    var demandPlatformFee = networkPayout * (demandPlatformFeePercent / 100);
    return {
        demandPlatformFee: demandPlatformFee,
        networkPayout: networkPayout,
        totalReceivable: networkPayout + demandPlatformFee,
    };
};
var calculateThresholdPayout = function (inputData) {
    var threshold = toNumber(inputData.threshold);
    var fundedAmount = toNumber(inputData.fundedAmount);
    var networkPayoutPercent = toNumber(inputData.networkPayoutPercent);
    var demandPlatformFeePercent = toNumber(inputData.demandPlatformFeePercent);
    var thresholdNetworkPayoutPercent = toNumber(inputData.thresholdNetworkPayoutPercent);
    var underThresholdCalc;
    var overThresholdCalc;
    if (Number(threshold) <= Number(fundedAmount)) {
        underThresholdCalc = threshold * (networkPayoutPercent / 100);
        overThresholdCalc =
            (fundedAmount - threshold) * (thresholdNetworkPayoutPercent / 100);
    }
    else {
        underThresholdCalc = fundedAmount * (networkPayoutPercent / 100);
        overThresholdCalc = 0;
    }
    var thresholdNetworkPayout = underThresholdCalc + overThresholdCalc;
    var demandPlatformFee = thresholdNetworkPayout * (demandPlatformFeePercent / 100);
    var totalReceivable = thresholdNetworkPayout + demandPlatformFee;
    return {
        demandPlatformFee: demandPlatformFee,
        thresholdNetworkPayout: thresholdNetworkPayout,
        totalReceivable: totalReceivable,
    };
};

var formatDollars = function (value) {
    var num = Number(value);
    if (isNaN(num)) {
        return '$0';
    }
    return numeral(num).format(num % 1 === 0 ? '$0,0' : '$0,0.0000');
};
var FeePreviewExample = function (_a) {
    var title = _a.title, example = _a.example, fundedAmount = _a.fundedAmount, isFetching = _a.isFetching, _b = _a.className, className = _b === void 0 ? '' : _b;
    if (!example) {
        return null;
    }
    return (jsx("div", __assign({ className: "fee-preview ".concat(isFetching ? 'fee-preview-loading' : '', " ").concat(className) }, { children: jsxs("div", __assign({ className: "fee-preview-row" }, { children: [jsxs("div", __assign({ className: "fee-preview-title" }, { children: [title, ' ', isFetching && (jsx(FontAwesomeIcon, { pulse: true, color: colors.themeGray7, icon: faCircleNotch, size: "xs" }))] })), jsx("div", __assign({ className: "fee-preview-item" }, { children: jsx(Tooltip2, __assign({ content: "Example Bid Amount" }, { children: jsxs("span", { children: ["Ex Bid ", formatDollars(fundedAmount)] }) })) })), jsx(FontAwesomeIcon, { color: colors.themeGray7, icon: faPipe, size: "xs" }), jsx("div", __assign({ className: "fee-preview-item" }, { children: jsx(Tooltip2, __assign({ content: "Network Payout" }, { children: jsxs("span", { children: ["NP ", formatDollars(example.networkPayout)] }) })) })), jsx(FontAwesomeIcon, { color: colors.themeGray7, icon: faPipe, size: "xs" }), jsx("div", __assign({ className: "fee-preview-item" }, { children: jsx(Tooltip2, __assign({ content: "Demand Platform Fee" }, { children: jsxs("span", { children: ["DPF ", formatDollars(example.demandPlatformFee)] }) })) })), jsx(FontAwesomeIcon, { color: colors.themeGray7, icon: faPipe, size: "xs" }), jsx("div", __assign({ className: "fee-preview-item" }, { children: jsx(Tooltip2, __assign({ content: "Total Receivable" }, { children: jsxs("span", { children: ["TR ", formatDollars(example.demandReceivable)] }) })) }))] })) })));
};

var FeePreview = function (props) {
    var costPerText = props.costPerText, demandPlatformFeePercent = props.demandPlatformFeePercent, demandReceivable = props.demandReceivable, _a = props.fundedAmount, fundedAmount = _a === void 0 ? 10000 : _a, networkPayoutPercent = props.networkPayoutPercent, revenueAmount = props.revenueAmount, _b = props.supplySubAccountId, supplySubAccountId = _b === void 0 ? 1 : _b, threshold = props.threshold, thresholdNetworkPayoutPercent = props.thresholdNetworkPayoutPercent;
    var _c = calculatePayout({
        demandPlatformFeePercent: demandPlatformFeePercent,
        fundedAmount: fundedAmount,
        networkPayoutPercent: networkPayoutPercent,
        revenueAmount: revenueAmount,
        threshold: threshold,
        thresholdNetworkPayoutPercent: thresholdNetworkPayoutPercent,
    }), demandPlatformFee = _c.demandPlatformFee, networkPayout = _c.networkPayout, thresholdNetworkPayout = _c.thresholdNetworkPayout, totalReceivable = _c.totalReceivable;
    var watch = useFormContext().watch;
    var body = watch();
    var _d = useState(body), debouncedBody = _d[0], setDebouncedBody = _d[1];
    useDebounce(function () {
        setDebouncedBody(body);
    }, 250, [body]);
    var _e = useSampleDemandContractFinancials({
        amount: parseFloat(String(fundedAmount)),
        supplySubAccountId: String(supplySubAccountId || 1),
    }, debouncedBody), sampleDemandContractFinancials = _e.data, isFetching = _e.isFetching;
    var _f = sampleDemandContractFinancials !== null && sampleDemandContractFinancials !== void 0 ? sampleDemandContractFinancials : {}, networkPayoutExample = _f.networkPayoutExample, demandReceivableExample = _f.demandReceivableExample;
    if (demandReceivable) {
        return (jsxs(Fragment, { children: [jsx(FeePreviewExample, { example: demandReceivableExample, fundedAmount: fundedAmount, isFetching: isFetching, title: "DPF Active" }), jsx(FeePreviewExample, { example: networkPayoutExample, fundedAmount: fundedAmount, isFetching: isFetching, title: "DPF Obsolete" })] }));
    }
    return (jsxs("div", __assign({ className: "fee-preview" }, { children: [jsxs("span", { children: ["Example Funded Amount: ", numeral(fundedAmount).format('$0,0')] }), Boolean(networkPayout) && (jsxs("span", { children: [" Network Payout: ", numeral(networkPayout).format('$0,0')] })), Boolean(revenueAmount) && (jsxs("span", { children: [costPerText, ": ", numeral(revenueAmount).format('$0,0')] })), Boolean(thresholdNetworkPayout) && (jsxs("span", { children: ["Threshold Network Payout:", numeral(thresholdNetworkPayout).format('$0,0')] })), Boolean(demandPlatformFee) && (jsxs("span", { children: ["Demand Platform Fee: ", numeral(demandPlatformFee).format('$0,0')] })), Boolean(totalReceivable) && (jsxs("span", { children: ["Total Receivable: ", numeral(totalReceivable).format('$0,0')] }))] })));
};

var round = function (value) {
    var valueAsNumber = Number(value);
    var percentValue = valueAsNumber;
    return Math.round(percentValue * 1e10) / 1e10; // Round to 10 decimal places to avoid floating point errors
};
var calculateTotalReceivablePercent = function (maybePercent, maybeDemandPlatformFeePercent) {
    var percent = toNumber(maybePercent);
    var demandPlatformFeePercent = toNumber(maybeDemandPlatformFeePercent);
    if (isNaN(percent) || isNaN(demandPlatformFeePercent)) {
        return undefined; // Explicitly return undefined if either value is not a number.
    }
    var percentageOfTotalReceivable = percent * (demandPlatformFeePercent / 100);
    var result = percent + percentageOfTotalReceivable;
    return result !== undefined ? round(result) : undefined;
};

// @TODO: investigate if this returns "3" for 3% or "0.03" for 3%. it should be the latter.
var formatPercent = function (value) {
    return value !== undefined
        ? (Math.round((Number(value) / 100 + Number.EPSILON) * 1e4) / 1e4).toString()
        : '0';
};
var getDemandPlatformFeeConfig = function (revenueClause, isDemandReceivablesEnabled) {
    var cost = revenueClause.cost, demandPlatformFeePercent = revenueClause.demandPlatformFeePercent, percentByFundedLoanAmount = revenueClause.percentByFundedLoanAmount, percentBySupplySubAccountId = revenueClause.percentBySupplySubAccountId, costPerSupplySubAccountId = revenueClause.costPerSupplySubAccountId, totalReceivablePercent = revenueClause.totalReceivablePercent;
    var tiers = {};
    var supplySubAccounts = {};
    var getDefaultPercentOf = function (fallback) {
        if (fallback === void 0) { fallback = DemandPlatformFeeConfigPercentOf.NetworkPayout; }
        return isDemandReceivablesEnabled
            ? DemandPlatformFeeConfigPercentOf.DemandReceivable
            : fallback;
    };
    percentByFundedLoanAmount === null || percentByFundedLoanAmount === void 0 ? void 0 : percentByFundedLoanAmount.forEach(function (_a) {
        var key = _a.key, demandPlatformFeePercent = _a.demandPlatformFeePercent;
        if (key) {
            tiers[key] = {
                configType: DemandPlatformFeeConfigType.PercentageOf,
                percent: formatPercent(demandPlatformFeePercent),
            };
        }
    });
    percentBySupplySubAccountId === null || percentBySupplySubAccountId === void 0 ? void 0 : percentBySupplySubAccountId.forEach(function (_a) {
        var key = _a.key, demandPlatformFeePercent = _a.demandPlatformFeePercent;
        if (key) {
            supplySubAccounts[key] = {
                configType: DemandPlatformFeeConfigType.PercentageOf,
                percent: formatPercent(demandPlatformFeePercent),
            };
        }
    });
    costPerSupplySubAccountId === null || costPerSupplySubAccountId === void 0 ? void 0 : costPerSupplySubAccountId.forEach(function (_a) {
        var key = _a.key, demandPlatformFeePercent = _a.demandPlatformFeePercent;
        if (key) {
            supplySubAccounts[key] = {
                configType: DemandPlatformFeeConfigType.PercentageOf,
                percent: formatPercent(demandPlatformFeePercent),
            };
        }
    });
    if (percentByFundedLoanAmount) {
        return {
            config: {
                configType: DemandPlatformFeeConfigType.Tiered,
                defaultTier: {
                    configType: DemandPlatformFeeConfigType.PercentageOf,
                    percent: formatPercent(demandPlatformFeePercent),
                },
                tiers: tiers,
            },
            percentOf: getDefaultPercentOf(DemandPlatformFeeConfigPercentOf.FinancialProductMonetaryValue),
        };
    }
    if (percentBySupplySubAccountId) {
        return {
            config: {
                configType: DemandPlatformFeeConfigType.SupplySubAccount,
                default: {
                    configType: DemandPlatformFeeConfigType.PercentageOf,
                    percent: formatPercent(demandPlatformFeePercent),
                },
                supplySubAccounts: supplySubAccounts,
            },
            percentOf: getDefaultPercentOf(),
        };
    }
    if (costPerSupplySubAccountId) {
        return {
            config: {
                configType: DemandPlatformFeeConfigType.SupplySubAccount,
                default: {
                    configType: DemandPlatformFeeConfigType.PercentageOf,
                    percent: formatPercent(demandPlatformFeePercent),
                },
                supplySubAccounts: supplySubAccounts,
            },
            percentOf: getDefaultPercentOf(),
        };
    }
    if (cost && demandPlatformFeePercent && totalReceivablePercent) {
        return {
            config: {
                configType: DemandPlatformFeeConfigType.PercentageOf,
                percent: formatPercent(demandPlatformFeePercent),
            },
            percentOf: getDefaultPercentOf(),
        };
    }
    if (demandPlatformFeePercent) {
        return {
            config: {
                configType: DemandPlatformFeeConfigType.PercentageOf,
                percent: formatPercent(demandPlatformFeePercent),
            },
            percentOf: getDefaultPercentOf(),
        };
    }
    return {
        config: {
            configType: DemandPlatformFeeConfigType.PercentageOf,
            percent: '0',
        },
        percentOf: getDefaultPercentOf(),
    };
};

var getRevenueClauseInputNames = function (index) {
    var baseName = "revenueClauses.".concat(index);
    return {
        basePercentInputName: "".concat(baseName, ".basePercent"),
        basePercentageInputName: "".concat(baseName, ".basePercentage"),
        costInputName: "".concat(baseName, ".cost"),
        costPerOfferIdInputName: "".concat(baseName, ".costPerOfferId"),
        costPerSubAccountIdInputName: "".concat(baseName, ".costPerSubAccountId"),
        costPerSupplySubAccountIdInputName: "".concat(baseName, ".costPerSupplySubAccountId"),
        defaultCostInputName: "".concat(baseName, ".defaultCost"),
        demandPlatformFeePercentInputName: "".concat(baseName, ".demandPlatformFeePercent"),
        flatFeeInputName: "".concat(baseName, ".flatFee"),
        marginalPercentInputName: "".concat(baseName, ".marginalPercent"),
        maxPercentInputName: "".concat(baseName, ".maxPercent"),
        percent: "".concat(baseName, ".percent"),
        percentByFundedLoanAmountInputName: "".concat(baseName, ".percentByFundedLoanAmount"),
        percentBySupplySubAccountIdInputName: "".concat(baseName, ".percentBySupplySubAccountId"),
        percentInputName: "".concat(baseName, ".percent"),
        revenueClauseInputName: "".concat(baseName),
        thresholdInputName: "".concat(baseName, ".threshold"),
        totalReceivablePercentInputName: "".concat(baseName, ".totalReceivablePercent"),
    };
};

var labels = {
    amount: 'Amount (USD)',
    defaultAmount: 'Default Amount (USD)',
    defaultDemandPlatformFeePercent: 'Default Demand Platform Fee %',
    defaultPercent: 'Default Percent %',
    defaultTotalReceivable: 'Default Total Receivable (USD)',
    defaultTotalReceivablePercent: 'Default Total Receivable %',
    demandPlatformFeePercent: 'Demand Platform Fee %',
    networkPayoutPercent: 'Network Payout Percent %',
    percent: 'Percent %',
    totalReceivable: 'Total Receivable (USD)',
    totalReceivablePercent: 'Total Receivable %',
};

var tooltips = {
    amount: 'The amount the Demand Partner owes per conversion, excluding any fees.',
    demandPlatformFeePercent: 'In this field please enter the Platform fees % signed with the partner in legal agreement.',
    networkPayoutPercent: 'This field will be used to calculate Supply partner payout and the recommendation score.',
    totalReceivable: 'This field indicates the total amount Demand Partners owe us inclusive of Platform fees. It will be calculated automatically based on the values entered in Network Payout Percent and Demand Platform Fee Percent fields.',
    totalReceivablePercent: 'This field indicates the total amount Demand Partners owe us inclusive of Platform fees.',
};

var CostField = function (_a) {
    var name = _a.name, label = _a.label;
    var control = useFormContext().control;
    return (jsx(MoneyInputController, { control: control, label: label !== null && label !== void 0 ? label : labels.amount, name: name, tooltip: tooltips.amount }));
};

var DefaultCostField = function (_a) {
    var name = _a.name;
    var control = useFormContext().control;
    return (jsx(MoneyInputController, { control: control, label: labels.defaultAmount, name: name, tooltip: tooltips.amount }));
};

var DefaultDemandPlatformFeePercentField = function (_a) {
    var name = _a.name;
    var control = useFormContext().control;
    return (jsx(PercentInputController, { control: control, label: labels.defaultDemandPlatformFeePercent, name: name, tooltip: tooltips.demandPlatformFeePercent }));
};

var DefaultNetworkPayoutPercentField = function (_a) {
    var name = _a.name;
    var control = useFormContext().control;
    return (jsx(PercentInputController, { control: control, label: "Default Network Payout Percent %", name: name, tooltip: tooltips.networkPayoutPercent }));
};

var DemandPlatformFeePercentField = function (_a) {
    var name = _a.name;
    var control = useFormContext().control;
    return (jsx(PercentInputController, { control: control, label: labels.demandPlatformFeePercent, name: name, tooltip: tooltips.demandPlatformFeePercent }));
};

var NetworkPayoutPercentField = function (_a) {
    var name = _a.name;
    var control = useFormContext().control;
    return (jsx(PercentInputController, { control: control, label: labels.networkPayoutPercent, name: name, tooltip: tooltips.networkPayoutPercent }));
};

var OfferIdField = function (_a) {
    var name = _a.name;
    var control = useFormContext().control;
    return jsx(InputController, { control: control, label: "Offer ID", name: name });
};

var PercentField = function (_a) {
    var name = _a.name;
    var control = useFormContext().control;
    return (jsx(PercentInputController, { control: control, label: labels.percent, name: name }));
};

var SubAccountIdField = function (_a) {
    var name = _a.name;
    var control = useFormContext().control;
    return (jsx(Controller, { control: control, name: name, render: function (_a) {
            var field = _a.field;
            return (jsx(Field, __assign({ label: "Sub Account ID" }, { children: jsx("input", { value: field.value, onChange: field.onChange }) })));
        } }));
};

var SupplySubAccountIdField = function (_a) {
    var name = _a.name;
    return (jsx(NumericInputController, { allowNumericCharactersOnly: true, fill: true, label: "Supply Sub Account ID", min: 0, name: name }));
};

var TotalReceivableAmountField = function (_a) {
    var name = _a.name, amount = _a.amount, demandPlatformFeePercent = _a.demandPlatformFeePercent, label = _a.label;
    var _b = useFormContext(), control = _b.control, setValue = _b.setValue;
    useEffect(function () {
        var totalReceivable = calculateTotalReceivablePercent(amount, demandPlatformFeePercent);
        setValue(name, totalReceivable);
    }, [amount, demandPlatformFeePercent]);
    return (jsx(MoneyInputController, { disabled: true, control: control, label: label !== null && label !== void 0 ? label : labels.totalReceivable, name: name, tooltip: tooltips.totalReceivable }));
};

var LegacyTotalReceivablePercentField = function (_a) {
    var name = _a.name, percent = _a.percent, label = _a.label, demandPlatformFeePercent = _a.demandPlatformFeePercent;
    var _b = useFormContext(), control = _b.control, setValue = _b.setValue;
    useEffect(function () {
        var totalReceivable = calculateTotalReceivablePercent(percent, demandPlatformFeePercent);
        setValue(name, totalReceivable);
    }, [percent, demandPlatformFeePercent]);
    return (jsx(PercentInputController, { disabled: true, control: control, label: label !== null && label !== void 0 ? label : labels.totalReceivablePercent, name: name, tooltip: tooltips.totalReceivable }));
};
var TotalReceivablePercentField = function (_a) {
    var name = _a.name;
    var control = useFormContext().control;
    return (jsx(PercentInputController, { control: control, label: labels.totalReceivablePercent, name: name, tooltip: tooltips.totalReceivablePercent }));
};

var CostPerLoanFieldGroup = function (_a) {
    var index = _a.index, costPerText = _a.costPerText;
    var _b = getRevenueClauseInputNames(index), costInputName = _b.costInputName, demandPlatformFeePercentInputName = _b.demandPlatformFeePercentInputName, totalReceivablePercentInputName = _b.totalReceivablePercentInputName;
    var watch = useFormContext().watch;
    var amount = watch(costInputName);
    var demandPlatformFeePercent = watch(demandPlatformFeePercentInputName);
    return (jsxs(Fragment, { children: [jsx(CostField, { name: costInputName }), jsx(DemandPlatformFeePercentField, { name: demandPlatformFeePercentInputName }), jsx(TotalReceivableAmountField, { amount: amount, demandPlatformFeePercent: demandPlatformFeePercent, name: totalReceivablePercentInputName }), jsx(FeePreview, { costPerText: costPerText, demandPlatformFeePercent: demandPlatformFeePercent, revenueAmount: amount })] }));
};

var LegacyCostPerLoanFundedBySupplySubAccountIdFieldGroup = function (_a) {
    var index = _a.index;
    var _b = useFormContext(), control = _b.control, watch = _b.watch;
    var _c = getRevenueClauseInputNames(index), costPerSupplySubAccountIdInputName = _c.costPerSupplySubAccountIdInputName, defaultCostInputName = _c.defaultCostInputName, demandPlatformFeePercentInputName = _c.demandPlatformFeePercentInputName, totalReceivablePercentInputName = _c.totalReceivablePercentInputName;
    var amount = watch(defaultCostInputName);
    var demandPlatformFeePercent = watch(demandPlatformFeePercentInputName);
    return (jsxs(Fragment, { children: [jsx(DefaultCostField, { name: defaultCostInputName }), jsx(DefaultDemandPlatformFeePercentField, { name: demandPlatformFeePercentInputName }), jsx(TotalReceivableAmountField, { amount: amount, demandPlatformFeePercent: demandPlatformFeePercent, label: labels.defaultTotalReceivable, name: totalReceivablePercentInputName }), jsx(FeePreview, { costPerText: "NP", demandPlatformFeePercent: demandPlatformFeePercent, revenueAmount: amount }), jsx(RepeaterController, { control: control, defaultValue: { demandPlatformFeePercent: '', key: '', value: '' }, itemRenderer: function (field, index) { return (jsxs(Fragment$1, { children: [jsx(SupplySubAccountIdField, { name: "".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".key") }), jsx(CostField, { name: "".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".value") }), jsx(DemandPlatformFeePercentField, { name: "".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".demandPlatformFeePercent") }), jsx(TotalReceivableAmountField, { amount: watch("".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".value")), demandPlatformFeePercent: watch("".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".demandPlatformFeePercent")), name: "".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".totalReceivablePercent") }), jsx(FeePreview, { demandPlatformFeePercent: toNumber(watch("".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".demandPlatformFeePercent"))), networkPayoutPercent: toNumber(watch("".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".value"))) })] }, field)); }, name: costPerSupplySubAccountIdInputName })] }));
};
var CostPerLoanFundedBySupplySubAccountIdFieldGroup = function (_a) {
    var index = _a.index;
    var _b = useFormContext(), control = _b.control, watch = _b.watch, getValues = _b.getValues, setValue = _b.setValue;
    var _c = getRevenueClauseInputNames(index), costPerSupplySubAccountIdInputName = _c.costPerSupplySubAccountIdInputName, defaultCostInputName = _c.defaultCostInputName, demandPlatformFeePercentInputName = _c.demandPlatformFeePercentInputName;
    var amount = watch(defaultCostInputName);
    var demandPlatformFeePercent = watch(demandPlatformFeePercentInputName);
    useEffect(function () {
        var costPerSupplySubAccountId = getValues(costPerSupplySubAccountIdInputName);
        if (costPerSupplySubAccountId === undefined) {
            setValue(costPerSupplySubAccountIdInputName, []);
        }
    });
    return (jsxs(Fragment, { children: [jsx(DefaultCostField, { name: defaultCostInputName }), jsx(DefaultDemandPlatformFeePercentField, { name: demandPlatformFeePercentInputName }), jsx(FeePreview, { demandReceivable: true, demandPlatformFeePercent: demandPlatformFeePercent, fundedAmount: 10, revenueAmount: amount }), jsx(RepeaterController, { control: control, defaultValue: { key: 0, value: 0 }, itemRenderer: function (field, index) { return (jsxs(Fragment$1, { children: [jsx(SupplySubAccountIdField, { name: "".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".key") }), jsx(CostField, { name: "".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".value") }), jsx(DemandPlatformFeePercentField, { name: "".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".demandPlatformFeePercent") }), jsx(FeePreview, { demandReceivable: true, demandPlatformFeePercent: toNumber(watch("".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".demandPlatformFeePercent"))), fundedAmount: watch("".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".value")), supplySubAccountId: watch("".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".key")) })] }, field)); }, name: costPerSupplySubAccountIdInputName })] }));
};

var CostPerOfferIdFieldGroup = function (_a) {
    var index = _a.index;
    var control = useFormContext().control;
    var _b = getRevenueClauseInputNames(index), defaultCostInputName = _b.defaultCostInputName, costPerOfferIdInputName = _b.costPerOfferIdInputName;
    return (jsxs(Fragment, { children: [jsx(DefaultCostField, { name: defaultCostInputName }), jsx(RepeaterController, { control: control, defaultValue: {}, itemRenderer: function (id, index) { return (jsxs(Fragment$1, { children: [jsx(OfferIdField, { name: "".concat(costPerOfferIdInputName, ".").concat(index, ".key") }), jsx(CostField, { name: "".concat(costPerOfferIdInputName, ".").concat(index, ".value") })] }, id)); }, name: costPerOfferIdInputName })] }));
};

var CostPerSubAccountIdFieldGroup = function (_a) {
    var index = _a.index;
    var control = useFormContext().control;
    var _b = getRevenueClauseInputNames(index), defaultCostInputName = _b.defaultCostInputName, costPerSubAccountIdInputName = _b.costPerSubAccountIdInputName;
    return (jsxs(Fragment, { children: [jsx(DefaultCostField, { name: defaultCostInputName }), jsx(RepeaterController, { control: control, defaultValue: {}, itemRenderer: function (id, index) { return (jsxs(Fragment$1, { children: [jsx(SubAccountIdField, { name: "".concat(costPerSubAccountIdInputName, ".").concat(index, ".key") }), jsx(CostField, { name: "".concat(costPerSubAccountIdInputName, ".").concat(index, ".value") })] }, id)); }, name: costPerSubAccountIdInputName })] }));
};

var CostPerSupplySubAccountIdFieldGroup = function (_a) {
    var index = _a.index;
    var control = useFormContext().control;
    var _b = getRevenueClauseInputNames(index), defaultCostInputName = _b.defaultCostInputName, costPerSupplySubAccountIdInputName = _b.costPerSupplySubAccountIdInputName;
    return (jsxs(Fragment, { children: [jsx(DefaultCostField, { name: defaultCostInputName }), jsx(RepeaterController, { control: control, defaultValue: {}, itemRenderer: function (id, index) { return (jsxs(Fragment$1, { children: [jsx(SupplySubAccountIdField, { name: "".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".key") }), jsx(CostField, { name: "".concat(costPerSupplySubAccountIdInputName, ".").concat(index, ".value") })] }, id)); }, name: costPerSupplySubAccountIdInputName })] }));
};

var CostPerUniqueSpecialOfferClickWithDynamicPayoutFieldGroup = function (_a) {
    var index = _a.index;
    var _b = useFormContext(), control = _b.control, watch = _b.watch;
    var _c = getRevenueClauseInputNames(index), basePercentageInputName = _c.basePercentageInputName, demandPlatformFeePercentInputName = _c.demandPlatformFeePercentInputName, percentBySupplySubAccountIdInputName = _c.percentBySupplySubAccountIdInputName;
    var basePercent = watch(basePercentageInputName);
    var demandPlatformFeePercent = watch(demandPlatformFeePercentInputName);
    return (jsxs(Fragment, { children: [jsx(DemandPlatformFeePercentField, { name: demandPlatformFeePercentInputName }), jsx(FeePreview, { demandReceivable: true, demandPlatformFeePercent: demandPlatformFeePercent, fundedAmount: 10, networkPayoutPercent: basePercent }), jsx(RepeaterController, { control: control, defaultValue: { key: '', value: '' }, itemRenderer: function (field, repeaterIdx) { return (jsxs(Fragment$1, { children: [jsx(SupplySubAccountIdField, { name: "".concat(percentBySupplySubAccountIdInputName, ".").concat(repeaterIdx, ".key") }), jsx(DemandPlatformFeePercentField, { name: "".concat(percentBySupplySubAccountIdInputName, ".").concat(repeaterIdx, ".demandPlatformFeePercent") }), jsx(FeePreview, { demandReceivable: true, demandPlatformFeePercent: watch("".concat(percentBySupplySubAccountIdInputName, ".").concat(repeaterIdx, ".demandPlatformFeePercent")), fundedAmount: 10, supplySubAccountId: watch("".concat(percentBySupplySubAccountIdInputName, ".").concat(repeaterIdx, ".key")) })] }, field)); }, name: percentBySupplySubAccountIdInputName })] }));
};

var PercentOfFundedLoanAmountByFundedLoanAmountTierFieldGroup = function (_a) {
    var index = _a.index;
    var _b = useFormContext(), control = _b.control, watch = _b.watch;
    var _c = getRevenueClauseInputNames(index), percentByFundedLoanAmountInputName = _c.percentByFundedLoanAmountInputName, demandPlatformFeePercentInputName = _c.demandPlatformFeePercentInputName, maxPercentInputName = _c.maxPercentInputName;
    var maxPercent = watch(maxPercentInputName);
    var demandPlatformFeePercent = watch(demandPlatformFeePercentInputName);
    return (jsxs(Fragment, { children: [jsx(PercentInputController, { control: control, label: "Network Payout Max Percent %", name: maxPercentInputName, tooltip: tooltips.networkPayoutPercent }), jsx(DefaultDemandPlatformFeePercentField, { name: demandPlatformFeePercentInputName }), jsx(FeePreview, { demandPlatformFeePercent: demandPlatformFeePercent, networkPayoutPercent: maxPercent }), jsx(RepeaterController, { control: control, defaultValue: { demandPlatformFeePercent: '', key: '', value: '' }, itemRenderer: function (field, index) {
                    var inputBase = "".concat(percentByFundedLoanAmountInputName, ".").concat(index);
                    var fundedAmount = watch("".concat(inputBase, ".key"));
                    var demandPlatformFeePercent = watch("".concat(inputBase, ".demandPlatformFeePercent"));
                    var networkPayoutPercent = watch("".concat(inputBase, ".value"));
                    return (jsxs(Fragment$1, { children: [jsx(MoneyInputController, { control: control, label: "Funded Loan Amount (Upper Bound)", name: "".concat(inputBase, ".key") }), jsx(NetworkPayoutPercentField, { name: "".concat(inputBase, ".value") }), jsx(DemandPlatformFeePercentField, { name: "".concat(inputBase, ".demandPlatformFeePercent") }), jsx(FeePreview, { demandPlatformFeePercent: demandPlatformFeePercent, fundedAmount: fundedAmount, networkPayoutPercent: networkPayoutPercent })] }, field));
                }, name: percentByFundedLoanAmountInputName })] }));
};

var PercentOfFundedLoanAmountWithThresholdMarginalPercentageFieldGroup = function (_a) {
    var index = _a.index;
    var control = useFormContext().control;
    var _b = getRevenueClauseInputNames(index), basePercentInputName = _b.basePercentInputName, demandPlatformFeePercentInputName = _b.demandPlatformFeePercentInputName, thresholdInputName = _b.thresholdInputName, marginalPercentInputName = _b.marginalPercentInputName;
    var watch = useFormContext().watch;
    var basePercent = watch(basePercentInputName);
    var threshold = watch(thresholdInputName);
    var marginalPercent = watch(marginalPercentInputName);
    var demandPlatformFeePercent = watch(demandPlatformFeePercentInputName);
    return (jsxs(Fragment, { children: [jsx(PercentInputController, { control: control, label: "Base Network Payout Percent %", name: basePercentInputName, tooltip: "This field will be used to calculate Supply partner payout and the recommendation score." }), jsx(MoneyInputController, { control: control, label: "Threshold (in $ USD)", name: thresholdInputName, tooltip: "Funding amounts over this value will use the Marginal Network Payout %" }), jsx(PercentInputController, { control: control, label: "Marginal Network Payout %", name: marginalPercentInputName, tooltip: "This field will be used to calculate Supply partner payout and the recommendation score over the given threshold." }), jsx(DemandPlatformFeePercentField, { name: demandPlatformFeePercentInputName }), jsx(FeePreview, { demandPlatformFeePercent: demandPlatformFeePercent, networkPayoutPercent: basePercent, threshold: threshold, thresholdNetworkPayoutPercent: marginalPercent })] }));
};

var PercentOfGrossFundedLoanAmountBySupplySubAccountIdFieldGroup = function (_a) {
    var index = _a.index;
    var control = useFormContext().control;
    var _b = getRevenueClauseInputNames(index), basePercentageInputName = _b.basePercentageInputName, demandPlatformFeePercentInputName = _b.demandPlatformFeePercentInputName, percentBySupplySubAccountIdInputName = _b.percentBySupplySubAccountIdInputName, totalReceivablePercentInputName = _b.totalReceivablePercentInputName;
    var watch = useFormContext().watch;
    var basePercent = watch(basePercentageInputName);
    var demandPlatformFeePercent = watch(demandPlatformFeePercentInputName);
    return (jsxs(Fragment, { children: [jsx(DefaultNetworkPayoutPercentField, { name: basePercentageInputName }), jsx(DefaultDemandPlatformFeePercentField, { name: demandPlatformFeePercentInputName }), jsx(LegacyTotalReceivablePercentField, { demandPlatformFeePercent: demandPlatformFeePercent, label: labels.defaultTotalReceivablePercent, name: totalReceivablePercentInputName, percent: basePercent }), jsx(FeePreview, { demandPlatformFeePercent: demandPlatformFeePercent, networkPayoutPercent: basePercent }), jsx(RepeaterController, { control: control, defaultValue: { key: '', value: '' }, itemRenderer: function (field, repeaterIdx) { return (jsxs(Fragment$1, { children: [jsx(SupplySubAccountIdField, { name: "".concat(percentBySupplySubAccountIdInputName, ".").concat(repeaterIdx, ".key") }), jsx(NetworkPayoutPercentField, { name: "".concat(percentBySupplySubAccountIdInputName, ".").concat(repeaterIdx, ".value") }), jsx(DemandPlatformFeePercentField, { name: "".concat(percentBySupplySubAccountIdInputName, ".").concat(repeaterIdx, ".demandPlatformFeePercent") }), jsx(LegacyTotalReceivablePercentField, { demandPlatformFeePercent: watch("".concat(percentBySupplySubAccountIdInputName, ".").concat(repeaterIdx, ".demandPlatformFeePercent")), name: "".concat(percentBySupplySubAccountIdInputName, ".").concat(repeaterIdx, ".totalReceivablePercent"), percent: watch("".concat(percentBySupplySubAccountIdInputName, ".").concat(repeaterIdx, ".value")) }), jsx(FeePreview, { demandPlatformFeePercent: watch("".concat(percentBySupplySubAccountIdInputName, ".").concat(repeaterIdx, ".demandPlatformFeePercent")), networkPayoutPercent: watch("".concat(percentBySupplySubAccountIdInputName, ".").concat(repeaterIdx, ".value")) })] }, field)); }, name: percentBySupplySubAccountIdInputName })] }));
};

var PercentOfGrossFundedLoanAmountFieldGroup = function (_a) {
    var index = _a.index;
    var _b = getRevenueClauseInputNames(index), demandPlatformFeePercentInputName = _b.demandPlatformFeePercentInputName, percentInputName = _b.percentInputName, totalReceivablePercentInputName = _b.totalReceivablePercentInputName;
    var watch = useFormContext().watch;
    var percent = watch(percentInputName);
    var demandPlatformFeePercent = watch(demandPlatformFeePercentInputName);
    return (jsxs(Fragment, { children: [jsx(NetworkPayoutPercentField, { name: percentInputName }), jsx(DemandPlatformFeePercentField, { name: demandPlatformFeePercentInputName }), jsx(LegacyTotalReceivablePercentField, { demandPlatformFeePercent: demandPlatformFeePercent, name: totalReceivablePercentInputName, percent: percent }), jsx(FeePreview, { demandPlatformFeePercent: demandPlatformFeePercent, networkPayoutPercent: percent })] }));
};

var PercentOfGrossFundedLoanAmountFlatFeeThresholdFieldGroup = function (_a) {
    var index = _a.index;
    var control = useFormContext().control;
    var _b = getRevenueClauseInputNames(index), percentInputName = _b.percentInputName, thresholdInputName = _b.thresholdInputName, flatFeeInputName = _b.flatFeeInputName;
    return (jsxs(Fragment, { children: [jsx(PercentField, { name: percentInputName }), jsx(MoneyInputController, { control: control, label: "Threshold (in $ USD)", name: thresholdInputName }), jsx(MoneyInputController, { control: control, label: "Flat Fee (in $ USD)", name: flatFeeInputName })] }));
};

var DefaultPercentField = function (_a) {
    var name = _a.name;
    var control = useFormContext().control;
    return (jsx(PercentInputController, { control: control, label: labels.defaultPercent, name: name }));
};

var PercentOfOtherConversionAmountBySupplySubAccountIdFieldGroup = function (_a) {
    var index = _a.index;
    var control = useFormContext().control;
    var _b = getRevenueClauseInputNames(index), basePercentageInputName = _b.basePercentageInputName, percentBySupplySubAccountIdInputName = _b.percentBySupplySubAccountIdInputName;
    return (jsxs(Fragment, { children: [jsx(DefaultPercentField, { name: basePercentageInputName }), jsx(RepeaterController, { control: control, defaultValue: {}, itemRenderer: function (id, index) { return (jsxs(Fragment$1, { children: [jsx(SupplySubAccountIdField, { name: "".concat(percentBySupplySubAccountIdInputName, ".").concat(index, ".key") }), jsx(CostField, { name: "".concat(percentBySupplySubAccountIdInputName, ".").concat(index, ".value") })] }, id)); }, name: percentBySupplySubAccountIdInputName })] }));
};

var SimpleCostFieldGroup = function (_a) {
    var index = _a.index;
    var costInputName = getRevenueClauseInputNames(index).costInputName;
    return jsx(CostField, { name: costInputName });
};

var SimplePercentFieldGroup = function (_a) {
    var index = _a.index;
    var percentInputName = getRevenueClauseInputNames(index).percentInputName;
    return jsx(PercentField, { name: percentInputName });
};

var PercentOfSpecialOfferConversionAmount = function (_a) {
    var index = _a.index;
    var watch = useFormContext().watch;
    var _b = getRevenueClauseInputNames(index), demandPlatformFeePercentInputName = _b.demandPlatformFeePercentInputName, percent = _b.percent;
    var demandPlatformFeePercent = watch(demandPlatformFeePercentInputName);
    return (jsxs(Fragment, { children: [jsx(DemandPlatformFeePercentField, { name: demandPlatformFeePercentInputName }), jsx(TotalReceivablePercentField, { name: percent }), jsx(FeePreview, { demandReceivable: true, demandPlatformFeePercent: demandPlatformFeePercent, fundedAmount: 10 })] }));
};

var TotalReceivablePerClickFieldGroup = function (_a) {
    var index = _a.index;
    var watch = useFormContext().watch;
    var _b = getRevenueClauseInputNames(index), costInputName = _b.costInputName, demandPlatformFeePercentInputName = _b.demandPlatformFeePercentInputName;
    var amount = watch(costInputName);
    var demandPlatformFeePercent = watch(demandPlatformFeePercentInputName);
    return (jsxs(Fragment, { children: [jsx(DemandPlatformFeePercentField, { name: demandPlatformFeePercentInputName }), jsx(CostField, { label: 'Total Receivable Per Click (in $USD)', name: costInputName }), jsx(FeePreview, { demandReceivable: true, demandPlatformFeePercent: demandPlatformFeePercent, fundedAmount: amount })] }));
};

var RevenueClauseHandler = function (_a) {
    var index = _a.index, demandReceivableFlags = _a.demandReceivableFlags;
    var _b = useFormContext(), watch = _b.watch, setValue = _b.setValue;
    var key = watch("revenueClauses.".concat(index, ".key"));
    var revenueClause = useWatch({ name: "revenueClauses.".concat(index) });
    var prevKey = usePrevious$1(key);
    // This is a temporary map to track which RevenueClauseTypes are enabled
    // for the demand receivables feature. Each type will have their own flag. This should be removed once the
    // feature is fully implemented and the feature flag is no longer needed.
    var demandReceivableEnabledMap = new Map([
        [
            RevenueClauseType.CostPerOtherConversion,
            demandReceivableFlags === null || demandReceivableFlags === void 0 ? void 0 : demandReceivableFlags.hasDrCostPerOtherConversion,
        ],
        [
            RevenueClauseType.CostPerOtherConversionBySupplySubAccountId,
            demandReceivableFlags === null || demandReceivableFlags === void 0 ? void 0 : demandReceivableFlags.hasDrCostPerOtherConversionBySupplySubAccountId,
        ],
        [
            RevenueClauseType.CostPerUniqueSpecialOfferClick,
            demandReceivableFlags === null || demandReceivableFlags === void 0 ? void 0 : demandReceivableFlags.hasDrCostPerUniqueSpecialOfferClick,
        ],
        [
            RevenueClauseType.CostPerUniqueSpecialOfferClickWithDynamicPayout,
            demandReceivableFlags === null || demandReceivableFlags === void 0 ? void 0 : demandReceivableFlags.hasDrCostPerUniqueSpecialOfferClickWithDynamicPayout,
        ],
        [
            RevenueClauseType.PercentOtherConversionAmount,
            demandReceivableFlags === null || demandReceivableFlags === void 0 ? void 0 : demandReceivableFlags.hasDrPercentOtherConversion,
        ],
        [RevenueClauseType.OtherRevenue, demandReceivableFlags === null || demandReceivableFlags === void 0 ? void 0 : demandReceivableFlags.hasDrOtherRevenue],
    ]);
    var isDemandReceivablesEnabled = demandReceivableEnabledMap.get(key);
    useEffect(function () {
        if (prevKey && key !== prevKey) {
            setValue("revenueClauses.".concat(index), { key: key });
        }
        var demandPlatformFeeConfig = getDemandPlatformFeeConfig(revenueClause, isDemandReceivablesEnabled);
        setValue('demandPlatformFeeConfig', demandPlatformFeeConfig);
    }, [key, prevKey, revenueClause]);
    if (isDemandReceivablesEnabled) {
        switch (key) {
            case RevenueClauseType.CostPerOtherConversionBySupplySubAccountId:
                return (jsx(CostPerLoanFundedBySupplySubAccountIdFieldGroup, { index: index }));
            case RevenueClauseType.CostPerOtherConversion:
            case RevenueClauseType.CostPerUniqueSpecialOfferClick:
            case RevenueClauseType.OtherRevenue:
                return jsx(TotalReceivablePerClickFieldGroup, { index: index });
            case RevenueClauseType.CostPerUniqueSpecialOfferClickWithDynamicPayout:
                return (jsx(CostPerUniqueSpecialOfferClickWithDynamicPayoutFieldGroup, { index: index }));
            case RevenueClauseType.PercentOtherConversionAmount:
                return jsx(PercentOfSpecialOfferConversionAmount, { index: index });
        }
    }
    switch (key) {
        case RevenueClauseType.CostPerCreditCardApproved:
        case RevenueClauseType.CostPerCreditCardFunded:
        case RevenueClauseType.CostPerCreditCardOpened:
        case RevenueClauseType.CostPerOtherConversion:
        case RevenueClauseType.CostPerSavingsClick:
        case RevenueClauseType.CostPerSavingsFunded:
        case RevenueClauseType.CostPerSavingsOpened:
        case RevenueClauseType.CostPerUniqueLoanClick15:
        case RevenueClauseType.CostPerUniqueSavingsClick:
        case RevenueClauseType.CostPerUniqueSpecialOfferClick:
            return jsx(SimpleCostFieldGroup, { index: index });
        case RevenueClauseType.PercentOriginationFee:
        case RevenueClauseType.PercentOtherConversionAmount:
            return jsx(SimplePercentFieldGroup, { index: index });
        case RevenueClauseType.CostPerFundedLoan:
            return jsx(CostPerLoanFieldGroup, { costPerText: "CPFL", index: index });
        case RevenueClauseType.CostPerLoanApproved:
            return jsx(CostPerLoanFieldGroup, { costPerText: "CPLA", index: index });
        case RevenueClauseType.CostPerLoanLenderQualifiedLead:
            return jsx(CostPerLoanFieldGroup, { costPerText: "CPLLQL", index: index });
        case RevenueClauseType.CostPerUniqueSavingsClickByOfferId:
            return jsx(CostPerOfferIdFieldGroup, { index: index });
        case RevenueClauseType.CostPerUniqueOtherClickBySubAccountId:
            return jsx(CostPerSubAccountIdFieldGroup, { index: index });
        case RevenueClauseType.CostPerSavingsOpenedBySupplySubAccountId:
            return jsx(CostPerSupplySubAccountIdFieldGroup, { index: index });
        case RevenueClauseType.CostPerLoanFundedBySupplySubAccountId:
            return (jsx(LegacyCostPerLoanFundedBySupplySubAccountIdFieldGroup, { index: index }));
        case RevenueClauseType.PercentGrossFundedLoanAmount:
            return jsx(PercentOfGrossFundedLoanAmountFieldGroup, { index: index });
        case RevenueClauseType.PercentFundedLoanAmountByFundedLoanAmountTier:
            return (jsx(PercentOfFundedLoanAmountByFundedLoanAmountTierFieldGroup, { index: index }));
        case RevenueClauseType.PercentFundedLoanAmountWithThresholdMarginalPercentage:
            return (jsx(PercentOfFundedLoanAmountWithThresholdMarginalPercentageFieldGroup, { index: index }));
        case RevenueClauseType.PercentGrossFundedLoanAmountFlatFeeThreshold:
            return (jsx(PercentOfGrossFundedLoanAmountFlatFeeThresholdFieldGroup, { index: index }));
        case RevenueClauseType.PercentGrossFundedLoanAmountBySupply:
            return (jsx(PercentOfGrossFundedLoanAmountBySupplySubAccountIdFieldGroup, { index: index }));
        case RevenueClauseType.PercentOtherConversionAmountBySupplySubAccountId:
            return (jsx(PercentOfOtherConversionAmountBySupplySubAccountIdFieldGroup, { index: index }));
        case RevenueClauseType.CostPerUniqueSpecialOfferClickWithDynamicPayout:
        case RevenueClauseType.LifeInsurancePolicyPayments:
        case RevenueClauseType.OtherRevenue:
        case RevenueClauseType.SavingsOfferClickPayout:
            return jsx(Fragment, {});
        default:
            return jsxs(Fragment, { children: ["Unsupported pricing plan: ", startCase(key)] });
    }
};

var CONTRACT_TYPE$1 = 'demand';
var DEMAND_PLATFORM_FEE_PERCENT_OFFSET = 100;
var mantissaOffset = function (items, dpfc, offset) {
    if (offset === void 0) { offset = 6; }
    var config = dpfc.config;
    var configType = config.configType;
    if (configType === DemandPlatformFeeConfigType.Tiered) {
        var tieredConfig_1 = config;
        return items === null || items === void 0 ? void 0 : items.map(function (item) {
            var _a, _b, _c;
            return (__assign(__assign({}, item), { demandPlatformFeePercent: Number(item.key !== undefined
                    ? (_c = (_b = (_a = tieredConfig_1.tiers) === null || _a === void 0 ? void 0 : _a[item.key]) === null || _b === void 0 ? void 0 : _b.percent) !== null && _c !== void 0 ? _c : 0
                    : 0) * DEMAND_PLATFORM_FEE_PERCENT_OFFSET, value: Number((item === null || item === void 0 ? void 0 : item.value) || 0) * Math.pow(10, offset) }));
        });
    }
};
var transformSupplySubAccountItems = function (items, dpfc, totalReceivablePercent) {
    var config = dpfc.config;
    var configType = config.configType;
    if (configType === DemandPlatformFeeConfigType.SupplySubAccount) {
        var supplySubAccountConfig_1 = config;
        var supplySubAccountItems = items;
        return supplySubAccountItems === null || supplySubAccountItems === void 0 ? void 0 : supplySubAccountItems.map(function (item) {
            var _a, _b, _c;
            return (__assign(__assign({}, item), { demandPlatformFeePercent: Number(item.key !== undefined
                    ? (_c = (_b = (_a = supplySubAccountConfig_1.supplySubAccounts) === null || _a === void 0 ? void 0 : _a[item.key]) === null || _b === void 0 ? void 0 : _b.percent) !== null && _c !== void 0 ? _c : 0
                    : 0) * DEMAND_PLATFORM_FEE_PERCENT_OFFSET, totalReceivablePercent: totalReceivablePercent, value: (item === null || item === void 0 ? void 0 : item.value) || 0 }));
        });
    }
};
// The undefined properties will be filtered out with helper function sanitizeRevenueClause
var offsetIfExists = function (value, offset) {
    if (offset === void 0) { offset = 1; }
    return value !== undefined ? (Number(value) * offset).toString() : undefined;
};
var getDemandPlatformFeePercent = function (dpfc) {
    var config = dpfc.config;
    switch (config.configType) {
        case DemandPlatformFeeConfigType.Tiered:
            return Number(config.defaultTier.percent);
        case DemandPlatformFeeConfigType.SupplySubAccount:
            return Number(config.default.percent);
        case DemandPlatformFeeConfigType.PercentageOf:
            return Number(config.percent);
        default:
            return 0;
    }
};
var DemandContractFormDrawer = function (props) {
    var visible = props.visible, demandContractToDuplicate = props.demandContractToDuplicate, selectedDemandSubAccount = props.selectedDemandSubAccount, productType = props.productType, onClose = props.onClose, onSubmit = props.onSubmit, isSubmitting = props.isSubmitting, demandReceivableFlags = props.demandReceivableFlags;
    var form = useForm();
    var handleSubmit = form.handleSubmit, control = form.control, reset = form.reset, setValue = form.setValue;
    useEffect(function () {
        if (selectedDemandSubAccount) {
            setValue('subAccount', selectedDemandSubAccount);
        }
    }, [selectedDemandSubAccount === null || selectedDemandSubAccount === void 0 ? void 0 : selectedDemandSubAccount.uuid]);
    useUpdateEffect(function () {
        var _a, _b;
        if (demandContractToDuplicate === null || demandContractToDuplicate === void 0 ? void 0 : demandContractToDuplicate.id) {
            var _c = demandContractToDuplicate !== null && demandContractToDuplicate !== void 0 ? demandContractToDuplicate : {}, dpfc_1 = _c.demandPlatformFeeConfig, effectiveAt = _c.effectiveAt, rcs = _c.revenueClauses, subAccount = _c.subAccount;
            var revenueClauses = rcs.map(function (revenueClause) {
                var basePercent = revenueClause.basePercent, basePercentage = revenueClause.basePercentage, costPerSupplySubAccountId = revenueClause.costPerSupplySubAccountId, marginalPercent = revenueClause.marginalPercent, maxPercent = revenueClause.maxPercent, percent = revenueClause.percent, percentByFundedLoanAmount = revenueClause.percentByFundedLoanAmount, percentBySupplySubAccountId = revenueClause.percentBySupplySubAccountId, totalReceivablePercent = revenueClause.totalReceivablePercent;
                var demandPlatformFeePercent = offsetIfExists(getDemandPlatformFeePercent(dpfc_1), DEMAND_PLATFORM_FEE_PERCENT_OFFSET);
                return __assign(__assign({}, revenueClause), { basePercent: offsetIfExists(basePercent), basePercentage: offsetIfExists(basePercentage), costPerSupplySubAccountId: transformSupplySubAccountItems(costPerSupplySubAccountId, dpfc_1, totalReceivablePercent), demandPlatformFeePercent: demandPlatformFeePercent, marginalPercent: offsetIfExists(marginalPercent), maxPercent: offsetIfExists(maxPercent), percent: offsetIfExists(percent), percentByFundedLoanAmount: mantissaOffset(percentByFundedLoanAmount, dpfc_1), percentBySupplySubAccountId: transformSupplySubAccountItems(percentBySupplySubAccountId, dpfc_1, totalReceivablePercent) });
            });
            var demandPlatformFeeConfig = cloneDeep(dpfc_1);
            if ((_b = (_a = demandPlatformFeeConfig === null || demandPlatformFeeConfig === void 0 ? void 0 : demandPlatformFeeConfig.config) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.percent) {
                demandPlatformFeeConfig.config.default.percent *= 1e4;
            }
            reset({
                demandPlatformFeeConfig: demandPlatformFeeConfig,
                effectiveAt: effectiveAt,
                revenueClauses: revenueClauses,
                subAccount: subAccount,
            });
        }
    }, [demandContractToDuplicate === null || demandContractToDuplicate === void 0 ? void 0 : demandContractToDuplicate.id]);
    useUpdateEffect(function () {
        if (!visible) {
            reset({
                demandPlatformFeeConfig: undefined,
                effectiveAt: '',
                revenueClauses: [],
                salesforceOpportunityIdOrUrl: undefined,
                subAccount: undefined,
            });
        }
    }, [visible]);
    return (jsx(Fragment, { children: jsxs(DrawerForm, __assign({ disableCloseOnMouseDown: true, isSubmitting: isSubmitting, size: DrawerSize.STANDARD, title: "New Demand Contract", visible: visible, onClose: onClose, onSubmit: handleSubmit(onSubmit) }, { children: [jsx(SubAccountSuggestController, { showOnlyDemandSubAccounts: true, control: control, disabled: Boolean(selectedDemandSubAccount), label: "Sub Account", name: "subAccount", productType: productType }), jsx(DateInputController, { control: control, label: "Effective At", name: "effectiveAt", tooltip: "When is this contract effective?" }), jsx(StringField, { control: control, label: "Salesforce Opportunity Link", name: "salesforceOpportunityIdOrUrl", rules: {
                        validate: function (value) { return salesforceUrlValidator(value, CONTRACT_TYPE$1); },
                    }, tooltip: "The Salesforce Opportunity link must contain the executed contract that agrees to pricing being entered into Control Center" }), jsxs(FormProvider, __assign({}, form, { children: [jsx(RepeaterController, { hideOnMaxItems: true, control: control, defaultValue: {
                                key: RevenueClauseType.PercentGrossFundedLoanAmount,
                            }, itemNoun: "Pricing Plan", itemRenderer: function (id, index) { return (jsxs(Fragment$1, { children: [jsx(SelectController, { control: control, itemKey: function (value) { return value; }, itemLabel: function (value) { return getRevenueClauseTypeDisplayText(value); }, items: [
                                            RevenueClauseType.CostPerCreditCardApproved,
                                            RevenueClauseType.CostPerCreditCardFunded,
                                            RevenueClauseType.CostPerCreditCardOpened,
                                            RevenueClauseType.CostPerLoanApproved,
                                            RevenueClauseType.CostPerFundedLoan,
                                            RevenueClauseType.CostPerLoanFundedBySupplySubAccountId,
                                            RevenueClauseType.CostPerLoanLenderQualifiedLead,
                                            RevenueClauseType.CostPerLoanLenderQualifiedLeadBySupplySubAccountId,
                                            RevenueClauseType.CostPerOtherConversion,
                                            RevenueClauseType.CostPerOtherConversionBySupplySubAccountId,
                                            RevenueClauseType.CostPerSavingsClick,
                                            RevenueClauseType.CostPerSavingsFunded,
                                            RevenueClauseType.CostPerSavingsOpened,
                                            RevenueClauseType.CostPerSavingsOpenedBySupplySubAccountId,
                                            RevenueClauseType.CostPerUniqueLoanClick15,
                                            RevenueClauseType.CostPerUniqueOtherClickBySubAccountId,
                                            RevenueClauseType.CostPerUniqueSavingsClick,
                                            RevenueClauseType.CostPerUniqueSavingsClickByOfferId,
                                            RevenueClauseType.CostPerUniqueSpecialOfferClick,
                                            RevenueClauseType.CostPerUniqueSpecialOfferClickWithDynamicPayout,
                                            RevenueClauseType.LifeInsurancePolicyPayments,
                                            RevenueClauseType.PercentFundedLoanAmountByFundedLoanAmountTier,
                                            RevenueClauseType.PercentFundedLoanAmountWithThresholdMarginalPercentage,
                                            RevenueClauseType.PercentGrossFundedLoanAmount,
                                            RevenueClauseType.PercentGrossFundedLoanAmountBySupply,
                                            RevenueClauseType.PercentGrossFundedLoanAmountFlatFeeThreshold,
                                            RevenueClauseType.PercentOriginationFee,
                                            RevenueClauseType.PercentOtherConversionAmount,
                                            RevenueClauseType.PercentOtherConversionAmountBySupplySubAccountId,
                                            RevenueClauseType.SavingsOfferClickPayout,
                                            RevenueClauseType.OtherRevenue,
                                        ], label: "Pricing Plan", name: "revenueClauses.".concat(index, ".key") }), jsx(HiddenInputController, { control: control, defaultValue: "revenue", name: "revenueClauses.".concat(index, ".type") }), jsx(RevenueClauseHandler, { demandReceivableFlags: demandReceivableFlags, index: index })] }, id)); }, maxItems: 1, name: "revenueClauses" }), jsx(Callout, __assign({ style: { marginTop: 20 } }, { children: "Pricing Plans are additive. If you have two plans within the same product type or a global plan and a product type specific plan, leads may be monetized multiple times." }))] }))] })) }));
};

var CopyToaster;
// Checking document here as when imported into portal-app, the production build
// throws "ReferenceError: document is not defined"
if (typeof document !== 'undefined') {
    CopyToaster = Toaster$1.create({
        autoFocus: true,
        maxToasts: 1,
        position: Position.TOP,
    });
}
var SEC = 1000;
var info = function (message) {
    CopyToaster.show({
        intent: Intent.NONE,
        message: message,
    });
};
var success = function (message) {
    CopyToaster.show({
        icon: 'tick',
        intent: Intent.SUCCESS,
        message: message,
        timeout: SEC * 2,
    });
};
var error = function (message) {
    CopyToaster.show({
        intent: Intent.DANGER,
        message: message,
        timeout: SEC * 10,
    });
};
var warn = function (message) {
    CopyToaster.show({
        intent: Intent.WARNING,
        message: message,
        timeout: SEC * 10,
    });
};
var createFailure = function (resourceName) {
    return error("Unable to create ".concat(resourceName));
};
var createLoading = function (resourceName) {
    return info("Creating ".concat(resourceName, "..."));
};
var createSuccess = function (resourceName) {
    return success("Successfully created ".concat(resourceName, "!"));
};
var deleteFailure = function (resourceName) {
    return error("Unable to delete ".concat(resourceName));
};
var deleteLoading = function (resourceName) {
    return info("Deleting ".concat(resourceName, "..."));
};
var deleteSuccess = function (resourceName) {
    return success("Successfully deleted ".concat(resourceName, "!"));
};
var updateLoading = function (resourceName) {
    return info("Updating ".concat(resourceName, "..."));
};
var updateSuccess = function (resourceName) {
    return success("Successfully updated ".concat(resourceName, "!"));
};
var updateFailure = function (resourceName) {
    return error("Unable to update ".concat(resourceName));
};
var Toaster = {
    error: error,
    info: info,
    success: success,
    warn: warn,
};
var CrudToaster = {
    createFailure: createFailure,
    createLoading: createLoading,
    createSuccess: createSuccess,
    deleteFailure: deleteFailure,
    deleteLoading: deleteLoading,
    deleteSuccess: deleteSuccess,
    updateFailure: updateFailure,
    updateLoading: updateLoading,
    updateSuccess: updateSuccess,
};
var createCrudToaster = function (resourceName) {
    var deleteLoading = function (resourceName) { return info("Deleting ".concat(resourceName, "...")); };
    var endLoading = function () { return info("Ending ".concat(resourceName, "...")); };
    var endSuccess = function () { return success("Successfully ended ".concat(resourceName, "!")); };
    var deleteFailure = function (resourceName) {
        return error("Unable to delete ".concat(resourceName));
    };
    var deleteSuccess = function (resourceName) {
        return success("Successfully deleted ".concat(resourceName, "!"));
    };
    var endFailure = function () { return error("Unable to end ".concat(resourceName)); };
    return {
        createFailure: function () { return createFailure(resourceName); },
        createLoading: function () { return createLoading(resourceName); },
        createSuccess: function () { return createSuccess(resourceName); },
        deleteFailure: function () { return deleteFailure(resourceName); },
        deleteLoading: function () { return deleteLoading(resourceName); },
        deleteSuccess: function () { return deleteSuccess(resourceName); },
        endFailure: endFailure,
        endLoading: endLoading,
        endSuccess: endSuccess,
        updateFailure: function () { return updateFailure(resourceName); },
        updateLoading: function () { return updateLoading(resourceName); },
        updateSuccess: function () { return updateSuccess(resourceName); },
    };
};

var generateColor = function (str) {
    var strArray = str.split('');
    var colorHash = strArray.reduce(function (acc, currChar) { return currChar.charCodeAt(0) + ((acc << 5) - acc); }, 0);
    return "hsl(".concat(colorHash % 360, ", 50%, 60%)");
};
var getInitials = function (name) {
    var formattedNameValue = name.replace(/\s+/g, ' ').trim();
    var splitName = formattedNameValue.toUpperCase().split(' ');
    if (splitName.length <= 1) {
        return splitName[0][0] || '';
    }
    return "".concat(splitName[0][0]).concat(splitName[splitName.length - 1][0]);
};
var UserAvatar = function (_a) {
    var avatarUrl = _a.avatarUrl, className = _a.className, name = _a.name, size = _a.size, withTooltip = _a.withTooltip;
    var MemoizedUserAvatar = useMemo(function () { return (jsxs("figure", __assign({ className: classNames('user-avatar-globals', className) }, { children: [jsx(Tooltip2, __assign({ content: withTooltip ? name : undefined, intent: "none", placement: "top" }, { children: jsx(Avatar, __assign({ className: "avatar", size: size, src: avatarUrl, style: { backgroundColor: generateColor(name || '') } }, { children: getInitials(name || '') })) })), !withTooltip && jsx("figcaption", __assign({ className: "name" }, { children: name }))] }))); }, [name, withTooltip]);
    return name ? MemoizedUserAvatar : null;
};

var DataProperty = function (_a) {
    var isInRow = _a.isInRow, label = _a.label, children = _a.children;
    return (jsxs("div", __assign({ className: classNames('data-property', { 'is-in-row': isInRow }) }, { children: [jsx("div", __assign({ className: "data-property-title" }, { children: label })), jsx("div", { children: children })] })));
};

var styles$e = {"date-range-filter":"DateRangeFilter-module_date-range-filter__roWx-"};

function doesFilterPass(cellVal, filterDateStart, filterDateEnd) {
    if (filterDateEnd === void 0) { filterDateEnd = null; }
    if (!filterDateStart && !filterDateEnd) {
        return true;
    }
    if (!Array.isArray(cellVal)) {
        // if we have a single val column
        var cellDate = cellVal;
        var isDateAfterStartFilter = filterDateStart && cellDate >= filterDateStart;
        var isDateBeforeEndFilter = filterDateEnd && cellDate <= filterDateEnd;
        if ((!filterDateEnd && isDateAfterStartFilter) ||
            (isDateAfterStartFilter && isDateBeforeEndFilter)) {
            return true;
        }
    }
    else {
        // if we have a DateRange
        var _a = cellVal, cellDateStart = _a[0], cellDateEnd = _a[1];
        var isStartDateWithinRange = filterDateStart && cellDateStart >= filterDateStart;
        var isEndDateWithinRange = filterDateEnd && cellDateEnd <= filterDateEnd;
        // This is trying to do a logical XOR
        // We can start filtering as soon as the first date is selected
        if ((!filterDateEnd && isStartDateWithinRange) ||
            (isStartDateWithinRange && isEndDateWithinRange) ||
            (!cellDateEnd && isStartDateWithinRange)) {
            return true;
        }
    }
    return false;
}

var DateRangeFilter = forwardRef(function (_a, ref) {
    var calendarProps = _a.calendarProps, props = __rest(_a, ["calendarProps"]);
    var _b = useState([null, null]), date = _b[0], setDate = _b[1];
    // expose AG Grid Filter Lifecycle callbacks
    useImperativeHandle(ref, function () {
        return {
            doesFilterPass: function (_a) {
                var _b, _c;
                var data = _a.data;
                var cellVal = new Date(data[(_c = (_b = props === null || props === void 0 ? void 0 : props.colDef) === null || _b === void 0 ? void 0 : _b.field) !== null && _c !== void 0 ? _c : '']);
                var filterDateStart = date[0], filterDateEnd = date[1];
                return doesFilterPass(cellVal, filterDateStart, filterDateEnd);
            },
            getModel: function () {
                return { value: date };
            },
            isFilterActive: function () {
                return date ? !isNullDateTuple(date) : false;
            },
            setModel: function (model) {
                setDate(model === null || model === void 0 ? void 0 : model.value);
            },
        };
    });
    useEffect(function () {
        props.filterChangedCallback();
    }, [date]);
    return (jsx(DateRangePicker, __assign({ className: styles$e['date-range-filter'], contiguousCalendarMonths: false, shortcuts: false, value: date, onChange: setDate }, calendarProps)));
});

var NumberRangeFilter = forwardRef(function (_a, ref) {
    var sliderProps = _a.sliderProps, props = __rest(_a, ["sliderProps"]);
    var _b = useState(), range = _b[0], setRange = _b[1];
    // expose AG Grid Filter Lifecycle callbacks
    useImperativeHandle(ref, function () {
        return {
            doesFilterPass: function () {
                return true;
                // const cellVal = data[props?.colDef?.field ?? ''] as Date;
                // const [filterDateStart, filterDateEnd] = date;
                // return doesFilterPass(cellVal, filterDateStart, filterDateEnd);
            },
            getModel: function () {
                return { value: range };
            },
            isFilterActive: function () {
                return Boolean(range === null || range === void 0 ? void 0 : range.length);
            },
            setModel: function (model) {
                setRange(model === null || model === void 0 ? void 0 : model.value);
            },
        };
    });
    useEffect(function () {
        props.filterChangedCallback();
    }, [range]);
    return (jsx("aside", __assign({ style: { margin: '10px 30px', width: 300 } }, { children: jsx(RangeSlider, __assign({}, sliderProps, { value: range, onChange: setRange })) })));
});

var SimpleTextFilter = forwardRef(function (props, ref) {
    var _a;
    var _b = useState(''), searchTerm = _b[0], setSearchTerm = _b[1];
    var _c = useState(''), serializedSearchTerm = _c[0], setSerializedSearchTerm = _c[1];
    var fieldName = ((_a = props === null || props === void 0 ? void 0 : props.colDef) === null || _a === void 0 ? void 0 : _a.field) || '';
    // expose AG Grid Filter Lifecycle callbacks
    useImperativeHandle(ref, function () {
        return {
            doesFilterPass: function (params) {
                var _a;
                var value = isString(params.data)
                    ? params.data
                    : (_a = params.data) === null || _a === void 0 ? void 0 : _a[fieldName];
                if (serialize$1(value).includes(serializedSearchTerm)) {
                    return true;
                }
                return false;
            },
            getModel: function () {
                return { value: searchTerm };
            },
            isFilterActive: function () {
                return searchTerm !== null && searchTerm !== '';
            },
            setModel: function (model) {
                var _a, _b;
                setSearchTerm((_a = model === null || model === void 0 ? void 0 : model[fieldName]) !== null && _a !== void 0 ? _a : null);
                setSerializedSearchTerm((_b = model === null || model === void 0 ? void 0 : model[fieldName]) !== null && _b !== void 0 ? _b : null);
            },
        };
    });
    var onSearchChange = function (event) {
        setSearchTerm(event.target.value);
        setSerializedSearchTerm(serialize$1(event.target.value));
    };
    useEffect(function () {
        props.filterChangedCallback();
    }, [searchTerm]);
    var placeHolderText = useMemo(function () {
        return props.placeHolder || 'Search...';
    }, [props.placeHolder]);
    return (jsxs("div", __assign({ className: "simple-text-filter" }, { children: [jsx("input", { className: classNames(Classes.INPUT, 'input'), placeholder: placeHolderText, onChange: onSearchChange }), jsx(Button, { minimal: true, className: "search-icon", icon: jsx(FontAwesomeIcon, { color: colors.themeGray7, icon: faSearch }), intent: Intent.NONE })] })));
});

var FilterIcon;
(function (FilterIcon) {
    FilterIcon["FILTER"] = "filter";
    FilterIcon["SEARCH"] = "search";
})(FilterIcon || (FilterIcon = {}));

var ColumnHeader = function (_a) {
    var showColumnMenu = _a.showColumnMenu, column = _a.column, setSort = _a.setSort, enableSorting = _a.enableSorting, enableMenu = _a.enableMenu, filterIcon = _a.filterIcon, displayName = _a.displayName;
    var _b = React.useState(column.isFilterActive()), isFilterActive = _b[0], setIsFilterActive = _b[1];
    var refButton = useRef(null);
    var onMenuClicked = function (event) {
        event.stopPropagation();
        showColumnMenu(refButton.current);
    };
    var onSort = function (event) {
        if (!enableSorting) {
            return;
        }
        if (column.isSortNone()) {
            return setSort('asc', event.shiftKey);
        }
        if (column.isSortAscending()) {
            return setSort('desc', event.shiftKey);
        }
        if (column.isSortDescending()) {
            return setSort(null, event.shiftKey);
        }
    };
    var icon = useMemo(function () {
        if (filterIcon === FilterIcon.FILTER) {
            return faFilter;
        }
        if (filterIcon === FilterIcon.SEARCH) {
            return faSearch$1;
        }
        return faSearch$1;
    }, [filterIcon]);
    var role = useMemo(function () {
        if (filterIcon === FilterIcon.FILTER) {
            return 'filter';
        }
        return 'search';
    }, [filterIcon]);
    React.useEffect(function () {
        var handleFilterChange = function (_a) {
            var column = _a.column;
            setIsFilterActive(column.isFilterActive());
        };
        column.addEventListener('filterChanged', handleFilterChange);
        return function () {
            column.removeEventListener('filterChanged', handleFilterChange);
        };
    }, []);
    return (jsx("div", __assign({ className: "column-header-wrapper", onClick: onSort, onTouchEnd: onSort }, { children: jsxs("div", __assign({ className: "column-header" }, { children: [jsx("span", __assign({ className: "column-header-title" }, { children: displayName })), enableSorting && (jsxs("div", __assign({ className: "column-header-sort" }, { children: [jsx(FontAwesomeIcon, { className: classNames('column-header-icon', 'column-header-sort-icon', 'column-header-sort-asc', { active: column.isSortAscending() }), icon: faCaretUp }), jsx(FontAwesomeIcon, { className: classNames('column-header-icon', 'column-header-sort-icon', 'column-header-sort-desc', { active: column.isSortDescending() }), icon: faCaretDown })] }))), enableMenu && (jsx("div", __assign({ ref: refButton, className: "column-header-search", role: role, onClick: onMenuClicked }, { children: jsx(FontAwesomeIcon, { className: classNames('column-header-icon', 'column-header-search-icon', { active: isFilterActive }), icon: icon }) })))] })) })));
};

var makeSimpleDate = function (jsDate) {
    return DateTime.fromJSDate(typeof jsDate === 'string' ? new Date(jsDate) : jsDate)
        .setLocale('en-US')
        .toFormat('MM/dd/yyyy');
};

var basicColumn = {
    suppressMenu: true,
};
var basicNoSortColumn = {
    sortable: false,
    suppressMenu: true,
};
var centerColumn = {
    cellStyle: function () { return ({
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
    }); },
};
var dollarColumn = {
    filter: 'agNumberColumnFilter',
    valueFormatter: function (_a) {
        var value = _a.value;
        return new Intl.NumberFormat('en-US', {
            currency: 'USD',
            style: 'currency',
        }).format(value);
    },
};
var dateColumn = {
    filter: 'dateRangeFilter',
    headerComponentParams: {
        filterIcon: FilterIcon.FILTER,
    },
    valueFormatter: function (_a) {
        var value = _a.value;
        return value ? makeSimpleDate(value) : '';
    },
};
var dateTimeColumn = {
    filter: 'dateRangeFilter',
    headerComponentParams: {
        filterIcon: FilterIcon.FILTER,
    },
    valueFormatter: function (_a) {
        var value = _a.value;
        var dt = DateTime.fromJSDate(value);
        return value ? dt.setLocale('en-US').toFormat('MM/dd/yyyy TT') : '';
    },
};
var dateRangeColumn = {
    comparator: function (_a, _b) {
        var startA = _a[0], endA = _a[1];
        var startB = _b[0], endB = _b[1];
        if (startA === startB) {
            return Number(endA) - Number(endB);
        }
        return Number(startA) - Number(startB);
    },
    filter: 'dateRangeFilter',
    valueFormatter: function (_a) {
        var _b = _a.data, startDate = _b.startDate, endDate = _b.endDate;
        var startDateString = makeSimpleDate(new Date(startDate));
        var endDateString = makeSimpleDate(new Date(endDate));
        return "".concat(startDateString, " \u2013 ").concat(endDateString);
    },
};
var activeStatusColumn = {
    cellRendererFramework: function (params) {
        var _a = params.activeText, activeText = _a === void 0 ? StatusType.Active : _a, _b = params.inactiveText, inactiveText = _b === void 0 ? StatusType.Inactive : _b, isActive = params.isActive;
        var intent = isActive(params) ? Intent.SUCCESS : Intent.NONE;
        var text = isActive(params) ? activeText : inactiveText;
        return (jsx(StatusDot, __assign({ important: true, status: intent }, { children: text })));
    },
    headerName: 'Status',
    suppressMenu: true,
};
var textColumn = {
    filter: 'simpleTextFilter',
    headerComponentParams: {
        filterIcon: FilterIcon.SEARCH,
    },
};
var idColumn = {
    cellStyle: { paddingLeft: 24 },
    filter: 'simpleTextFilter',
    filterParams: { placeHolder: 'Search by ID' },
    headerName: 'ID',
    resizable: false,
    width: 120,
};

var columnTypes = /*#__PURE__*/Object.freeze({
    __proto__: null,
    basicColumn: basicColumn,
    basicNoSortColumn: basicNoSortColumn,
    centerColumn: centerColumn,
    dollarColumn: dollarColumn,
    dateColumn: dateColumn,
    dateTimeColumn: dateTimeColumn,
    dateRangeColumn: dateRangeColumn,
    activeStatusColumn: activeStatusColumn,
    textColumn: textColumn,
    idColumn: idColumn
});

var setMinWidthOnColumns = function (_a) {
    var columnApi = _a.columnApi;
    return __awaiter(void 0, void 0, void 0, function () {
        var columns;
        return __generator(this, function (_b) {
            columns = columnApi.getColumns();
            columns === null || columns === void 0 ? void 0 : columns.forEach(function (column) { return __awaiter(void 0, void 0, void 0, function () {
                var manualMinWidth, colDef, colId, columnHeaderSelector, headerTitleElem, offsetWidth, newColDef;
                return __generator(this, function (_a) {
                    manualMinWidth = column.getMinWidth();
                    colDef = column.getColDef();
                    colId = column.getColId();
                    columnHeaderSelector = ".ag-header-cell[col-id=\"".concat(colId, "\"] .column-header-title");
                    headerTitleElem = document.querySelector(columnHeaderSelector);
                    if (headerTitleElem) {
                        offsetWidth = headerTitleElem.offsetWidth;
                        newColDef = __assign(__assign({}, colDef), { 
                            // 88px accounts for 24px of padding on either side +
                            // ~40px in width for sort/filter icons.
                            minWidth: Math.max(offsetWidth + 88, manualMinWidth !== null && manualMinWidth !== void 0 ? manualMinWidth : 0) });
                        column.setColDef(newColDef, newColDef);
                    }
                    return [2 /*return*/];
                });
            }); });
            return [2 /*return*/];
        });
    });
};
var defaults = {
    cacheBlockSize: 100,
    columnTypes: columnTypes,
    defaultColDef: {
        autoHeaderHeight: true,
        autoHeight: true,
        headerComponentParams: {
            filterIcon: FilterIcon.SEARCH,
        },
        menuTabs: ['filterMenuTab'],
        resizable: true,
        sortable: true,
        wrapHeaderText: true,
    },
    domLayout: 'autoHeight',
    enableRangeSelection: true,
    frameworkComponents: {
        agColumnHeader: ColumnHeader,
        dateRangeFilter: DateRangeFilter,
        numberRangeFilter: NumberRangeFilter,
        simpleTextFilter: SimpleTextFilter,
    },
    headerHeight: 52,
    immutableData: true,
    maxBlocksInCache: 100,
    paginationPageSize: 100,
    reactUi: true,
    rowBuffer: 10,
    rowSelection: 'multiple',
    suppressContextMenu: true,
    suppressDragLeaveHidesColumns: true,
};
/**
 * Merges Control Center default AgGrid options with overrides.
 */
var usePortalAgGridOptions = function (overrides) {
    var eventHandlers = useMemo(function () { return ({
        onColumnEverythingChanged: function (event) {
            var _a;
            setMinWidthOnColumns(event);
            (_a = overrides === null || overrides === void 0 ? void 0 : overrides.onColumnEverythingChanged) === null || _a === void 0 ? void 0 : _a.call(overrides, event);
        },
        onGridReady: function (event) {
            var _a;
            setMinWidthOnColumns(event);
            (_a = overrides === null || overrides === void 0 ? void 0 : overrides.onGridReady) === null || _a === void 0 ? void 0 : _a.call(overrides, event);
        },
    }); }, []);
    return __assign(__assign(__assign(__assign({}, defaults), overrides), { defaultColDef: __assign(__assign({}, defaults.defaultColDef), overrides === null || overrides === void 0 ? void 0 : overrides.defaultColDef), frameworkComponents: __assign(__assign({}, defaults.frameworkComponents), overrides === null || overrides === void 0 ? void 0 : overrides.frameworkComponents) }), eventHandlers);
};

var columnsDefsForCostPerSubAccountId = [
    {
        field: 'key',
        flex: 1,
        headerName: 'Sub Account ID',
    },
    {
        field: 'value',
        flex: 1,
        headerName: 'Amount',
    },
];
var columnsDefsForCostPerOfferId = [
    {
        field: 'key',
        flex: 1,
        headerName: 'Offer ID',
    },
    {
        field: 'value',
        flex: 1,
        headerName: 'Amount',
    },
];
var columnDefsForPercentByFundedLoanAmount = [
    {
        field: 'key',
        flex: 1,
        headerName: 'Funded Loan Amount (Upper Bound)',
    },
    {
        field: 'value',
        flex: 1,
        headerName: 'Network Payout %',
    },
    {
        field: 'demandPlatformFeePercent',
        flex: 1,
        headerName: 'Demand Platform Fee %',
    },
];
var columnDefsForPercentBySupplySubAccountId = [
    {
        field: 'key',
        flex: 1,
        headerName: 'Supply Sub Account ID',
    },
    {
        field: 'value',
        flex: 1,
        headerName: 'Network Payout %',
    },
    {
        field: 'demandPlatformFeePercent',
        flex: 1,
        headerName: 'Demand Platform Fee %',
    },
    {
        field: 'totalReceivablePercent',
        flex: 1,
        headerName: 'Total Receivable %',
    },
];
var PricingPlan = function (_a) {
    var count = _a.count, revenueClause = _a.revenueClause, type = _a.type;
    var basePercent = revenueClause.basePercent, cost = revenueClause.cost, costPerOfferId = revenueClause.costPerOfferId, costPerSubAccountId = revenueClause.costPerSubAccountId, costPerSupplySubAccountId = revenueClause.costPerSupplySubAccountId, defaultCost = revenueClause.defaultCost, defaultDemandPlatformFeePercent = revenueClause.defaultDemandPlatformFeePercent, demandPlatformFeePercent = revenueClause.demandPlatformFeePercent, flatFee = revenueClause.flatFee, key = revenueClause.key, marginalPercent = revenueClause.marginalPercent, maxPercent = revenueClause.maxPercent, percent = revenueClause.percent, percentByFundedLoanAmount = revenueClause.percentByFundedLoanAmount, percentBySupplySubAccountId = revenueClause.percentBySupplySubAccountId, threshold = revenueClause.threshold, totalReceivablePercent = revenueClause.totalReceivablePercent;
    var gridOptions = usePortalAgGridOptions();
    return (jsxs("div", __assign({ className: "pricing-plan" }, { children: [jsxs("div", __assign({ className: "pricing-plan-title" }, { children: ["Pricing Plan ", count] })), jsxs("div", __assign({ className: "pricing-plan-properties" }, { children: [jsx(DataProperty, __assign({ isInRow: true, label: "Product Type" }, { children: jsx(Tag, { children: startCase(type) }) })), jsx(DataProperty, __assign({ isInRow: true, label: "Pricing Model" }, { children: jsx(Tag, __assign({ multiline: true }, { children: startCase(key) })) })), Boolean(cost) && (jsx(DataProperty, __assign({ isInRow: true, label: "Amount" }, { children: moneyFormatter(cost) }))), Boolean(defaultCost) && (jsx(DataProperty, __assign({ isInRow: true, label: "Default Amount" }, { children: moneyFormatter(defaultCost) }))), Boolean(threshold) && (jsx(DataProperty, __assign({ isInRow: true, label: "Threshold" }, { children: moneyFormatter(threshold) }))), Boolean(flatFee) && (jsx(DataProperty, __assign({ isInRow: true, label: "Flat Fee" }, { children: moneyFormatter(flatFee) }))), Boolean(defaultDemandPlatformFeePercent) && (jsx(DataProperty, __assign({ isInRow: true, label: "Default Demand Platform Fee %" }, { children: percentFormatter(defaultDemandPlatformFeePercent) }))), Boolean(demandPlatformFeePercent) &&
                        Boolean(!defaultDemandPlatformFeePercent) && (jsx(DataProperty, __assign({ isInRow: true, label: "Demand Platform Fee %" }, { children: percentFormatter(demandPlatformFeePercent) }))), Boolean(percent) && (jsx(DataProperty, __assign({ isInRow: true, label: "Network Payout %" }, { children: percentFormatter(percent) }))), Boolean(basePercent) && (jsx(DataProperty, __assign({ isInRow: true, label: "Base %" }, { children: percentFormatter(basePercent) }))), Boolean(maxPercent) && (jsx(DataProperty, __assign({ isInRow: true, label: "Network Max Percent %" }, { children: percentFormatter(maxPercent) }))), Boolean(marginalPercent) && (jsx(DataProperty, __assign({ isInRow: true, label: "Marginal %" }, { children: percentFormatter(marginalPercent) }))), Boolean(totalReceivablePercent) && (jsx(DataProperty, __assign({ isInRow: true, label: "Total Receivable %" }, { children: percentFormatter(totalReceivablePercent) })))] })), Boolean(costPerSubAccountId) && (jsx("div", __assign({ className: "ag-theme-alpine" }, { children: jsx(AgGridReact, { columnDefs: columnsDefsForCostPerSubAccountId, gridOptions: gridOptions, rowData: costPerSubAccountId }) }))), Boolean(costPerSupplySubAccountId) && (jsx("div", __assign({ className: "ag-theme-alpine" }, { children: jsx(AgGridReact, { columnDefs: columnsDefsForCostPerSubAccountId, gridOptions: gridOptions, rowData: costPerSupplySubAccountId }) }))), Boolean(costPerOfferId) && (jsx("div", __assign({ className: "ag-theme-alpine" }, { children: jsx(AgGridReact, { columnDefs: columnsDefsForCostPerOfferId, gridOptions: gridOptions, rowData: costPerOfferId }) }))), Boolean(percentByFundedLoanAmount) && (jsx("div", __assign({ className: "ag-theme-alpine" }, { children: jsx(AgGridReact, { columnDefs: columnDefsForPercentByFundedLoanAmount, gridOptions: gridOptions, rowData: percentByFundedLoanAmount }) }))), Boolean(percentBySupplySubAccountId) && (jsx("div", __assign({ className: "ag-theme-alpine" }, { children: jsx(AgGridReact, { columnDefs: columnDefsForPercentBySupplySubAccountId, gridOptions: gridOptions, rowData: percentBySupplySubAccountId }) })))] })));
};

var ActiveContractCard = function (props) {
    var _a;
    var readOnly = props.readOnly, demandContract = props.demandContract, demandSubAccount = props.demandSubAccount;
    var DEMAND_CONTRACT = 'demand contract';
    var _b = useState(), demandContractToDuplicate = _b[0], setDemandContractToDuplicate = _b[1];
    var _c = useToggle(false), showDemandContractCreateForm = _c[0], toggleDemandContractCreateForm = _c[1];
    var createDemandContractMutation = useMutation(createDemandContract);
    var deleteDemandContractMutation = useMutation(deleteDemandContract);
    var handleDuplicate = function (demandContract) {
        setDemandContractToDuplicate(demandContract);
        toggleDemandContractCreateForm();
    };
    var handleClose = function () {
        toggleDemandContractCreateForm();
        setDemandContractToDuplicate(undefined);
    };
    var appendClauseIfExists = function (clause, clauseKey) {
        var _a;
        var items = clause[clauseKey];
        return items
            ? (_a = {},
                _a[clauseKey] = items.map(function (item) { return (__assign(__assign({}, item), { key: Number(item.key), value: Number(item.value) })); }),
                _a) : {};
    };
    var sanitizeRevenueClause = function (clause) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        clause.demandPlatformFeePercent; 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        clause.totalReceivablePercent; 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        clause.type; var restClause = __rest(clause, ["demandPlatformFeePercent", "totalReceivablePercent", "type"]);
        var sanitizedRestClause = Object.fromEntries(Object.entries(restClause).filter(function (_a) {
            var value = _a[1];
            return value !== undefined;
        }));
        return sanitizedRestClause;
    };
    var handleSubmit = function (formData) {
        var _a, _b;
        var createData = {
            demandPlatformFeeConfig: formData.demandPlatformFeeConfig,
            effectiveAt: formData.effectiveAt,
            revenueClauses: formData.revenueClauses.map(function (clause) { return (__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, sanitizeRevenueClause(clause)), (clause.cost !== undefined && {
                cost: Number(clause.cost),
            })), (clause.defaultCost !== undefined && {
                flatFee: Number(clause.defaultCost),
            })), (clause.flatFee !== undefined && {
                flatFee: Number(clause.flatFee),
            })), (clause.threshold !== undefined && {
                threshold: Number(clause.threshold),
            })), appendClauseIfExists(clause, 'costPerSubAccountId')), appendClauseIfExists(clause, 'costPerSupplySubAccountId')), appendClauseIfExists(clause, 'percentByFundedLoanAmount')), appendClauseIfExists(clause, 'percentBySupplySubAccountId'))); }),
            salesforceOpportunityIdOrUrl: formData.salesforceOpportunityIdOrUrl,
            subAccountUuid: (_b = (_a = formData.subAccount) === null || _a === void 0 ? void 0 : _a.uuid) !== null && _b !== void 0 ? _b : '',
        };
        createDemandContractMutation.mutate(createData);
    };
    var onDelete = function (id) {
        deleteDemandContractMutation.mutate(id, {
            onError: function () {
                CrudToaster.deleteFailure(DEMAND_CONTRACT);
            },
            onSuccess: function () {
                CrudToaster.deleteSuccess(DEMAND_CONTRACT);
            },
        });
    };
    var title = 'Active Contract';
    var renderDemandContractFormDrawer = (jsx(DemandContractFormDrawer, { demandContractToDuplicate: demandContractToDuplicate, isSubmitting: createDemandContractMutation.isLoading, productType: (_a = demandContract === null || demandContract === void 0 ? void 0 : demandContract.productType) !== null && _a !== void 0 ? _a : '', selectedDemandSubAccount: demandSubAccount, visible: showDemandContractCreateForm, onClose: handleClose, onSubmit: handleSubmit }));
    var headerContent = !readOnly && (jsxs(Fragment, { children: [Boolean(demandContract) && (jsx(ConfirmableAction, __assign({ message: DELETE_CONTRACT_CONFIRMATION_MESSAGE, onOk: function () { return onDelete(demandContract === null || demandContract === void 0 ? void 0 : demandContract.id); } }, { children: jsx(EvenButton, __assign({ outlined: true }, { children: "Delete" })) }))), Boolean(demandContract) && (jsx(EvenButton, __assign({ outlined: true, onClick: function () { return handleDuplicate(demandContract); } // @todo double check typing
             }, { children: "Duplicate" }))), jsx(EvenCreateNewButton, __assign({ onClick: toggleDemandContractCreateForm }, { children: "Create" }))] }));
    if (!demandContract) {
        return (jsxs(Fragment, { children: [jsx(RoundedCard, __assign({ headerContent: headerContent, title: title }, { children: jsx(NoData, { description: "No active contract found" }) })), renderDemandContractFormDrawer] }));
    }
    var id = demandContract.id, effectiveAt = demandContract.effectiveAt, createdAt = demandContract.createdAt, createdBy = demandContract.createdBy, demandPlatformFeeConfig = demandContract.demandPlatformFeeConfig, productType = demandContract.productType, revenueClauses = demandContract.revenueClauses;
    var demandPlatformFeePercent = (function () {
        var percent = Number(demandPlatformFeeConfig === null || demandPlatformFeeConfig === void 0 ? void 0 : demandPlatformFeeConfig.config.percent);
        return isNaN(percent) ? '0' : (percent * 100).toString();
    })();
    return (jsxs(Fragment, { children: [jsx(RoundedCard, __assign({ headerContent: headerContent, title: title }, { children: jsxs(RoundedCard.Content, __assign({ className: "active-contract-card-data" }, { children: [jsxs("div", __assign({ className: "active-contract-card-data-properties" }, { children: [jsx(DataProperty, __assign({ isInRow: true, label: "ID" }, { children: id })), jsx(DataProperty, __assign({ isInRow: true, label: "Effective At" }, { children: formatDate$1(effectiveAt) })), jsx(DataProperty, __assign({ isInRow: true, label: "Created At" }, { children: formatDateTimeShort(createdAt) })), jsx(DataProperty, __assign({ isInRow: true, label: "Created By" }, { children: jsx(UserAvatar, { name: createdBy === null || createdBy === void 0 ? void 0 : createdBy.fullName }) }))] })), jsx("div", { children: revenueClauses.map(function (revenueClause, index) {
                                var _a, _b;
                                return (jsx(PricingPlan
                                // No other great alternative for key value
                                , { count: index + 1, revenueClause: __assign(__assign({}, revenueClause), { demandPlatformFeePercent: demandPlatformFeePercent, percentByFundedLoanAmount: (_a = revenueClause.percentByFundedLoanAmount) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
                                            var _b, _c, _d, _e, _f, _g;
                                            var key = _a.key, value = _a.value;
                                            return ({
                                                demandPlatformFeePercent: ((_d = (_c = (_b = demandPlatformFeeConfig === null || demandPlatformFeeConfig === void 0 ? void 0 : demandPlatformFeeConfig.config) === null || _b === void 0 ? void 0 : _b.tiers) === null || _c === void 0 ? void 0 : _c[key]) === null || _d === void 0 ? void 0 : _d.percent)
                                                    ? (Number((_g = (_f = (_e = demandPlatformFeeConfig === null || demandPlatformFeeConfig === void 0 ? void 0 : demandPlatformFeeConfig.config) === null || _e === void 0 ? void 0 : _e.tiers) === null || _f === void 0 ? void 0 : _f[key]) === null || _g === void 0 ? void 0 : _g.percent) * 100).toString()
                                                    : '0',
                                                key: key,
                                                value: value,
                                            });
                                        }), percentBySupplySubAccountId: (_b = revenueClause.percentBySupplySubAccountId) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
                                            var _b, _c, _d;
                                            var key = _a.key, value = _a.value;
                                            var demandPlatformFeePercent = ((_d = (_c = (_b = demandPlatformFeeConfig === null || demandPlatformFeeConfig === void 0 ? void 0 : demandPlatformFeeConfig.config) === null || _b === void 0 ? void 0 : _b.supplySubAccounts) === null || _c === void 0 ? void 0 : _c[key]) === null || _d === void 0 ? void 0 : _d.percent)
                                                ? (Number(demandPlatformFeeConfig.config
                                                    .supplySubAccounts[key].percent) * 100).toString()
                                                : '0';
                                            var totalReceivablePercent = calculateTotalReceivablePercent(value, demandPlatformFeePercent);
                                            return {
                                                demandPlatformFeePercent: demandPlatformFeePercent,
                                                key: key,
                                                totalReceivablePercent: totalReceivablePercent,
                                                value: value,
                                            };
                                        }) }), type: productType }, index));
                            }) })] })) })), renderDemandContractFormDrawer] }));
};

var ColumnDefs;
(function (ColumnDefs) {
    ColumnDefs["ACTIVE_STATUS"] = "activeStatusColumn";
    ColumnDefs["CENTERED"] = "centerColumn";
    ColumnDefs["DATE"] = "dateColumn";
    ColumnDefs["DATE_RANGE"] = "dateRangeColumn";
    ColumnDefs["DATE_TIME"] = "dateTimeColumn";
    ColumnDefs["DOLLAR"] = "dollarColumn";
    ColumnDefs["ID"] = "idColumn";
    ColumnDefs["NUMERIC"] = "numericColumn";
    ColumnDefs["RIGHT_ALIGNED"] = "rightAligned";
    ColumnDefs["TEXT"] = "textColumn";
})(ColumnDefs || (ColumnDefs = {}));

var HeaderWithActions = function (_a) {
    var title = _a.title, children = _a.children, className = _a.className;
    return (jsxs("div", __assign({ className: "header-with-actions" }, { children: [title && jsx("span", __assign({ className: className }, { children: title })), jsx("div", __assign({ className: "actions" }, { children: children }))] })));
};

var DetailHeader = function (_a) {
    var aboveTitleContent = _a.aboveTitleContent, aboveTitleTopRightContent = _a.aboveTitleTopRightContent, children = _a.children, className = _a.className, nextToTitleContent = _a.nextToTitleContent, title = _a.title;
    return (jsxs("header", __assign({ className: classNames('detail-header', className) }, { children: [jsxs("div", __assign({ className: "above-title-wrapper" }, { children: [jsx("div", __assign({ className: "above-title-content" }, { children: aboveTitleContent })), jsx("div", __assign({ className: "above-title-top-right-content" }, { children: aboveTitleTopRightContent }))] })), jsx(HeaderWithActions, __assign({ className: className, title: title }, { children: nextToTitleContent })), jsx("div", { children: children })] })));
};

var TemplateCenterDemandApisPanel = function (_a) {
    var _b;
    var refObj = _a.refObj, _c = _a.demandApis, demandApis = _c === void 0 ? [] : _c, onDemandApiToggle = _a.onDemandApiToggle, readOnly = _a.readOnly;
    var renderActivateCell = useCallback(function (_a) {
        var _b = _a.data, isActive = _b.isActive, subAccountId = _b.subAccountId, subAccountName = _b.subAccountName;
        return (jsx(Switch, { "aria-label": "Activate for ".concat(subAccountName), checked: isActive, disabled: readOnly, role: "checkbox", style: { margin: 0 }, onChange: function (_a) {
                var checked = _a.currentTarget.checked;
                onDemandApiToggle(checked, subAccountId);
            } }, subAccountId));
    }, [onDemandApiToggle, readOnly]);
    var columnDefs = useMemo(function () { return [
        {
            cellRenderer: renderActivateCell,
            field: 'isActive',
            filter: 'agSetColumnFilter',
            filterParams: {
                valueFormatter: function (_a) {
                    var value = _a.value;
                    return value === 'true' ? 'Activated' : 'Not Activated';
                },
            },
            flex: 3,
            headerComponentParams: {
                filterIcon: FilterIcon.FILTER,
            },
            headerName: 'Activate',
            minWidth: 150,
            sortable: true,
        },
        {
            field: 'subAccountId',
            filter: 'agSetColumnFilter',
            filterParams: { placeHolder: 'Search by Demand Sub-Account ID' },
            flex: 4,
            headerName: 'Demand Sub-Account ID',
            minWidth: 250,
            type: ColumnDefs.NUMERIC,
            valueFormatter: function (params) { var _a; return (_a = params.value) === null || _a === void 0 ? void 0 : _a.toString(); },
            valueParser: function (params) { return params.newValue; },
        },
        {
            field: 'subAccountName',
            filterParams: { placeHolder: 'Search by Demand Sub-Account Name' },
            flex: 6,
            headerName: 'Demand Sub-Account Name',
            minWidth: 250,
            type: ColumnDefs.TEXT,
        },
    ]; }, [renderActivateCell]);
    var uniqueDemandApis = useMemo(function () { return uniqBy(demandApis, 'subAccountId'); }, [demandApis]);
    var onGridReady = function (_a) {
        var columnApi = _a.columnApi;
        columnApi.applyColumnState({
            state: [{ colId: 'subAccountId', sort: 'asc' }],
        });
    };
    var gridOptions = usePortalAgGridOptions({ onGridReady: onGridReady });
    return (jsx(AgGridReact, { ref: refObj, pagination: true, className: classNames('demand-apis-table', (_b = {},
            _b[Classes.SKELETON] = !demandApis,
            _b)), 
        // There appears to be some kind of bug with enableRangeSelection being turned on:
        // https://stackoverflow.com/questions/69220165/react-typescript-ag-grid-cannot-read-property-addorremovecssclass-of-undefi
        columnDefs: columnDefs, enableRangeSelection: false, getRowId: function (_a) {
            var data = _a.data;
            return data.subAccountId;
        }, gridOptions: gridOptions, paginationPageSize: 25, rowData: uniqueDemandApis, rowHeight: 40 }));
};

var IncomeRange = function (props) {
    var _a = props.value, min = _a[0], max = _a[1];
    var formattedString = "".concat(moneyFormatter(min), " - ").concat(moneyFormatter(max));
    return jsx("span", { children: formattedString });
};

var Totaller = function (_a) {
    var accumulated = _a.accumulated, total = _a.total, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (jsx("span", __assign({ className: "totaller-widget ".concat(className) }, { children: jsx(StatusDot, __assign({ important: true, status: accumulated > 0 ? 'success' : 'none' }, { children: "".concat(accumulated, " of ").concat(total) })) })));
};

var OfferRulesTotaller = function (_a) {
    var value = _a.value;
    var amountActive = React.useMemo(function () {
        if (!value) {
            return 0;
        }
        return value.reduce(function (acc, curr) {
            if (curr.isActive) {
                return acc + 1;
            }
            return acc;
        }, 0);
    }, value);
    if (!value) {
        return jsx("span", { children: "n/a" });
    }
    return jsx(Totaller, { accumulated: amountActive, total: value.length });
};

var createOfferRulesChildren = function (activeOffer, offerRules, offerId) {
    if (!offerRules.length) {
        return undefined;
    }
    return offerRules.map(function (offerRule) {
        var _a, _b, _c, _d;
        var ruleIsActive = ((activeOffer === null || activeOffer === void 0 ? void 0 : activeOffer.offerRuleIds) || []).includes(offerRule.rootId);
        return {
            creditScores: offerRule.selfAssessedCreditScoreKeys,
            id: offerRule.id,
            incomeRange: [
                (_a = offerRule.annualIncomeRange) === null || _a === void 0 ? void 0 : _a.start,
                (_b = offerRule.annualIncomeRange) === null || _b === void 0 ? void 0 : _b.end,
            ],
            isActive: ruleIsActive,
            loanPurposes: offerRule.loanPurposeKeys,
            loanRangeAmount: [
                (_c = offerRule.loanAmountRange) === null || _c === void 0 ? void 0 : _c.start,
                (_d = offerRule.loanAmountRange) === null || _d === void 0 ? void 0 : _d.end,
            ],
            memo: offerRule.memo,
            offerId: offerId,
            rootId: offerRule.rootId,
            states: offerRule.stateAbbreviations,
        };
    });
};
var formatRowData = function (offerData, offerState) {
    var offers = offerData.map(function (offer) {
        var _a, _b, _c, _d;
        var activeOffer = offerState[offer.offerId];
        // the presence of "children" tells ag-grid to create a nested table.
        return {
            children: createOfferRulesChildren(activeOffer, offer.offerRules, offer.offerId),
            demandSubAccountId: (_a = offer.demandSubAccount) === null || _a === void 0 ? void 0 : _a.id,
            demandSubAccountName: (_b = offer.demandSubAccount) === null || _b === void 0 ? void 0 : _b.name,
            isActive: Boolean(activeOffer),
            offerCatalogProductType: (_c = offer.offerCatalog) === null || _c === void 0 ? void 0 : _c.productType,
            offerId: offer.offerId,
            offerName: ((_d = offer.offerCatalog) === null || _d === void 0 ? void 0 : _d.internalName) || offer.name,
        };
    });
    return offers;
};

var actions = {
    activateOffer: createAction('ACTIVATE_OFFER')(),
    activateOfferRule: createAction('ACTIVATE_OFFER_RULE')(),
    deactivateOffer: createAction('DEACTIVATE_OFFER')(),
    deactivateOfferRule: createAction('DEACTIVATE_OFFER_RULE')(),
    resetOffers: createAction('RESET_OFFERS')(),
    setOffers: createAction('SET_OFFERS')(),
};
var offersReducer = createReducer({})
    .handleAction(actions.activateOffer, function (state, _a) {
    var payload = _a.payload;
    return produce(state, function (draftState) {
        // offerRuleIds need to be added to FormSupplyTemplateOffer type.
        var offerRuleIds = payload.offerRules.map(function (rule) { return rule.rootId; });
        draftState[payload.offerId] = __assign(__assign({}, payload), { offerRuleIds: offerRuleIds });
    });
})
    .handleAction(actions.deactivateOffer, function (state, _a) {
    var payload = _a.payload;
    return produce(state, function (draftState) {
        var offerId = payload.offerId;
        delete draftState[offerId];
    });
})
    .handleAction(actions.activateOfferRule, function (state, _a) {
    var payload = _a.payload;
    return produce(state, function (draftState) {
        var offerId = payload.offer.offerId;
        if (draftState[offerId]) {
            draftState[offerId].offerRuleIds.push(payload.offerRuleId);
        }
        else {
            var newOffer = __assign(__assign({}, payload.offer), { offerRuleIds: [payload.offerRuleId] });
            draftState[offerId] = newOffer;
        }
    });
})
    .handleAction(actions.deactivateOfferRule, function (state, _a) {
    var payload = _a.payload;
    return produce(state, function (draftState) {
        var offerId = payload.offer.offerId;
        var offerRuleIds = draftState[offerId].offerRuleIds.filter(function (id) { return id !== payload.offerRuleId; });
        if (offerRuleIds.length) {
            draftState[offerId].offerRuleIds = offerRuleIds;
        }
        else {
            // if there are no Offer Rules remaining then remove the Offer itself
            delete draftState[offerId];
        }
    });
})
    .handleAction(actions.setOffers, function (_state, _a) {
    var payload = _a.payload;
    return keyBy(payload, 'offerId');
});

var TemplateCenterOffersPanel = function (_a) {
    var isOfferCatalog = _a.isOfferCatalog, offerData = _a.offerData, readOnly = _a.readOnly, refObj = _a.refObj, offerState = _a.offerState, dispatch = _a.dispatch;
    var gridOptions = usePortalAgGridOptions({
        defaultColDef: {
            filter: false,
            flex: 1,
            headerComponentParams: {
                filterIcon: FilterIcon.FILTER,
            },
            suppressMovable: true,
        },
        onGridReady: function (_a) {
            var columnApi = _a.columnApi;
            columnApi.applyColumnState({
                state: [{ colId: 'offerId', sort: 'asc' }],
            });
        },
    });
    var offerHandler = React.useCallback(function (compProps) {
        var offer = offerData === null || offerData === void 0 ? void 0 : offerData.find(function (offer) { return offer.offerId === compProps.data.offerId; });
        if (offer) {
            var isActive = !compProps.value;
            dispatch(isActive
                ? actions.activateOffer(offer)
                : actions.deactivateOffer(offer));
        }
        else {
            throw new Error('Could not find matching Static Offer.');
        }
    }, [offerData]);
    var columnDefs = React.useMemo(function () { return [
        {
            cellRendererParams: {
                innerRenderer: function (compProps) { return (jsx(Switch, { checked: compProps.value, disabled: readOnly, onChange: function () { return offerHandler(compProps); } })); },
            },
            cellRendererSelector: function (params) {
                if (!params.data.children) {
                    return {
                        component: function (compProps) { return (jsx(Switch, { checked: compProps.value, disabled: readOnly, onChange: function () { return offerHandler(compProps); } })); },
                        params: params,
                    };
                }
                return { component: 'agGroupCellRenderer', params: params };
            },
            field: 'isActive',
            filter: 'agSetColumnFilter',
            filterParams: {
                valueFormatter: function (_a) {
                    var value = _a.value;
                    return value === 'true' ? 'Activated' : 'Not Activated';
                },
            },
            headerName: 'Activate',
            minWidth: 100,
        },
        {
            field: 'demandSubAccountId',
            filter: 'agSetColumnFilter',
            filterParams: { placeHolder: 'Search by Demand Subaccount ID' },
            headerName: 'Demand Subaccount ID',
            minWidth: 100,
            type: ColumnDefs.NUMERIC,
            valueFormatter: function (params) { var _a; return (_a = params.value) === null || _a === void 0 ? void 0 : _a.toString(); },
            valueParser: function (params) { return params.newValue; },
        },
        {
            field: 'demandSubAccountName',
            filter: 'agSetColumnFilter',
            headerName: 'Demand Subaccount Name',
            minWidth: 175,
            type: ColumnDefs.TEXT,
        },
        {
            field: 'offerId',
            filter: 'agSetColumnFilter',
            filterParams: { placeHolder: 'Search by Offer ID' },
            headerName: 'Offer ID',
            minWidth: 100,
            type: ColumnDefs.NUMERIC,
            valueFormatter: function (params) { var _a; return (_a = params.value) === null || _a === void 0 ? void 0 : _a.toString(); },
            valueParser: function (params) { return params.newValue; },
        },
        {
            field: 'offerName',
            filter: 'agSetColumnFilter',
            minWidth: 175,
            type: ColumnDefs.TEXT,
        },
        {
            field: 'offerCatalogProductType',
            filter: 'agSetColumnFilter',
            headerName: 'Product Type',
            hide: !isOfferCatalog,
            minWidth: 175,
            type: ColumnDefs.TEXT,
        },
        __assign(__assign({ cellRendererFramework: OfferRulesTotaller, field: 'offerRules', minWidth: 150 }, basicNoSortColumn), { valueGetter: function (_a) {
                var data = _a.data;
                return data.children;
            } }),
        {
            field: 'offerRulesForExport',
            headerName: 'Offer Rules',
            hide: true,
            valueGetter: function (_a) {
                var data = _a.data;
                return JSON.stringify(data.children);
            },
        },
    ]; }, [readOnly, offerHandler]);
    var offerRuleHandler = React.useCallback(function (compProps) {
        var offer = offerData === null || offerData === void 0 ? void 0 : offerData.find(function (offer) { return offer.offerId === compProps.data.offerId; });
        if (offer) {
            var isActive = !compProps.value;
            var offerRuleId = compProps.data.rootId;
            var payload = { offer: offer, offerRuleId: offerRuleId };
            dispatch(isActive
                ? actions.activateOfferRule(payload)
                : actions.deactivateOfferRule(payload));
        }
        else {
            throw new Error('Could not find matching Static Offer.');
        }
    }, [offerData]);
    var offerRuleColumnDefs = React.useMemo(function () {
        return [
            {
                cellRenderer: function (compProps) { return (jsx(Checkbox, { checked: compProps.value, disabled: readOnly, onChange: function () { return offerRuleHandler(compProps); } })); },
                field: 'isActive',
                headerName: '',
                maxWidth: 75,
            },
            { field: 'id', maxWidth: 100 },
            {
                cellRenderer: IncomeRange,
                field: 'loanRangeAmount',
            },
            {
                cellRenderer: IncomeRange,
                field: 'incomeRange',
            },
            {
                cellRenderer: function (_a) {
                    var value = _a.value;
                    return jsx(Truncate, { text: value === null || value === void 0 ? void 0 : value.join(', ') });
                },
                field: 'creditScores',
            },
            {
                cellRenderer: function (_a) {
                    var value = _a.value;
                    return jsx(Truncate, { text: value === null || value === void 0 ? void 0 : value.join(', ') });
                },
                field: 'states',
            },
            {
                cellRenderer: function (_a) {
                    var value = _a.value;
                    return jsx(Truncate, { text: value === null || value === void 0 ? void 0 : value.join(', ') });
                },
                field: 'loanPurposes',
            },
            {
                cellRenderer: function (_a) {
                    var value = _a.value;
                    return jsx(Truncate, { text: value });
                },
                field: 'memo',
            },
        ].map(function (def) { return (__assign(__assign({}, def), basicNoSortColumn)); });
    }, [offerRuleHandler, readOnly]);
    var formattedRowData = React.useMemo(function () {
        return offerData ? formatRowData(offerData, offerState) : undefined;
    }, [offerData, offerState]);
    var detailCellRendererParams = React.useMemo(function () {
        return {
            detailGridOptions: {
                columnDefs: offerRuleColumnDefs,
                defaultColDef: gridOptions.defaultColDef,
                getRowId: function (params) {
                    return params.data.id;
                },
            },
            getDetailRowData: function (_a) {
                var data = _a.data, successCallback = _a.successCallback;
                successCallback(data.children);
            },
        };
    }, [offerRuleColumnDefs]);
    return (jsx(AgGridReact, { ref: refObj, detailRowAutoHeight: true, masterDetail: true, pagination: true, className: "custom-ag-grid", columnDefs: columnDefs, detailCellRendererParams: detailCellRendererParams, getRowId: function (params) {
            var _a = params.data, offerId = _a.offerId, offerCatalogProductType = _a.offerCatalogProductType;
            return offerId + '-' + (offerCatalogProductType || '');
        }, gridOptions: gridOptions, groupDefaultExpanded: 0, paginationPageSize: 25, rowData: formattedRowData, rowHeight: 40 }));
};

var ConfirmationDialogMessage = function (props) {
    var setMemo = props.setMemo, reason = props.reason, setReason = props.setReason;
    return (jsxs(Fragment, { children: [jsx(Field, __assign({ label: "Reason*", layout: FieldLayout.Horizontal }, { children: jsx(Select, { activeItem: reason, "data-testid": "inclusion-reason", itemKey: function (competitionType) { return competitionType; }, itemLabel: function (value) { var _a; return (_a = startCase(value)) !== null && _a !== void 0 ? _a : ''; }, items: [
                        InclusionReason.DemandOnboarding,
                        InclusionReason.DemandRequest,
                        InclusionReason.PoorPerformance,
                        InclusionReason.SupplyOnboarding,
                        InclusionReason.SupplyRequest,
                        InclusionReason.Other,
                    ], onItemSelect: setReason }) })), jsx(Field, __assign({ label: "Note", layout: FieldLayout.Horizontal }, { children: jsx(TextAreaWithCharacterLimit, { limit: 250, placeholder: 'Provide further details to the reason for creation', onChange: setMemo }) })), jsx("p", { children: "Changes to this sub account enablements will be immediate. This will not change the template if one was previously applied to this sub account." })] }));
};
var ConfirmationDialog = function (props) {
    var handleSubmit = props.handleSubmit, setReadOnly = props.setReadOnly, memo = props.memo, setMemo = props.setMemo, reason = props.reason, setReason = props.setReason;
    return (jsx(ConfirmableAction, __assign({ cancelText: "Cancel", message: jsx(ConfirmationDialogMessage, { memo: memo, reason: reason, setMemo: setMemo, setReason: setReason }), okText: "Ok, I understand", title: "Saving Enablement Changes", onOk: function () {
            setReadOnly(function (prevState) { return !prevState; });
            handleSubmit();
        } }, { children: jsx(Button, __assign({ intent: Intent.PRIMARY }, { children: "Save Changes" })) })));
};

var OfferCatalogPanel = function (props) {
    var dispatch = props.dispatch, offerState = props.offerState, readOnly = props.readOnly, refObj = props.refObj;
    var _a = useGetSubAccountsByIdQuery({
        subAccountTypeKey: SubAccountType.DemandSource,
    }).data, demandById = _a === void 0 ? {} : _a;
    var _b = useQuery(queries.ews.offerCatalog.offers({})).data, offerCatalogOffers = _b === void 0 ? [] : _b;
    var offerCatalogOffersByDemandSubAccountUuid = useMemo(function () {
        return offerCatalogOffers.reduce(function (acc, offer) {
            var key = offer.demandSubAccountUuid;
            if (key) {
                acc[key] = offer;
            }
            return acc;
        }, {});
    }, [offerCatalogOffers]);
    var offerUuids = offerCatalogOffers.map(function (offer) { return offer.uuid; });
    var _c = useQuery(queries.originator.admin.getStaticOffersWithRules({
        offerUuids: offerUuids,
    })).data, staticOffersWithRulesData = _c === void 0 ? [] : _c;
    var offerDataOfferCatalog = staticOffersWithRulesData
        .map(function (data) {
        var _a;
        var _b = data || {}, staticOffer = _b.staticOffer, _c = _b.offerRules, offerRules = _c === void 0 ? [] : _c;
        var demandSubAccountId = (_a = offerRules[0]) === null || _a === void 0 ? void 0 : _a.demandSubAccountId;
        var demandSubAccount = demandSubAccountId
            ? demandById[demandSubAccountId]
            : undefined;
        var offerCatalog = (demandSubAccount === null || demandSubAccount === void 0 ? void 0 : demandSubAccount.uuid)
            ? offerCatalogOffersByDemandSubAccountUuid[demandSubAccount.uuid]
            : undefined;
        var activeOfferRules = offerRules.filter(function (offerRule) { return !offerRule.deletedAt; });
        return __assign(__assign({}, staticOffer), { demandSubAccount: demandSubAccount, offerCatalog: offerCatalog, offerRules: activeOfferRules });
    })
        .filter(function (offer) {
        return offer.offerCatalog &&
            offer.offerRules.length &&
            offer.demandSubAccount &&
            !offer.demandSubAccount.deletedAt &&
            !!offer.offerId &&
            !!offer.id;
    });
    return (jsx("section", __assign({ className: "ag-theme-alpine", style: { height: '100%' } }, { children: jsx(TemplateCenterOffersPanel, { isOfferCatalog: true, dispatch: dispatch, offerData: offerDataOfferCatalog, offerState: offerState, readOnly: readOnly, refObj: refObj }) })));
};

var EnablementSection = function (props) {
    var _a;
    var demandApisWithStatus = props.demandApisWithStatus, demandApiToggledIds = props.demandApiToggledIds, enabledStaticOffers = props.enabledStaticOffers, productType = props.productType, secondLooksWithStatus = props.secondLooksWithStatus, handleDemandApiToggle = props.handleDemandApiToggle, handleSubmit = props.handleSubmit, setToggledIds = props.setToggledIds, staticOfferDispatch = props.staticOfferDispatch, reason = props.reason, setReason = props.setReason, memo = props.memo, setMemo = props.setMemo;
    var _b = useQuery(queries.originator.staticOffer.getStaticOffersByProductType({ productType: productType })).data, offerData = _b === void 0 ? [] : _b;
    var _c = useQuery(queries.originator.staticOffer.getStaticOffersByProductType({
        productType: ProductType.Other,
    })).data, offerData2L = _c === void 0 ? [] : _c;
    var _d = useState(TabIds$1.DemandApi), selectedTabId = _d[0], setSelectedTabId = _d[1];
    var _e = useState(true), readOnly = _e[0], setReadOnly = _e[1];
    var demandApiTabRef = React__default.useRef(null);
    var offerTabRef = React__default.useRef(null);
    var demandApiTab2L = React__default.useRef(null);
    var offer2LTabRef = React__default.useRef(null);
    var offerCatalogTabRef = React__default.useRef(null);
    var tabRefMap = (_a = {},
        _a[TabIds$1.DemandApi] = demandApiTabRef,
        _a[TabIds$1.DemandApi2L] = demandApiTab2L,
        _a[TabIds$1.Offers] = offerTabRef,
        _a[TabIds$1.Offers2L] = offer2LTabRef,
        _a[TabIds$1.OfferCatalogOffers] = offerCatalogTabRef,
        _a);
    var getCurrentExportParams = useCallback(function () {
        return selectedTabId === TabIds$1.DemandApi ||
            selectedTabId === TabIds$1.DemandApi2L
            ? {}
            : {
                columnKeys: [
                    'isActive',
                    'demandSubAccountId',
                    'demandSubAccountName',
                    'offerId',
                    'offerName',
                    'offerRulesForExport',
                ],
            };
    }, [selectedTabId]);
    var getCurrentTabRef = function () { return tabRefMap[selectedTabId]; };
    var _f = useGetSubAccountsByIdQuery({
        subAccountTypeKey: SubAccountType.DemandSource,
    }).data, demandById = _f === void 0 ? {} : _f;
    var handleTabChange = useCallback(function (newTabId) {
        setSelectedTabId(newTabId);
    }, []);
    var unsavedDemandApisWithStatus = useMemo(function () {
        return demandApisWithStatus.map(function (demandApi) { return (__assign(__assign({}, demandApi), { isActive: demandApiToggledIds.has(demandApi.subAccountId)
                ? !demandApi.isActive
                : demandApi.isActive })); });
    }, [demandApisWithStatus, demandApiToggledIds]);
    var unsavedDemandApi2LWithStatus = useMemo(function () {
        return secondLooksWithStatus.map(function (demandApi2L) { return (__assign(__assign({}, demandApi2L), { isActive: demandApiToggledIds.has(demandApi2L.subAccountId)
                ? !demandApi2L.isActive
                : demandApi2L.isActive })); });
    }, [secondLooksWithStatus, demandApiToggledIds]);
    var offerDataWithOfferRules = useMemo(function () {
        return offerData
            .filter(function (offer) { return offer.offerRules.length; })
            .map(function (offer) {
            var demandSubAccountId = offer.offerRules[0].demandSubAccountId;
            var demandSubAccount = demandById[demandSubAccountId];
            return __assign(__assign({}, offer), { demandSubAccount: demandSubAccount });
        });
    }, [offerData, demandById]);
    var offerData2LWithOfferRules = useMemo(function () {
        return offerData2L
            .filter(function (offer) { return offer.offerRules.length; })
            .map(function (offer) {
            var demandSubAccountId = offer.offerRules[0].demandSubAccountId;
            var demandSubAccount = demandById[demandSubAccountId];
            return __assign(__assign({}, offer), { demandSubAccount: demandSubAccount });
        });
    }, [offerData2L, demandById]);
    return (jsxs(Fragment, { children: [jsx(DetailHeader, { className: "demand-inclusions-section is-borderless subtitle", nextToTitleContent: jsxs("div", __assign({ className: "even-table-action-bar-buttons" }, { children: [readOnly ? (jsx(EditButton, { onClick: function () { return setReadOnly(function (prevState) { return !prevState; }); } })) : (jsxs(Fragment, { children: [jsx(EvenButton, __assign({ outlined: true, onClick: function () {
                                        setReadOnly(function (prevState) { return !prevState; });
                                        setToggledIds.reset();
                                        staticOfferDispatch(actions.resetOffers());
                                    } }, { children: "Cancel Changes" })), jsx(ConfirmationDialog, { handleSubmit: handleSubmit, memo: memo, reason: reason, setMemo: setMemo, setReadOnly: setReadOnly, setReason: setReason })] })), jsx(ClearAllButton, { gridRef: getCurrentTabRef() }), jsx(ExportCSVButton, { csvExportParams: getCurrentExportParams(), gridRef: getCurrentTabRef() })] })), title: "Demand Enablements" }), jsxs(Tabs, __assign({ selectedTabId: selectedTabId, onChange: handleTabChange }, { children: [jsx(Tab, { id: TabIds$1.DemandApi, panel: jsx("section", __assign({ className: "ag-theme-alpine", style: { height: '100%' } }, { children: jsx(TemplateCenterDemandApisPanel, { demandApis: unsavedDemandApisWithStatus, readOnly: readOnly, refObj: demandApiTabRef, onDemandApiToggle: handleDemandApiToggle }) })), title: "Demand APIs" }), jsx(Tab, { id: TabIds$1.Offers, panel: jsx("section", __assign({ className: "ag-theme-alpine", style: { height: '100%' } }, { children: jsx(TemplateCenterOffersPanel, { dispatch: staticOfferDispatch, offerData: offerDataWithOfferRules, offerState: enabledStaticOffers, readOnly: readOnly, refObj: offerTabRef }) })), title: "Static Offers" }), jsx(Tab, { id: TabIds$1.DemandApi2L, panel: jsx("section", __assign({ className: "ag-theme-alpine", style: { height: '100%' } }, { children: jsx(TemplateCenterDemandApisPanel, { demandApis: unsavedDemandApi2LWithStatus, readOnly: readOnly, refObj: demandApiTab2L, onDemandApiToggle: handleDemandApiToggle }) })), title: "Demand APIs 2L" }), jsx(Tab, { id: TabIds$1.Offers2L, panel: jsx("section", __assign({ className: "ag-theme-alpine", style: { height: '100%' } }, { children: jsx(TemplateCenterOffersPanel, { dispatch: staticOfferDispatch, offerData: offerData2LWithOfferRules, offerState: enabledStaticOffers, readOnly: readOnly, refObj: offer2LTabRef }) })), title: "Static Offers 2L" }), jsx(Tab, { id: TabIds$1.OfferCatalogOffers, panel: jsx(OfferCatalogPanel, { dispatch: staticOfferDispatch, offerState: enabledStaticOffers, readOnly: readOnly, refObj: offerCatalogTabRef }), title: "Offer Catalog Offers" })] }))] }));
};

enableMapSet();
var staticOffersInitialState = {
    activatedOffers: new Map(),
    deactivatedOffers: new Map(),
};
var staticOffersReducer = createReducer(staticOffersInitialState)
    .handleAction(actions.activateOffer, function (state, _a) {
    var payload = _a.payload;
    return produce(state, function (draftState) {
        payload.offerRules.forEach(function (offerRule) {
            var rootId = offerRule.rootId;
            if (draftState.deactivatedOffers.has(rootId)) {
                draftState.deactivatedOffers.delete(rootId);
            }
            else {
                draftState.activatedOffers.set(rootId, payload);
            }
        });
    });
})
    .handleAction(actions.deactivateOffer, function (state, _a) {
    var payload = _a.payload;
    return produce(state, function (draftState) {
        payload.offerRules.forEach(function (offerRule) {
            var rootId = offerRule.rootId;
            if (draftState.activatedOffers.has(rootId)) {
                draftState.activatedOffers.delete(rootId);
            }
            else {
                draftState.deactivatedOffers.set(rootId, payload);
            }
        });
    });
})
    .handleAction(actions.activateOfferRule, function (state, _a) {
    var payload = _a.payload;
    return produce(state, function (draftState) {
        var offer = payload.offer, offerRuleId = payload.offerRuleId;
        if (draftState.deactivatedOffers.has(offerRuleId)) {
            draftState.deactivatedOffers.delete(offerRuleId);
        }
        else {
            draftState.activatedOffers.set(offerRuleId, offer);
        }
    });
})
    .handleAction(actions.deactivateOfferRule, function (state, _a) {
    var payload = _a.payload;
    return produce(state, function (draftState) {
        var offer = payload.offer, offerRuleId = payload.offerRuleId;
        if (draftState.activatedOffers.has(offerRuleId)) {
            draftState.activatedOffers.delete(offerRuleId);
        }
        else {
            draftState.deactivatedOffers.set(offerRuleId, offer);
        }
    });
})
    .handleAction(actions.resetOffers, function () { return staticOffersInitialState; });

var HistoryActionType;
(function (HistoryActionType) {
    HistoryActionType["Disabled"] = "Disabled";
    HistoryActionType["Enabled"] = "Enabled";
})(HistoryActionType || (HistoryActionType = {}));

var demandSubAccountCellIdRenderer = function (_a) {
    var value = _a.value;
    if (!value) {
        return '--';
    }
    return jsx("a", __assign({ href: "/demand-sub-accounts/".concat(value.uuid) }, { children: value.id }));
};
var demandSubAccountCellNameRenderer = function (_a) {
    var value = _a.value;
    if (!value) {
        return '--';
    }
    return jsx("a", __assign({ href: "/demand-sub-accounts/".concat(value.uuid) }, { children: value.name }));
};
var userCellRenderer$1 = function (_a) {
    var value = _a.value;
    if (!value) {
        return '--';
    }
    return (jsx("a", __assign({ href: "/users/".concat(value.uuid) }, { children: "".concat(value.firstName, " ").concat(value.lastName) })));
};
var actionTypeCellRenderer = function (_a) {
    var value = _a.value;
    var intent = value === HistoryActionType.Enabled ? Intent.SUCCESS : Intent.DANGER;
    return (jsx(Tag, __assign({ intent: intent }, { children: value }), value));
};

var HistoryTable = function (props) {
    var history = props.history;
    var refObj = useRef(null);
    var gridOptions = usePortalAgGridOptions({
        defaultColDef: {
            filter: false,
            flex: 1,
            headerComponentParams: {
                filterIcon: FilterIcon.FILTER,
            },
            suppressMovable: true,
        },
        onGridReady: function (_a) {
            var columnApi = _a.columnApi;
            columnApi.applyColumnState({
                state: [{ colId: 'timestamp', sort: 'desc' }],
            });
            columnApi.autoSizeAllColumns();
        },
    });
    var columnDefs = useMemo(function () { return [
        {
            cellRenderer: actionTypeCellRenderer,
            field: 'actionType',
            filter: 'agSetColumnFilter',
            filterParams: {
                suppressMiniFilter: true,
            },
            headerComponentParams: {
                filterIcon: FilterIcon.FILTER,
            },
            headerName: 'Action',
            maxWidth: 120,
            type: ColumnDefs.TEXT,
        },
        {
            field: 'demandSubAccount.id',
            filter: 'agSetColumnFilter',
            headerName: 'Demand Subaccount ID',
            hide: true,
            type: ColumnDefs.TEXT,
        },
        {
            field: 'demandSubAccount.name',
            filter: 'agSetColumnFilter',
            headerName: 'Demand Subaccount Name',
            hide: true,
            type: ColumnDefs.TEXT,
        },
        {
            cellRenderer: demandSubAccountCellIdRenderer,
            field: 'demandSubAccount',
            filter: 'simpleTextFilter',
            filterParams: { placeHolder: 'Search by Demand Subaccount ID' },
            filterValueGetter: function (_a) {
                var _b;
                var data = _a.data;
                return (_b = data === null || data === void 0 ? void 0 : data.demandSubAccount) === null || _b === void 0 ? void 0 : _b.id;
            },
            flex: 0.5,
            headerName: 'Demand Subaccount ID',
            maxWidth: 145,
            type: ColumnDefs.TEXT,
        },
        {
            cellRenderer: demandSubAccountCellNameRenderer,
            field: 'demandSubAccount',
            filter: 'agSetColumnFilter',
            filterParams: { placeHolder: 'Search by Demand Subaccount Name' },
            filterValueGetter: function (_a) {
                var _b;
                var data = _a.data;
                return (_b = data === null || data === void 0 ? void 0 : data.demandSubAccount) === null || _b === void 0 ? void 0 : _b.name;
            },
            flex: 4,
            headerComponentParams: {
                filterIcon: FilterIcon.FILTER,
            },
            headerName: 'Demand Subaccount Name',
            minWidth: 175,
            type: ColumnDefs.TEXT,
        },
        {
            field: 'staticOffer.offerId',
            filter: 'simpleTextFilter',
            filterParams: { placeHolder: 'Search by Offer ID' },
            headerName: 'Offer ID',
            maxWidth: 115,
            type: ColumnDefs.TEXT,
        },
        {
            field: 'staticOffer.name',
            filter: 'agSetColumnFilter',
            filterParams: { placeHolder: 'Search by Offer Name' },
            flex: 4,
            headerComponentParams: {
                filterIcon: FilterIcon.FILTER,
            },
            headerName: 'Offer Name',
            minWidth: 185,
            type: ColumnDefs.TEXT,
        },
        {
            field: 'ruleId',
            filter: 'simpleTextFilter',
            filterParams: { placeHolder: 'Search by Offer Rule ID' },
            headerName: 'Rule ID',
            maxWidth: 110,
            type: ColumnDefs.TEXT,
        },
        {
            field: 'user.firstName',
            filter: 'agSetColumnFilter',
            headerName: 'First Name',
            hide: true,
            type: ColumnDefs.TEXT,
        },
        {
            field: 'user.lastName',
            filter: 'agSetColumnFilter',
            headerName: 'Last Name',
            hide: true,
            type: ColumnDefs.TEXT,
        },
        {
            cellRenderer: userCellRenderer$1,
            field: 'user',
            filter: 'agSetColumnFilter',
            filterParams: { placeHolder: 'Search by User' },
            filterValueGetter: function (_a) {
                var data = _a.data;
                if (data === null || data === void 0 ? void 0 : data.user) {
                    return "".concat(data.user.firstName, " ").concat(data.user.lastName);
                }
                return '';
            },
            flex: 2,
            headerComponentParams: {
                filterIcon: FilterIcon.FILTER,
            },
            headerName: 'User',
            minWidth: 130,
            type: ColumnDefs.TEXT,
        },
        {
            field: 'timestamp',
            filter: 'agDateColumnFilter',
            filterParams: { placeHolder: 'Search by Created At Date' },
            flex: 4,
            headerName: 'Timestamp',
            minWidth: 190,
            type: ColumnDefs.DATE_TIME,
            valueFormatter: function (params) {
                return params.value ? new Date(params.value).toLocaleString() : '';
            },
        },
    ]; }, []);
    return (jsxs(Fragment, { children: [jsx(DetailHeader, { className: "audit-history-section is-borderless subtitle", nextToTitleContent: jsxs("div", __assign({ className: "even-table-action-bar-buttons" }, { children: [jsx(ClearAllButton, { gridRef: refObj }), jsx(ExportCSVButton, { csvExportParams: {
                                columnKeys: [
                                    'actionType',
                                    'demandSubAccount.id',
                                    'demandSubAccount.name',
                                    'staticOffer.offerId',
                                    'staticOffer.name',
                                    'ruleId',
                                    'user.firstName',
                                    'user.lastName',
                                    'timestamp',
                                ],
                            }, gridRef: refObj })] })), title: "Audit History" }), jsx("div", __assign({ className: "ag-theme-alpine", style: { height: '100%' } }, { children: jsx(AgGridReact, { ref: refObj, detailRowAutoHeight: true, masterDetail: true, pagination: true, columnDefs: columnDefs, getRowId: function (params) { return params.data.id; }, gridOptions: gridOptions, groupDefaultExpanded: 0, paginationPageSize: 20, rowData: history, rowHeight: 35 }) }))] }));
};

var BenchmarkReportCard = function (_a) {
    var link = _a.link;
    return (jsx(RoundedCard, __assign({ headerContent: jsx(EvenAnchorButton, __assign({ onClick: function () { return window.open(link, '_blank'); } }, { children: "Go to Reports" })), title: "Benchmark Reports" }, { children: jsxs("div", __assign({ className: "benchmark-reports-card" }, { children: [jsx(FontAwesomeKitIcon, { color: colors.cistern, icon: KitIconNames.NullStateBenchmarkReport, size: "4x" }), jsx("p", { children: "Benchmark reports are analytics that we provide to our Financial Services Partners, allowing them to understand comparative performance against other Partners on our network." })] })) })));
};

var BillingActivity = function (_a) {
    var events = _a.events;
    return (jsxs(Fragment, { children: [jsx("div", __assign({ className: "portal-plist-title" }, { children: "Activity" })), jsx(Timeline, { children: events === null || events === void 0 ? void 0 : events.map(function (item) { return (jsxs(Timeline.Item, { children: [jsx("div", __assign({ className: "portal-timeline-date" }, { children: DateTime.fromJSDate(item.timestamp).toLocaleString(DateTime.DATETIME_MED) })), item.details || startCase(item.eventType)] }, item.timestamp.toString())); }) })] }));
};

var PortalClipboardType;
(function (PortalClipboardType) {
    PortalClipboardType["BlueTextIcon"] = "blue-text-icon";
    PortalClipboardType["TextIcon"] = "text-icon";
})(PortalClipboardType || (PortalClipboardType = {}));
var TextIcon = function (_a) {
    var text = _a.text, maxLength = _a.maxLength, className = _a.className;
    return (jsxs("div", __assign({ className: classNames('text-icon-component', className) }, { children: [jsx("span", __assign({ className: "text-icon-component-text" }, { children: maxLength ? truncate(text, { length: maxLength }) : text })), jsx(FontAwesomeIcon, { className: "text-icon-component-icon", icon: faCopy$1 })] })));
};
var PortalClipboard = function (_a) {
    var alterText = _a.alterText, type = _a.type, text = _a.text, _b = _a.maxLength, maxLength = _b === void 0 ? 0 : _b, className = _a.className;
    return (jsx(CopyToClipboard, __assign({ text: alterText || text, onCopy: function () { return Toaster.success('Copied to clipboard!'); } }, { children: jsx("div", __assign({ className: classNames('portal-clipboard', className) }, { children: jsx(TextIcon, { className: classNames({
                    'is-blue-text': type === PortalClipboardType.BlueTextIcon,
                }), maxLength: maxLength, text: text }) })) })));
};

var CollapseCard = function (_a) {
    var children = _a.children, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, headerTileContent = _a.headerTileContent, _c = _a.expandButtonLabel, expandButtonLabel = _c === void 0 ? 'Show Details' : _c, className = _a.className;
    var _d = React.useState(isOpen), cardOpen = _d[0], setCardOpen = _d[1];
    return (jsxs("div", __assign({ className: classNames('collapse-card', className) }, { children: [jsxs("div", __assign({ className: classNames('header-title', {
                    'button-right': Boolean(headerTileContent),
                }) }, { children: [headerTileContent, jsx(Button, __assign({ minimal: true, intent: Intent.PRIMARY, rightIcon: jsx(FontAwesomeIcon, { icon: cardOpen ? faChevronUp : faChevronDown }), onClick: function () { return setCardOpen(!cardOpen); } }, { children: expandButtonLabel }))] })), jsx(Collapse, __assign({ isOpen: cardOpen }, { children: children }))] })));
};

var CopyToClipboardButton = function (_a) {
    var buttonProps = _a.buttonProps, copyData = _a.copyData, children = _a.children;
    var onCopy = function () { return message.success('Copied to clipboard!', 1); };
    return (jsx(CopyToClipboard, __assign({ text: copyData ? copyData : (children === null || children === void 0 ? void 0 : children.toString()) || '', onCopy: onCopy }, { children: jsx(Button, __assign({ outlined: true, icon: jsx(FontAwesomeIcon, { icon: faCopy$1 }), intent: Intent.PRIMARY }, buttonProps, { children: children === null || children === void 0 ? void 0 : children.toString() })) })));
};

var Fields;
(function (Fields) {
    Fields["Strategy"] = "applicationStrategy";
    Fields["Template"] = "supplyInclusionsTemplate";
})(Fields || (Fields = {}));
var DemandInclusionTemplateModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, onSubmit = _a.onSubmit, templates = _a.templates;
    var form = useForm();
    var control = form.control, handleSubmit = form.handleSubmit, errors = form.formState.errors, reset = form.reset;
    React.useEffect(function () {
        reset();
    }, [isOpen]);
    return (jsxs(Dialog, __assign({ className: "demand-inclusions-template-modal", isOpen: isOpen, onClose: onClose }, { children: [jsx("h2", { children: "Apply New Demand Inclusion Template" }), jsx(Controller, { control: control, name: Fields.Template, render: function (_a) {
                    var _b;
                    var _c = _a.field, value = _c.value, onChange = _c.onChange;
                    return (jsx(Field, __assign({ error: (_b = errors[Fields.Template]) === null || _b === void 0 ? void 0 : _b.type, label: "Select Template" }, { children: jsx(Select, { activeItem: value, itemKey: function (_a) {
                                var id = _a.id;
                                return id;
                            }, itemLabel: function (_a) {
                                var id = _a.id, name = _a.name;
                                return "".concat(name, " (").concat(id, ")");
                            }, items: templates, onItemSelect: onChange }) })));
                }, rules: { required: true } }), jsx("h3", { children: "Define your template application strategy" }), jsx(Controller, { control: control, name: Fields.Strategy, render: function (_a) {
                    var _b;
                    var _c = _a.field, value = _c.value, onChange = _c.onChange;
                    return (jsxs("div", __assign({ className: "radio-group-wrapper" }, { children: [jsxs(RadioGroup, __assign({ className: "radio-group", selectedValue: value, onChange: onChange }, { children: [jsx(Radio, { label: "Remove & Apply", value: SupplyTemplateApplicationStrategy.AddAndRemove }), jsx(Radio, { label: "Keep & Apply", value: SupplyTemplateApplicationStrategy.AddOnly })] })), jsx("p", { children: "Remove all current Demand Inclusions for this Sub Account and Only apply the inclusions from this template" }), jsx("p", { children: "Keep curent Demand Inclusions for this Sub Account and Add any new inclusions from this template" }), errors[Fields.Strategy] && (jsx("div", __assign({ className: "field-error" }, { children: (_b = errors[Fields.Strategy]) === null || _b === void 0 ? void 0 : _b.type })))] })));
                }, rules: { required: true } }), jsxs("section", __assign({ className: "button-section" }, { children: [jsx(EvenButton, __assign({ outlined: true, onClick: onClose }, { children: "Cancel" })), jsx(EvenButton, __assign({ onClick: handleSubmit(onSubmit) }, { children: "Save & Apply Changes" }))] }))] })));
};

var DemandInclusionTemplatesListItem = function (_a) {
    var templateName = _a.templateName, lastApplied = _a.lastApplied, templateLastUpdated = _a.templateLastUpdated, templateUuid = _a.templateUuid, appliedBy = _a.appliedBy, notes = _a.notes;
    var outdated = !templateLastUpdated || templateLastUpdated > lastApplied;
    var templateNotFound = !templateName;
    return (jsx(CollapseCard, __assign({ className: "demand-inclusion-templates-list-item", headerTileContent: jsxs("section", __assign({ className: "title-content" }, { children: [templateNotFound ? (jsx("span", __assign({ className: "not-found" }, { children: "Template Not Found" }))) : (jsx("a", __assign({ className: "template-name", href: "/channels/template-center/".concat(templateUuid) }, { children: templateName }))), jsxs("div", __assign({ className: "last-applied" }, { children: [jsx("span", { children: "Last Applied: " }), formatDate$1(lastApplied), outdated && jsx("span", __assign({ className: "outdated" }, { children: "(outdated)" }))] }))] })) }, { children: jsxs("section", __assign({ className: "collapse-content" }, { children: [outdated && !templateNotFound && (jsxs(Callout, __assign({ intent: Intent.WARNING }, { children: ["The Demand Inclusion Template was last updated on", ' ', formatDate$1(templateLastUpdated), ", you will need to re-apply the template to see these changes reflected."] }))), jsx(Callout, __assign({ intent: Intent.PRIMARY }, { children: "Demand Inclusion Templates are intended for bulk inclusion management only. Individual inclusion changes can be made by accessing the Motherboard feature in Admin2." })), jsx("h4", { children: "Applied By" }), jsx(UserAvatar, { name: appliedBy }), jsx("h4", { children: "Description/Notes" }), jsx("p", { children: notes || '-' })] })) })));
};

var styles$d = {"container":"DetailTopBar-module_container__EFRel","back":"DetailTopBar-module_back__9lD4W","actions":"DetailTopBar-module_actions__6A3uG"};

var DetailTopBar = function (_a) {
    var _b = _a.backText, backText = _b === void 0 ? 'Back' : _b, actions = _a.actions, _c = _a.enableBackButton, enableBackButton = _c === void 0 ? true : _c, onBack = _a.onBack;
    return (jsxs("div", __assign({ className: styles$d.container }, { children: [enableBackButton && (jsx(Button, __assign({ minimal: true, className: styles$d.back, icon: jsx(FontAwesomeIcon, { icon: faAngleLeft }), onClick: onBack }, { children: backText }))), jsx("div", __assign({ className: styles$d.actions }, { children: actions }))] })));
};

var EvenLogo = function (_a) {
    var className = _a.className, showLargeLogo = _a.showLargeLogo, inverse = _a.inverse;
    return (jsxs(Fragment, { children: [showLargeLogo && (jsx("span", __assign({ className: className }, { children: jsx(FontAwesomeKitIcon, { icon: KitIconNames.CompanyLogoHorizontal, inverse: inverse, size: "3x" }) }))), !showLargeLogo && (jsx("span", __assign({ className: className }, { children: jsx(FontAwesomeKitIcon, { icon: KitIconNames.CompanyLogoVertical, inverse: inverse, size: "2x" }) })))] }));
};

var competitionTypeLabelMap = new Map([
    [
        CompetitionType.MarketplaceCompetitionBySubtype,
        'One secondary offer per product subtype',
    ],
    [
        CompetitionType.MarketplaceDynamicOfferPreference,
        'One secondary offer with preference to Second Look',
    ],
    [CompetitionType.Legacy, 'Legacy'],
]);
var SecondLookOfferConfigurationFieldGroup = function (_a) {
    var control = _a.control, path = _a.path, _b = _a.layout, layout = _b === void 0 ? FieldLayout.Horizontal : _b, readOnly = _a.readOnly;
    var getFieldName = function (name) { return (path ? "".concat(path, ".").concat(name) : name); };
    return (jsxs(Fragment, { children: [jsx(Controller, { control: control, defaultValue: 15, name: getFieldName('firstLookTimeout'), render: function (_a) {
                    var _b = _a.field, name = _b.name, onBlur = _b.onBlur, onChange = _b.onChange, value = _b.value;
                    return (jsx(Field, __assign({ extra: "(seconds)", inputId: name, label: "First Look Timeout", layout: layout }, { children: jsx(NumericInput, { "data-testid": "first-look-timeout", id: name, majorStepSize: 1, min: 0, readOnly: readOnly, stepSize: 1, value: value, onBlur: onBlur, onValueChange: onChange }) })));
                } }), jsx(Controller, { control: control, defaultValue: 15, name: getFieldName('secondLookTimeout'), render: function (_a) {
                    var _b = _a.field, name = _b.name, onBlur = _b.onBlur, onChange = _b.onChange, value = _b.value;
                    return (jsx(Field, __assign({ extra: "(seconds)", inputId: name, label: "Second Look Timeout", layout: layout }, { children: jsx(NumericInput, { "data-testid": "second-look-timeout", id: name, majorStepSize: 1, min: 0, readOnly: readOnly, stepSize: 1, value: value, onBlur: onBlur, onValueChange: onChange }) })));
                } }), jsx(Controller, { control: control, defaultValue: CompetitionType.MarketplaceCompetitionBySubtype, name: getFieldName('competitionType'), render: function (_a) {
                    var _b = _a.field, onChange = _b.onChange, value = _b.value;
                    return (jsx(Field, __assign({ label: "Competition Type", layout: layout }, { children: jsx(Select, { activeItem: value, "data-testid": "competition-type", disabled: readOnly, itemKey: function (competitionType) { return competitionType; }, itemLabel: function (value) { var _a; return (_a = competitionTypeLabelMap.get(value)) !== null && _a !== void 0 ? _a : ''; }, items: [
                                CompetitionType.MarketplaceCompetitionBySubtype,
                                CompetitionType.MarketplaceDynamicOfferPreference,
                                CompetitionType.Legacy,
                            ], onItemSelect: onChange }) })));
                } })] }));
};

var integrationTypeOptions = difference(Object.values(SupplySubAccountIntegrationType), ['cla', 'pls', 'credit_com_embed']);
var SupplySubAccountCreateForm = function (_a) {
    var _b, _c, _d;
    var _e = _a.accountOptions, accountOptions = _e === void 0 ? [] : _e, defaultValues = _a.defaultValues, onClose = _a.onClose, onSubmit = _a.onSubmit, visible = _a.visible, preSelectedAccount = _a.preSelectedAccount;
    var _f = useForm(), control = _f.control, errors = _f.formState.errors, handleSubmit = _f.handleSubmit, register = _f.register, reset = _f.reset, setValue = _f.setValue, watch = _f.watch;
    var integrationType = watch('integrationType');
    var supplyProductType = watch('supplyProductType');
    var leadHydrationEnabled = watch('leadHydrationEnabled');
    var leadHydrationCreditBucketsEnabled = watch('leadHydrationCreditBucketsEnabled');
    var disableAccountInput = Boolean(preSelectedAccount);
    var disableLeadDeduplication = !(integrationType === null || integrationType === void 0 ? void 0 : integrationType.includes('api'));
    var showLeadHydrationCreditBuckets = leadHydrationEnabled && supplyProductType !== ProductType$1.CreditCard;
    useEffect(function () {
        if (defaultValues) {
            reset(defaultValues);
        }
    }, [defaultValues]);
    useEffect(function () {
        if (preSelectedAccount) {
            setValue('account', preSelectedAccount);
        }
    }, [preSelectedAccount]);
    useEffect(function () {
        var isApiIntegrationType = integrationType === null || integrationType === void 0 ? void 0 : integrationType.includes('api');
        if (!isApiIntegrationType) {
            setValue('leadDeduplicationEnabled', false);
            setValue('leadDeduplication', undefined);
        }
        else {
            setValue('leadDeduplication', 1140);
        }
    }, [integrationType]);
    return (jsxs(DrawerForm, __assign({ disableCloseOnMouseDown: true, className: "supply-sub-account-create-form", title: "New Channel", visible: visible, onClose: onClose, onSubmit: handleSubmit(onSubmit) }, { children: [jsx(Controller, { control: control, name: "account", render: function (_a) {
                    var _b;
                    var _c = _a.field, onChange = _c.onChange, value = _c.value;
                    return (jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.account) === null || _b === void 0 ? void 0 : _b.message, label: "Account" }, { children: jsx(Select, { activeItem: value, "data-testid": "account-field", disabled: disableAccountInput, itemKey: function (_a) {
                                var id = _a.id;
                                return id;
                            }, itemLabel: function (_a) {
                                var name = _a.name;
                                return name;
                            }, items: accountOptions, onItemSelect: onChange }) })));
                }, rules: { required: 'Please select an account.' } }), jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.name) === null || _b === void 0 ? void 0 : _b.message, label: "Name" }, { children: jsx("input", __assign({ className: Classes.INPUT, "data-testid": "name-field" }, register('name', { required: 'Please input a name.' }))) })), jsx(Field, __assign({ error: (_c = errors === null || errors === void 0 ? void 0 : errors.displayName) === null || _c === void 0 ? void 0 : _c.message, label: "Display name", tooltip: "External name displayed to all Consumers and Partners" }, { children: jsx("input", __assign({ className: Classes.INPUT, "data-testid": "display-name-field" }, register('displayName', {
                    required: 'Please input a display name.',
                }))) })), jsx(Controller, { control: control, name: "integrationType", render: function (_a) {
                    var _b;
                    var _c = _a.field, onChange = _c.onChange, value = _c.value;
                    return (jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.integrationType) === null || _b === void 0 ? void 0 : _b.message, label: "Integration Type", tooltip: "Determines the asset that can be created from a supply sub account" }, { children: jsx(Select, { activeItem: value, "data-testid": "integration-type-field", itemKey: function (item) { return item; }, itemLabel: startCase, items: integrationTypeOptions, onItemSelect: onChange }) })));
                }, rules: { required: 'You must select an integration type.' } }), jsx(Controller, { control: control, name: "supplyProductType", render: function (_a) {
                    var _b;
                    var _c = _a.field, onChange = _c.onChange, value = _c.value;
                    return (jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.supplyProductType) === null || _b === void 0 ? void 0 : _b.message, label: "Supply Product Type", tooltip: "Product type associated with a supply sub account" }, { children: jsx(Select, { activeItem: value, "data-testid": "supply-product-type-field", itemKey: function (productType) { return productType; }, itemLabel: startCase, items: Object.values(ProductType$1), onItemSelect: onChange }) })));
                }, rules: { required: 'You must select a supply product type.' } }), jsx(Field, __assign({ error: (_d = errors === null || errors === void 0 ? void 0 : errors.description) === null || _d === void 0 ? void 0 : _d.message, label: "Description" }, { children: jsx("textarea", __assign({ className: classNames(Classes.INPUT, 'description-field'), "data-testid": "description-field", rows: 1 }, register('description', {
                    required: 'Please input a description.',
                }))) })), jsx(H4, __assign({ className: "heading" }, { children: "Settings" })), jsx(Controller, { control: control, name: "dataShare", render: function (_a) {
                    var _b;
                    var _c = _a.field, onChange = _c.onChange, value = _c.value;
                    return (jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.dataShare) === null || _b === void 0 ? void 0 : _b.message, label: "Data Share", tooltip: "Defaults to Eligible, which means we are permitted to share lead information with 3rd parties." }, { children: jsx(Select, { activeItem: value, "data-testid": "data-share-field", itemKey: function (dataShare) { return dataShare; }, itemLabel: startCase, items: Object.values(DataShareType), onItemSelect: onChange }) })));
                }, rules: { required: 'You must select a data share type' } }), jsx(Controller, { control: control, name: "leadDeduplicationEnabled", render: function (_a) {
                    var _b = _a.field, onBlur = _b.onBlur, onChange = _b.onChange, value = _b.value;
                    return (jsx(Switch, { checked: value, disabled: disableLeadDeduplication, label: "Lead Deduplication Enabled", style: { marginBottom: 25 }, onBlur: onBlur, onChange: onChange }));
                } }), jsx(Controller, { control: control, name: "leadDeduplication", render: function (_a) {
                    var _b;
                    var _c = _a.field, onBlur = _c.onBlur, onChange = _c.onChange, value = _c.value;
                    return (jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.leadDeduplication) === null || _b === void 0 ? void 0 : _b.message, extra: "(minutes)", label: "Lead Deduplication", tooltip: 'Only applicable to partners with Integration Type "API" if we are one of the partners in their funnel' }, { children: jsx(NumericInput, { disabled: disableLeadDeduplication, majorStepSize: 15, min: 0, stepSize: 15, value: value, onBlur: onBlur, onValueChange: onChange }) })));
                } }), jsx(Controller, { control: control, defaultValue: false, name: "leadHydrationEnabled", render: function (_a) {
                    var _b = _a.field, onBlur = _b.onBlur, onChange = _b.onChange, value = _b.value;
                    return (jsx(Switch, { checked: value, label: "Lead Hydration Enabled", style: { marginBottom: 25 }, onBlur: onBlur, onChange: onChange }));
                } }), showLeadHydrationCreditBuckets && (jsx(Controller, { control: control, name: "leadHydrationCreditBucketsEnabled", render: function (_a) {
                    var _b;
                    var _c = _a.field, value = _c.value, onChange = _c.onChange;
                    return (jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.leadHydrationCreditBucketsEnabled) === null || _b === void 0 ? void 0 : _b.map(function () { return message; }).join(', '), label: "Lead Hydration Credit Buckets" }, { children: jsx(MultiSelect, { activeItem: value, itemRemoveFilter: function (value, valueToRemove) {
                                return value !== valueToRemove;
                            }, itemRenderer: function (value, props) { return (jsx(SelectItem, __assign({ selectedItems: leadHydrationCreditBucketsEnabled, text: String(value) }, props), String(value))); }, items: Object.values(CreditBucket), tagRenderer: function (value) { return value; }, onChange: onChange }) })));
                } })), jsx(H4, __assign({ className: "heading" }, { children: "Secondary Offer Configuration" })), jsx(SecondLookOfferConfigurationFieldGroup, { control: control, path: "secondLookOfferConfiguration" }), jsx(H4, __assign({ className: "heading" }, { children: "Communication Eligibility" })), jsx(Controller, { control: control, defaultValue: false, name: "transactionalEmail", render: function (_a) {
                    var _b = _a.field, onBlur = _b.onBlur, onChange = _b.onChange, value = _b.value;
                    return (jsx(Switch, { checked: value, label: "Transactional", onBlur: onBlur, onChange: onChange }));
                } }), jsx(Controller, { control: control, defaultValue: false, name: "remarketingEmail", render: function (_a) {
                    var _b = _a.field, onBlur = _b.onBlur, onChange = _b.onChange, value = _b.value;
                    return (jsx(Switch, { checked: value, label: "Remarketing", onBlur: onBlur, onChange: onChange }));
                } }), jsx(Controller, { control: control, defaultValue: false, name: "coBrand", render: function (_a) {
                    var _b = _a.field, onBlur = _b.onBlur, onChange = _b.onChange, value = _b.value;
                    return (jsx(Switch, { checked: value, label: "Co-branded E-mails", onBlur: onBlur, onChange: onChange }));
                } }), jsx(Controller, { control: control, defaultValue: false, name: "lenderRemarketing", render: function (_a) {
                    var _b = _a.field, onBlur = _b.onBlur, onChange = _b.onChange, value = _b.value;
                    return (jsx(Field, __assign({ tooltip: "Allow Even's lender network to contact my leads" }, { children: jsx(Switch, { checked: value, label: "Lender Remarketing Email", onBlur: onBlur, onChange: onChange }) })));
                } })] })));
};

var UserSettingsForm = function (_a) {
    var defaultValues = _a.defaultValues, disableNameInputs = _a.disableNameInputs, onError = _a.onError, onPasswordReset = _a.onPasswordReset, onResendEmail = _a.onResendEmail, onSubmit = _a.onSubmit, showEmailVerificationButton = _a.showEmailVerificationButton, showPasswordResetButton = _a.showPasswordResetButton;
    var _b = useForm(), handleSubmit = _b.handleSubmit, register = _b.register, reset = _b.reset;
    useEffect(function () {
        reset(defaultValues);
    }, [defaultValues]);
    return (jsx(RoundedCard, __assign({ title: "Settings" }, { children: jsxs("div", __assign({ style: { margin: '0 auto', padding: '24px', width: '75%' } }, { children: [jsx(Field, __assign({ label: "First Name", layout: FieldLayout.Horizontal }, { children: jsx("input", __assign({ className: Classes.INPUT, "data-testid": UserField.FirstName, disabled: disableNameInputs }, register(UserField.FirstName, { required: true }))) })), jsx(Field, __assign({ label: "Last Name", layout: FieldLayout.Horizontal }, { children: jsx("input", __assign({ className: Classes.INPUT, "data-testid": UserField.LastName, disabled: disableNameInputs }, register(UserField.LastName, { required: true }))) })), jsx(Field, __assign({ label: "Email Address", layout: FieldLayout.Horizontal }, { children: jsx("input", __assign({ disabled: true, className: Classes.INPUT, "data-testid": UserField.EmailAddress }, register(UserField.EmailAddress, { required: true }))) })), showEmailVerificationButton && (jsx(Field, __assign({ label: "Email Verification", layout: FieldLayout.Horizontal }, { children: jsx(EvenButton, __assign({ minimal: true, onClick: onResendEmail }, { children: "Resend Verification Email" })) }))), showPasswordResetButton && (jsx(Field, __assign({ label: "Reset Password", layout: FieldLayout.Horizontal }, { children: jsx(EvenButton, __assign({ minimal: true, onClick: onPasswordReset }, { children: "Reset Password" })) }))), jsx("div", __assign({ style: { display: 'flex', justifyContent: 'flex-end' } }, { children: jsx(EvenButton, __assign({ onClick: handleSubmit(onSubmit, onError) }, { children: "Save changes" })) }))] })) })));
};

var styles$c = {"free-trial-banner":"FreeTrialBanner-module_free-trial-banner__4Y5yK","expiring-soon":"FreeTrialBanner-module_expiring-soon__FBnSN"};

var FreeTrialBanner = function (_a) {
    var freeTrialDaysLeft = _a.freeTrialDaysLeft, isPermanent = _a.isPermanent;
    return (jsx(Fragment, { children: isPermanent ? (jsx("div", __assign({ className: styles$c['free-trial-banner'] }, { children: jsx("span", { children: "Permanent Trial" }) }))) : (jsxs("div", __assign({ className: classNames([
                styles$c['free-trial-banner'],
                freeTrialDaysLeft <= 0 && styles$c['expiring-soon'],
            ]) }, { children: [jsx("span", { children: "Free Trial" }), freeTrialDaysLeft > 0 && (jsx("span", { children: "".concat(freeTrialDaysLeft, " day").concat(freeTrialDaysLeft === 1 ? '' : 's', " left") })), freeTrialDaysLeft === 0 && jsx("span", { children: "Expires Today" }), freeTrialDaysLeft < 0 && jsx("span", { children: "Expired" })] }))) }));
};

var ReactJson = dynamic(function () { return import('react-json-view'); }, { ssr: false });
var JsonDisplayCard = function (props) {
    var schema = props.schema;
    return (jsx("div", __assign({ className: "json-container" }, { children: jsx(ReactJson, { displayDataTypes: false, name: false, src: schema, style: { padding: '20px' }, theme: "monokai" }) })));
};

var UpdateKeywordsMessage = function (props) {
    var existingKeywords = props.existingKeywords, updatedKeywords = props.updatedKeywords;
    var removed = difference(existingKeywords, updatedKeywords);
    var added = difference(updatedKeywords, existingKeywords);
    var unchanged = difference(existingKeywords, added, removed);
    return (jsxs(Fragment, { children: [jsx("p", __assign({ style: { fontWeight: 'bold' } }, { children: "Are you sure you want to make the following updates?" })), jsx("br", {}), unchanged.length ? (jsxs("p", { children: ["Keywords Unchanged:", ' ', jsx("span", __assign({ style: { color: 'gray' } }, { children: unchanged.join(', ') }))] })) : null, added.length ? (jsxs("p", { children: ["Keywords Added:", ' ', jsx("span", __assign({ style: { color: 'green' } }, { children: added.join(', ') }))] })) : null, removed.length ? (jsxs("p", { children: ["Keywords Removed:", ' ', jsx("span", __assign({ style: { color: 'red' } }, { children: removed.join(', ') }))] })) : null] }));
};

var KeywordsCard = function (props) {
    var existingKeywords = props.existingKeywords, onSubmit = props.onSubmit, readOnly = props.readOnly;
    var gridRef = useRef();
    var gridOptions = usePortalAgGridOptions();
    var _a = useToggle(false), isEditState = _a[0], toggleEditState = _a[1];
    var _b = useState(''), newKeyword = _b[0], setNewKeyword = _b[1];
    var _c = useSet(new Set(existingKeywords)), workingKeywords = _c[0], _d = _c[1], add = _d.add, remove = _d.remove, reset = _d.reset;
    var workingKeywordsArr = Array.from(workingKeywords);
    var hasModifiedKeywords = !isEqual(existingKeywords, workingKeywordsArr);
    var columnDefs = useMemo(function () { return [
        {
            cellRenderer: function (_a) {
                var data = _a.data;
                return jsx("span", { children: data });
            },
            filter: 'simpleTextFilter',
            flex: 1,
            headerName: 'Keyword',
            valueGetter: function (_a) {
                var data = _a.data;
                return data;
            },
        },
        {
            cellRenderer: function (_a) {
                var data = _a.data;
                return (jsx(DeleteCell, { disabled: !isEditState, onClick: function () { return remove(data); } }));
            },
            filter: false,
            flex: 1,
            headerName: 'Remove Keyword',
            sortable: false,
        },
    ]; }, [isEditState]);
    var handleAddKeyword = function () {
        if (newKeyword) {
            add(newKeyword.trim());
            setNewKeyword('');
        }
    };
    var handleSubmit = function () {
        onSubmit(workingKeywordsArr);
    };
    useUpdateEffect(function () {
        workingKeywords.forEach(remove);
        existingKeywords.forEach(add);
    }, [existingKeywords]);
    useUpdateEffect(function () {
        if (!isEditState) {
            reset();
        }
    }, [isEditState]);
    var title = 'Keywords';
    var showEditButton = !readOnly && !isEditState;
    var showCancelButton = !readOnly && isEditState;
    var headerContent = (jsxs(Fragment, { children: [jsx(ExportCSVButton, { csvExportParams: { fileName: 'keywords-export' }, gridRef: gridRef }), showEditButton ? jsx(EditButton, { onClick: toggleEditState }) : null, showCancelButton ? jsx(CancelButton, { onClick: toggleEditState }) : null] }));
    if (!existingKeywords.length && !isEditState) {
        return (jsx(RoundedCard, __assign({ headerContent: headerContent, title: title }, { children: jsx(NoData, { description: "No keywords exist for this offer", size: "1x" }) })));
    }
    return (jsxs(RoundedCard, __assign({ headerContent: headerContent, title: title }, { children: [isEditState ? (jsx("div", __assign({ style: {
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    paddingTop: '20px',
                } }, { children: jsx(Field, __assign({ label: "Add Keyword", tooltip: 'To add keyword, click "Add" or hit enter. Changes must be saved to take effect.' }, { children: jsxs("div", __assign({ style: { display: 'flex' } }, { children: [jsx(Input, { value: newKeyword, onChange: function (_a) {
                                    var value = _a.value;
                                    return setNewKeyword(value);
                                }, onEnter: handleAddKeyword }), jsx(Button, __assign({ disabled: newKeyword === '', icon: jsx(FontAwesomeIcon, { icon: faPlus }), style: { marginLeft: '10px' }, onClick: handleAddKeyword }, { children: "Add" }))] })) })) }))) : null, jsx("div", __assign({ className: "ag-theme-alpine" }, { children: jsx(AgGridReact, { ref: gridRef, columnDefs: columnDefs, getRowId: function (_a) {
                        var data = _a.data;
                        return data;
                    }, gridOptions: gridOptions, rowData: workingKeywordsArr }) })), isEditState ? (jsx(RoundedCard.Content, { children: jsx("div", __assign({ style: { display: 'flex', justifyContent: 'flex-end' } }, { children: jsx(ConfirmableAction, __assign({ message: jsx(UpdateKeywordsMessage, { existingKeywords: existingKeywords, updatedKeywords: workingKeywordsArr }), onOk: handleSubmit }, { children: jsx(Button, __assign({ disabled: !hasModifiedKeywords, intent: "primary" }, { children: "Save Changes" })) })) })) })) : null] })));
};

var styles$b = {"container":"ContactItem-module_container__XuE5q","title":"ContactItem-module_title__hkzFI","body":"ContactItem-module_body__joIo5","name":"ContactItem-module_name__kcdu6","email":"ContactItem-module_email__Rd5Mx","emailtext":"ContactItem-module_emailtext__TUdg-","icon":"ContactItem-module_icon__xpRCD"};

var ContactItem = function (_a) {
    var className = _a.className, email = _a.email, name = _a.name, title = _a.title;
    return (jsxs("div", __assign({ className: classNames(styles$b.container, className) }, { children: [title && jsx("div", __assign({ className: styles$b.title }, { children: title })), jsxs("div", __assign({ className: styles$b.body }, { children: [jsx(UserAvatar, { className: styles$b.name, name: name, size: "small" }), email && (jsx(AnchorButton, { minimal: true, className: styles$b.email, href: "mailto:".concat(email), icon: jsx(FontAwesomeIcon, { icon: faEnvelope }), text: email }))] }))] })));
};

var QuickLinkSection = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, children = _a.children;
    return (jsxs("nav", { children: [jsx(H5, { children: title }), subtitle && jsx(H6, { children: subtitle }), children] }));
};

var QuickLinkSectionItem = function (_a) {
    var href = _a.href, icon = _a.icon, kitIcon = _a.kitIcon, target = _a.target, title = _a.title;
    var iconStyle = { height: 'auto', width: 16 };
    var Icon = icon ? (jsx(FontAwesomeIcon, { fixedWidth: true, icon: icon, style: iconStyle })) : (jsx(FontAwesomeKitIcon, { fixedWidth: true, icon: kitIcon, style: iconStyle }));
    return (jsxs("a", __assign({ className: "quick-link-section-item", href: href, target: target }, { children: [Icon, jsx("span", __assign({ className: "quick-link-section-item-title" }, { children: title }))] })));
};

var SectionLearnMore = function () { return (jsxs(QuickLinkSection, __assign({ title: "Learn More" }, { children: [jsx(QuickLinkSectionItem, { href: "https://engine.tech/developer-center/integrations/api/products/loans/personal", icon: faLandmark, target: "_blank", title: "Personal Loans" }), jsx(QuickLinkSectionItem, { href: "https://engine.tech/developer-center/integrations/api/products/loans/personal", icon: faGraduationCap, target: "_blank", title: "Student Loan Refinancing" }), jsx(QuickLinkSectionItem, { href: "https://engine.tech/developer-center/integrations/api/products/loans/heloc", icon: faHouse, target: "_blank", title: "HELOC" }), jsx(QuickLinkSectionItem, { href: "https://engine.tech/developer-center/integrations/api/products/loans/auto-refinancing", icon: faCarSide, target: "_blank", title: "Auto Loan Refinancing" }), jsx(QuickLinkSectionItem, { href: "https://engine.tech/developer-center/integrations/api/products/savings", icon: faCoins, target: "_blank", title: "Savings" })] }))); };

var SectionResources = function () { return (jsxs(QuickLinkSection, __assign({ title: "Resources" }, { children: [jsx(QuickLinkSectionItem, { href: "/docs/master-services-agreement.pdf", icon: faDownload, title: "Master Services Agreement" }), jsx(QuickLinkSectionItem, { href: "/docs/control-center-addendum.pdf", icon: faDownload, title: "Control Center Addendum" })] }))); };

var SectionQuickLinks = function (_a) {
    var _b = _a.showRebrandGuideAndAssetsLink, showRebrandGuideAndAssetsLink = _b === void 0 ? false : _b;
    return (jsxs(QuickLinkSection, __assign({ title: "Quick Links" }, { children: [jsx(QuickLinkSectionItem, { href: "https://engine.tech/docs/api-reference/#overview", kitIcon: KitIconNames.ApiSolid, target: "_blank", title: "API Reference" }), jsx(QuickLinkSectionItem, { href: "https://engine.tech/control-center/guides/reporting", icon: faChartPie, target: "_blank", title: "Analytics" }), showRebrandGuideAndAssetsLink ? (jsx(QuickLinkSectionItem, { href: "https://engine.tech/s3/announcements/", icon: faEngine, target: "_blank", title: "Rebrand Guide & Assets" })) : null] })));
};

var SectionSupport = function () { return (jsxs(QuickLinkSection, __assign({ subtitle: "Questions? Get in touch!", title: "Support" }, { children: [jsx("a", __assign({ href: "mailto:partnersupport@engine.tech" }, { children: "partnersupport@engine.tech" })), jsx(CopyToClipboardButton, __assign({ buttonProps: {
                className: 'quick-links-support-copy-to-clipboard-button',
                outlined: true,
            }, copyData: "partnersupport@engine.tech" }, { children: "Copy Email" }))] }))); };

var QuickLinks = function (_a) {
    var _b = _a.showRebrandGuideAndAssetsLink, showRebrandGuideAndAssetsLink = _b === void 0 ? false : _b, _c = _a.showResources, showResources = _c === void 0 ? false : _c, _d = _a.showSupport, showSupport = _d === void 0 ? true : _d;
    return (jsxs("section", __assign({ className: "quick-links-container" }, { children: [showSupport && jsx(SectionSupport, {}), jsx(SectionQuickLinks, { showRebrandGuideAndAssetsLink: showRebrandGuideAndAssetsLink }), jsx(SectionLearnMore, {}), showResources && jsx(SectionResources, {})] })));
};

var styles$a = {"container":"ExternalHomeLayout-module_container__hb5wN","title":"ExternalHomeLayout-module_title__FooCI","description":"ExternalHomeLayout-module_description__RykMb","main":"ExternalHomeLayout-module_main__9u-yB","sidebar":"ExternalHomeLayout-module_sidebar__BOcc1","sidebarlabel":"ExternalHomeLayout-module_sidebarlabel__I1NS-"};

var ExternalHomeLayout = function (_a) {
    var children = _a.children, contacts = _a.contacts, _b = _a.description, description = _b === void 0 ? "Here you can access everything you'll need to monitor your account, including key metrics and other tools." : _b, _c = _a.showRebrandGuideAndAssetsLink, showRebrandGuideAndAssetsLink = _c === void 0 ? false : _c, _d = _a.title, title = _d === void 0 ? 'Welcome' : _d;
    return (jsxs("div", __assign({ className: styles$a.container }, { children: [jsxs("main", __assign({ className: styles$a.main }, { children: [jsxs("header", __assign({ className: styles$a.header }, { children: [jsx(H2, __assign({ className: styles$a.title }, { children: title })), jsx("div", __assign({ className: styles$a.description }, { children: description }))] })), jsx("div", { children: children })] })), jsxs("aside", __assign({ className: styles$a.sidebar }, { children: [jsx("div", __assign({ className: styles$a.sidebarlabel }, { children: "Questions? Get in touch!" })), contacts === null || contacts === void 0 ? void 0 : contacts.map(function (contact) { return (jsx(ContactItem, __assign({}, contact), contact.title)); }), jsx(QuickLinks, { showRebrandGuideAndAssetsLink: showRebrandGuideAndAssetsLink, showSupport: false })] }))] })));
};

var DefaultLayoutDefault = function (_a) {
    var defaultTab = _a.defaultTab, headerProps = _a.headerProps, onTabChange = _a.onTabChange, sidebarContent = _a.sidebarContent, _b = _a.tabs, tabs = _b === void 0 ? [] : _b;
    return (jsxs("div", __assign({ className: "detail-layout default-container" }, { children: [jsxs("main", __assign({ className: "main" }, { children: [jsx(DetailHeader, __assign({ className: "header title" }, headerProps)), jsx(Tabs, __assign({ animate: false, className: "tabs", defaultSelectedTabId: defaultTab, onChange: onTabChange }, { children: tabs.map(function (tabProps) { return (jsx(Tab, __assign({}, tabProps), tabProps.id)); }) }))] })), jsx("aside", __assign({ className: "sidebar", "data-testid": "detail-sidebar" }, { children: sidebarContent }))] })));
};

var PanelWrapper = function (_a) {
    var main = _a.main, children = _a.children;
    return (jsxs("div", __assign({ className: "panel" }, { children: [jsx("main", __assign({ className: "main" }, { children: main })), jsx("aside", __assign({ className: "sidebar", "data-testid": "detail-sidebar" }, { children: children }))] })));
};
var DetailLayoutFullWidthHeader = function (_a) {
    var defaultTab = _a.defaultTab, headerProps = _a.headerProps, onTabChange = _a.onTabChange, sidebarContent = _a.sidebarContent, _b = _a.tabs, tabs = _b === void 0 ? [] : _b;
    return (jsxs("div", __assign({ className: "full-width-container detail-layout" }, { children: [jsx(DetailHeader, __assign({ className: classNames('header title', 'is-borderless') }, headerProps)), jsx(Tabs, __assign({ animate: false, className: "tabs", selectedTabId: defaultTab, onChange: onTabChange }, { children: tabs.map(function (_a) {
                    var panel = _a.panel, id = _a.id, title = _a.title;
                    return (jsx(Tab, { "data-testid": "detail-layout-tab-".concat(id), id: id, panel: jsx(PanelWrapper, __assign({ main: panel }, { children: sidebarContent })), title: title }, id));
                }) }))] })));
};

var DetailLayout = function (props) {
    var _a = props.enableFullWidthHeader, enableFullWidthHeader = _a === void 0 ? false : _a, topBarProps = props.topBarProps, _b = props.showTopBar, showTopBar = _b === void 0 ? true : _b, className = props.className;
    return (jsxs("div", __assign({ className: className }, { children: [showTopBar && jsx(DetailTopBar, __assign({}, topBarProps)), enableFullWidthHeader ? (jsx(DetailLayoutFullWidthHeader, __assign({}, props))) : (jsx(DefaultLayoutDefault, __assign({}, props)))] })));
};

var MenuItem = function (_a) {
    var _b = _a.additionalPaths, additionalPaths = _b === void 0 ? [] : _b, eventKey = _a.eventKey, itemText = _a.itemText, onRouteChange = _a.onRouteChange, route = _a.route, showBadgeDollarIcon = _a.showBadgeDollarIcon, showDisabledIcon = _a.showDisabledIcon, showWrenchIcon = _a.showWrenchIcon, menuItemProps = __rest(_a, ["additionalPaths", "eventKey", "itemText", "onRouteChange", "route", "showBadgeDollarIcon", "showDisabledIcon", "showWrenchIcon"]);
    var handleRouteChange = function () {
        if (route) {
            onRouteChange === null || onRouteChange === void 0 ? void 0 : onRouteChange(route);
        }
    };
    var currentPath = useRouter().asPath;
    var isSelected = useMemo(function () {
        return __spreadArray([route], additionalPaths, true).some(function (targetPath) {
            var isHome = currentPath === '/home' && targetPath === '/home';
            return (isHome ||
                (targetPath &&
                    targetPath !== '/home' &&
                    currentPath.includes(targetPath)));
        });
    }, [additionalPaths, currentPath]);
    return (jsx(Menu$1.Item, __assign({}, menuItemProps, { className: classNames('ant-menu-item nav-menu-item', {
            'ant-menu-item-selected': isSelected,
        }), eventKey: eventKey, onClick: handleRouteChange }, { children: jsxs("span", { children: [jsx("span", { children: itemText }), (showDisabledIcon || menuItemProps.disabled) && (jsx(FontAwesomeIcon, { fixedWidth: true, className: "menu-icon-lock", icon: faLock })), showWrenchIcon && (jsx(FontAwesomeIcon, { fixedWidth: true, icon: faScrewdriverWrench, pull: "right", style: { fontSize: 16 }, transform: { y: 12 } })), showBadgeDollarIcon && (jsx("span", { children: jsx(FontAwesomeKitIcon, { icon: KitIconNames.BadgeDollarSign, pull: "right", style: {
                            fontSize: 16,
                            position: 'absolute',
                            right: '16px',
                            top: '12px',
                        } }) }))] }) })));
};

function isKitIcon(icon) {
    return Object.values(KitIconNames).includes(icon);
}
var SidebarIconPlaceholder = function (_a) {
    var children = _a.children;
    return jsx("span", __assign({ className: "anticon" }, { children: children }));
};
var SidebarIcon = function (_a) {
    var icon = _a.icon, rest = __rest(_a, ["icon"]);
    return (jsx(SidebarIconPlaceholder, { children: isKitIcon(icon) ? (jsx(FontAwesomeKitIcon, __assign({ fixedWidth: true, icon: icon, transform: { y: 1 } }, rest))) : (jsx(FontAwesomeIcon, __assign({ fixedWidth: true, icon: icon, transform: { y: 1 } }, rest))) }));
};

var BasicNav = function (_a) {
    var accountUuid = _a.accountUuid, onRouteChange = _a.onRouteChange, props = __rest(_a, ["accountUuid", "onRouteChange"]);
    return (jsxs(Menu$2.ItemGroup, __assign({}, props, { children: [jsx(MenuItem, { icon: jsx(SidebarIcon, { icon: faHome }), itemText: "Home", route: "/home", onRouteChange: onRouteChange }, "home"), jsx(MenuItem, { icon: jsx(SidebarIcon, { icon: faSquareUser }), itemText: "Account", route: "/accounts/".concat(accountUuid), onRouteChange: onRouteChange }, "account"), jsx(MenuItem, { icon: jsx(SidebarIcon, { icon: faUserAlt }), itemText: "Users", route: "/users", onRouteChange: onRouteChange }, "users")] })));
};

var DemandOfferManagementItemGroup = function (_a) {
    var onRouteChange = _a.onRouteChange, showBenchmarkReportsMenuItem = _a.showBenchmarkReportsMenuItem, showMCIReportsMenuItem = _a.showMCIReportsMenuItem, props = __rest(_a, ["onRouteChange", "showBenchmarkReportsMenuItem", "showMCIReportsMenuItem"]);
    return (jsxs(Menu$2.ItemGroup, __assign({ title: jsx("strong", __assign({ style: { textTransform: 'uppercase' } }, { children: "Offer Management" })) }, props, { children: [jsxs(Menu$2.SubMenu, __assign({ icon: jsx(SidebarIcon, { icon: KitIconNames.FinancialOffers }), title: "Financial Services" }, { children: [jsxs(Menu$2.SubMenu, __assign({ icon: jsx(SidebarIcon, { icon: faSackDollar }), title: "Personal Loans" }, { children: [jsx(MenuItem, { itemText: "Dashboard", route: DemandMVPOfferManagementRoute.PersonalLoansDashboard, onRouteChange: onRouteChange }, "dashboard"), (showMCIReportsMenuItem || showBenchmarkReportsMenuItem) && (jsxs(Menu$2.SubMenu, __assign({ title: "Data & Analytics" }, { children: [showMCIReportsMenuItem && (jsxs(Menu$2.SubMenu, __assign({ icon: jsx(SidebarIcon, { icon: faList }), title: "MCI Reports" }, { children: [jsx(MenuItem, { itemText: "MCI Offers", route: DemandMVPOfferManagementRoute.PersonalLoansMCIOffersReports, onRouteChange: onRouteChange }, "mci-offers-reports"), jsx(MenuItem, { itemText: "MCI Rejections", route: DemandMVPOfferManagementRoute.PersonalLoansMCIRejectionsReports, onRouteChange: onRouteChange }, "mci-rejections-reports"), jsx(MenuItem, { itemText: "MCI Conversions", route: DemandMVPOfferManagementRoute.PersonalLoansMCIConversionsReports, onRouteChange: onRouteChange }, "mci-conversions-reports")] }), "mci-reports")), showBenchmarkReportsMenuItem && (jsx(MenuItem, { icon: jsx(SidebarIcon, { icon: faChartLine }), itemText: "Benchmark Reports", route: DemandMVPOfferManagementRoute.PersonalLoansBenchmarkReports, onRouteChange: onRouteChange }, "benchmark-reports"))] }), "data-analytic"))] }), "personal-loans"), jsx(MenuItem, { showWrenchIcon: true, icon: jsx(SidebarIcon, { icon: faGraduationCap }), itemText: "Student Loan Refi", route: DemandMVPOfferManagementRoute.StudentLoanRefi, onRouteChange: onRouteChange }, "student-loan-refi"), jsx(MenuItem, { showWrenchIcon: true, icon: jsx(SidebarIcon, { icon: faCarSide }), itemText: "Auto Loan Refi", route: DemandMVPOfferManagementRoute.AutoLoanRefi, onRouteChange: onRouteChange }, "auto-loan-refi"), jsx(MenuItem, { showWrenchIcon: true, icon: jsx(SidebarIcon, { icon: faPiggyBank }), itemText: "Savings", route: DemandMVPOfferManagementRoute.Savings, onRouteChange: onRouteChange }, "savings"), jsx(MenuItem, { showWrenchIcon: true, icon: jsx(SidebarIcon, { icon: faUmbrella }), itemText: "Life Insurance", route: DemandMVPOfferManagementRoute.LifeInsurance, onRouteChange: onRouteChange }, "life-insurance"), jsx(MenuItem, { showWrenchIcon: true, icon: jsx(SidebarIcon, { icon: faCreditCard }), itemText: "Credit Cards", route: DemandMVPOfferManagementRoute.CreditCards, onRouteChange: onRouteChange }, "credit-cards")] }), "financial-services"), jsx(MenuItem, { icon: jsx(SidebarIcon, { icon: faTags }), itemText: "Custom Offers", route: DemandMVPOfferManagementRoute.CustomOffers, onRouteChange: onRouteChange }, "custom-offers")] })));
};

var SideNavContext = React__default.createContext({
    isCollapsed: false,
    onRouteChange: function () { },
});
var useSideNavContext = function () { return useContext(SideNavContext); };

var InternalDevelopmentItemGroup = function (props) {
    var showFeatureFlags = props.showFeatureFlags, itemGroupProps = __rest(props, ["showFeatureFlags"]);
    var _a = useSideNavContext(), isCollapsed = _a.isCollapsed, onRouteChange = _a.onRouteChange;
    if (!showFeatureFlags) {
        return null;
    }
    return (jsx(Menu$2.ItemGroup, __assign({ className: "nav-menu-item-group", title: isCollapsed ? '' : 'DEVELOPMENT' }, itemGroupProps, { children: jsx(MenuItem, { eventKey: "feature-flags", icon: jsx(SidebarIcon, { icon: faFlag }), itemText: "Feature Flags", route: InternalRoutes.FeatureFlags, onRouteChange: onRouteChange }, "feature-flags") })));
};

var InternalOfferCatalogItemGroup = function (props) {
    var showOffers = props.showOffers, showProductTypes = props.showProductTypes, itemGroupProps = __rest(props, ["showOffers", "showProductTypes"]);
    var _a = useSideNavContext(), isCollapsed = _a.isCollapsed, onRouteChange = _a.onRouteChange;
    if (!showProductTypes && !showOffers) {
        return null;
    }
    return (jsxs(Menu$2.ItemGroup, __assign({ className: "nav-menu-item-group", title: isCollapsed ? '' : 'OFFER CATALOG' }, itemGroupProps, { children: [showProductTypes ? (jsx(MenuItem, { eventKey: "offer-catalog-product-types", icon: jsx(SidebarIcon, { icon: faBook }), itemText: "Product Types", route: InternalRoutes.OfferCatalog.ProductTypes, onRouteChange: onRouteChange }, "offer-catalog-product-types")) : null, showOffers ? (jsx(MenuItem, { eventKey: "offer-catalog-offers", icon: jsx(SidebarIcon, { icon: faEnvelopeOpenDollar }), itemText: "Offers", route: InternalRoutes.OfferCatalog.Offers, onRouteChange: onRouteChange }, "offer-catalog-offers")) : null] })));
};

var InternalDataAndAnalyticsSubMenu = function (props) {
    var baseKey = props.baseKey, baseUrl = props.baseUrl, onRouteChange = props.onRouteChange, showBenchmarkReports = props.showBenchmarkReports, showMciReports = props.showMciReports, subMenuProps = __rest(props, ["baseKey", "baseUrl", "onRouteChange", "showBenchmarkReports", "showMciReports"]);
    if (!showBenchmarkReports && !showMciReports) {
        return null;
    }
    return (jsxs(Menu$2.SubMenu, __assign({ title: "Data & Analytics" }, subMenuProps, { children: [showMciReports ? (jsxs(Menu$2.SubMenu, __assign({ icon: jsx(SidebarIcon, { icon: faList }), title: "MCI Reports" }, { children: [jsx(MenuItem, { 
                        // eventKey={`${baseKey}-mci-reports-offers`}
                        itemText: "MCI Offers", route: "".concat(baseUrl, "/mci-reports/offers"), onRouteChange: onRouteChange }, "".concat(baseKey, "-mci-reports-offers")), jsx(MenuItem, { 
                        // eventKey={`${baseKey}-mci-reports-rejections`}
                        itemText: "MCI Rejections", route: "".concat(baseUrl, "/mci-reports/rejections"), onRouteChange: onRouteChange }, "".concat(baseKey, "-mci-reports-rejections")), jsx(MenuItem, { 
                        // eventKey={`${baseKey}-mci-reports-conversions`}
                        itemText: "MCI Conversions", route: "".concat(baseUrl, "/mci-reports/conversions"), onRouteChange: onRouteChange }, "".concat(baseKey, "-mci-reports-conversions"))] }), "".concat(baseKey, "-mci-reports"))) : null, showBenchmarkReports ? (jsx(MenuItem, { 
                // eventKey={`${baseKey}-benchmark-reports`}
                icon: jsx(SidebarIcon, { icon: faChartLine }), itemText: "Benchmark Reports", route: "".concat(baseUrl, "/benchmark-reports"), onRouteChange: onRouteChange }, "".concat(baseKey, "-benchmark-reports"))) : null] }), "data-analytics"));
};

var InternalLeadFilteringSubMenu = function (props) {
    var baseKey = props.baseKey, baseUrl = props.baseUrl, onRouteChange = props.onRouteChange, showLenderProvidedFilters = props.showLenderProvidedFilters, showMatchingCriteria = props.showMatchingCriteria, showProductOfferRules = props.showProductOfferRules, subMenuProps = __rest(props, ["baseKey", "baseUrl", "onRouteChange", "showLenderProvidedFilters", "showMatchingCriteria", "showProductOfferRules"]);
    if (!showLenderProvidedFilters &&
        !showMatchingCriteria &&
        !showProductOfferRules) {
        return null;
    }
    return (jsxs(Menu$2.SubMenu, __assign({ title: "Lead Filtering" }, subMenuProps, { children: [showProductOfferRules ? (jsx(MenuItem, { 
                // eventKey={`${baseKey}-preview-offer-rules`}
                itemText: "Preview Offer Rules", route: "".concat(baseUrl, "/lead-filtering/preview-offer-rules"), onRouteChange: onRouteChange }, "".concat(baseKey, "-preview-offer-rules"))) : null, showMatchingCriteria ? (jsx(MenuItem, { 
                // eventKey={`${baseKey}-matching-criteria`}
                itemText: "Matching Criteria", route: "".concat(baseUrl, "/lead-filtering/matching-criteria"), onRouteChange: onRouteChange }, "".concat(baseKey, "-matching-criteria"))) : null, showLenderProvidedFilters ? (jsx(MenuItem, { 
                // eventKey={`${baseKey}-lender-provided-filters`}
                itemText: "Lender Provided Filters", route: "".concat(baseUrl, "/lead-filtering/lender-provided-filters"), onRouteChange: onRouteChange }, "".concat(baseKey, "-lender-provided-filters"))) : null] }), "".concat(baseKey, "-lead-filtering")));
};

var InternalOfferManagementSubMenu = function (props) {
    var title = props.title, identifier = props.identifier, showBenchmarkReports = props.showBenchmarkReports, showCapping = props.showCapping, showChannelCapping = props.showChannelCapping, showCompliance = props.showCompliance, showDashboard = props.showDashboard, showLenderProvidedFilters = props.showLenderProvidedFilters, showMatchingCriteria = props.showMatchingCriteria, showMciReports = props.showMciReports, showPreviewOffers = props.showPreviewOffers, showPricingControls = props.showPricingControls, showProductOfferRules = props.showProductOfferRules, showProductOffers = props.showProductOffers, onRouteChange = props.onRouteChange, icon = props.icon, subMenuProps = __rest(props, ["title", "identifier", "showBenchmarkReports", "showCapping", "showChannelCapping", "showCompliance", "showDashboard", "showLenderProvidedFilters", "showMatchingCriteria", "showMciReports", "showPreviewOffers", "showPricingControls", "showProductOfferRules", "showProductOffers", "onRouteChange", "icon"]);
    var titleElement = (jsxs("span", { children: [jsx(SidebarIcon, { icon: icon }), jsx("span", { children: title })] }));
    var baseKey = "offer-management-".concat(identifier);
    var baseUrl = "/offer-management/".concat(identifier);
    return (createElement(Menu$2.SubMenu, __assign({}, subMenuProps, { key: baseKey, className: "nav-menu-submenu", eventKey: baseKey, title: titleElement }),
        showDashboard ? (jsx(MenuItem, { eventKey: "".concat(baseKey, "-home"), itemText: "Dashboard", route: "".concat(baseUrl, "/home"), onRouteChange: onRouteChange }, "".concat(baseKey, "-home"))) : null,
        jsx(MenuItem, { eventKey: "".concat(baseKey, "-configurations"), itemText: "Configurations", route: "".concat(baseUrl, "/configurations"), onRouteChange: onRouteChange }, "".concat(baseKey, "-configurations")),
        showCompliance ? (jsx(MenuItem, { eventKey: "".concat(baseKey, "-compliance"), itemText: "Compliance", route: "".concat(baseUrl, "/compliance"), onRouteChange: onRouteChange }, "".concat(baseKey, "-compliance"))) : null,
        jsx(MenuItem, { eventKey: "".concat(baseKey, "-contracts"), itemText: "Contracts", route: "".concat(baseUrl, "/contracts"), onRouteChange: onRouteChange }, "".concat(baseKey, "-contracts")),
        showProductOffers ? (jsx(MenuItem, { eventKey: "".concat(baseKey, "-product-offers"), itemText: "Product Offers", route: "".concat(baseUrl, "/product-offers"), onRouteChange: onRouteChange }, "".concat(baseKey, "-product-offers"))) : null,
        showPreviewOffers ? (jsx(MenuItem, { eventKey: "".concat(baseKey, "-preview-offers"), itemText: "Preview Offers", route: "".concat(baseUrl, "/preview-offers"), onRouteChange: onRouteChange }, "".concat(baseKey, "-preview-offers"))) : null,
        jsx(InternalLeadFilteringSubMenu, { baseKey: baseKey, baseUrl: baseUrl, showLenderProvidedFilters: showLenderProvidedFilters, showMatchingCriteria: showMatchingCriteria, showProductOfferRules: showProductOfferRules, onRouteChange: onRouteChange }),
        showPricingControls ? (jsx(MenuItem, { eventKey: "".concat(baseKey, "-pricing-controls"), itemText: "Pricing Controls", route: "".concat(baseUrl, "/pricing-controls"), onRouteChange: onRouteChange }, "".concat(baseKey, "-pricing-controls"))) : null,
        showCapping ? (jsx(MenuItem, { eventKey: "".concat(baseKey, "-capping"), itemText: "Capping", route: "".concat(baseUrl, "/capping"), onRouteChange: onRouteChange }, "".concat(baseKey, "-capping"))) : null,
        showChannelCapping ? (jsx(MenuItem, { eventKey: "".concat(baseKey, "-channel-capping"), itemText: "Channel Capping", route: "".concat(baseUrl, "/channel-capping"), onRouteChange: onRouteChange }, "".concat(baseKey, "-channel-capping"))) : null,
        jsx(InternalDataAndAnalyticsSubMenu, { baseKey: baseKey, baseUrl: baseUrl, showBenchmarkReports: showBenchmarkReports, showMciReports: showMciReports, onRouteChange: onRouteChange })));
};

var InternalOfferManagementItemGroup = function (props) {
    var _a = useSideNavContext(), isCollapsed = _a.isCollapsed, onRouteChange = _a.onRouteChange;
    return (jsxs(Menu$2.ItemGroup, __assign({ className: "nav-menu-item-group", title: isCollapsed ? '' : 'OFFER MANAGEMENT' }, props, { children: [jsx(InternalOfferManagementSubMenu, { showBenchmarkReports: true, showCapping: true, showChannelCapping: true, showCompliance: true, showDashboard: true, showLenderProvidedFilters: true, showMciReports: true, showPreviewOffers: true, showPricingControls: true, showProductOfferRules: true, icon: faSackDollar, identifier: "personal-loans", title: "Personal Loans", onRouteChange: onRouteChange }), jsx(InternalOfferManagementSubMenu, { showBenchmarkReports: true, showCapping: true, showCompliance: true, showProductOfferRules: true, showProductOffers: true, icon: faPiggyBank, identifier: "savings", title: "Savings", onRouteChange: onRouteChange }), jsx(InternalOfferManagementSubMenu, { showBenchmarkReports: true, icon: faUmbrella, identifier: "life-insurance", title: "Life Insurance", onRouteChange: onRouteChange }), jsx(InternalOfferManagementSubMenu, { showBenchmarkReports: true, showCapping: true, showCompliance: true, showMatchingCriteria: true, showProductOfferRules: true, showProductOffers: true, icon: faCreditCard, identifier: "credit-cards", title: "Credit Cards", onRouteChange: onRouteChange }), jsx(InternalOfferManagementSubMenu, { showBenchmarkReports: true, showCapping: true, showChannelCapping: true, showProductOfferRules: true, showProductOffers: true, icon: faTags, identifier: "custom-offers", title: "Custom Offers", onRouteChange: onRouteChange })] })));
};

var SideNav = function (_a) {
    var children = _a.children, _b = _a.collapsed, collapsed = _b === void 0 ? false : _b, _c = _a.showLogo, showLogo = _c === void 0 ? true : _c, _d = _a.inlineIndent, inlineIndent = _d === void 0 ? 24 : _d, _e = _a.defaultOpenKeys, defaultOpenKeys = _e === void 0 ? [] : _e, menuProps = __rest(_a, ["children", "collapsed", "showLogo", "inlineIndent", "defaultOpenKeys"]);
    var currentPath = useRouter().asPath;
    var pathKeys = currentPath.split('/');
    pathKeys.pop();
    var openKeys = __spreadArray(__spreadArray([], defaultOpenKeys, true), pathKeys, true);
    return (jsx("aside", __assign({ className: classNames('cc-side-nav', {
            'is-collapsed': collapsed,
        }) }, { children: jsxs(Menu$1, __assign({}, menuProps, { defaultOpenKeys: openKeys, inlineCollapsed: collapsed, inlineIndent: inlineIndent, mode: "inline", selectable: false, theme: "dark" }, { children: [showLogo && (jsx(Menu$1.Item, __assign({ className: "cc-side-nav-logo-item" }, { children: jsx(EvenLogo, { inverse: true, className: "cc-side-nav-logo", showLargeLogo: !collapsed }) }))), children] })) })));
};

var SubMenu = function (props) {
    return jsx(Menu$1.SubMenu, __assign({}, props, { children: props.children }));
};

var PropertyInputType = {
    Boolean: 'boolean',
    DateTime: 'date-time',
    Enum: 'enum',
    EnumArray: 'enum-array',
    Number: 'number',
    NumberArray: 'number-array',
    String: 'string',
    StringArray: 'string-array',
    Unsupported: 'unsupported',
};

// eslint-disable-next-line complexity
var getPropertyInputType = function (property) {
    var _a, _b, _c, _d, _e;
    var hasEnums = Boolean(((_a = property === null || property === void 0 ? void 0 : property.enum) === null || _a === void 0 ? void 0 : _a.length) || ((_c = (_b = property === null || property === void 0 ? void 0 : property.items) === null || _b === void 0 ? void 0 : _b.enum) === null || _c === void 0 ? void 0 : _c.length));
    var isStringItemType = ((_d = property === null || property === void 0 ? void 0 : property.items) === null || _d === void 0 ? void 0 : _d.type) === PropertyItemType.String;
    var isNumberItemType = ((_e = property === null || property === void 0 ? void 0 : property.items) === null || _e === void 0 ? void 0 : _e.type) === PropertyItemType.Number;
    var isDateTimeFormat = property.format === PropertyFormatType.DateTime;
    var isArrayType = property.type === ProductPropertyType.Array;
    var isStringType = property.type === ProductPropertyType.String;
    var isNumberType = property.type === ProductPropertyType.Number;
    var isIntegerType = property.type === ProductPropertyType.Integer;
    var isBooleanType = property.type === ProductPropertyType.Boolean;
    if (isArrayType && isNumberItemType) {
        return PropertyInputType.NumberArray;
    }
    if (isArrayType && isStringItemType && hasEnums) {
        return PropertyInputType.EnumArray;
    }
    if (isArrayType && isStringItemType) {
        return PropertyInputType.StringArray;
    }
    if (isNumberType || isIntegerType) {
        return PropertyInputType.Number;
    }
    if (isStringType && hasEnums) {
        return PropertyInputType.Enum;
    }
    if (isStringType && isDateTimeFormat) {
        return PropertyInputType.DateTime;
    }
    if (isStringType) {
        return PropertyInputType.String;
    }
    if (isBooleanType) {
        return PropertyInputType.Boolean;
    }
    return PropertyInputType.Unsupported;
};

var Message = {
    INVAILD_DATETIME: 'Value must be a valid date',
    INVALID_ARR_OF_DATETIMES: 'All values must be a valid date',
    INVALID_ARR_OF_URIS: 'All values must be a valid date',
    INVALID_ARR_OF_UUIDS: 'All values must be a valid uuid',
    INVALID_INPUT: 'Invalid input format',
    INVALID_URI: 'Value must be a valid uri (https://example.com)',
    INVALID_UUID: 'Value must be a valid uuid',
    REQUIRED: 'This field is required',
};
var isRequiredValidator = function (required) { return function (value) {
    if (required && (value === undefined || value === null || value === '')) {
        return Message.REQUIRED;
    }
    return true;
}; };
var isDateTimeValidator = function (value) {
    if (!value) {
        return true;
    }
    if (!isDateString(value)) {
        return Message.INVAILD_DATETIME;
    }
    return true;
};
var isUuidValidator = function (value) {
    if (!value) {
        return true;
    }
    if (!isUUID(value)) {
        return Message.INVALID_UUID;
    }
    return true;
};
var isUriValidator = function (value) {
    if (!value) {
        return true;
    }
    if (!isURL(String(value), { require_protocol: true })) {
        return Message.INVALID_URI;
    }
    return true;
};
var isArrayOfDateTimeValidator = function (value) {
    if (!value) {
        return true;
    }
    if (!Array.isArray(value)) {
        return Message.INVALID_INPUT;
    }
    if (!value.every(function (item) { return isDateString(item); })) {
        return Message.INVALID_ARR_OF_DATETIMES;
    }
    return true;
};
var isArrayOfUuidsValidator = function (value) {
    if (!value) {
        return true;
    }
    if (!Array.isArray(value)) {
        return Message.INVALID_INPUT;
    }
    if (!value.every(function (item) { return isUUID(item); })) {
        return Message.INVALID_ARR_OF_UUIDS;
    }
    return true;
};
var isArrayOfUrisValidator = function (value) {
    if (!value) {
        return true;
    }
    if (!Array.isArray(value)) {
        return Message.INVALID_INPUT;
    }
    if (!value.every(function (item) { return isURL(String(item), { require_protocol: true }); })) {
        return Message.INVALID_ARR_OF_URIS;
    }
    return true;
};
var minValidator = function (minValue) { return function (maxValue) {
    var minValueNumber = toNumber(minValue);
    var maxValueNumber = toNumber(maxValue);
    if (minValue === undefined && maxValue === undefined) {
        return true;
    }
    if ((minValue !== undefined && maxValue === undefined) ||
        (minValue === undefined && maxValue !== undefined)) {
        return 'Both Min and Max values must be defined if one is provided.';
    }
    if (isNaN(minValueNumber)) {
        return 'Min value must be a valid number';
    }
    if (maxValueNumber < minValueNumber) {
        return "Max value must be greater than the min value of ".concat(minValueNumber);
    }
    return true;
}; };
var maxValidator = function (maxValue) { return function (minValue) {
    var minValueNumber = toNumber(minValue);
    var maxValueNumber = toNumber(maxValue);
    if (minValue === undefined && maxValue === undefined) {
        return true;
    }
    if ((minValue !== undefined && maxValue === undefined) ||
        (minValue === undefined && maxValue !== undefined)) {
        return 'Both Min and Max values must be defined if one is provided.';
    }
    if (isNaN(maxValueNumber)) {
        return 'Max value must be a valid number';
    }
    if (minValueNumber > maxValueNumber) {
        return "Min value must be less than the max value of ".concat(maxValueNumber);
    }
    return true;
}; };
var minToMaxPropertyKey = new Map([
    ['amountCentsMin', 'amountCentsMax'],
    ['annualPercentageRateBasisPointsMin', 'annualPercentageRateBasisPointsMax'],
    ['enrollmentFeeBasisPointsMin', 'enrollmentFeeBasisPointsMax'],
    ['fastTransferFeeBasisPointsMin', 'fastTransferFeeBasisPointsMax'],
    ['fastTransferFeeCentsMin', 'fastTransferFeeCentsMax'],
    ['monthlyFeeCentsMin', 'monthlyFeeCentsMax'],
    ['monthlyPaymentCentsMin', 'monthlyPaymentCentsMax'],
    ['termLengthMonthsMin', 'termLengthMonthsMax'],
]);
var maxToMinPropertyKey = new Map(Array.from(minToMaxPropertyKey.entries()).map(function (_a) {
    var minKey = _a[0], maxKey = _a[1];
    return [
        maxKey,
        minKey,
    ];
}));
var getPropertyInfo = function (property) {
    var isIntegerType = property.type === ProductPropertyType.Integer;
    var isArrayType = property.type === ProductPropertyType.Array;
    var isDateTimeFormat = property.format === PropertyFormatType.DateTime;
    var isUuidFormat = property.format === PropertyFormatType.Uuid;
    var isUriFormat = property.format === PropertyFormatType.Uri;
    return {
        isArrayType: isArrayType,
        isDateTimeFormat: isDateTimeFormat,
        isIntegerType: isIntegerType,
        isUriFormat: isUriFormat,
        isUuidFormat: isUuidFormat,
    };
};
var getCorrespondingMinPropertyKey = function (propertyKey) {
    var _a;
    var isMaxProperty = maxToMinPropertyKey.has(propertyKey) || propertyKey.endsWith('Max');
    if (!isMaxProperty) {
        return null;
    }
    return ((_a = maxToMinPropertyKey.get(propertyKey)) !== null && _a !== void 0 ? _a : propertyKey.replace('Max', 'Min'));
};
var getCorrespondingMaxPropertyKey = function (propertyKey) {
    var _a;
    var isMinProperty = minToMaxPropertyKey.has(propertyKey) || propertyKey.endsWith('Min');
    if (!isMinProperty) {
        return null;
    }
    return (_a = minToMaxPropertyKey.get(propertyKey)) !== null && _a !== void 0 ? _a : null;
};
var mergedValidators = function (validators) { return function (value) {
    var error = validators
        .map(function (validator) { return validator(value); })
        .find(function (result) { return result !== true; });
    if (error) {
        return error;
    }
    return true;
}; };
// eslint-disable-next-line complexity
var usePropertyInputValidator = function (propertyKey, property, required) {
    var watch = useFormContext().watch;
    var _a = getPropertyInfo(property), isArrayType = _a.isArrayType, isIntegerType = _a.isIntegerType, isDateTimeFormat = _a.isDateTimeFormat, isUriFormat = _a.isUriFormat, isUuidFormat = _a.isUuidFormat;
    var minPropertyKey = getCorrespondingMinPropertyKey(propertyKey);
    var maxPropertyKey = getCorrespondingMaxPropertyKey(propertyKey);
    var minValue = minPropertyKey ? watch(minPropertyKey) : undefined;
    var maxValue = maxPropertyKey ? watch(maxPropertyKey) : undefined;
    var isRequired = isRequiredValidator(required);
    if (isIntegerType && minPropertyKey) {
        return mergedValidators([isRequired, minValidator(minValue)]);
    }
    if (isIntegerType && maxPropertyKey) {
        return mergedValidators([isRequired, maxValidator(maxValue)]);
    }
    if (isArrayType && isDateTimeFormat) {
        return mergedValidators([isRequired, isArrayOfDateTimeValidator]);
    }
    if (isArrayType && isUuidFormat) {
        return mergedValidators([isRequired, isArrayOfUuidsValidator]);
    }
    if (isArrayType && isUriFormat) {
        return mergedValidators([isRequired, isArrayOfUrisValidator]);
    }
    if (isDateTimeFormat) {
        return mergedValidators([isRequired, isDateTimeValidator]);
    }
    if (isUuidFormat) {
        return mergedValidators([isRequired, isUuidValidator]);
    }
    if (isUriFormat) {
        return mergedValidators([isRequired, isUriValidator]);
    }
    return isRequired;
};

var textAreaProperties = new Set(['description', 'legal language']);
var OfferPropertyHandler = function (props) {
    var _a;
    var propertyKey = props.propertyKey, property = props.property, _b = props.property, description = _b.description, enumKey = _b.enum, items = _b.items, max = _b.maximum, maxLength = _b.maxLength, min = _b.minimum, minLength = _b.minLength, type = _b.type, requiredProperties = props.requiredProperties, layout = props.layout;
    var control = useFormContext().control;
    var enumValues = (_a = enumKey !== null && enumKey !== void 0 ? enumKey : items === null || items === void 0 ? void 0 : items.enum) !== null && _a !== void 0 ? _a : [];
    var inputType = getPropertyInputType(property);
    var label = startCase$1(propertyKey);
    var required = requiredProperties === null || requiredProperties === void 0 ? void 0 : requiredProperties.has(propertyKey);
    var validate = usePropertyInputValidator(propertyKey, property, required);
    var isTextArea = Boolean(textAreaProperties.has(label.toLowerCase()));
    var rules = {
        max: max,
        maxLength: maxLength,
        min: min,
        minLength: minLength,
        validate: validate,
    };
    switch (inputType) {
        case PropertyInputType.NumberArray:
            return (jsx(NumericListInputController, { control: control, label: label, layout: layout, name: propertyKey, rules: rules, showAsterisk: required, tooltip: description }));
        case PropertyInputType.EnumArray:
            return (jsx(MultiSelectController, { control: control, itemRemoveFilter: function (item, itemToRemove) {
                    return !isEqual$1(item, itemToRemove);
                }, itemRenderer: function (item, props) { return (jsx(SelectItem, __assign({ text: item }, props), item)); }, items: enumValues, label: label, layout: layout, name: propertyKey, rules: rules, showAsterisk: required, tagRenderer: startCase$1, tooltip: description }));
        case PropertyInputType.StringArray:
            return (jsx(ListInputController, { control: control, label: label, layout: layout, name: propertyKey, rules: rules, showAsterisk: required, tooltip: description }));
        case PropertyInputType.Number:
            return (jsx(NumericInputController, { control: control, label: label, layout: layout, name: propertyKey, rules: rules, showAsterisk: required, tooltip: description }));
        case PropertyInputType.Enum:
            return (jsx(SelectController, { control: control, itemKey: function (enumValue) { return String(enumValue); }, itemLabel: startCase$1, items: enumValues, label: label, layout: layout, name: propertyKey, rules: rules, showAsterisk: required, tooltip: description }));
        case PropertyInputType.DateTime:
            return (jsx(DateInputController, { control: control, label: label, layout: layout, name: propertyKey, rules: rules, showAsterisk: required, tooltip: description }));
        case PropertyInputType.String:
            if (isTextArea) {
                return (jsx(TextAreaController, { control: control, label: label, layout: FieldLayout.HorizontalStart, name: propertyKey, rows: 8, rules: rules, showAsterisk: required, tooltip: description }));
            }
            return (jsx(InputController, { control: control, label: label, layout: layout, name: propertyKey, rules: rules, showAsterisk: required, tooltip: description }));
        case PropertyInputType.Boolean:
            return (jsx(SwitchController, { control: control, label: label, layout: layout, name: propertyKey, rules: rules, showAsterisk: required, tooltip: description }));
        default:
            return (jsx(Field, __assign({ label: label, layout: layout, tooltip: "The property type \"".concat(type, "\" is unsupported by Control Center at this time.") }, { children: jsx(Input, { disabled: true, placeholder: "Unsupported property type" }) })));
    }
};

// These keys are handled by Control Center already and don't need
// to be handled dynamically.
var reservedKeys = new Set([
    'demandSubAccountUuid',
    'url',
    'unmonetizedUrl',
    'tags',
    'keywords',
]);
var OfferCreateFormDrawer = function (props) {
    var _a, _b, _c;
    var form = useForm();
    var visible = props.visible, isSubmitting = props.isSubmitting, onClose = props.onClose, onSubmit = props.onSubmit, productType = props.productType;
    var control = form.control, watch = form.watch, handleSubmit = form.handleSubmit;
    var product = watch('product');
    var type = product === null || product === void 0 ? void 0 : product.type;
    var version = 'write';
    var productsQuery = useQuery(queries.ews.offerCatalog.products());
    var defaultProductType = useMemo(function () {
        var _a, _b;
        return (_b = (_a = productsQuery === null || productsQuery === void 0 ? void 0 : productsQuery.data) === null || _a === void 0 ? void 0 : _a.find(function (product) { return product.type === productType; })) !== null && _b !== void 0 ? _b : null;
    }, []);
    var productVersionQuery = useQuery(queries.ews.offerCatalog.productVersion({ type: type, version: version }, { enabled: Boolean(product) }));
    var productVersionSchema = (_a = productVersionQuery === null || productVersionQuery === void 0 ? void 0 : productVersionQuery.data) === null || _a === void 0 ? void 0 : _a.schema;
    var requiredProperties = new Set((_b = productVersionSchema === null || productVersionSchema === void 0 ? void 0 : productVersionSchema.required) !== null && _b !== void 0 ? _b : []);
    var clientSideRequiredProperties = ['internalName'];
    clientSideRequiredProperties.forEach(function (property) {
        return requiredProperties.add(property);
    });
    var properties = orderBy(Object.entries((_c = productVersionSchema === null || productVersionSchema === void 0 ? void 0 : productVersionSchema.properties) !== null && _c !== void 0 ? _c : {})
        .filter(function (_a) {
        var key = _a[0];
        return !reservedKeys.has(key);
    })
        .filter(function (_a) {
        var readOnly = _a[1].readOnly;
        return !readOnly;
    }), [
        function (_a) {
            var property = _a[0];
            return requiredProperties.has(property);
        },
        function (_a) {
            var property = _a[0];
            return property;
        },
    ], ['desc', 'asc']);
    return (jsxs(DrawerForm, __assign({ disableCloseOnMouseDown: true, isSubmitting: isSubmitting, size: DrawerSize.STANDARD, title: "Create New Offer", visible: visible, onClose: onClose, onSubmit: handleSubmit(onSubmit) }, { children: [jsx(SelectController, { control: control, defaultValue: defaultProductType !== null && defaultProductType !== void 0 ? defaultProductType : undefined, itemKey: function (_a) {
                    var type = _a.type, displayName = _a.displayName;
                    return type + displayName;
                }, itemLabel: function (_a) {
                    var displayName = _a.displayName;
                    return displayName;
                }, items: Array.isArray(productsQuery === null || productsQuery === void 0 ? void 0 : productsQuery.data) ? productsQuery === null || productsQuery === void 0 ? void 0 : productsQuery.data : [], label: "Product Type", name: "product", rules: { required: 'Product type is required' } }), jsx(SubAccountSuggestController, { showOnlyDemandSubAccounts: true, control: control, label: "Demand Sub Account", name: "demandSubAccount", rules: { required: 'Demand sub account is required' } }), jsx(InputController, { control: control, label: "Unmonetized URL", name: "unmonetizedUrl", rules: {
                    required: 'Unmonetized URL is required',
                    validate: function (value) {
                        var _a;
                        return isURL((_a = value === null || value === void 0 ? void 0 : value.toString()) !== null && _a !== void 0 ? _a : '', { require_protocol: true }) ||
                            'Please enter a valid URL (https://example.com)';
                    },
                } }), jsx(FormProvider, __assign({}, form, { children: properties === null || properties === void 0 ? void 0 : properties.map(function (_a) {
                    var key = _a[0], property = _a[1];
                    return (jsx(OfferPropertyHandler, { property: property, propertyKey: key, requiredProperties: requiredProperties }, key));
                }) })), jsx(Field, __assign({ label: "Keywords" }, { children: jsx(RepeaterController, { isCondensed: true, control: control, defaultValue: {}, itemNoun: "Keyword", itemRenderer: function (_, index) { return (jsx(InputController, { control: control, name: "keywords.".concat(index, ".value"), useFieldWrapper: false })); }, name: "keywords" }) })), jsx(Field, __assign({ label: "Tags" }, { children: jsx(RepeaterController, { isCondensed: true, control: control, defaultValue: {}, itemNoun: "Tag", itemRenderer: function (_, index) { return (jsxs("div", __assign({ style: { display: 'flex' } }, { children: [jsx(InputController, { control: control, name: "tags.".concat(index, ".key"), placeholder: "Key", style: { marginRight: '10px' }, useFieldWrapper: false }), jsx(InputController, { control: control, name: "tags.".concat(index, ".value"), placeholder: "Value", useFieldWrapper: false })] }))); }, name: "tags" }) }))] })));
};

var OffersTable = function (props) {
    var gridRef = props.gridRef, _a = props.showProductTypeColumn, showProductTypeColumn = _a === void 0 ? true : _a, rowData = props.rowData;
    var agGridOptions = usePortalAgGridOptions();
    var columnDefs = useMemo(function () { return [
        {
            cellRenderer: function (_a) {
                var _b;
                var data = _a.data;
                return (jsx(Link, __assign({ href: {
                        pathname: InternalRoutes.OfferCatalog.OffersDetail,
                        query: {
                            productType: data.productType,
                            productVersion: Math.max.apply(Math, data.productVersions),
                            uuid: data.uuid,
                            version: data.version,
                        },
                    } }, { children: jsx("a", { children: (_b = data.internalName) !== null && _b !== void 0 ? _b : '[No Name Specified]' }) })));
            },
            field: 'internalName',
            filter: 'simpleTextFilter',
            flex: 4,
            headerName: 'Offer Name',
            minWidth: 170,
        },
        {
            cellRenderer: function (_a) {
                var _b;
                var data = _a.data;
                return (jsx(Link, __assign({ href: {
                        pathname: InternalRoutes.Accounts,
                        query: { uuid: data.accountUuid },
                    } }, { children: jsx("a", { children: (_b = data.accountDisplayName) !== null && _b !== void 0 ? _b : '' }) })));
            },
            field: 'accountDisplayName',
            filter: 'simpleTextFilter',
            flex: 4,
            headerName: 'Account Name',
            minWidth: 170,
        },
        {
            cellRenderer: function (_a) {
                var data = _a.data;
                return (jsx(Link, __assign({ href: {
                        pathname: InternalRoutes.DemandSubAccountDetail,
                        query: { uuid: data.demandSubAccountUuid },
                    } }, { children: jsx("a", { children: data.demandSubAccountName }) })));
            },
            field: 'demandSubAccountName',
            filter: 'simpleTextFilter',
            flex: 4,
            headerName: 'Demand Sub Account Name',
            minWidth: 170,
        },
        {
            cellRenderer: function (_a) {
                var value = _a.value;
                return value;
            },
            field: 'productType',
            filter: 'agSetColumnFilter',
            flex: 4,
            headerComponentParams: {
                filterIcon: FilterIcon.FILTER,
            },
            headerName: 'Product Type Key',
            hide: !showProductTypeColumn,
            minWidth: 170,
        },
        {
            cellRenderer: function (_a) {
                var data = _a.data, value = _a.value;
                return (jsx(Link, __assign({ href: {
                        pathname: "".concat(InternalRoutes.OfferCatalog.ProductTypes, "/").concat(value, "/").concat(data.productVersions[0]),
                    } }, { children: jsx("a", { children: data.productDisplayName }) })));
            },
            field: 'productType',
            filter: 'agSetColumnFilter',
            flex: 4,
            headerComponentParams: {
                filterIcon: FilterIcon.FILTER,
            },
            headerName: 'Product Type Display Name',
            hide: !showProductTypeColumn,
            minWidth: 145,
        },
        {
            field: 'monetizedUrl',
            filter: 'agSetColumnFilter',
            filterParams: {
                suppressMiniFilter: true,
                suppressSelectAll: false,
                values: ['Yes', 'No'],
            },
            filterValueGetter: function (_a) {
                var data = _a.data;
                return ((data === null || data === void 0 ? void 0 : data.monetizedUrl) ? 'Yes' : 'No');
            },
            flex: 3,
            headerComponentParams: {
                filterIcon: FilterIcon.FILTER,
            },
            headerName: 'Is Monetizable',
            minWidth: 150,
            valueGetter: function (_a) {
                var data = _a.data;
                return ((data === null || data === void 0 ? void 0 : data.monetizedUrl) ? 'Yes' : 'No');
            },
        },
        // TODO - once https://moneylion.atlassian.net/browse/CCCR-1129 is completed, remove "hide: true" and uncomment the commented out properties
        {
            // cellRenderer: dateTimeShortCellRenderer,
            field: 'createdAt',
            // filter: 'dateRangeFilter',
            // flex: 3,
            // headerComponentParams: {
            //   filterIcon: FilterIcon.FILTER,
            // },
            headerName: 'Created At',
            hide: true,
            // minWidth: 110,
            sort: 'desc',
        },
        {
            cellRenderer: dateTimeShortCellRenderer,
            field: 'updatedAt',
            filter: 'dateRangeFilter',
            flex: 3,
            headerComponentParams: {
                filterIcon: FilterIcon.FILTER,
            },
            headerName: 'Updated At',
            minWidth: 110,
        },
    ]; }, [showProductTypeColumn, rowData]);
    return (jsx("div", __assign({ className: "ag-theme-alpine", style: { height: '100%' } }, { children: jsx(AgGridReact, { ref: gridRef, pagination: true, columnDefs: columnDefs, getRowId: function (_a) {
                var data = _a.data;
                return data.uuid;
            }, gridOptions: agGridOptions, paginationPageSize: 25, rowData: rowData }) })));
};

var DetailCellRenderer = function (_a) {
    var revenueClauses = _a.revenueClauses, productType = _a.productType;
    return (jsx(RoundedCard, { children: jsx(RoundedCard.Content, __assign({ className: "other-contract-card-data" }, { children: jsx("div", { children: revenueClauses.map(function (revenueClause, index) { return (jsx(PricingPlan, { count: index + 1, revenueClause: revenueClause, type: productType }, index)); }) }) })) }));
};

var OtherContractsCard = function (props) {
    var demandContracts = props.demandContracts;
    var detailCellRenderer = useCallback(DetailCellRenderer, []);
    var columnDefs = useMemo(function () { return [
        {
            cellRenderer: 'agGroupCellRenderer',
            field: 'id',
            filter: 'agSetColumnFilter',
            filterParams: { placeHolder: 'Search by Contract ID' },
            flex: 1,
            headerName: 'ID',
            type: ColumnDefs.NUMERIC,
            valueFormatter: function (params) { var _a; return (_a = params.value) === null || _a === void 0 ? void 0 : _a.toString(); },
            valueParser: function (params) { return params.newValue; },
        },
        {
            cellRenderer: function (params) { return (jsx(Tag, __assign({ minimal: true, style: { marginRight: 10 } }, { children: startCase(params.value) }), params.value)); },
            field: 'productType',
            filter: 'agSetColumnFilter',
            flex: 2,
            headerName: 'Pricing Plan',
            suppressMenu: true,
        },
        {
            field: 'effectiveAt',
            flex: 1,
            headerName: 'Effective At',
            sort: 'desc',
            sortedAt: 1,
            type: ColumnDefs.DATE,
        },
        {
            cellRenderer: userAvatarRenderer,
            field: 'createdBy',
            filter: 'agSetColumnFilter',
            filterValueGetter: function (_a) {
                var _b;
                var data = _a.data;
                return (_b = data === null || data === void 0 ? void 0 : data.createdBy) === null || _b === void 0 ? void 0 : _b.fullName;
            },
            flex: 2,
            headerComponentParams: {
                filterIcon: FilterIcon.FILTER,
            },
            headerName: 'Created By',
        },
        {
            cellRenderer: dateShortCellRenderer,
            field: 'createdAt',
            flex: 2,
            headerName: 'Created At',
            sort: 'desc',
            sortedAt: 0,
        },
    ]; }, []);
    var headerContent = jsx(Button, { children: "Clear All Filters" });
    var gridOptions = usePortalAgGridOptions();
    var gridRef = useRef(null);
    return (jsx(RoundedCard, __assign({ headerContent: headerContent, title: "Other Contracts" }, { children: jsx("div", __assign({ className: "ag-theme-alpine", style: { height: '100%' } }, { children: jsx(AgGridReact, { ref: gridRef, detailRowAutoHeight: true, masterDetail: true, pagination: true, columnDefs: columnDefs, detailCellRenderer: detailCellRenderer, detailCellRendererParams: function (params) {
                    var _a, _b;
                    var data = params.data;
                    var productType = data.productType, revenueClauses = data.revenueClauses, demandPlatformFeeConfig = data.demandPlatformFeeConfig;
                    var config = (demandPlatformFeeConfig || {}).config;
                    var demandPlatformFeePercent = '';
                    var defaultDemandPlatformFeePercent = '';
                    if (config) {
                        if (config.configType === 'percentageOf' &&
                            typeof config.percent === 'string') {
                            demandPlatformFeePercent = (Number(config.percent) * 100).toString();
                        }
                        if ((_a = config.defaultTier) === null || _a === void 0 ? void 0 : _a.percent) {
                            defaultDemandPlatformFeePercent = (Number(config.defaultTier.percent) * 100).toString();
                        }
                        if ((_b = config.default) === null || _b === void 0 ? void 0 : _b.percent) {
                            defaultDemandPlatformFeePercent = (Number(config.default.percent) * 100).toString();
                        }
                    }
                    return {
                        productType: productType,
                        revenueClauses: revenueClauses.map(function (revenueClause) {
                            var _a, _b;
                            return (__assign(__assign({}, revenueClause), { defaultDemandPlatformFeePercent: defaultDemandPlatformFeePercent, demandPlatformFeePercent: demandPlatformFeePercent, percentByFundedLoanAmount: (_a = revenueClause.percentByFundedLoanAmount) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
                                    var _b, _c, _d, _e, _f, _g;
                                    var key = _a.key, value = _a.value;
                                    return ({
                                        demandPlatformFeePercent: ((_d = (_c = (_b = demandPlatformFeeConfig === null || demandPlatformFeeConfig === void 0 ? void 0 : demandPlatformFeeConfig.config) === null || _b === void 0 ? void 0 : _b.tiers) === null || _c === void 0 ? void 0 : _c[key]) === null || _d === void 0 ? void 0 : _d.percent)
                                            ? (Number((_g = (_f = (_e = demandPlatformFeeConfig === null || demandPlatformFeeConfig === void 0 ? void 0 : demandPlatformFeeConfig.config) === null || _e === void 0 ? void 0 : _e.tiers) === null || _f === void 0 ? void 0 : _f[key]) === null || _g === void 0 ? void 0 : _g.percent) * 100).toString()
                                            : '',
                                        key: key,
                                        value: value,
                                    });
                                }), percentBySupplySubAccountId: (_b = revenueClause.percentBySupplySubAccountId) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
                                    var _b, _c, _d;
                                    var key = _a.key, value = _a.value;
                                    var demandPlatformFeePercent = ((_d = (_c = (_b = demandPlatformFeeConfig === null || demandPlatformFeeConfig === void 0 ? void 0 : demandPlatformFeeConfig.config) === null || _b === void 0 ? void 0 : _b.supplySubAccounts) === null || _c === void 0 ? void 0 : _c[key]) === null || _d === void 0 ? void 0 : _d.percent)
                                        ? (Number(demandPlatformFeeConfig.config.supplySubAccounts[key].percent) * 100).toString()
                                        : '';
                                    var totalReceivablePercent = calculateTotalReceivablePercent(value, demandPlatformFeePercent);
                                    return {
                                        demandPlatformFeePercent: demandPlatformFeePercent,
                                        key: key,
                                        totalReceivablePercent: totalReceivablePercent,
                                        value: value,
                                    };
                                }) }));
                        }),
                    };
                }, getRowId: function (_a) {
                    var data = _a.data;
                    return String(data.id);
                }, gridOptions: gridOptions, paginationPageSize: 5, rowData: demandContracts }) })) })));
};

var PartnerTypeSelect = function (_a) {
    var testId = _a["data-testid"], partnerTypeArray = _a.partnerTypeArray, props = __rest(_a, ['data-testid', "partnerTypeArray"]);
    return (jsx("span", __assign({ "data-testid": testId }, { children: jsx(Select, __assign({ itemKey: function (partnerType) { return partnerType; }, itemLabel: function (partnerType) { return partnerType; }, items: partnerTypeArray }, props)) })));
};

var FirstRowMetricItem = function (_a) {
    var format = _a.format, icon = _a.icon, iconColor = _a.iconColor, title = _a.title, value = _a.value;
    return (jsxs("article", __assign({ className: "perf-report-card-item container" }, { children: [jsxs("div", __assign({ className: "icon fa-layers fa-fw", style: { borderColor: iconColor } }, { children: [jsx(FontAwesomeIcon, { icon: faCircle$1, style: { color: iconColor } }), jsx(FontAwesomeIcon, { fontSize: 24, icon: icon, style: { color: iconColor } })] })), jsx("div", __assign({ className: "value" }, { children: value ? format(Number(value)) : '-' })), jsx("div", { children: title })] })));
};

var MetricColor;
(function (MetricColor) {
    MetricColor["AmountOriginated"] = "#CF9D52";
    MetricColor["ApprovalRate"] = "#5697BC";
    MetricColor["ClickRate"] = "#6BAD42";
    MetricColor["ClickToFund"] = "#8D6FBD";
})(MetricColor || (MetricColor = {}));
var FirstRowMetrics = function (_a) {
    var loanSummary = _a.loanSummary;
    return (jsxs("main", __assign({ className: "perf-report-card container" }, { children: [jsx(FirstRowMetricItem, { format: function (val) { return formatPercentWithPrecision(val, true); }, icon: faBadgeCheck, iconColor: MetricColor.ApprovalRate, title: "Approval Rate", value: loanSummary === null || loanSummary === void 0 ? void 0 : loanSummary.totalApprovalRate }), jsx(FirstRowMetricItem, { format: function (val) { return formatPercentWithPrecision(val, true); }, icon: faComputerMouse, iconColor: MetricColor.ClickRate, title: "Click Rate", value: loanSummary === null || loanSummary === void 0 ? void 0 : loanSummary.totalClickRate }), jsx(FirstRowMetricItem, { format: function (val) { return formatPercentWithPrecision(val, true); }, icon: faFilterCircleDollar, iconColor: MetricColor.ClickToFund, title: "Click to Fund", value: loanSummary === null || loanSummary === void 0 ? void 0 : loanSummary.totalClicksToFund }), jsx(FirstRowMetricItem, { format: moneyFormatter, icon: faSackDollar, iconColor: MetricColor.AmountOriginated, title: "Amount Originated", value: loanSummary === null || loanSummary === void 0 ? void 0 : loanSummary.totalOrigination })] })));
};

var SecondRowMetrics = function (_a) {
    var loanSummary = _a.loanSummary;
    return (jsxs(Fragment, { children: [jsxs("section", __assign({ className: "perf-report-card header" }, { children: [jsx("div", { children: "Requests" }), jsx("div", { children: "Approvals" }), jsx("div", { children: "Clicks" }), jsx("div", { children: "Funded Loans" })] })), !isEmpty(loanSummary) ? (jsxs("section", __assign({ className: "perf-report-card content" }, { children: [jsx("div", { children: loanSummary === null || loanSummary === void 0 ? void 0 : loanSummary.totalRequests }), jsx("div", { children: loanSummary === null || loanSummary === void 0 ? void 0 : loanSummary.totalApprovals }), jsx("div", { children: loanSummary === null || loanSummary === void 0 ? void 0 : loanSummary.totalClicks }), jsx("div", { children: loanSummary === null || loanSummary === void 0 ? void 0 : loanSummary.fundedLoans })] }))) : (jsx(NoData, {}))] }));
};

var PerformanceReportCard = function (_a) {
    var demandSubAccounts = _a.demandSubAccounts, loanSummary = _a.loanSummary, selectedDemandSubAccount = _a.selectedDemandSubAccount, onDemandSubAccountChange = _a.onDemandSubAccountChange, onViewMoreClick = _a.onViewMoreClick;
    return (jsxs(RoundedCard, __assign({ headerContent: jsxs(Fragment, { children: [jsx(Select, { activeItem: selectedDemandSubAccount, className: "perf-report-card select", itemKey: function (_a) {
                        var id = _a.id;
                        return id;
                    }, itemLabel: function (_a) {
                        var name = _a.name;
                        return name;
                    }, items: demandSubAccounts, onItemSelect: onDemandSubAccountChange }), jsx(ViewMoreButton, { onClick: onViewMoreClick })] }), title: "Month-to-Date Performance Report" }, { children: [jsx(FirstRowMetrics, { loanSummary: loanSummary }), jsx(SecondRowMetrics, { loanSummary: loanSummary })] })));
};

var styles$9 = {"portal-selectable-card":"index-module_portal-selectable-card__TKcRf","portal-selectable-card-small":"index-module_portal-selectable-card-small__AXs8G","portal-selectable-card-large":"index-module_portal-selectable-card-large__8pem3","card-icon":"index-module_card-icon__CaLgQ","portal-selectable-card-locked":"index-module_portal-selectable-card-locked__o9UFM","portal-selectable-card-selected":"index-module_portal-selectable-card-selected__6aV30","portal-selectable-card-extra":"index-module_portal-selectable-card-extra__g9yTd","card-select-input":"index-module_card-select-input__qb3JK"};

var ProductTypeCardSelect = function (_a) {
    var size = _a.size, handlePurchasePlan = _a.handlePurchasePlan;
    var contents = [
        {
            icon: faSackDollar,
            label: 'Personal Loans',
            locked: false,
            value: ProductType$1.Loan,
        },
        {
            icon: faCreditCard,
            label: 'Credit Cards',
            locked: true,
            value: ProductType$1.CreditCard,
        },
        {
            icon: faUmbrella,
            label: 'Life Insurance',
            locked: true,
            value: ProductType$1.LifeInsurance,
        },
        {
            icon: faPiggyBank,
            label: 'Savings',
            locked: true,
            value: ProductType$1.Savings,
        },
        {
            icon: faGraduationCap,
            label: 'Student Loan Refinancing',
            locked: true,
            value: ProductSubType.StudentLoanRefinance,
        },
        {
            icon: faCarSide,
            label: 'Auto Loan Refinancing',
            locked: true,
            value: ProductSubType.Refinance,
        },
    ];
    var _b = useState(false), modalVisible = _b[0], setIsModalVisible = _b[1];
    var handleOk = function () {
        setIsModalVisible(false);
        handlePurchasePlan();
    };
    var showPurchaseModal = function () {
        setIsModalVisible(true);
    };
    var _c = useFormContext(), getValues = _c.getValues, setValue = _c.setValue;
    var selectedValue = getValues().productType;
    return (jsxs("div", __assign({ className: styles$9['card-select-input'] }, { children: [contents === null || contents === void 0 ? void 0 : contents.map(function (cardContent) {
                var _a;
                var locked = cardContent.locked, label = cardContent.label, value = cardContent.value, icon = cardContent.icon;
                return (jsxs("div", __assign({ className: classNames(styles$9['portal-selectable-card'], (_a = {},
                        _a[styles$9['portal-selectable-card-large']] = size === 'large',
                        _a[styles$9['portal-selectable-card-locked']] = locked,
                        _a[styles$9['portal-selectable-card-selected']] = selectedValue === value,
                        _a[styles$9['portal-selectable-card-small']] = size === 'small',
                        _a)), onClick: function () {
                        locked ? showPurchaseModal() : setValue('productType', value);
                    } }, { children: [locked && (jsx(FontAwesomeIcon, { className: styles$9['portal-selectable-card-extra'], icon: faLockKeyhole, size: "lg" })), jsxs("div", { children: [icon && (jsx(FontAwesomeIcon, { className: styles$9['card-icon'], icon: icon, size: "2x" })), label && jsx("p", { children: label })] })] }), value));
            }), jsx(EvenDialog, { cancelationButtonProps: {
                    text: 'Cancel',
                }, confirmationButtonProps: {
                    text: 'Purchase Plan',
                }, message: "Please purchase a plan to create integrations with other product types.", title: "Purchase a plan to unlock other product types", visible: modalVisible, onCancel: function () { return setIsModalVisible(false); }, onOk: handleOk })] })));
};

var ProductTypeFieldType;
(function (ProductTypeFieldType) {
    ProductTypeFieldType["Array"] = "array";
    ProductTypeFieldType["ArrayOfIntegers"] = "array_of_integers";
    ProductTypeFieldType["ArrayOfStrings"] = "array_of_strings";
    ProductTypeFieldType["Boolean"] = "boolean";
    ProductTypeFieldType["Currency"] = "currency";
    ProductTypeFieldType["Description"] = "description";
    ProductTypeFieldType["DescriptionPoints"] = "description_points";
    ProductTypeFieldType["Headline"] = "headline";
    ProductTypeFieldType["Integer"] = "integer";
    ProductTypeFieldType["Object"] = "object";
    ProductTypeFieldType["Percentage"] = "percentage";
    ProductTypeFieldType["String"] = "string";
})(ProductTypeFieldType || (ProductTypeFieldType = {}));
var stringFieldTypes = [
    ProductTypeFieldType.String,
    ProductTypeFieldType.ArrayOfStrings,
];
var numberFieldTypes = [
    ProductTypeFieldType.Percentage,
    ProductTypeFieldType.Currency,
    ProductTypeFieldType.Integer,
];
var arrayFieldTypes = [
    ProductTypeFieldType.Array,
    ProductTypeFieldType.ArrayOfIntegers,
    ProductTypeFieldType.ArrayOfStrings,
];

var ProductTypeBackfillValueItem = function (_a) {
    var control = _a.control, fieldType = _a.fieldType, name = _a.name, _b = _a.placeholder, placeholder = _b === void 0 ? 'Backfill value for existing offers' : _b;
    switch (fieldType) {
        case ProductTypeFieldType.ArrayOfIntegers:
            return (jsx(NumericListInputController, { control: control, label: "Backfill values for existing offers", name: name }));
        case ProductTypeFieldType.Array:
        case ProductTypeFieldType.ArrayOfStrings:
            return (jsx(ListInputController, { control: control, label: "Backfill values for existing offers", name: name }));
        case ProductTypeFieldType.Boolean:
            return (jsx(SwitchController, { control: control, label: 'Backfill value for existing offers', name: name, placeholder: placeholder, rules: { required: 'Backfill value is required' } }));
        case ProductTypeFieldType.Currency:
        case ProductTypeFieldType.Percentage:
        case ProductTypeFieldType.Integer:
            return (jsx(NumericInputController, { control: control, label: "Backfill value for existing offers", name: name, placeholder: placeholder, rules: { required: 'Backfill value is required' } }));
        case ProductTypeFieldType.String:
        default:
            return (jsx(InputController, { control: control, label: "Backfill value for existing offers", name: name, placeholder: placeholder, rules: { required: 'Backfill value is required' } }));
    }
};

var ProductTypeDefaultValueItem = function (_a) {
    var control = _a.control, isStringFieldType = _a.isStringFieldType, name = _a.name;
    return isStringFieldType ? (jsx(InputController, { control: control, label: "Default value for existing offers", name: name })) : (jsx(NumericInputController, { control: control, label: "Default value for existing offers", name: name }));
};

var ProductTypeRangeValueItem = function (props) {
    var _a = useFormContext(), control = _a.control, watch = _a.watch;
    var fieldType = props.fieldType, isUpdate = props.isUpdate, name = props.name;
    var BACKFILL_MAX_VALUE = "".concat(name, ".backfillMaxValue");
    var BACKFILL_MIN_VALUE = "".concat(name, ".backfillMinValue");
    var MAKE_MAX_REQUIRED = "".concat(name, ".makeMaxRequired");
    var MAKE_MIN_REQUIRED = "".concat(name, ".makeMinRequired");
    var makeMaxRequired = watch(MAKE_MAX_REQUIRED);
    var makeMinRequired = watch(MAKE_MIN_REQUIRED);
    return (jsxs(Fragment, { children: [jsx(CheckboxController, { control: control, label: "Make min required", layout: FieldLayout.Horizontal, name: MAKE_MIN_REQUIRED }), makeMinRequired && isUpdate && (jsx(ProductTypeBackfillValueItem, { control: control, fieldType: fieldType, name: BACKFILL_MIN_VALUE, placeholder: "Backfill min required value" })), jsx(CheckboxController, { control: control, label: "Make max required", layout: FieldLayout.Horizontal, name: MAKE_MAX_REQUIRED }), makeMaxRequired && isUpdate && (jsx(ProductTypeBackfillValueItem, { control: control, fieldType: fieldType, name: BACKFILL_MAX_VALUE, placeholder: "Backfill max required value" }))] }));
};

var booleanSchema = {
    type: ProductPropertyType.Boolean,
};
var stringSchema = {
    type: ProductPropertyType.String,
};
var integerSchema = {
    minimum: 0,
    type: ProductPropertyType.Integer,
};
var objectSchema = {
    type: ProductPropertyType.Object,
};
var arrayOfStringsSchema = {
    items: {
        type: 'string',
    },
    type: ProductPropertyType.Array,
};
var arrayOfIntegersSchema = {
    items: {
        type: 'number',
    },
    type: ProductPropertyType.Array,
};
var fieldTypeToSchema = new Map([
    [ProductTypeFieldType.Array, arrayOfStringsSchema],
    [ProductTypeFieldType.ArrayOfIntegers, arrayOfIntegersSchema],
    [ProductTypeFieldType.ArrayOfStrings, arrayOfStringsSchema],
    [ProductTypeFieldType.Currency, integerSchema],
    [ProductTypeFieldType.Boolean, booleanSchema],
    [ProductTypeFieldType.Description, stringSchema],
    [ProductTypeFieldType.DescriptionPoints, arrayOfStringsSchema],
    [ProductTypeFieldType.Headline, stringSchema],
    [ProductTypeFieldType.Integer, integerSchema],
    [ProductTypeFieldType.Object, objectSchema],
    [ProductTypeFieldType.Percentage, integerSchema],
    [ProductTypeFieldType.String, stringSchema],
]);
var productPropertyArrayTypes = [
    ProductTypeFieldType.Array,
    ProductTypeFieldType.ArrayOfIntegers,
    ProductTypeFieldType.ArrayOfStrings,
];
var addFieldToPropertySchema = function (data) {
    var backfillMaxValue = data.backfillMaxValue, backfillMinValue = data.backfillMinValue, backfillValue = data.backfillValue, enumOptions = data.enumOptions, fieldFormat = data.fieldFormat, fieldName = data.fieldName, fieldType = data.fieldType, makeMaxRequired = data.makeMaxRequired, makeMinRequired = data.makeMinRequired, makeRanged = data.makeRanged, makeRequired = data.makeRequired, maxFieldName = data.maxFieldName, minFieldName = data.minFieldName, tooltip = data.tooltip;
    var schema = fieldTypeToSchema.get(fieldType);
    if (!schema) {
        throw new Error('Schema for type not found');
    }
    var type = schema.type, items = schema.items, minimum = schema.minimum;
    var isArrayType = productPropertyArrayTypes.includes(fieldType);
    var enumValue = (enumOptions === null || enumOptions === void 0 ? void 0 : enumOptions.length) ? enumOptions : undefined;
    var itemsWithEnum = items && __assign(__assign({}, items), { enum: isArrayType ? enumValue : undefined });
    var propertySchema = {
        description: tooltip,
        enum: isArrayType ? undefined : enumValue,
        format: fieldFormat,
        items: itemsWithEnum,
        minimum: minimum,
        type: type,
    };
    if (makeRanged) {
        return [
            {
                backfillValue: backfillMinValue,
                propertyKey: minFieldName,
                propertySchema: propertySchema,
                required: makeMinRequired,
            },
            {
                backfillValue: backfillMaxValue,
                propertyKey: maxFieldName,
                propertySchema: propertySchema,
                required: makeMaxRequired,
            },
        ];
    }
    return [
        {
            backfillValue: backfillValue,
            propertyKey: fieldName,
            propertySchema: propertySchema,
            required: makeRequired,
        },
    ];
};

var fieldTypeToSuffix = new Map([
    [ProductTypeFieldType.Currency, 'Cents'],
    [ProductTypeFieldType.Percentage, 'Basis Points'],
]);
var getFieldName = function (fieldNameBase, fieldType) {
    var _a;
    if (fieldNameBase === void 0) { fieldNameBase = ''; }
    var typeSuffix = fieldType ? (_a = fieldTypeToSuffix.get(fieldType)) !== null && _a !== void 0 ? _a : '' : '';
    return camelCase("".concat(fieldNameBase.trim(), " ").concat(typeSuffix));
};
var getFieldDisplayName = function (fieldNameBase, fieldType, makeRanged) {
    var _a;
    if (fieldNameBase === void 0) { fieldNameBase = ''; }
    var typeSuffix = fieldType ? (_a = fieldTypeToSuffix.get(fieldType)) !== null && _a !== void 0 ? _a : '' : '';
    var fieldNameBaseFormatted = startCase(fieldNameBase);
    var fieldNameWithTypeSuffix = "".concat(fieldNameBaseFormatted.trim(), " ").concat(typeSuffix);
    var fieldNameWithRangeSuffix = "".concat(fieldNameWithTypeSuffix.trim(), " Min/Max");
    return makeRanged ? fieldNameWithRangeSuffix : fieldNameWithTypeSuffix;
};
var getMaxFieldName = function (fieldName, makeRanged) {
    return makeRanged ? camelCase("".concat(fieldName, " Max")) : null;
};
var getMinFieldName = function (fieldName, makeRanged) {
    return makeRanged ? camelCase("".concat(fieldName, " Min")) : null;
};

var specialStringFieldTypes = [
    ProductTypeFieldType.Description,
    ProductTypeFieldType.DescriptionPoints,
    ProductTypeFieldType.Headline,
];
var commonFieldType = __spreadArray([
    ProductTypeFieldType.Percentage,
    ProductTypeFieldType.Currency
], specialStringFieldTypes, true);
var customFieldTypes = [
    ProductTypeFieldType.Boolean,
    ProductTypeFieldType.String,
    ProductTypeFieldType.Integer,
    ProductTypeFieldType.Object,
    ProductTypeFieldType.ArrayOfStrings,
    ProductTypeFieldType.ArrayOfIntegers,
];
var fieldTypes = __spreadArray(__spreadArray([], commonFieldType, true), customFieldTypes, true);
var ProductTypeAddFieldItem = function (props) {
    var name = props.name, isCollapsed = props.isCollapsed, isUpdate = props.isUpdate, onExpand = props.onExpand;
    var _a = useFormContext(), control = _a.control, watch = _a.watch, setValue = _a.setValue;
    var BACKFILL_VALUE = "".concat(name, ".backfillValue");
    var DEFAULT_VALUE = "".concat(name, ".defaultValue");
    var ENUM_OPTIONS = "".concat(name, ".enumOptions");
    var FIELD_DISPLAY_NAME = "".concat(name, ".fieldDisplayName");
    var FIELD_FORMAT = "".concat(name, ".fieldFormat");
    var FIELD_NAME = "".concat(name, ".fieldName");
    var FIELD_NAME_BASE = "".concat(name, ".fieldNameBase");
    var FIELD_TYPE = "".concat(name, ".fieldType");
    var MAKE_MAX_REQUIRED = "".concat(name, ".makeMaxRequired");
    var MAKE_MIN_REQUIRED = "".concat(name, ".makeMinRequired");
    var MAKE_RANGED = "".concat(name, ".makeRanged");
    var MAKE_REQUIRED = "".concat(name, ".makeRequired");
    var MAX_FIELD_NAME = "".concat(name, ".maxFieldName");
    var MIN_FIELD_NAME = "".concat(name, ".minFieldName");
    var fieldDisplayName = watch(FIELD_DISPLAY_NAME);
    var fieldNameBase = watch(FIELD_NAME_BASE);
    var fieldType = watch(FIELD_TYPE);
    var makeRanged = watch(MAKE_RANGED);
    var makeRequired = watch(MAKE_REQUIRED);
    var isStringFieldType = fieldType
        ? stringFieldTypes.includes(fieldType)
        : false;
    var isNumberFieldType = fieldType
        ? numberFieldTypes.includes(fieldType)
        : false;
    var isSpecialStringFieldType = fieldType
        ? specialStringFieldTypes.includes(fieldType)
        : false;
    useUpdateEffect(function () {
        if (isSpecialStringFieldType) {
            setValue(FIELD_NAME_BASE, camelCase(fieldType));
        }
        else {
            setValue(FIELD_NAME_BASE, '');
        }
    }, [isSpecialStringFieldType]);
    useUpdateEffect(function () {
        var fieldName = getFieldName(fieldNameBase, fieldType);
        var fieldDisplayName = getFieldDisplayName(fieldNameBase, fieldType, makeRanged);
        setValue(FIELD_NAME, fieldName);
        setValue(FIELD_DISPLAY_NAME, fieldDisplayName);
        setValue(MAX_FIELD_NAME, getMaxFieldName(fieldName, makeRanged));
        setValue(MIN_FIELD_NAME, getMinFieldName(fieldName, makeRanged));
    }, [fieldNameBase, fieldType, makeRanged]);
    useUpdateEffect(function () {
        if (makeRanged) {
            setValue(MAKE_MIN_REQUIRED, false);
            setValue(MAKE_MAX_REQUIRED, false);
            setValue(MAKE_REQUIRED, false);
        }
        else {
            setValue(MAKE_REQUIRED, false);
        }
    }, [makeRanged]);
    useUpdateEffect(function () {
        if (makeRequired) {
            if (fieldType && arrayFieldTypes.includes(fieldType)) {
                setValue(BACKFILL_VALUE, []);
            }
        }
        else {
            setValue(BACKFILL_VALUE, undefined);
        }
    }, [fieldType, makeRequired]);
    useUpdateEffect(function () {
        setValue(ENUM_OPTIONS, undefined);
        setValue(FIELD_FORMAT, undefined);
        setValue(MAKE_RANGED, false);
        setValue(MAKE_MIN_REQUIRED, false);
        setValue(MAKE_MAX_REQUIRED, false);
    }, [fieldType]);
    if (isCollapsed) {
        return (jsx("div", __assign({ className: "product-type-add-field-item is-collapsed", onClick: onExpand, onKeyDown: onExpand }, { children: fieldNameBase ? fieldDisplayName : 'Unnamed Field' })));
    }
    return (jsxs("div", __assign({ className: "product-type-add-field-item" }, { children: [jsx(InputController, { control: control, disabled: isSpecialStringFieldType, label: "Field Name", name: FIELD_NAME_BASE, rules: { required: 'Field name is required' } }), Boolean(fieldDisplayName) && (jsx(InputController, { disabled: true, control: control, label: "Final Field Name", name: FIELD_DISPLAY_NAME, tooltip: "The final name of the field after creating or modifying the schema." })), jsx(SelectController, { control: control, itemGroup: function (item) {
                    return commonFieldType.includes(item) ? 'Common' : 'Custom';
                }, itemKey: function (item) { return item; }, itemLabel: function (item) { return startCase(item); }, items: fieldTypes, label: "Field Type", name: FIELD_TYPE, rules: { required: 'Field type is required' } }), isStringFieldType && (jsx(SelectController, { control: control, itemKey: function (item) { return item; }, itemLabel: function (item) { return startCase(item); }, items: ['uri', 'uuid', 'date-time'], label: "Field Format", name: FIELD_FORMAT })), isStringFieldType && (jsx(ListInputController, { control: control, label: "Enum options", name: ENUM_OPTIONS })), isNumberFieldType && (jsx(CheckboxController, { control: control, label: "Make ranged", layout: FieldLayout.Horizontal, name: MAKE_RANGED })), makeRanged ? (jsx(ProductTypeRangeValueItem, { fieldType: fieldType, isUpdate: Boolean(isUpdate), name: name })) : (jsx(CheckboxController, { control: control, label: "Make required", layout: FieldLayout.Horizontal, name: MAKE_REQUIRED })), makeRequired && isUpdate && (jsx(ProductTypeBackfillValueItem, { control: control, fieldType: fieldType, name: BACKFILL_VALUE })), jsx(ProductTypeDefaultValueItem, { control: control, isStringFieldType: isStringFieldType, name: DEFAULT_VALUE }), jsx(InputController, { control: control, label: "Tooltip", name: "".concat(name, ".tooltip") })] })));
};

var ProductTypeAddField = function (props) {
    var name = props.name, isUpdate = props.isUpdate;
    var _a = useFormContext(), control = _a.control, watch = _a.watch;
    var fields = watch(name);
    var _b = useState(), expandedFieldId = _b[0], setExpandedFieldId = _b[1];
    var shouldBeCollapsed = function (id, index) {
        if (!expandedFieldId && index === (fields === null || fields === void 0 ? void 0 : fields.length) - 1) {
            return false;
        }
        return expandedFieldId !== id;
    };
    return (jsx(RepeaterController, { control: control, defaultValue: {}, itemNoun: "Field", itemRenderer: function (id, index) { return (jsx(ProductTypeAddFieldItem, { isCollapsed: shouldBeCollapsed(id, index), isUpdate: isUpdate, name: "".concat(name, ".").concat(index), onExpand: function () { return setExpandedFieldId(id); } })); }, name: name, onAdd: function () { return setExpandedFieldId(undefined); } }));
};

var productTypeKeyValidator = function (value) {
    var formattedValue = upperFirst(camelCase(value));
    if (formattedValue !== value) {
        return 'Product type key must be Pascal case.';
    }
    return true;
};
var baseSchema = {
    properties: {
        createdAt: {
            format: 'date-time',
            readOnly: true,
            type: 'string',
        },
        demandSubAccountDisplayName: {
            readOnly: true,
            type: 'string',
        },
        demandSubAccountImageUrl: {
            format: 'uri',
            readOnly: true,
            type: 'string',
        },
        demandSubAccountUuid: {
            format: 'uuid',
            type: 'string',
        },
        internalName: {
            type: 'string',
        },
        keywords: {
            items: {
                type: 'string',
            },
            type: 'array',
        },
        legalLanguage: {
            type: 'string',
        },
        monetizedUrl: {
            format: 'uri',
            type: 'string',
        },
        productDisplayName: {
            readOnly: true,
            type: 'string',
        },
        productType: {
            readOnly: true,
            type: 'string',
        },
        productVersions: {
            items: {
                readOnly: true,
                type: 'number',
            },
            readOnly: true,
            type: 'array',
        },
        status: {
            enum: ['active', 'inactive'],
            type: 'string',
        },
        tags: {
            type: 'object',
        },
        unmonetizedUrl: {
            format: 'uri',
            type: 'string',
        },
        updatedAt: {
            format: 'date-time',
            readOnly: true,
            type: 'string',
        },
        url: {
            format: 'uri',
            readOnly: true,
            type: 'string',
        },
        uuid: {
            format: 'uuid',
            readOnly: true,
            type: 'string',
        },
        version: {
            readOnly: true,
            type: 'integer',
        },
    },
    required: [
        'createdAt',
        'demandSubAccountDisplayName',
        'demandSubAccountImageUrl',
        'demandSubAccountUuid',
        'productDisplayName',
        'productType',
        'productVersions',
        'status',
        'unmonetizedUrl',
        'updatedAt',
        'url',
        'uuid',
        'version',
    ],
};
var toProductTypeCreateData = function (form) {
    var displayName = form.displayName, fields = form.fields, keywords = form.keywords, tagsArr = form.tagsArr, type = form.type;
    var tags = tagsArr.reduce(function (accum, _a) {
        var key = _a.key, value = _a.value;
        accum[key] = value;
        return accum;
    }, {});
    var schemaData = fields.map(addFieldToPropertySchema).flat();
    var required = schemaData
        .reduce(function (accum, _a) {
        var propertyKey = _a.propertyKey, required = _a.required;
        if (required) {
            accum.push(propertyKey);
        }
        return accum;
    }, [])
        .concat(baseSchema.required);
    var properties = schemaData.reduce(function (accum, _a) {
        var propertyKey = _a.propertyKey, propertySchema = _a.propertySchema;
        accum[propertyKey] = propertySchema;
        return accum;
    }, __assign({}, baseSchema.properties));
    var schema = { properties: properties, required: required };
    var createData = {
        description: '',
        displayName: displayName,
        keywords: keywords,
        schema: schema,
        tags: tags,
        type: type,
    };
    return createData;
};

var ProductTypeCreateFormDrawer = function (props) {
    var form = useForm();
    var visible = props.visible, onClose = props.onClose, onSubmitted = props.onSubmitted;
    var control = form.control, handleSubmit = form.handleSubmit, setValue = form.setValue, watch = form.watch;
    var tagsArr = watch('tagsArr');
    var createProductMutation = useMutation(createOfferCatalogProduct, {
        onError: function () { return CrudToaster.createFailure('product'); },
        onMutate: function () { return CrudToaster.createLoading('product'); },
        onSuccess: function () {
            onSubmitted();
            CrudToaster.createSuccess('product');
        },
    });
    var handleCreateProductType = function (form) {
        var createData = toProductTypeCreateData(form);
        createProductMutation.mutate(createData);
    };
    useEffect(function () {
        if (!tagsArr) {
            return;
        }
        var hasLLMDescription = tagsArr.some(function (_a) {
            var key = _a.key;
            return key === 'llmDescription';
        });
        if (!hasLLMDescription) {
            setValue('tagsArr', __spreadArray([{ key: 'llmDescription', value: '' }], tagsArr, true));
        }
    }, [tagsArr]);
    return (jsx(DrawerForm, __assign({ disableCloseOnMouseDown: true, isSubmitting: createProductMutation.isLoading, size: DrawerSize.STANDARD, submitText: "Create", submittingText: "Creating...", title: "New Product Type", visible: visible, onClose: onClose, onSubmit: handleSubmit(handleCreateProductType) }, { children: jsxs(FormProvider, __assign({}, form, { children: [jsx(InputController, { control: control, label: "Product Type Key", name: "type", rules: {
                        required: 'Product Type Key is required',
                        validate: function (value) { return productTypeKeyValidator(value); },
                    }, tooltip: "The key should be in Pascal case. Capitalize the first letter of each word, with no spaces. Example: StudentLoanRefinance" }), jsx(InputController, { control: control, label: "Product Type Display Name", name: "displayName", rules: { required: 'Product Type Display Name is required' } }), jsx(Callout, __assign({ intent: "primary" }, { children: "Created At, Updated At, Product UUID and Version will be added automatically after product type is created" })), jsx("br", {}), jsx(Field, __assign({ label: "Tags" }, { children: jsx(RepeaterController, { isCondensed: true, control: control, defaultValue: { key: '', value: '' }, itemNoun: "Tag", itemRenderer: function (_, index) { return (jsxs("div", __assign({ style: { display: 'flex', gap: '15px' } }, { children: [jsx(InputController, { control: control, name: "tagsArr.".concat(index, ".key"), placeholder: "Key", rules: {
                                        validate: function () {
                                            var currentTag = tagsArr[index];
                                            var isLLMDescription = currentTag.key === 'llmDescription';
                                            if (isLLMDescription && !(currentTag === null || currentTag === void 0 ? void 0 : currentTag.value)) {
                                                return 'LLM Description (llmDescription) is required.';
                                            }
                                        },
                                    } }), jsx(Controller, { control: control, name: "tagsArr.".concat(index, ".value"), render: function (_a) {
                                        var _b;
                                        var field = _a.field, fieldState = _a.fieldState;
                                        return (jsx(Field, __assign({ error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message }, { children: jsx(TextArea, { growVertically: true, small: true, placeholder: "Value", value: field.value, onChange: field.onChange }) })));
                                    } })] }))); }, name: "tagsArr" }) })), jsx(ListInputController, { control: control, label: "Keywords", name: "keywords" }), jsx(Field, __assign({ label: "Offer Schema" }, { children: jsx(ProductTypeAddField, { name: "fields" }) }))] })) })));
};

var productPropertyTypeToFieldType = function (productPropertyType) {
    switch (productPropertyType) {
        case ProductPropertyType.Array:
            return ProductTypeFieldType.Array;
        case ProductPropertyType.Bool:
        case ProductPropertyType.Boolean:
            return ProductTypeFieldType.Boolean;
        case ProductPropertyType.Integer:
        case ProductPropertyType.Number:
            return ProductTypeFieldType.Integer;
        case ProductPropertyType.String:
        default:
            return ProductTypeFieldType.String;
    }
};

var ProductTypeEditFieldItem = function (props) {
    var productProperty = props.productProperty, fieldName = props.fieldName, makeRequired = props.makeRequired;
    var _a = useFormContext(), control = _a.control, watch = _a.watch, setValue = _a.setValue;
    var FIELD_NAME = "fieldsToEdit.operations.".concat(fieldName, ".fieldName");
    var FIELD_TYPE = "fieldsToEdit.operations.".concat(fieldName, ".fieldType");
    var MAKE_REQUIRED = "fieldsToEdit.operations.".concat(fieldName, ".makeRequired");
    var BACKFILL_VALUE = "fieldsToEdit.operations.".concat(fieldName, ".backfillValue");
    var updatedRequired = watch(MAKE_REQUIRED);
    var fieldType = productPropertyTypeToFieldType(productProperty.type);
    var showBackfill = updatedRequired ? makeRequired === false : false;
    useUpdateEffect(function () {
        if (updatedRequired) {
            if (fieldType && arrayFieldTypes.includes(fieldType)) {
                setValue(BACKFILL_VALUE, []);
            }
        }
        else {
            setValue(BACKFILL_VALUE, undefined);
        }
    }, [fieldType, updatedRequired]);
    return (jsxs("div", __assign({ className: "product-type-add-field-item" }, { children: [jsx(InputController, { disabled: true, control: control, defaultValue: fieldName, label: "Field Name", name: FIELD_NAME }), jsx(InputController, { disabled: true, control: control, defaultValue: productProperty.type, label: "Field Type", name: FIELD_TYPE }), jsx(CheckboxController, { control: control, defaultValue: makeRequired, label: "Make required", layout: FieldLayout.Horizontal, name: MAKE_REQUIRED }), showBackfill && (jsx(ProductTypeBackfillValueItem, { control: control, fieldType: fieldType, name: BACKFILL_VALUE }))] })));
};

var ProductTypeEditField = function (props) {
    var _a;
    var editableFields = props.editableFields, existingSchema = props.existingSchema;
    var properties = existingSchema.properties, required = existingSchema.required;
    var _b = useFormContext(), control = _b.control, watch = _b.watch;
    var fieldsToEdit = watch('fieldsToEdit');
    return (jsxs(Fragment, { children: [jsx(MultiSelectController, { control: control, itemRemoveFilter: function (item, itemToRemove) { return item !== itemToRemove; }, itemRenderer: function (item, props) { return (jsx(SelectItem, __assign({ currentItem: item, selectedItems: fieldsToEdit === null || fieldsToEdit === void 0 ? void 0 : fieldsToEdit.items, text: startCase(item) }, props), item)); }, items: editableFields, name: "fieldsToEdit.items", tagRenderer: startCase }), (_a = fieldsToEdit === null || fieldsToEdit === void 0 ? void 0 : fieldsToEdit.items) === null || _a === void 0 ? void 0 : _a.map(function (fieldName) {
                var productProperty = properties[fieldName];
                return (jsx(ProductTypeEditFieldItem, { fieldName: fieldName, fieldType: productProperty.type, makeRequired: required.includes(fieldName), productProperty: productProperty }, "product-type-edit-field-item-".concat(fieldName)));
            })] }));
};

var buildModifiedSchemaOperation = function (existingSchema, data) {
    var operations = [];
    var fieldsToRemove = data.fieldsToRemove, fieldsToAdd = data.fieldsToAdd, fieldsToEdit = data.fieldsToEdit;
    var modifiedSchema = cloneDeep(existingSchema);
    var requiredFields = new Set(modifiedSchema.required);
    fieldsToRemove === null || fieldsToRemove === void 0 ? void 0 : fieldsToRemove.forEach(function (fieldToRemove) {
        var makeRequired = requiredFields.has(fieldToRemove);
        var operation = makeRequired
            ? OperationType.DeleteRequired
            : OperationType.DeleteOptional;
        operations.push({
            fieldName: fieldToRemove,
            operation: operation,
        });
    });
    fieldsToAdd === null || fieldsToAdd === void 0 ? void 0 : fieldsToAdd.forEach(function (fieldToAdd) {
        var defaultValue = fieldToAdd.defaultValue;
        addFieldToPropertySchema(fieldToAdd)
            .flat()
            .forEach(function (propertySchemaData) {
            var backfillValue = propertySchemaData.backfillValue, propertyKey = propertySchemaData.propertyKey, propertySchema = propertySchemaData.propertySchema, required = propertySchemaData.required;
            if (required) {
                requiredFields.add(propertyKey);
            }
            var operation = required
                ? OperationType.AddRequired
                : OperationType.AddOptional;
            var description = propertySchema.description, enumValues = propertySchema.enum, items = propertySchema.items, type = propertySchema.type;
            operations.push({
                backfillValue: backfillValue,
                defaultValue: defaultValue,
                description: description,
                enumValues: enumValues,
                fieldName: propertyKey,
                fieldType: type,
                items: items,
                operation: operation,
            });
        });
    });
    var _a = (fieldsToEdit !== null && fieldsToEdit !== void 0 ? fieldsToEdit : {}).operations, editOperations = _a === void 0 ? {} : _a;
    Object.keys(editOperations).forEach(function (fieldName) {
        var _a = editOperations[fieldName], makeRequired = _a.makeRequired, backfillValue = _a.backfillValue, fieldType = _a.fieldType;
        var operation = makeRequired
            ? OperationType.ChangeOptionalToRequired
            : OperationType.ChangeRequiredToOptional;
        operations.push({
            backfillValue: backfillValue,
            fieldName: fieldName,
            fieldType: fieldType,
            operation: operation,
        });
    });
    return operations;
};

var nonRemovableFields = new Set([
    'createdAt',
    'demandSubAccountDisplayName',
    'demandSubAccountImageUrl',
    'demandSubAccountUuid',
    'internalName',
    'keywords',
    'monetizedUrl',
    'productDisplayName',
    'productType',
    'productVersions',
    'status',
    'tags',
    'unmonetizedUrl',
    'updatedAt',
    'url',
    'uuid',
    'version',
]);
var confirmationMessage = (jsxs(Fragment, { children: [jsx("p", { children: "Warning: this will create a new product version. This is an irreversible operation. Are you sure you want to proceed?" }), jsx("p", { children: "Note: please ping Christopher Novak, Eric Peters, Sweta Parekh, and Leah Naidorf for approval" })] }));
var ProductTypeModifySchemaDrawer = function (props) {
    var form = useForm();
    var _a = props.existingProduct, type = _a.type, maxVersion = _a.maxVersion, existingSchema = props.existingSchema, onClose = props.onClose, visible = props.visible;
    var control = form.control, watch = form.watch, handleSubmit = form.handleSubmit;
    var fieldsToRemove = watch('fieldsToRemove');
    var updateProductMutation = useMutation(updateCurrentProduct);
    var editableFields = Object.keys(existingSchema.properties).filter(function (property) { return !nonRemovableFields.has(property); });
    var removableFields = editableFields.filter(function (property) { return !existingSchema.required.includes(property); });
    var handleModifySchema = function (data) {
        var operations = buildModifiedSchemaOperation(existingSchema, data);
        var variables = {
            currentVersion: maxVersion,
            operations: operations,
            type: type,
        };
        var options = {
            onError: function () { return CrudToaster.updateFailure('product schema'); },
            onSuccess: function (response) {
                var nextVersion = response.maxVersion;
                onClose();
                CrudToaster.updateSuccess('product schema');
                // Short timeout to avoid product version not found error.
                setTimeout(function () {
                    window.location.href = "/offer-catalog/product-types/".concat(type, "/").concat(nextVersion);
                });
            },
        };
        CrudToaster.updateLoading('product schema');
        updateProductMutation.mutate(variables, options);
    };
    return (jsx(DrawerForm, __assign({ disableCloseOnMouseDown: true, requireConfirmation: true, confirmationMessage: confirmationMessage, isSubmitting: updateProductMutation.isLoading, size: DrawerSize.STANDARD, submitText: "Modify Schema", title: "Modify Schema", visible: visible, onClose: onClose, onSubmit: handleSubmit(handleModifySchema) }, { children: jsxs(FormProvider, __assign({}, form, { children: [jsx(H4, { children: "Remove Fields" }), jsx(MultiSelectController, { control: control, itemRemoveFilter: function (item, itemToRemove) { return item !== itemToRemove; }, itemRenderer: function (item, props) { return (jsx(SelectItem, __assign({ currentItem: item, selectedItems: fieldsToRemove, text: startCase(item) }, props), item)); }, items: removableFields, name: "fieldsToRemove", tagRenderer: startCase }), jsx("br", {}), jsx(H4, { children: "Add Fields" }), jsx(ProductTypeAddField, { isUpdate: true, name: "fieldsToAdd" }), jsx("br", {}), jsx(H4, { children: "Edit Fields" }), jsx(ProductTypeEditField, { editableFields: editableFields, existingSchema: existingSchema })] })) })));
};

var styles$8 = {"container":"PropertyItem-module_container__CjlB2","title":"PropertyItem-module_title__Xtqh8","body":"PropertyItem-module_body__GsFPM","copy-icon":"PropertyItem-module_copy-icon__KKNJ3"};

var COPY_TEXT = 'Copied to clipboard';
var PropertyItem = function (_a) {
    var _b = _a.clipboardValue, clipboardValue = _b === void 0 ? '' : _b, _c = _a.enableCopyToClipboard, enableCopyToClipboard = _c === void 0 ? true : _c, renderValue = _a.renderValue, title = _a.title, value = _a.value;
    var onCopyToClipboard = function () { return Toaster.success(COPY_TEXT); };
    return (jsxs("aside", __assign({ className: styles$8.container }, { children: [jsx(H5, __assign({ className: styles$8.title, "data-testid": "propertyItem-title-".concat(kebabCase(title)) }, { children: title })), jsxs("div", __assign({ className: styles$8.body }, { children: [jsx("span", __assign({ "data-testid": "property-item-value" }, { children: renderValue ? renderValue(value) : value })), enableCopyToClipboard && (jsx(CopyToClipboard, __assign({ text: clipboardValue ? clipboardValue === null || clipboardValue === void 0 ? void 0 : clipboardValue.toString() : value === null || value === void 0 ? void 0 : value.toString(), onCopy: onCopyToClipboard }, { children: jsx(EvenButton, { minimal: true, icon: jsx(FontAwesomeIcon, { className: styles$8['copy-icon'], icon: faPaste }) }) })))] }))] })));
};

var RoleSelect = function (_a) {
    var testId = _a["data-testid"], _b = _a.showExternalRoleOptions, showExternalRoleOptions = _b === void 0 ? true : _b, _c = _a.showInternalRoleOptions, showInternalRoleOptions = _c === void 0 ? true : _c, showSupplyRoles = _a.showSupplyRoles, showDemandRoles = _a.showDemandRoles, isMultiSelected = _a.isMultiSelected, props = __rest(_a, ['data-testid', "showExternalRoleOptions", "showInternalRoleOptions", "showSupplyRoles", "showDemandRoles", "isMultiSelected"]);
    var roleOptions = useMemo(function () {
        var options = [];
        if (showInternalRoleOptions) {
            options.push.apply(options, internalRoleObjectArray);
        }
        if (showSupplyRoles) {
            options.push.apply(options, supplyRoleObjectArray);
            // if multi is selected, filter out the other options. (EG only show Scale from Scale, Growth, Starter, etc...)
            if (isMultiSelected) {
                options = options.filter(function (option) {
                    return Object.keys(SupplyFlatRolesForMulti).includes(option.flatRole);
                });
            }
        }
        if (showDemandRoles) {
            options.push.apply(options, demandRoleObjectArray);
            // if multi is selected, filter out the other options.
            if (isMultiSelected) {
                options = options.filter(function (option) {
                    return Object.keys(DemandFlatRolesForMulti).includes(option.flatRole);
                });
            }
        }
        return options;
    }, [showInternalRoleOptions, showExternalRoleOptions, isMultiSelected]);
    return (jsx("span", __assign({ "data-testid": testId }, { children: jsx(Select, __assign({ itemKey: function (_a) {
                var flatRole = _a.flatRole;
                return flatRole;
            }, itemLabel: function (_a) {
                var flatRole = _a.flatRole;
                return flatRole;
            }, items: roleOptions }, props)) })));
};

/**
 * This component has three states: loading, empty, and data determined
 * by the following conditions:
 * existingSloc === undefined => Loading State; display Spinner
 * existingSloc === null      => Empty State; display NoData component
 * existingSloc = { data... } => Data State; display data
 */
var SecondLookOfferConfigurationCard = function (_a) {
    var canEditSecondLookOfferConfiguration = _a.canEditSecondLookOfferConfiguration, existingSloc = _a.existingSloc, onSubmit = _a.onSubmit;
    var _b = useForm(), control = _b.control, handleSubmit = _b.handleSubmit, reset = _b.reset;
    useEffect(function () {
        if (existingSloc) {
            reset(existingSloc);
        }
    }, [existingSloc]);
    return (jsx(RoundedCard, __assign({ className: "second-look-offer-configuration-card", title: "Second Look Offer Configuration" }, { children: existingSloc === undefined ? (
        // Loading state
        jsx(Spinner, {})) : existingSloc === null ? (
        // Empty state
        jsx(NoData, { description: "No Second Look Offer Configuration" })) : (
        // Data state
        jsxs("div", __assign({ className: "vertical-form-container" }, { children: [jsx(SecondLookOfferConfigurationFieldGroup, { control: control, readOnly: !canEditSecondLookOfferConfiguration }), canEditSecondLookOfferConfiguration && (jsx("div", __assign({ className: "vertical-form-submit" }, { children: jsx(EvenButton, { text: "Save Changes", onClick: handleSubmit(onSubmit) }) })))] }))) })));
};

var _a$3, _b$1;
var DropdownText;
(function (DropdownText) {
    DropdownText["ChannelPartner"] = "Channel Partner";
    DropdownText["FinancialInstitution"] = "Financial Institution";
})(DropdownText || (DropdownText = {}));
var DropdownTextToExperienceMap = (_a$3 = {},
    _a$3[DropdownText.ChannelPartner] = Experience.Supply,
    _a$3[DropdownText.FinancialInstitution] = Experience.Demand,
    _a$3);
var ExperienceToDropdownTextMap = (_b$1 = {},
    _b$1[Experience.Supply] = DropdownText.ChannelPartner,
    _b$1[Experience.Demand] = DropdownText.FinancialInstitution,
    _b$1);
var dropdownOptions = Object.values(DropdownText);
var ExperienceSelect = function (_a) {
    var onExperienceSelect = _a.onExperienceSelect, props = __rest(_a, ["onExperienceSelect"]);
    var localStorageValue = window.localStorage.getItem('preferredExperience');
    // State for experience: If there's a value in LS: use it. Else default to Supply.
    var _b = React.useState(localStorageValue
        ? localStorageValue
        : Experience.Supply), selectedExperience = _b[0], setSelectedExperience = _b[1];
    var onSelect = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var mappedValue;
        return __generator(this, function (_a) {
            mappedValue = DropdownTextToExperienceMap[value];
            setSelectedExperience(mappedValue);
            onExperienceSelect(mappedValue);
            return [2 /*return*/];
        });
    }); };
    return (jsxs("div", __assign({ "data-testid": 'experience-select', style: { alignItems: 'center', display: 'flex' } }, { children: [jsx("span", __assign({ style: {
                    fontWeight: 'bold',
                    paddingRight: '5px',
                } }, { children: "Division" })), jsx(Select, __assign({ activeItem: ExperienceToDropdownTextMap[selectedExperience], filterable: false, itemKey: function (exp) { return String(exp); }, itemLabel: function (exp) { return String(exp); }, items: dropdownOptions, onItemSelect: onSelect }, props))] })));
};

var SiteHeader = function (_a) {
    var avatarColor = _a.avatarColor, fullscreenMode = _a.fullscreenMode, onFeedbackClick = _a.onFeedbackClick, onHelpCenterClick = _a.onHelpCenterClick, onNotificationsClick = _a.onNotificationsClick, onSideNavClick = _a.onSideNavClick, onSignOutClick = _a.onSignOutClick, showGiveFeedbackHeaderItem = _a.showGiveFeedbackHeaderItem, showHelpCenterHeaderItem = _a.showHelpCenterHeaderItem, showNotificationsHeaderItem = _a.showNotificationsHeaderItem, sidenavCollapsed = _a.sidenavCollapsed, unreadNotificationsCount = _a.unreadNotificationsCount, _b = _a.userFullName, userFullName = _b === void 0 ? '' : _b, showTrialBar = _a.showTrialBar, trialBar = _a.trialBar, minimal = _a.minimal, onExperienceSelect = _a.onExperienceSelect, showExperienceSelect = _a.showExperienceSelect;
    var userInitials = React.useMemo(function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = (userFullName !== null && userFullName !== void 0 ? userFullName : '')) === null || _a === void 0 ? void 0 : _a.split(' ')) === null || _b === void 0 ? void 0 : _b.map(function (n) { return n[0]; })) === null || _c === void 0 ? void 0 : _c.join('');
    }, [userFullName]);
    var hasNotifications = unreadNotificationsCount > 0;
    return (jsxs(Navbar, __assign({ className: classNames('blueprint-nav', {
            'header-hidden': fullscreenMode,
            'sticky-header': !fullscreenMode,
        }) }, { children: [jsx(Navbar.Group, __assign({ align: Alignment.LEFT }, { children: jsx(Button, { minimal: true, "aria-controls": "sidenav", "aria-label": "Toggle Sidenav", icon: jsx(FontAwesomeIcon, { icon: sidenavCollapsed ? faArrowRightFromLine : faArrowLeftToLine, size: "lg" }), intent: Intent.NONE, name: "toggle-sidenav-button", title: "Click to ".concat(sidenavCollapsed ? 'open' : 'close', " the side nav"), onClick: onSideNavClick }) })), jsxs(Navbar.Group, __assign({ align: Alignment.RIGHT }, { children: [showExperienceSelect && (jsx(ExperienceSelect, { onExperienceSelect: onExperienceSelect })), showGiveFeedbackHeaderItem && (jsx(Button, __assign({ minimal: true, "aria-controls": "feedback-drawer", "aria-label": "Toggle Feedback Drawer", icon: jsx(FontAwesomeIcon, { fixedWidth: true, icon: faLightbulb, size: "lg" }), intent: Intent.NONE, name: "toggle-feedback-drawer-button", title: "Give Feedback", onClick: onFeedbackClick }, { children: !minimal && 'Give Feedback' }))), showHelpCenterHeaderItem && (jsx(Button, __assign({ minimal: true, icon: jsx(FontAwesomeIcon, { fixedWidth: true, icon: faCircleQuestion, size: "lg" }), intent: Intent.NONE, title: "Help Center", onClick: onHelpCenterClick }, { children: !minimal && 'Help Center' }))), showTrialBar && !minimal && jsx(Fragment, { children: trialBar }), showNotificationsHeaderItem && (jsx(Button, __assign({ minimal: true, "aria-controls": "notifications-drawer", "aria-label": "Toggle Notifications Drawer", icon: jsxs("span", __assign({ className: "fa-layers fa-fw fa-lg" }, { children: [jsx(FontAwesomeIcon, { icon: faBell, shake: hasNotifications }), hasNotifications && (jsx("span", __assign({ className: "fa-layers-counter" }, { children: unreadNotificationsCount })))] })), intent: Intent.NONE, name: "toggle-notifications-drawer-button", title: "Notifications", onClick: onNotificationsClick }, { children: !minimal && 'Notifications' }))), jsx(Popover2, __assign({ minimal: true, content: jsx(Menu, { children: jsx(MenuItem$1, { "aria-label": "Click to sign out", icon: "log-out", intent: Intent.DANGER, text: "Sign Out", onClick: onSignOutClick }) }), placement: "bottom-start" }, { children: jsx(Button, { minimal: true, "aria-controls": "sign-out-button", "aria-label": "Toggle Sign Out Button", icon: jsxs("span", __assign({ className: "fa-layers fa-lg" }, { children: [jsx(FontAwesomeIcon, { color: avatarColor, icon: faCircle }), jsx("span", __assign({ className: "fa-layers-text fa-inverse", "data-fa-transform": "shrink-8", style: { letterSpacing: '0.01em' } }, { children: userInitials }))] })), intent: Intent.NONE, name: "user-avatar", text: userFullName }) }))] }))] })));
};

var _a$2, _b;
var StatusType;
(function (StatusType) {
    StatusType["Active"] = "Active";
    StatusType["Complete"] = "Complete";
    StatusType["Inactive"] = "Inactive";
    StatusType["Incomplete"] = "Incomplete";
})(StatusType || (StatusType = {}));
var IntentColors = (_a$2 = {},
    _a$2[Intent.PRIMARY] = colors.clearChill,
    _a$2.secondary = colors.tempGreen2,
    _a$2[Intent.WARNING] = colors.themeOrange,
    _a$2[Intent.DANGER] = colors.themeRed,
    _a$2[Intent.SUCCESS] = colors.kellyGreen,
    _a$2[Intent.NONE] = colors.cistern,
    _a$2);
var ImportantIntentColors = __assign(__assign({}, IntentColors), (_b = {}, _b[Intent.PRIMARY] = colors.celticBlue, _b[Intent.WARNING] = colors.themeOrange, _b[Intent.DANGER] = colors.themeRed, _b));
var StatusToIntent = {
    0: Intent.NONE,
    1: Intent.SUCCESS,
    active: Intent.SUCCESS,
    approved: Intent.SUCCESS,
    backlog: Intent.PRIMARY,
    complete: Intent.SUCCESS,
    completed: Intent.SUCCESS,
    draft: Intent.NONE,
    ended: Intent.DANGER,
    failed: Intent.DANGER,
    false: Intent.NONE,
    'identified violation': Intent.DANGER,
    ignored: Intent.NONE,
    inactive: Intent.NONE,
    live: Intent.SUCCESS,
    overdue: Intent.DANGER,
    paid: Intent.SUCCESS,
    'pending compliance review': Intent.WARNING,
    rejected: Intent.DANGER,
    'requires lender approval': Intent.WARNING,
    scheduled: Intent.PRIMARY,
    started: Intent.PRIMARY,
    true: Intent.SUCCESS,
    undefined: Intent.NONE,
    unpaid: Intent.NONE,
    upcoming: Intent.PRIMARY,
    'waiting on supply partner': Intent.PRIMARY,
};

var StatusDot = function (_a) {
    var children = _a.children, iconProps = _a.iconProps, important = _a.important, status = _a.status, className = _a.className;
    var colors = useMemo(function () { return (important ? ImportantIntentColors : IntentColors); }, [important]);
    return (jsxs("div", __assign({ className: classNames('even-status', className) }, { children: [jsx("span", __assign({ className: "even-status-icon" }, { children: jsx(FontAwesomeIcon, __assign({ color: colors[status !== null && status !== void 0 ? status : Intent.NONE], fontSize: "8px", icon: faCircle }, iconProps)) })), children] })));
};

var statusTypeToIntent = new Map([
    ['active', Intent.SUCCESS],
    ['inactive', Intent.NONE],
]);
var StatusIndicator = function (props) {
    var _a = props.type, type = _a === void 0 ? 'inactive' : _a;
    var intent = statusTypeToIntent.get(type);
    return jsx(StatusDot, __assign({ status: intent }, { children: startCase(type) }));
};

var CostByCreditRatingAndDeviceTypeFieldGroup = function (_a) {
    var basePath = _a.basePath, control = _a.control;
    var DEFAULT_COST_NAME = getFieldNames(basePath).DEFAULT_COST_NAME;
    return (jsxs(Fragment, { children: [jsx(MoneyField, { control: control, label: Labels.DEFAULT_COST, name: DEFAULT_COST_NAME }), creditRatingsAndDeviceTypes.map(function (creditRatingAndDeviceType) {
                var CREDIT_RATING_AND_DEVICE_TYPE_COST_NAME = "".concat(basePath, ".").concat(creditRatingAndDeviceType, "Cost");
                return (jsx(MoneyField, { control: control, label: "".concat(startCase(creditRatingAndDeviceType), " Amount"), name: CREDIT_RATING_AND_DEVICE_TYPE_COST_NAME }, creditRatingAndDeviceType));
            })] }));
};

var CostByCreditRatingBySubIdFieldGroup = function (_a) {
    var basePath = _a.basePath, control = _a.control;
    var _b = getFieldNames(basePath), DEFAULT_COST_NAME = _b.DEFAULT_COST_NAME, SUB_ID_KEY_NAME = _b.SUB_ID_KEY_NAME;
    return (jsxs(Fragment, { children: [jsx(MoneyField, { control: control, label: Labels.DEFAULT_COST, name: DEFAULT_COST_NAME }), jsx(StringField, { control: control, label: Labels.SUB_ID_KEY, name: SUB_ID_KEY_NAME, rules: subIdKeyRules }), creditRatings.map(function (creditRating) {
                var CREDIT_RATING_DEFAULT_COST_NAME = "".concat(basePath, ".").concat(creditRating, "DefaultCost");
                var CREDIT_RATING_COST_PER_VALUE_NAME = "".concat(basePath, ".").concat(creditRating, "CostPerValue");
                return (jsxs(React.Fragment, { children: [jsx(MoneyField, { control: control, label: "Default ".concat(startCase(creditRating), " Amount"), name: CREDIT_RATING_DEFAULT_COST_NAME }), jsx(RepeaterController, { control: control, defaultValue: { key: '', value: '' }, itemNoun: Labels.SUB_ID_KEY, itemRenderer: function (id, index) { return (jsxs("div", __assign({ style: { display: 'flex' } }, { children: [jsx("div", __assign({ className: "key-value-input" }, { children: jsx(StringField, { control: control, label: Labels.SUB_ID_VALUE, name: "".concat(CREDIT_RATING_COST_PER_VALUE_NAME, ".").concat(index, ".key") }) })), jsx("div", __assign({ className: "key-value-input" }, { children: jsx(MoneyField, { control: control, label: "".concat(startCase(creditRating), " Amount"), name: "".concat(CREDIT_RATING_COST_PER_VALUE_NAME, ".").concat(index, ".value") }) }))] }), id)); }, name: CREDIT_RATING_COST_PER_VALUE_NAME })] }, creditRating));
            })] }));
};

var CostByCreditRatingFieldGroup = function (_a) {
    var basePath = _a.basePath, control = _a.control;
    var DEFAULT_COST_NAME = getFieldNames(basePath).DEFAULT_COST_NAME;
    return (jsxs(Fragment, { children: [jsx(MoneyField, { control: control, label: Labels.DEFAULT_COST, name: DEFAULT_COST_NAME }), creditRatings.map(function (creditRating) {
                var CREDIT_RATING_COST_NAME = "".concat(basePath, ".").concat(creditRating, "Cost");
                return (jsx(MoneyField, { control: control, label: "".concat(startCase(creditRating), " Amount"), name: CREDIT_RATING_COST_NAME }, creditRating));
            })] }));
};

var CostByDemandFieldGroup = function (_a) {
    var basePath = _a.basePath, control = _a.control;
    var _b = getFieldNames(basePath), DEFAULT_COST_NAME = _b.DEFAULT_COST_NAME, COST_PER_DEMAND_SUB_ACCOUNT_ID_NAME = _b.COST_PER_DEMAND_SUB_ACCOUNT_ID_NAME;
    return (jsxs(Fragment, { children: [jsx(MoneyField, { control: control, label: Labels.DEFAULT_COST, name: DEFAULT_COST_NAME }), jsx(RepeaterController, { control: control, defaultValue: { key: '', value: '' }, itemNoun: Labels.DEMAND_SUB_ACCOUNT, itemRenderer: function (id, index) {
                    var KEY_NAME = "".concat(COST_PER_DEMAND_SUB_ACCOUNT_ID_NAME, ".").concat(index, ".key");
                    var VALUE_NAME = "".concat(COST_PER_DEMAND_SUB_ACCOUNT_ID_NAME, ".").concat(index, ".value");
                    return (jsxs(React.Fragment, { children: [jsx(StringField, { control: control, label: Labels.DEMAND_SUB_ACCOUNT_ID, name: KEY_NAME }), jsx(MoneyField, { control: control, label: Labels.COST, name: VALUE_NAME })] }, id));
                }, name: COST_PER_DEMAND_SUB_ACCOUNT_ID_NAME })] }));
};

var CostByDeviceTypeFieldGroup = function (_a) {
    var basePath = _a.basePath, control = _a.control;
    var DEFAULT_COST_NAME = getFieldNames(basePath).DEFAULT_COST_NAME;
    return (jsxs(Fragment, { children: [jsx(MoneyField, { control: control, label: Labels.DEFAULT_COST, name: DEFAULT_COST_NAME }), deviceTypes.map(function (deviceType) {
                var DEVICE_TYPE_COST_NAME = "".concat(basePath, ".").concat(deviceType, "Cost");
                return (jsx(MoneyField, { control: control, label: "".concat(startCase(deviceType), " Amount"), name: DEVICE_TYPE_COST_NAME }, deviceType));
            })] }));
};

var CostByOfferIdFieldGroup = function (_a) {
    var basePath = _a.basePath, control = _a.control;
    var _b = getFieldNames(basePath), COST_PER_OFFER_ID_NAME = _b.COST_PER_OFFER_ID_NAME, DEFAULT_COST_NAME = _b.DEFAULT_COST_NAME;
    return (jsxs(Fragment, { children: [jsx(MoneyField, { control: control, label: Labels.DEFAULT_COST, name: DEFAULT_COST_NAME }), jsx(RepeaterController, { control: control, defaultValue: { key: '', value: '' }, itemNoun: "Offer", itemRenderer: function (id, index) {
                    var KEY_NAME = "".concat(COST_PER_OFFER_ID_NAME, ".").concat(index, ".key");
                    var VALUE_NAME = "".concat(COST_PER_OFFER_ID_NAME, ".").concat(index, ".value");
                    return (jsxs("div", __assign({ style: { display: 'flex' } }, { children: [jsx("div", __assign({ className: "key-value-input" }, { children: jsx(StringField, { control: control, label: Labels.OFFER_ID, name: KEY_NAME }) })), jsx("div", __assign({ className: "key-value-input" }, { children: jsx(MoneyField, { control: control, label: Labels.COST, name: VALUE_NAME }) }))] }), id));
                }, name: COST_PER_OFFER_ID_NAME })] }));
};

var CostBySubIdFieldGroup = function (_a) {
    var basePath = _a.basePath, control = _a.control;
    var _b = getFieldNames(basePath), COST_PER_VALUE_NAME = _b.COST_PER_VALUE_NAME, DEFAULT_COST_NAME = _b.DEFAULT_COST_NAME, SUB_ID_KEY_NAME = _b.SUB_ID_KEY_NAME;
    return (jsxs(Fragment, { children: [jsx(MoneyField, { control: control, label: Labels.DEFAULT_COST, name: DEFAULT_COST_NAME }), jsx(StringField, { control: control, label: Labels.SUB_ID_KEY, name: SUB_ID_KEY_NAME, rules: subIdKeyRules }), jsx(RepeaterController, { control: control, defaultValue: { key: '', value: '' }, itemNoun: Labels.SUB_ID_KEY, itemRenderer: function (id, index) { return (jsxs("div", __assign({ style: { display: 'flex' } }, { children: [jsx("div", __assign({ className: "key-value-input" }, { children: jsx(StringField, { control: control, label: Labels.SUB_ID_VALUE, name: "".concat(COST_PER_VALUE_NAME, ".").concat(index, ".key") }) })), jsx("div", __assign({ className: "key-value-input" }, { children: jsx(MoneyField, { control: control, label: Labels.COST, name: "".concat(COST_PER_VALUE_NAME, ".").concat(index, ".value") }) }))] }), id)); }, name: COST_PER_VALUE_NAME })] }));
};

var ShareByDemandFieldGroup = function (_a) {
    var basePath = _a.basePath, control = _a.control;
    var _b = getFieldNames(basePath), BASE_PERCENTAGE_NAME = _b.BASE_PERCENTAGE_NAME, PERCENT_BY_DEMAND_SUB_ACCOUNT_ID_NAME = _b.PERCENT_BY_DEMAND_SUB_ACCOUNT_ID_NAME;
    return (jsxs(Fragment, { children: [jsx(PercentInputController, { required: true, control: control, defaultValue: "0", label: Labels.BASE_PERCENT, name: BASE_PERCENTAGE_NAME }), jsx(RepeaterController, { control: control, defaultValue: { key: '', value: '' }, itemNoun: Labels.DEMAND_SUB_ACCOUNT, itemRenderer: function (id, index) {
                    var KEY_NAME = "".concat(PERCENT_BY_DEMAND_SUB_ACCOUNT_ID_NAME, ".").concat(index, ".key");
                    var VALUE_NAME = "".concat(PERCENT_BY_DEMAND_SUB_ACCOUNT_ID_NAME, ".").concat(index, ".value");
                    return (jsxs("div", __assign({ style: { display: 'flex' } }, { children: [jsx("div", __assign({ className: "key-value-input" }, { children: jsx(NumericInputController, { control: control, label: Labels.DEMAND_SUB_ACCOUNT_ID, name: KEY_NAME }) })), jsx("div", __assign({ className: "key-value-input" }, { children: jsx(PercentInputController, { required: true, control: control, defaultValue: "0", label: Labels.PERCENT, name: VALUE_NAME }) }))] }), id));
                }, name: PERCENT_BY_DEMAND_SUB_ACCOUNT_ID_NAME })] }));
};

var CostByScoreFieldGroup = function (_a) {
    var basePath = _a.basePath, control = _a.control;
    var DEFAULT_COST_NAME = getFieldNames(basePath).DEFAULT_COST_NAME;
    return (jsxs(Fragment, { children: [jsx(MoneyField, { control: control, label: Labels.DEFAULT_COST, name: DEFAULT_COST_NAME }), scores.map(function (_a) {
                var scoreNumber = _a[0], scoreText = _a[1];
                var SCORE_COST_NAME = "".concat(basePath, ".").concat(scoreText, "Cost");
                return (jsx(MoneyField, { control: control, label: "Score ".concat(scoreNumber), name: SCORE_COST_NAME }, scoreText));
            })] }));
};

var CostPerLeadByVantageScoreFieldGroup = function (props) {
    var control = props.control, basePath = props.basePath;
    return (jsxs(Fragment, { children: [jsx(MoneyField, { control: control, label: "Max Cost (in $ USD)", name: "".concat(basePath, ".maxCost") }), jsx(RepeaterController, { control: control, defaultValue: {}, itemNoun: "Vantage Score", itemRenderer: function (_, index) { return (jsxs(Fragment, { children: [jsx(NumericInputController, { control: control, label: "Vantage Score (Upper Bound & Inclusive)", name: "".concat(basePath, ".costByVantageScore.").concat(index, ".key") }), jsx(MoneyInputController, { control: control, label: "Cost (in $ USD)", name: "".concat(basePath, ".costByVantageScore.").concat(index, ".value") })] })); }, name: "".concat(basePath, ".vantageScores") })] }));
};

var PayoutClauseHandler = function (_a) {
    var basePath = _a.basePath;
    var _b = useFormContext(), control = _b.control, watch = _b.watch;
    var _c = getFieldNames(basePath), ADB_COST_NAME = _c.ADB_COST_NAME, CAMPAIGN_DATE_NAME = _c.CAMPAIGN_DATE_NAME, COST_NAME = _c.COST_NAME, DEFAULT_COST_NAME = _c.DEFAULT_COST_NAME, DEMAND_EXCLUSIONS_NAME = _c.DEMAND_EXCLUSIONS_NAME, KEY_NAME = _c.KEY_NAME, PERCENT_NAME = _c.PERCENT_NAME, SHARE_NAME = _c.SHARE_NAME;
    var selectedKey = watch(KEY_NAME);
    if (!selectedKey) {
        return null;
    }
    switch (selectedKey) {
        case PayoutClauseType.CostPerCompletedApplication:
        case PayoutClauseType.CostPerLead:
        case PayoutClauseType.CostPerUniqueFundedLoan:
        case PayoutClauseType.CostPerUniqueLoanClick:
        case PayoutClauseType.CostPerUniqueOtherClick:
        case PayoutClauseType.CostPerUniqueSavingsClick:
            return (jsx(MoneyField, { control: control, label: Labels.COST, name: COST_NAME }));
        case PayoutClauseType.RevenueShareCreditCard:
        case PayoutClauseType.RevenueShareInsurance:
        case PayoutClauseType.RevenueShareLoan:
        case PayoutClauseType.RevenueShareMortgage:
        case PayoutClauseType.RevenueShareOther:
        case PayoutClauseType.RevenueShareSavings:
        case PayoutClauseType.GenericRevenueShare:
            return (jsx(PercentInputController, { required: true, control: control, defaultValue: "0", label: Labels.REVENUE_SHARE_PERCENT, name: SHARE_NAME, tooltip: Tooltips.REVENUE_SHARE }));
        case PayoutClauseType.PercentOfFundedLoanAmount:
            return (jsx(PercentInputController, { required: true, control: control, defaultValue: "0", label: Labels.PERCENT, name: PERCENT_NAME }));
        case PayoutClauseType.BidderDemandExclusions:
            return (jsx(RepeaterController, { control: control, defaultValue: 1, itemNoun: Labels.DEMAND_SUB_ACCOUNT, itemRenderer: function (id, index) { return (jsx(StringField, { control: control, label: Labels.DEMAND_SUB_ACCOUNT_ID, name: "".concat(DEMAND_EXCLUSIONS_NAME, ".").concat(index) }, id)); }, name: DEMAND_EXCLUSIONS_NAME }));
        case PayoutClauseType.CostPerLifeInsuranceApplied:
            return (jsxs(Fragment, { children: [jsx(MoneyField, { control: control, label: Labels.DEFAULT_COST, name: DEFAULT_COST_NAME }), jsx(MoneyField, { control: control, label: Labels.ADB_COST, name: ADB_COST_NAME })] }));
        case PayoutClauseType.CostPerCompletedApplicationBySubId:
        case PayoutClauseType.CostPerLeadBySubId:
        case PayoutClauseType.CostPerUniqueFundedLoanBySubId:
        case PayoutClauseType.CostPerUniqueLoanClickBySubId:
            return jsx(CostBySubIdFieldGroup, { basePath: basePath, control: control });
        case PayoutClauseType.CostPerLeadByCreditRatingBySubId:
            return (jsx(CostByCreditRatingBySubIdFieldGroup, { basePath: basePath, control: control }));
        case PayoutClauseType.CostPerCompletedApplication60ByCreditRating:
        case PayoutClauseType.CostPerCompletedApplicationByCreditRating:
        case PayoutClauseType.CostPerLeadByCreditRating:
            return (jsx(CostByCreditRatingFieldGroup, { basePath: basePath, control: control }));
        case PayoutClauseType.CostPerLeadByDeviceType:
            return (jsx(CostByDeviceTypeFieldGroup, { basePath: basePath, control: control }));
        case PayoutClauseType.CostPerCompletedApplicationByCreditRatingAndDeviceType:
        case PayoutClauseType.CostPerLeadByCreditRatingAndDeviceType:
            return (jsx(CostByCreditRatingAndDeviceTypeFieldGroup, { basePath: basePath, control: control }));
        case PayoutClauseType.CostPerPreSelectedCreditCardOfferByDemand:
        case PayoutClauseType.CostPerUniqueLoanClickByDemand:
            return jsx(CostByDemandFieldGroup, { basePath: basePath, control: control });
        case PayoutClauseType.CostPerUniqueOtherClickByOfferId:
            return jsx(CostByOfferIdFieldGroup, { basePath: basePath, control: control });
        case PayoutClauseType.CostPerLeadByLifeInsuranceApprovalProbabilityScore:
            return jsx(CostByScoreFieldGroup, { basePath: basePath, control: control });
        case PayoutClauseType.CostPerLeadByVantageScore:
            return (jsx(CostPerLeadByVantageScoreFieldGroup, { basePath: basePath, control: control }));
        case PayoutClauseType.RevenueShareLoanByDemand:
            return jsx(ShareByDemandFieldGroup, { basePath: basePath, control: control });
        case PayoutClauseType.EmailCampaign:
            return (jsxs(Fragment, { children: [jsx(MoneyField, { control: control, label: Labels.COST, name: COST_NAME }), jsx(Controller, { control: control, name: CAMPAIGN_DATE_NAME, render: function (_a) {
                            var _b = _a.field, value = _b.value, onChange = _b.onChange, error = _a.fieldState.error;
                            return (jsx(Field, __assign({ error: error === null || error === void 0 ? void 0 : error.message, label: Labels.CAMPAIGN_DATE }, { children: jsx(DateInput, { formatDate: dateInputFormat, minDate: DateTime.now().toJSDate(), parseDate: parseDate, value: parseDate(value) || undefined, onChange: function (date) {
                                        return onChange(date ? dateInputFormat(date) : '');
                                    } }) })));
                        } })] }));
        case PayoutClauseType.Bidder:
        case PayoutClauseType.EvenOwned:
        case PayoutClauseType.LifeInsurancePayout:
            return (jsx(Callout, __assign({ style: { marginBottom: 20 } }, { children: "Note: Selected payout clause type does not require anything additional to be filled out." })));
        default:
            return (jsx(Callout, __assign({ style: { marginBottom: 20 } }, { children: "Unsupported payout clause type. Please reach out to the Control Center team." })));
    }
};

var SupplyProcessingFeeTooltip = function () {
    return (jsxs(Fragment, { children: [jsx("p", { children: "Supply processing fees are applied pre Rev-share and they do not impact the recommendation score." }), jsx("p", { children: "Example: For a given pay cycle if supply partner revenue is $100,000 at 80% rev share contract and Supply processing fee is 5%, then:" }), jsx("p", { children: "Step 1 - Apply Processing Fee" }), jsxs("ul", { children: [jsx("li", { children: "5% of $100,000 = $5,000" }), jsx("li", { children: "Supply Payout before applying rev share = $100,000 - $5,000 = $95,000" })] }), jsx("p", { children: "Step 2 - Apply Rev Share" }), jsx("ul", { children: jsx("li", { children: "80% of $95,000 = $76,000" }) })] }));
};

var EFFECTIVE_AT_NAME = 'effectiveAt';
var PAYOUT_CLAUSES_NAME = 'payoutClauses';
var SALESFORCE_OPPORTUNITY_URL = 'salesforceOpportunityIdOrUrl';
var SUB_ACCOUNT_UUID_NAME = 'subAccountUuid';
var CONTRACT_TYPE = 'supply';
var SupplyContractFormDrawer = function (_a) {
    var currentSupplyContractEffectiveAt = _a.currentSupplyContractEffectiveAt, disableSubAccountInput = _a.disableSubAccountInput, defaultValues = _a.defaultValues, onClose = _a.onClose, onSubmit = _a.onSubmit, subAccountOptions = _a.subAccountOptions, title = _a.title, visible = _a.visible;
    var form = useForm({ defaultValues: defaultValues });
    var control = form.control, handleSubmit = form.handleSubmit, reset = form.reset, watch = form.watch;
    var _b = useFieldArray({
        control: control,
        name: PAYOUT_CLAUSES_NAME,
    }), fields = _b.fields, append = _b.append, remove = _b.remove, update = _b.update;
    var payoutClauses = watch(PAYOUT_CLAUSES_NAME);
    var payoutClauseKeysInUse = new Set(payoutClauses === null || payoutClauses === void 0 ? void 0 : payoutClauses.map(function (_a) {
        var key = _a.key;
        return key;
    }));
    var filteredNonLegacyPayoutClauseKeys = nonLegacyPayoutClauses.filter(function (key) { return !payoutClauseKeysInUse.has(key); });
    var subAccountsByUuid = keyBy(subAccountOptions, 'uuid');
    useEffect(function () {
        if (defaultValues) {
            reset(defaultValues);
        }
        else {
            reset({
                effectiveAt: '',
                payoutClauses: [],
                salesforceOpportunityIdOrUrl: '',
                subAccountUuid: '',
                supplyProcessingFeeConfig: '',
            });
        }
    }, [defaultValues]);
    return (jsx(DrawerForm, __assign({ disableCloseOnMouseDown: true, title: title, visible: visible, onClose: onClose, onSubmit: handleSubmit(onSubmit) }, { children: jsxs(FormProvider, __assign({}, form, { children: [jsx(Controller, { control: control, name: SUB_ACCOUNT_UUID_NAME, render: function (_a) {
                        var _b = _a.field, value = _b.value, onChange = _b.onChange, error = _a.fieldState.error;
                        return (jsx(Field, __assign({ error: error === null || error === void 0 ? void 0 : error.message, label: Labels.SUB_ACCOUNT }, { children: jsx(Select, { activeItem: value, ariaLabel: Labels.SUB_ACCOUNT, disabled: disableSubAccountInput, itemKey: function (uuid) { return uuid; }, itemLabel: function (uuid) { var _a; return (_a = subAccountsByUuid[uuid]) === null || _a === void 0 ? void 0 : _a.name; }, items: sortBy(subAccountOptions, 'name').map(function (_a) {
                                    var uuid = _a.uuid;
                                    return uuid;
                                }), onItemSelect: onChange }) })));
                    }, rules: {
                        required: 'You must select a sub account.',
                    } }), jsx(Controller, { control: control, name: EFFECTIVE_AT_NAME, render: function (_a) {
                        var _b = _a.field, value = _b.value, onChange = _b.onChange, error = _a.fieldState.error;
                        return (jsx(Field, __assign({ error: error === null || error === void 0 ? void 0 : error.message, label: Labels.EFFECTIVE_AT, tooltip: "When is this contract effective?" }, { children: jsx(DateInput, { formatDate: dateInputFormat, parseDate: parseDate, value: parseDate(value) || undefined, onChange: function (date) { return onChange(date ? dateInputFormat(date) : ''); } }) })));
                    }, rules: {
                        validate: function (value) {
                            return effectiveAtValidator(value, currentSupplyContractEffectiveAt);
                        },
                    } }), jsx(PercentInputController, { control: control, defaultValue: "0", label: Labels.PROCESSING_FEE_PERCENT, name: "supplyProcessingFeeConfig", tooltip: jsx(SupplyProcessingFeeTooltip, {}) }), jsx(StringField, { control: control, label: Labels.SALESFORCE_OPPORTUNITY_LINK, name: SALESFORCE_OPPORTUNITY_URL, rules: {
                        validate: function (value) { return salesforceUrlValidator(value, CONTRACT_TYPE); },
                    }, tooltip: "The Salesforce Opportunity link must contain the executed contract that agrees to pricing being entered into Control Center" }), jsx(Field, { label: "Payout Clauses" }), jsx(Repeater, { itemKey: function (field) { return field.id; }, itemNoun: "Pricing Plan", itemRenderer: function (_, index) { return (jsxs(Fragment, { children: [jsx(Controller, { control: control, name: "".concat(PAYOUT_CLAUSES_NAME, ".").concat(index, ".key"), render: function (_a) {
                                    var value = _a.field.value;
                                    return (jsx(Field, __assign({ label: Labels.PRICING_MODEL }, { children: jsx(Select, { activeItem: value, ariaLabel: Labels.PRICING_MODEL, groupSorter: payoutClauseProductTypeSorter, itemGroup: function (item) { return payoutClauseToProductTypeMap[item]; }, itemKey: function (item) { return item; }, itemLabel: startCase, items: filteredNonLegacyPayoutClauseKeys, onItemSelect: function (key) {
                                                // Using update here as opposed to field.onChange as we want any
                                                // previous payout clause data to be erased when a user selects
                                                // a new payout clause type.
                                                update(index, { key: key });
                                            } }) })));
                                } }), jsx(PayoutClauseHandler, { basePath: "".concat(PAYOUT_CLAUSES_NAME, ".").concat(index) })] })); }, items: fields, onAdd: function () { return append({ key: filteredNonLegacyPayoutClauseKeys[0] }); }, onRemove: remove }), jsx(Callout, __assign({ style: { marginTop: 20 } }, { children: "Pricing Plans are additive. If you have two plans within the same product type or a global plan and a product type specific plan, leads may be monetized multiple times." }))] })) })));
};

var styles$7 = {"supply-contracts-list":"SupplyContractsList-module_supply-contracts-list__z4lzr","supply-contracts-list-tag":"SupplyContractsList-module_supply-contracts-list-tag__4TOOE"};

var SupplyContractsList = function (_a) {
    var contracts = _a.contracts;
    return (jsx("section", __assign({ className: styles$7['supply-contracts-list'] }, { children: jsxs("table", { children: [jsx("thead", { children: jsxs("tr", { children: [jsx("th", { colSpan: 1 }), jsx("th", { colSpan: 4 })] }) }), jsx("tbody", { children: contracts.map(function (contract, index) { return (jsxs("tr", { children: [jsxs("td", { children: ["Product Type", jsx("br", {}), jsx(Tag, __assign({ minimal: true, className: styles$7['supply-contracts-list-tag'], style: { marginRight: 10 } }, { children: startCase$1(camelCase$1(contract.productType)) }))] }), jsxs("td", { children: ["Pricing Module", jsx("br", {}), jsx(Tag, __assign({ minimal: true, className: styles$7['supply-contracts-list-tag'], style: { marginRight: 10 } }, { children: contract.pricingModel.toUpperCase() === contract.pricingModel
                                            ? contract.pricingModel
                                            : startCase$1(camelCase$1(contract.pricingModel)) }))] })] }, index)); }) })] }) })));
};

var TagsCard = function (props) {
    var readOnly = props.readOnly, existingTags = props.existingTags, onSubmit = props.onSubmit;
    var gridRef = useRef();
    var gridOptions = usePortalAgGridOptions();
    var existingTagsArr = Object.entries(existingTags).map(function (_a) {
        var key = _a[0], value = _a[1];
        return ({
            key: key,
            value: value,
        });
    });
    var _a = useToggle(false), isEditState = _a[0], toggleEditState = _a[1];
    var _b = useState(''), newTagKey = _b[0], setNewTagKey = _b[1];
    var _c = useState(''), newTagValue = _c[0], setNewTagValue = _c[1];
    var _d = useSet(new Set(existingTagsArr)), tagsSet = _d[0], _e = _d[1], reset = _e.reset, add = _e.add, remove = _e.remove;
    var newTagKeyInputRef = useRef(null);
    var columnDefs = useMemo(function () { return [
        {
            field: 'key',
            filter: 'simpleTextFilter',
            flex: 1,
            title: 'Key',
        },
        {
            autoHeight: true,
            cellStyle: {
                'line-height': '2em',
                padding: '20px',
                'white-space': 'normal',
            },
            field: 'value',
            filter: 'simpleTextFilter',
            flex: 1,
            title: 'Value',
        },
        {
            cellRenderer: function (_a) {
                var data = _a.data;
                return (jsx(DeleteCell, { disabled: !isEditState, onClick: function () { return remove(data); } }));
            },
            flex: 1,
            headerComponentParams: {
                enableMenu: false,
                enableSorting: false,
            },
            headerName: '',
        },
    ]; }, [isEditState, remove]);
    var handleAdd = function () {
        var _a;
        if (!newTagKey && !newTagValue) {
            return;
        }
        add({
            key: newTagKey.trim(),
            value: newTagValue.trim(),
        });
        setNewTagKey(' ');
        setNewTagValue(' ');
        (_a = newTagKeyInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var handleCancelChanges = function () {
        setNewTagKey('');
        setNewTagValue('');
        toggleEditState();
        reset();
    };
    var handleSubmit = function () {
        var tagsObj = Array.from(tagsSet).reduce(function (accum, _a) {
            var key = _a.key, value = _a.value;
            accum[key] = value;
            return accum;
        }, {});
        onSubmit(tagsObj);
    };
    var title = 'Tags';
    var showEditButton = !readOnly && !isEditState;
    var showCancelButton = !readOnly && isEditState;
    var headerContent = (jsxs(Fragment, { children: [jsx(ExportCSVButton, { csvExportParams: { fileName: 'tags-export' }, gridRef: gridRef }), showEditButton ? jsx(EditButton, { onClick: toggleEditState }) : null, showCancelButton ? jsx(CancelButton, { onClick: handleCancelChanges }) : null] }));
    if (!existingTagsArr.length && !isEditState) {
        return (jsx(RoundedCard, __assign({ headerContent: headerContent, title: title }, { children: jsx(NoData, { description: "No tags exist for this offer", size: "1x" }) })));
    }
    return (jsxs(RoundedCard, __assign({ headerContent: headerContent, title: title }, { children: [isEditState ? (jsxs("div", __assign({ style: { padding: '20px', width: '70%' } }, { children: [jsx(Field, __assign({ label: "Key" }, { children: jsx(Input, { inputRef: newTagKeyInputRef, value: newTagKey, onChange: function (_a) {
                                var value = _a.value;
                                return setNewTagKey(value);
                            } }) })), jsx(Field, __assign({ label: "Value" }, { children: jsx(TextArea, { growVertically: true, style: { width: '100%' }, value: newTagValue, onChange: function (e) { return setNewTagValue(e.target.value); } }) })), jsx(Button, __assign({ onClick: handleAdd }, { children: "Add Tag" }))] }))) : null, jsx("div", __assign({ className: "ag-theme-alpine" }, { children: jsx(AgGridReact, { ref: gridRef, columnDefs: columnDefs, getRowId: function (_a) {
                        var data = _a.data;
                        return data.key;
                    }, gridOptions: gridOptions, rowData: Array.from(tagsSet) }) })), isEditState ? (jsx(RoundedCard.Content, { children: jsx("div", __assign({ style: { display: 'flex', justifyContent: 'flex-end' } }, { children: jsx(ConfirmableAction, __assign({ message: "Are you sure you want to update the tags?", onOk: handleSubmit }, { children: jsx(Button, __assign({ intent: "primary" }, { children: "Save Changes" })) })) })) })) : null] })));
};

var TrialBar = function (_a) {
    var _b;
    var _c = _a.trialExpirationDays, trialExpirationDays = _c === void 0 ? -1 : _c, isPermanent = _a.isPermanent, onClick = _a.onClick;
    var props = {
        children: '',
        intent: Intent.NONE,
        interactive: true,
        large: true,
        minimal: true,
        onClick: onClick,
    };
    if (isPermanent) {
        props.children = 'Permanent Trial';
        props.intent = Intent.PRIMARY;
    }
    else {
        if (trialExpirationDays > 0) {
            props.children = "Free Trial - ".concat(trialExpirationDays, " days");
            props.intent = Intent.PRIMARY;
        }
        if (trialExpirationDays === 0) {
            props.children = 'Free Trial Expires Today';
            props.intent = Intent.WARNING;
        }
        if (trialExpirationDays < 0) {
            props.children = 'Free Trial Expired';
            props.intent = Intent.DANGER;
        }
    }
    // Don't show anything if children is undefined
    return ((_b = props.children) === null || _b === void 0 ? void 0 : _b.length) ? (jsx(Tag, __assign({ className: "trial-bar" }, props, { interactive: Boolean(onClick) }))) : null;
};

var styles$6 = {"upgrade-banner":"UpgradeBanner-module_upgrade-banner__cxbrI","upgrade-banner-text":"UpgradeBanner-module_upgrade-banner-text__Zk9aI"};

var UpgradeBanner = function (_a) {
    var monthlyFee = _a.monthlyFee, onClick = _a.onClick;
    return (jsx(Fragment, { children: monthlyFee !== 0 && (jsxs("div", __assign({ className: styles$6['upgrade-banner'] }, { children: [jsx("p", __assign({ className: styles$6['upgrade-banner-text'] }, { children: "Purchase a plan to continue using your integrations before trial period expires." })), jsx(EvenButton, __assign({ onClick: onClick }, { children: "Purchase Plan" }))] }))) }));
};

var NO_RESULTS_TEXT = 'No Users Available';
var UserMultiSelect = function (_a) {
    var users = _a.users, _b = _a.showUserID, showUserID = _b === void 0 ? false : _b, multiSelectProps = __rest(_a, ["users", "showUserID"]);
    var getLabel = function (user) {
        var labelText = showUserID
            ? "".concat(user.id, " - ").concat(getUserFullName(user))
            : getUserFullName(user);
        return "".concat(labelText, " (").concat(user.emailAddress, ")");
    };
    return (jsx(MultiSelect, __assign({ itemPredicate: function (query, user) {
            return serialize(getLabel(user)).includes(serialize(query));
        }, itemRemoveFilter: filterByUuid, itemRenderer: function (user, props) { return (jsx(SelectItem, __assign({ text: getLabel(user) }, props), user.id)); }, items: users, noResults: NO_RESULTS_TEXT, popoverProps: { minimal: true }, tagRenderer: function (user) { return getLabel(user); } }, multiSelectProps)));
};

var dateShortCellRenderer = function (_a) {
    var value = _a.value;
    if (!value) {
        return '--';
    }
    // Check if the date string has a timezone offset
    var hasTimezone = /(Z|([+-]\d{2}:\d{2}))$/.test(value);
    var zone = hasTimezone ? 'UTC' : 'America/New_York';
    return DateTime.fromISO(value, { zone: zone })
        .setZone('local')
        .toLocaleString(DateTime.DATE_SHORT);
};
var dateTimeShortCellRenderer = function (_a) {
    var value = _a.value;
    if (!value) {
        return '--';
    }
    return DateTime.fromISO(value, { zone: 'UTC' })
        .setZone('local')
        .toLocaleString(DateTime.DATETIME_SHORT);
};
var userAvatarRenderer = function (_a) {
    var value = _a.value;
    if (!value) {
        return '--';
    }
    return jsx(UserAvatar, { name: value.fullName });
};
var userCellRenderer = function (_a) {
    var value = _a.value;
    if (!value) {
        return '--';
    }
    return jsx(UserAvatar, { withTooltip: true, name: value.fullName });
};
var supplySubAccountCellRenderer = function (_a) {
    var value = _a.value;
    if (!value) {
        return '--';
    }
    return jsx("a", __assign({ href: "/supply-sub-accounts/".concat(value.uuid) }, { children: value.name }));
};
var demandSubAccountCellRenderer = function (_a) {
    var value = _a.value;
    if (!value) {
        return '--';
    }
    return jsx("a", __assign({ href: "/demand-sub-accounts/".concat(value.uuid) }, { children: value.name }));
};

var DeleteCell = function (props) {
    var disabled = props.disabled, onClick = props.onClick;
    return (jsx("div", __assign({ style: {
            alignItems: 'center',
            display: 'flex',
            height: '50px',
            justifyContent: 'center',
        } }, { children: jsx(Button, { disabled: disabled, icon: jsx(FontAwesomeIcon, { icon: faTrashCan }), onClick: onClick }) })));
};

var DateEditor = memo(forwardRef(function (props, ref) {
    var stopEditing = props.stopEditing, rawValue = props.value;
    var inputRef = useRef(null);
    var _a = useState(DateTime.fromISO(rawValue).toJSDate()), value = _a[0], setValue = _a[1];
    useImperativeHandle(ref, function () {
        return {
            getValue: function () {
                return value === null || value === void 0 ? void 0 : value.toISOString();
            },
        };
    });
    useEffect(function () {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    var today = DateTime.now();
    var dateValue = value && DateTime.max(today, DateTime.fromJSDate(value));
    // bp4-popover-target bp4-popover-open
    // bp4-input-group these need height: 100% as well
    return (jsx("div", __assign({ style: { height: '100%', lineHeight: 'normal' } }, { children: jsx(DateInput, { closeOnSelection: false, footerElement: jsx("div", __assign({ style: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    padding: '10px 5px 5px 5px',
                } }, { children: jsx(Button, __assign({ small: true, intent: Intent.NONE, onClick: stopEditing }, { children: "Confirm Selection" })) })), formatDate: function (date) {
                return DateTime.fromJSDate(date).toLocaleString(DateTime.DATE_SHORT);
            }, initialMonth: dateValue === null || dateValue === void 0 ? void 0 : dateValue.toJSDate(), inputProps: { inputRef: inputRef }, minDate: today.toJSDate(), parseDate: function (date) { return toDate(date); }, value: dateValue === null || dateValue === void 0 ? void 0 : dateValue.toJSDate(), onChange: function (date, isUserChange) {
                if (isUserChange) {
                    setValue(date);
                }
            } }) })));
}));

var getCapTypeDisplayValue = function (value) {
    switch (value) {
        case CapType.ClickCap:
        case CapType.DemandSubAccountClickCap:
            return 'Clicks';
        case CapType.LeadCap:
            return 'Requests';
        case CapType.BudgetCap:
            return 'Budget';
        default:
            return 'Unknown';
    }
};
var capTypeCellRenderer = function (_a) {
    var value = _a.value;
    return getCapTypeDisplayValue(value);
};
var InventoryCapsTable = function (props) {
    var editable = props.editable, inventoryCaps = props.inventoryCaps, offerBaseUrl = props.offerBaseUrl, onDelete = props.onDelete, onUpdate = props.onUpdate, _a = props.showActualEndDateColumn, showActualEndDateColumn = _a === void 0 ? false : _a, _b = props.showChannelColumn, showChannelColumn = _b === void 0 ? false : _b, _c = props.showConfigurationColumn, showConfigurationColumn = _c === void 0 ? false : _c, _d = props.showDeleteColumn, showDeleteColumn = _d === void 0 ? false : _d, _e = props.showOfferColumn, showOfferColumn = _e === void 0 ? false : _e, _f = props.showStatusColumn, showStatusColumn = _f === void 0 ? false : _f, paginationPageSize = props.paginationPageSize;
    var gridOptions = usePortalAgGridOptions();
    var columnDefDeps = [
        showActualEndDateColumn,
        showChannelColumn,
        showConfigurationColumn,
        showDeleteColumn,
        showOfferColumn,
        showStatusColumn,
    ];
    var columnDefs = useMemo(function () {
        return [
            {
                field: 'id',
                filter: 'simpleTextFilter',
                headerName: 'ID',
                width: 100,
            },
            {
                cellRenderer: demandSubAccountCellRenderer,
                field: 'demandSubAccount',
                filter: 'agSetColumnFilter',
                filterValueGetter: function (_a) {
                    var _b;
                    var data = _a.data;
                    return (_b = data === null || data === void 0 ? void 0 : data.demandSubAccount) === null || _b === void 0 ? void 0 : _b.name;
                },
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Configuration',
                hide: !showConfigurationColumn,
                width: 170,
            },
            {
                cellRenderer: supplySubAccountCellRenderer,
                field: 'supplySubAccount',
                filter: 'agSetColumnFilter',
                filterValueGetter: function (_a) {
                    var _b;
                    var data = _a.data;
                    return (_b = data === null || data === void 0 ? void 0 : data.supplySubAccount) === null || _b === void 0 ? void 0 : _b.name;
                },
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Channel',
                hide: !showChannelColumn,
                width: 150,
            },
            {
                cellRenderer: function (_a) {
                    var value = _a.value, data = _a.data;
                    return (jsx(Link, __assign({ href: "/".concat(offerBaseUrl, "/").concat(data.offerUuid) }, { children: value })));
                },
                field: 'offerName',
                filter: 'simpleTextFilter',
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Offer',
                hide: !showOfferColumn,
                width: 150,
            },
            {
                cellRenderer: capTypeCellRenderer,
                field: 'type',
                filter: 'agSetColumnFilter',
                filterValueGetter: function (_a) {
                    var data = _a.data;
                    return data ? getCapTypeDisplayValue(data.type) : '';
                },
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Cap Type',
                width: 125,
            },
            {
                editable: editable,
                field: 'capAmount',
                filter: 'agNumberColumnFilter',
                headerName: 'Cap Count',
                width: 125,
            },
            {
                field: 'status',
                filter: 'agSetColumnFilter',
                headerName: 'Status',
                hide: !showStatusColumn,
                width: 150,
            },
            {
                cellEditor: DateEditor,
                cellRenderer: dateShortCellRenderer,
                editable: editable,
                field: 'startDate',
                filter: 'dateRangeFilter',
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Schedule Start Date',
                width: 150,
            },
            {
                cellEditor: DateEditor,
                cellRenderer: dateShortCellRenderer,
                editable: editable,
                field: 'endDate',
                filter: 'dateRangeFilter',
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Schedule End Date',
                width: 150,
            },
            {
                cellRenderer: userCellRenderer,
                field: 'createdBy',
                filter: 'agSetColumnFilter',
                filterValueGetter: function (_a) {
                    var _b;
                    var data = _a.data;
                    return (_b = data === null || data === void 0 ? void 0 : data.createdBy) === null || _b === void 0 ? void 0 : _b.fullName;
                },
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Created By',
                width: 140,
            },
            {
                cellRenderer: dateShortCellRenderer,
                field: 'createdAt',
                headerName: 'Created At',
                width: 140,
            },
            {
                cellRenderer: userCellRenderer,
                field: 'updatedBy',
                filter: 'agSetColumnFilter',
                filterValueGetter: function (_a) {
                    var _b;
                    var data = _a.data;
                    return (_b = data === null || data === void 0 ? void 0 : data.updatedBy) === null || _b === void 0 ? void 0 : _b.fullName;
                },
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Updated By',
                width: 140,
            },
            {
                cellRenderer: dateShortCellRenderer,
                field: 'updatedAt',
                headerName: 'Updated At',
                width: 140,
            },
            {
                cellRenderer: dateShortCellRenderer,
                field: 'endDate',
                filter: 'dateRangeFilter',
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Actual End Date',
                hide: !showActualEndDateColumn,
                width: 150,
            },
            {
                cellRenderer: function (_a) {
                    var data = _a.data;
                    return (jsx(Button, { icon: "trash", intent: Intent.DANGER, onClick: function () { return onDelete === null || onDelete === void 0 ? void 0 : onDelete(data.id); } }));
                },
                hide: !showDeleteColumn,
                sortable: false,
                suppressMenu: true,
                width: 100,
            },
        ];
    }, columnDefDeps);
    var orderedInventoryCaps = orderBy$1(inventoryCaps, ['startDate'], ['desc']);
    return (jsx(Fragment, { children: jsx("div", __assign({ className: "ag-theme-alpine", style: { height: '100%' } }, { children: jsx(AgGridReact, { columnDefs: columnDefs, getRowId: function (_a) {
                    var data = _a.data;
                    return String(data.id);
                }, gridOptions: gridOptions, pagination: inventoryCaps.length > paginationPageSize, paginationPageSize: paginationPageSize, rowData: orderedInventoryCaps, onCellValueChanged: function (event) { return onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(event.data); } }) })) }));
};

var CappingPage = function (props) {
    var _a;
    var productType = props.productType, title = props.title;
    var inventoryCapsQuery = useQuery(queries.inventory.demandSubAccountInventoryCaps({
        productType: productType,
    }));
    return (jsx(TableLayout, __assign({ isLoading: inventoryCapsQuery.isLoading, title: title }, { children: jsx(InventoryCapsTable, { showConfigurationColumn: true, showStatusColumn: true, inventoryCaps: (_a = inventoryCapsQuery.data) !== null && _a !== void 0 ? _a : [], paginationPageSize: 100 }) })));
};

var ChannelCappingPage = function (props) {
    var _a;
    var productType = props.productType, title = props.title;
    var inventoryCapsQuery = useQuery(queries.inventory.supplyDemandSubAccountInventoryCaps({
        productType: productType,
    }));
    return (jsx(TableLayout, __assign({ isLoading: inventoryCapsQuery.isLoading, title: title }, { children: jsx(InventoryCapsTable, { showChannelColumn: true, showConfigurationColumn: true, showStatusColumn: true, inventoryCaps: (_a = inventoryCapsQuery.data) !== null && _a !== void 0 ? _a : [], paginationPageSize: 100 }) })));
};

var CommunicationType;
(function (CommunicationType) {
    CommunicationType[CommunicationType["Transactional"] = 0] = "Transactional";
    CommunicationType[CommunicationType["EngineFionaRemarketing"] = 1] = "EngineFionaRemarketing";
    CommunicationType[CommunicationType["LenderRemarketing"] = 2] = "LenderRemarketing";
    CommunicationType[CommunicationType["CoBrand"] = 3] = "CoBrand";
})(CommunicationType || (CommunicationType = {}));
var communicationTypeToText = new Map([
    [CommunicationType.Transactional, 'transactional'],
    [CommunicationType.EngineFionaRemarketing, 'Engine/Fiona remarketing'],
    [CommunicationType.CoBrand, 'co-brand'],
    [CommunicationType.LenderRemarketing, 'lender remarketing'],
]);
var communicationEligibilityToaster = createCrudToaster('communication eligibility');
var CommunicationEligibilitiesPage = function () {
    var _a = useToggle(false), showConfirmationPrompt = _a[0], toggleConfirmationPrompt = _a[1];
    var _b = useState(), confirmationMessage = _b[0], setConfirmationMessage = _b[1];
    var _c = useState(), communicationUpdateData = _c[0], setCommunicationUpdateData = _c[1];
    var communicationsQuery = useQuery(queries.partnerData.communications());
    var updateCommunicationMutation = useMutation(updateCommunication);
    var gridOptions = usePortalAgGridOptions();
    var gridRef = useRef(null);
    var handleUpdateCommunication = useCallback(function (communicationType, communication) {
        var _a;
        var subAccount = communication.subAccount;
        if (!subAccount) {
            return;
        }
        var updateData = {
            subAccountId: subAccount.id,
        };
        switch (communicationType) {
            case CommunicationType.Transactional:
                updateData.transactional = !communication.transactional;
                break;
            case CommunicationType.EngineFionaRemarketing:
                updateData.engineFionaRemarketing =
                    !communication.engineFionaRemarketing;
                break;
            case CommunicationType.CoBrand:
                updateData.coBrand = !communication.coBrand;
                break;
            case CommunicationType.LenderRemarketing:
                updateData.lenderRemarketing = !communication.lenderRemarketing;
        }
        var communicationTypeText = communicationTypeToText.get(communicationType);
        setCommunicationUpdateData(updateData);
        setConfirmationMessage("Are you sure you would like to change ".concat(communicationTypeText, " communication eligibility for \"").concat((_a = communication === null || communication === void 0 ? void 0 : communication.subAccount) === null || _a === void 0 ? void 0 : _a.name, "\""));
        toggleConfirmationPrompt();
    }, [
        setCommunicationUpdateData,
        setConfirmationMessage,
        toggleConfirmationPrompt,
    ]);
    var handleConfirmUpdateCommunication = function () {
        toggleConfirmationPrompt();
        if (!communicationUpdateData) {
            return;
        }
        var options = {
            onError: function () {
                communicationEligibilityToaster.updateFailure();
            },
            onSettled: function () {
                setConfirmationMessage(undefined);
                setCommunicationUpdateData(undefined);
                communicationsQuery.refetch();
            },
            onSuccess: function () {
                communicationEligibilityToaster.updateSuccess();
            },
        };
        communicationEligibilityToaster.updateLoading();
        updateCommunicationMutation.mutate(communicationUpdateData, options);
    };
    var columnDefs = useMemo(function () {
        return [
            {
                field: 'subAccount.id',
                filter: 'simpleTextFilter',
                headerName: 'ID',
                width: 100,
            },
            {
                cellRenderer: supplySubAccountCellRenderer,
                field: 'subAccount',
                filter: 'simpleTextFilter',
                headerName: 'Name',
            },
            {
                field: 'subAccountExport',
                filter: 'simpleTextFilter',
                headerName: 'Name',
                hide: true,
                // Use valueGetter for manipulating the data purely for export.
                valueGetter: function (params) { var _a, _b; return ((_b = (_a = params.data) === null || _a === void 0 ? void 0 : _a.subAccount) === null || _b === void 0 ? void 0 : _b.name) || '--'; },
            },
            {
                field: 'subAccount.uuid',
                filter: 'simpleTextFilter',
                headerName: 'UUID',
            },
            {
                field: 'subAccount.companyUuid',
                filter: 'simpleTextFilter',
                headerName: 'Company UUID',
            },
            {
                cellRenderer: function (_a) {
                    var value = _a.value, data = _a.data;
                    return (jsx(Switch, { checked: value, onChange: function () {
                            return handleUpdateCommunication(CommunicationType.Transactional, data);
                        } }));
                },
                field: 'transactional',
                filter: 'agSetColumnFilter',
                filterParams: {
                    suppressMiniFilter: true,
                },
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Transactional',
                width: '175px',
            },
            {
                cellRenderer: function (_a) {
                    var value = _a.value, data = _a.data;
                    return (jsx(Switch, { checked: value, onChange: function () {
                            return handleUpdateCommunication(CommunicationType.EngineFionaRemarketing, data);
                        } }));
                },
                field: 'engineFionaRemarketing',
                filter: 'agSetColumnFilter',
                filterParams: {
                    suppressMiniFilter: true,
                },
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Engine / Fiona Remarketing',
                width: '175px',
            },
            {
                cellRenderer: function (_a) {
                    var value = _a.value, data = _a.data;
                    return (jsx(Switch, { checked: value, onChange: function () {
                            return handleUpdateCommunication(CommunicationType.CoBrand, data);
                        } }));
                },
                field: 'coBrand',
                filter: 'agSetColumnFilter',
                filterParams: {
                    suppressMiniFilter: true,
                },
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Co-Branded Emails',
                // Use valueGetter to provide a default value for export when no data is present
                valueGetter: function (params) {
                    var _a;
                    // Check if the coBrand value exists and return it; otherwise, return false
                    return ((_a = params.data) === null || _a === void 0 ? void 0 : _a.coBrand) === true ? true : false;
                },
                width: '175px',
            },
            {
                cellRenderer: function (_a) {
                    var value = _a.value, data = _a.data;
                    return (jsx(Switch, { checked: value, onChange: function () {
                            return handleUpdateCommunication(CommunicationType.LenderRemarketing, data);
                        } }));
                },
                field: 'lenderRemarketing',
                filter: 'agSetColumnFilter',
                filterParams: {
                    suppressMiniFilter: true,
                },
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Lender Remarketing Email',
                width: '175px',
            },
        ];
    }, [communicationsQuery.data, handleUpdateCommunication]);
    return (jsxs(Fragment, { children: [jsx(TableLayout, __assign({ showClearAllButton: true, showExportButton: true, csvExportParams: {
                    columnKeys: [
                        'subAccount.id',
                        'subAccountExport',
                        'subAccount.uuid',
                        'subAccount.companyUuid',
                        'transactional',
                        'engineFionaRemarketing',
                        'coBrand',
                        'lenderRemarketing',
                    ],
                    fileName: 'communication-eligibilities',
                }, gridRef: gridRef, isLoading: communicationsQuery.isLoading, title: "Communication Eligibilities" }, { children: jsx("div", __assign({ className: "ag-theme-alpine", style: { height: '100%' } }, { children: jsx(AgGridReact, { ref: gridRef, pagination: true, columnDefs: columnDefs, getRowId: function (_a) {
                            var _b;
                            var data = _a.data;
                            return (_b = data.subAccount) === null || _b === void 0 ? void 0 : _b.id;
                        }, gridOptions: gridOptions, rowData: communicationsQuery.data }) })) })), jsx(EvenDialog, { message: confirmationMessage, visible: showConfirmationPrompt, onCancel: toggleConfirmationPrompt, onOk: handleConfirmUpdateCommunication })] }));
};

var ActiveInventoryCapsCard = function (props) {
    var _a, _b, _c, _d;
    var inventoryCaps = props.inventoryCaps, onCreateClicksCap = props.onCreateClicksCap, onCreateRequestCap = props.onCreateRequestCap, onEndActiveCap = props.onEndActiveCap, showChannelColumn = props.showChannelColumn, endCapMessage = props.endCapMessage, canCreateCap = props.canCreateCap, canUpdateCap = props.canUpdateCap;
    var endCapButton = useMemo(function () { return (jsx(ConfirmableAction, __assign({ message: endCapMessage, onOk: function () { var _a; return onEndActiveCap((_a = inventoryCaps[0]) === null || _a === void 0 ? void 0 : _a.id); } }, { children: jsx(EvenButton, { intent: Intent.NONE, text: "End Cap" }) }))); }, [onEndActiveCap]);
    var createNewPopover = useMemo(function () { return (jsx(Popover, __assign({ content: jsxs(Menu, { children: [jsx(MenuItem$1, { text: "Clicks Cap", onClick: onCreateClicksCap }), jsx(MenuItem$1, { text: "Request Cap", onClick: onCreateRequestCap })] }), placement: "bottom" }, { children: jsx(EvenCreateNewButton, {}) }))); }, [onCreateClicksCap, onCreateRequestCap]);
    var headerContent = (jsxs(Fragment, { children: [inventoryCaps.length && canUpdateCap ? endCapButton : null, canCreateCap ? createNewPopover : null] }));
    var activeCapAmount = (_b = (_a = inventoryCaps === null || inventoryCaps === void 0 ? void 0 : inventoryCaps[0]) === null || _a === void 0 ? void 0 : _a.activeCapAmount) !== null && _b !== void 0 ? _b : 0;
    var capAmount = (_d = (_c = inventoryCaps === null || inventoryCaps === void 0 ? void 0 : inventoryCaps[0]) === null || _c === void 0 ? void 0 : _c.capAmount) !== null && _d !== void 0 ? _d : 0;
    return (jsxs(RoundedCard, __assign({ headerContent: headerContent, title: "Active Caps" }, { children: [canCreateCap ? (jsx(RoundedCard.Content, { children: jsx(Callout, __assign({ intent: Intent.PRIMARY }, { children: "If you create a cap for today, requests and clicks starting at 00:00 UTC onwards will be counted." })) })) : null, inventoryCaps.length ? (jsxs(Fragment, { children: [jsx(InventoryCapsTable, { inventoryCaps: inventoryCaps, paginationPageSize: 10, showChannelColumn: showChannelColumn }), jsxs(RoundedCard.Content, { children: [jsx("p", __assign({ className: "stats-title" }, { children: "Stats" })), jsxs("div", __assign({ className: "stats-list" }, { children: [jsxs("div", __assign({ className: "stat-item" }, { children: [jsx("p", { children: "Active Cap Count" }), jsxs("p", { children: [activeCapAmount, " / ", capAmount] })] })), jsxs("div", __assign({ className: "stat-item" }, { children: [jsx("p", { children: "Status" }), jsx("p", { children: activeCapAmount >= capAmount ? 'Ended' : 'Started' })] }))] }))] })] })) : (jsx(NoData, { description: "No active caps", size: "sm" }))] })));
};

var validateDateRangeOverlap = function (dateToValidate, startDate, endDate) {
    var dateToValidateMillis = dateToValidate.toMillis();
    var startDateMillis = startDate.toMillis();
    var endDateMillis = endDate.toMillis();
    var overlapsWithStartDate = startDate.hasSame(dateToValidate, 'day');
    var overlapsWithEndDate = endDate.hasSame(dateToValidate, 'day');
    var overlapsWithDateRange = dateToValidateMillis > startDateMillis &&
        dateToValidateMillis < endDateMillis;
    return overlapsWithStartDate || overlapsWithEndDate || overlapsWithDateRange;
};

var isRequestCap = function (capType) {
    return capType === CapType.LeadCap;
};
var isClickCap = function (capType) {
    return (capType === CapType.ClickCap || capType === CapType.DemandSubAccountClickCap);
};

var toDemandSubAccountInventoryCapCreateData = function (formData) {
    var capCount = formData.capCount, capType = formData.capType, demandSubAccount = formData.demandSubAccount, endDate = formData.endDate, startDate = formData.startDate;
    var clickCapAmount = isClickCap(capType) ? toNumber(capCount) : undefined;
    var leadCapAmount = isRequestCap(capType) ? toNumber(capCount) : undefined;
    var createData = {
        capType: capType,
        clickCapAmount: clickCapAmount,
        demandSubAccountId: demandSubAccount === null || demandSubAccount === void 0 ? void 0 : demandSubAccount.id,
        endDate: DateTime.fromJSDate(endDate).toISODate(),
        leadCapAmount: leadCapAmount,
        startDate: DateTime.fromJSDate(startDate).toISODate(),
    };
    return createData;
};

var toDemandSubAccountInventoryCapUpdateData = function (capData) {
    var capAmount = capData.capAmount, type = capData.type;
    var clickCapAmount = isClickCap(type) ? toNumber(capAmount) : undefined;
    var leadCapAmount = isRequestCap(type) ? toNumber(capAmount) : undefined;
    var updateData = {
        clickCapAmount: clickCapAmount,
        endDate: DateTime.fromISO(capData.endDate).toISODate(),
        id: capData.id,
        leadCapAmount: leadCapAmount,
        startDate: DateTime.fromISO(capData.startDate).toISODate(),
    };
    return updateData;
};

var toSupplyDemandSubAccountInventoryCapCreateData = function (formData) {
    var demandSubAccount = formData.demandSubAccount, _a = formData.supplySubAccounts, supplySubAccounts = _a === void 0 ? [] : _a, capType = formData.capType, capCount = formData.capCount, startDate = formData.startDate, endDate = formData.endDate;
    var leadCapAmount = isRequestCap(capType) ? toNumber(capCount) : undefined;
    var clickCapAmount = isClickCap(capType) ? toNumber(capCount) : undefined;
    var createData = {
        capType: capType,
        clickCapAmount: clickCapAmount,
        demandSubAccountId: demandSubAccount.id,
        endDate: DateTime.fromJSDate(endDate).toISODate(),
        leadCapAmount: leadCapAmount,
        startDate: DateTime.fromJSDate(startDate).toISODate(),
        supplySubAccountIds: supplySubAccounts.map(function (_a) {
            var id = _a.id;
            return id;
        }),
    };
    return createData;
};

var toSupplyDemandSubAccountInventoryCapUpdateData = function (capData) {
    var capAmount = capData.capAmount, type = capData.type;
    var clickCapAmount = isClickCap(type) ? toNumber(capAmount) : undefined;
    var leadCapAmount = isRequestCap(type) ? toNumber(capAmount) : undefined;
    var updateData = {
        clickCapAmount: clickCapAmount,
        endDate: capData.endDate.split('T')[0],
        id: capData.id,
        leadCapAmount: leadCapAmount,
        startDate: capData.startDate.split('T')[0],
    };
    return updateData;
};

var getDisabledDatesBySupplySubAccountId = function (inventoryCaps) {
    return inventoryCaps.reduce(function (accum, _a) {
        var _b;
        var startDate = _a.startDate, endDate = _a.endDate, supplySubAccount = _a.supplySubAccount;
        var supplySubAccountId = supplySubAccount === null || supplySubAccount === void 0 ? void 0 : supplySubAccount.id;
        if (!supplySubAccountId) {
            return accum;
        }
        var disabledDates = (_b = accum.get(supplySubAccountId)) !== null && _b !== void 0 ? _b : [];
        accum.set(supplySubAccountId, __spreadArray(__spreadArray([], disabledDates, true), [startDate, endDate], false));
        return accum;
    }, new Map());
};

var getDisabledDates = function (options) {
    var disabledDates = options.disabledDates, disabledDatesBySupplySubAccountId = options.disabledDatesBySupplySubAccountId, supplySubAccounts = options.supplySubAccounts;
    if (disabledDates) {
        return uniq(disabledDates.map(function (date) { return date; }));
    }
    if (supplySubAccounts) {
        return uniq(supplySubAccounts.flatMap(function (_a) {
            var _b;
            var id = _a.id;
            return (_b = disabledDatesBySupplySubAccountId === null || disabledDatesBySupplySubAccountId === void 0 ? void 0 : disabledDatesBySupplySubAccountId.get(id)) !== null && _b !== void 0 ? _b : [];
        }));
    }
    return [];
};

var formatDate = function (date) {
    return DateTime.fromJSDate(date).toLocaleString(DateTime.DATE_SHORT);
};
var CreateInventoryCapDrawerForm = function (props) {
    var isSubmitting = props.isSubmitting, onClose = props.onClose, onSubmit = props.onSubmit, selectedDemandSubAccount = props.selectedDemandSubAccount, _a = props.showDemandSubAccountDropdown, showDemandSubAccountDropdown = _a === void 0 ? false : _a, _b = props.showSupplySubAccountDropdown, showSupplySubAccountDropdown = _b === void 0 ? false : _b, visible = props.visible, capType = props.capType, disabledDates = props.disabledDates, disabledDatesBySupplySubAccountId = props.disabledDatesBySupplySubAccountId;
    var validateDateRange = useCallback(function (_, context) {
        var _a = context.parent, startDate = _a.startDate, endDate = _a.endDate, supplySubAccounts = _a.supplySubAccounts;
        var disabledDatesAsDateTime = getDisabledDates({
            disabledDates: disabledDates,
            disabledDatesBySupplySubAccountId: disabledDatesBySupplySubAccountId,
            supplySubAccounts: supplySubAccounts,
        }).map(function (date) { return DateTime.fromISO(date); });
        if (startDate && endDate) {
            var startDateAsDateTime_1 = DateTime.fromJSDate(startDate);
            var endDateAsDateTime_1 = DateTime.fromJSDate(endDate);
            var hasOverlap = disabledDatesAsDateTime.some(function (disabledDateTime) {
                return validateDateRangeOverlap(disabledDateTime, startDateAsDateTime_1, endDateAsDateTime_1);
            });
            return !hasOverlap;
        }
        return false;
    }, [disabledDates, disabledDatesBySupplySubAccountId]);
    var minDate = DateTime.now().startOf('day');
    var maxDate = DateTime.now().plus({ days: 90 }).endOf('day');
    var schemaDeps = [
        validateDateRange,
        showDemandSubAccountDropdown,
        showSupplySubAccountDropdown,
    ];
    var schema = useMemo(function () {
        return object({
            capCount: string().required(),
            capType: string().oneOf(Object.values(CapType)).required(),
            demandSubAccount: mixed().when({
                is: showDemandSubAccountDropdown,
                then: function (schema) { return schema.required(); },
            }),
            endDate: date()
                .required()
                .min(minDate.toJSDate())
                .max(maxDate.toJSDate())
                .test('validate-date-range', 'Caps already exists for these dates', validateDateRange),
            startDate: date()
                .required()
                .min(minDate.toJSDate())
                .max(maxDate.toJSDate()),
            supplySubAccounts: array().when({
                is: showSupplySubAccountDropdown,
                then: function (schema) { return schema.required(); },
            }),
        });
    }, schemaDeps);
    var _c = useForm({
        reValidateMode: 'onSubmit',
        resolver: yupResolver(schema),
    }), control = _c.control, handleSubmit = _c.handleSubmit, setValue = _c.setValue, watch = _c.watch;
    var startDate = watch('startDate');
    var supplySubAccounts = watch('supplySubAccounts');
    useEffect(function () {
        if (capType) {
            setValue('capType', capType);
        }
    }, [capType]);
    useEffect(function () {
        if (selectedDemandSubAccount) {
            setValue('demandSubAccount', selectedDemandSubAccount);
        }
    }, [selectedDemandSubAccount === null || selectedDemandSubAccount === void 0 ? void 0 : selectedDemandSubAccount.uuid]);
    var capCountTooltip = isClickCap(capType)
        ? 'Click caps block future API requests once a certain number of clicks has been tracked. You may see Click counts exceed the specified value due to remarketing etc. However, additional API requests will not be created after the click count is reached.'
        : undefined;
    var title = isClickCap(capType)
        ? 'New Clicks Cap'
        : isRequestCap(capType)
            ? 'New Request Cap'
            : 'New Cap';
    var disabledDatesAsJSDate = getDisabledDates({
        disabledDates: disabledDates,
        disabledDatesBySupplySubAccountId: disabledDatesBySupplySubAccountId,
        supplySubAccounts: supplySubAccounts,
    }).map(function (date) { return DateTime.fromISO(date).toJSDate(); });
    return (jsxs(DrawerForm, __assign({ disableCloseOnMouseDown: true, isSubmitting: isSubmitting, title: title, visible: visible, onClose: onClose, onSubmit: handleSubmit(onSubmit) }, { children: [showDemandSubAccountDropdown && (jsx(Controller, { control: control, name: "demandSubAccount", render: function (_a) {
                    var _b;
                    var field = _a.field, fieldState = _a.fieldState;
                    return (jsx(Field, __assign({ error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, label: "Configuration" }, { children: jsx(SubAccountSuggest, { showOnlyDemandSubAccounts: true, disabled: Boolean(selectedDemandSubAccount), selectedItem: field.value, onItemSelect: field.onChange }) })));
                } })), showSupplySubAccountDropdown && (jsx(Controller, { control: control, name: "supplySubAccounts", render: function (_a) {
                    var _b;
                    var field = _a.field, fieldState = _a.fieldState;
                    return (jsx(Field, __assign({ error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, label: "Channel" }, { children: jsx(SubAccountMultiSelect, { enableSubAccountsFromApi: true, showOnlySupplySubAccounts: true, selectedItems: field.value, onChange: field.onChange }) })));
                } })), jsx(Controller, { control: control, name: "capCount", render: function (_a) {
                    var _b;
                    var field = _a.field, fieldState = _a.fieldState;
                    return (jsx(Field, __assign({ error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, label: "Daily Cap Count", tooltip: capCountTooltip }, { children: jsx("input", { className: Classes.INPUT, type: "number", value: field.value, onChange: field.onChange }) })));
                } }), jsx(Controller, { control: control, name: "startDate", render: function (_a) {
                    var _b;
                    var field = _a.field, fieldState = _a.fieldState;
                    return (jsx(Field, __assign({ error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, label: "Scheduled Start Date (UTC)" }, { children: jsx(DateInput, { dayPickerProps: { disabledDays: disabledDatesAsJSDate }, formatDate: formatDate, maxDate: maxDate.toJSDate(), minDate: minDate.toJSDate(), parseDate: toDate, value: field.value, onChange: field.onChange }) })));
                } }), jsx(Controller, { control: control, name: "endDate", render: function (_a) {
                    var _b;
                    var field = _a.field, fieldState = _a.fieldState;
                    return (jsx(Field, __assign({ error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, label: "Scheduled End Date (UTC)" }, { children: jsx(DateInput, { dayPickerProps: { disabledDays: disabledDatesAsJSDate }, formatDate: formatDate, maxDate: maxDate.toJSDate(), minDate: startDate ? startDate : minDate.toJSDate(), parseDate: toDate, value: field.value, onChange: field.onChange }) })));
                } })] })));
};

var PreviousInventoryCapsCard = function (props) {
    var inventoryCaps = props.inventoryCaps, showChannelColumn = props.showChannelColumn, showClicksCapNotice = props.showClicksCapNotice;
    return (jsx(RoundedCard, __assign({ title: "History" }, { children: inventoryCaps.length ? (jsxs(Fragment, { children: [showClicksCapNotice ? (jsx(RoundedCard.Content, { children: jsx(Callout, __assign({ intent: Intent.PRIMARY }, { children: "Click caps block future API requests once a certain number of clicks has been tracked. You may see Click counts exceed the specified value due to remarketing etc. However, additional API requests will not be created after the click count is reached." })) })) : null, jsx(InventoryCapsTable, { showActualEndDateColumn: true, inventoryCaps: inventoryCaps, paginationPageSize: 10, showChannelColumn: showChannelColumn })] })) : (jsx(NoData, { description: "No ended caps", size: "sm" })) })));
};

var UpcomingInventoryCapsCard = function (props) {
    var inventoryCaps = props.inventoryCaps, canDeleteCap = props.canDeleteCap, canUpdateCap = props.canUpdateCap, onDelete = props.onDelete, onDeleteAll = props.onDeleteAll, onUpdate = props.onUpdate, showChannelColumn = props.showChannelColumn;
    var deleteAllButton = useMemo(function () { return (jsx(ConfirmableAction, __assign({ message: "This action will delete all the upcoming caps set for this sub-account. To proceed please confirm.", onOk: onDeleteAll }, { children: jsx(EvenButton, { intent: Intent.NONE, text: "Delete All" }) }))); }, [onDeleteAll]);
    return (jsx(RoundedCard, __assign({ headerContent: inventoryCaps.length && canDeleteCap ? deleteAllButton : null, title: "Upcoming Caps" }, { children: inventoryCaps.length ? (jsx(InventoryCapsTable, { editable: canUpdateCap, inventoryCaps: inventoryCaps, paginationPageSize: 10, showChannelColumn: showChannelColumn, showDeleteColumn: canDeleteCap, onDelete: onDelete, onUpdate: onUpdate })) : (jsx(NoData, { description: "No upcoming caps", size: "sm" })) })));
};

var ContractTermsTab = function (props) {
    var _a;
    var subAccount = props.subAccount, readOnly = props.readOnly;
    var demandContracts = useGetDemandContractsQuery({
        subAccountId: subAccount.id,
    });
    var demandContractsData = (_a = demandContracts.data) !== null && _a !== void 0 ? _a : [];
    var demandContract = getActiveDemandContract(demandContractsData);
    var otherContracts = demandContractsData.filter(function (contract) { return contract.id !== (demandContract === null || demandContract === void 0 ? void 0 : demandContract.id); });
    return (jsxs(Fragment, { children: [jsx(ActiveContractCard, { demandContract: demandContract, demandSubAccount: subAccount, readOnly: readOnly, onDelete: function () { } }), jsx(OtherContractsCard, { demandContracts: otherContracts })] }));
};

var CapToaster = createCrudToaster('cap');
var UpcomingCapsToaster = createCrudToaster('upcoming caps');
var DemandSubAccountInventoryCapsTab = function (props) {
    var _a;
    var demandSubAccount = props.demandSubAccount, demandSubAccountId = props.demandSubAccount.id, canCreateDemandCaps = props.canCreateDemandCaps, canDeleteDemandCaps = props.canDeleteDemandCaps, canUpdateDemandCaps = props.canUpdateDemandCaps;
    var _b = useToggle(false), showCreateDrawerForm = _b[0], toggleCreateDrawerForm = _b[1];
    var _c = useState(CapType.DemandSubAccountClickCap), capType = _c[0], setCapType = _c[1];
    var demandSubAccountsInventoryCapsQuery = useQuery(queries.inventory.demandSubAccountInventoryCaps({ demandSubAccountId: demandSubAccountId }));
    var createBulkDemandSubAccountInventoryCapMutation = useMutation(createBulkDemandSubAccountInventoryCap);
    var updateDemandSubAccountInventoryCapMutation = useMutation(updateDemandSubAccountInventoryCap);
    var deleteBulkDemandSubAccountInventoryCapsMutation = useMutation(deleteBulkDemandSubAccountInventoryCap);
    var _d = filterInventoryCapsByStatus((_a = demandSubAccountsInventoryCapsQuery.data) !== null && _a !== void 0 ? _a : []), activeInventoryCaps = _d.activeInventoryCaps, upcomingInventoryCaps = _d.upcomingInventoryCaps, previousInventoryCaps = _d.previousInventoryCaps;
    var handleToggleCreateClicksCap = function () {
        setCapType(CapType.DemandSubAccountClickCap);
        toggleCreateDrawerForm();
    };
    var handleToggleCreateRequestCap = function () {
        setCapType(CapType.LeadCap);
        toggleCreateDrawerForm();
    };
    var handleCreate = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
        var createData;
        return __generator(this, function (_a) {
            createData = toDemandSubAccountInventoryCapCreateData(formData);
            CapToaster.createLoading();
            createBulkDemandSubAccountInventoryCapMutation.mutate(createData, {
                onError: function () {
                    CapToaster.createFailure();
                },
                onSettled: function () {
                    toggleCreateDrawerForm();
                },
                onSuccess: function () {
                    CapToaster.createSuccess();
                    demandSubAccountsInventoryCapsQuery.refetch();
                },
            });
            return [2 /*return*/];
        });
    }); };
    var handleUpdate = function (capData) { return __awaiter(void 0, void 0, void 0, function () {
        var updateData;
        return __generator(this, function (_a) {
            updateData = toDemandSubAccountInventoryCapUpdateData(capData);
            CapToaster.updateLoading();
            updateDemandSubAccountInventoryCapMutation.mutate(updateData, {
                onError: function () {
                    CapToaster.updateFailure();
                },
                onSuccess: function () {
                    CapToaster.updateSuccess();
                    demandSubAccountsInventoryCapsQuery.refetch();
                },
            });
            return [2 /*return*/];
        });
    }); };
    var handleEndActiveCap = function (id) {
        var deleteData = {
            ids: [id],
        };
        CapToaster.endLoading();
        deleteBulkDemandSubAccountInventoryCapsMutation.mutate(deleteData, {
            onError: function () {
                CapToaster.endFailure();
            },
            onSuccess: function () {
                CapToaster.endSuccess();
                demandSubAccountsInventoryCapsQuery.refetch();
            },
        });
    };
    var handleDelete = function (id) {
        var deleteData = {
            ids: [id],
        };
        CapToaster.deleteLoading();
        deleteBulkDemandSubAccountInventoryCapsMutation.mutate(deleteData, {
            onError: function () {
                CapToaster.deleteFailure();
            },
            onSuccess: function () {
                CapToaster.deleteSuccess();
                demandSubAccountsInventoryCapsQuery.refetch();
            },
        });
    };
    var handleDeleteAllUpcoming = function () {
        var deleteData = {
            ids: upcomingInventoryCaps.map(function (_a) {
                var id = _a.id;
                return id;
            }),
        };
        UpcomingCapsToaster.deleteLoading();
        deleteBulkDemandSubAccountInventoryCapsMutation.mutate(deleteData, {
            onError: function () {
                UpcomingCapsToaster.deleteFailure();
            },
            onSuccess: function () {
                UpcomingCapsToaster.deleteSuccess();
                demandSubAccountsInventoryCapsQuery.refetch();
            },
        });
    };
    var activeAndUpcomingCapDates = uniq(activeInventoryCaps
        .concat(upcomingInventoryCaps)
        .map(function (_a) {
        var startDate = _a.startDate;
        return startDate;
    }));
    if (demandSubAccountsInventoryCapsQuery.isLoading &&
        !demandSubAccountsInventoryCapsQuery.data) {
        return jsx(Spinner, {});
    }
    return (jsxs(Fragment, { children: [jsx(ActiveInventoryCapsCard, { canCreateCap: canCreateDemandCaps, canUpdateCap: canUpdateDemandCaps, endCapMessage: "This action will end the active cap immediately. Note that this will have no impact on upcoming caps. If you would like to end this as well as upcoming caps, after ending the active cap please delete all upcoming caps. To proceed with ending this active cap, please confirm.", inventoryCaps: activeInventoryCaps, onCreateClicksCap: handleToggleCreateClicksCap, onCreateRequestCap: handleToggleCreateRequestCap, onEndActiveCap: handleEndActiveCap }), jsx(UpcomingInventoryCapsCard, { canDeleteCap: canDeleteDemandCaps, canUpdateCap: canUpdateDemandCaps, inventoryCaps: upcomingInventoryCaps, onDelete: handleDelete, onDeleteAll: handleDeleteAllUpcoming, onUpdate: handleUpdate }), jsx(PreviousInventoryCapsCard, { showClicksCapNotice: true, inventoryCaps: previousInventoryCaps }), jsx(CreateInventoryCapDrawerForm, { showDemandSubAccountDropdown: true, capType: capType, disabledDates: activeAndUpcomingCapDates, isSubmitting: createBulkDemandSubAccountInventoryCapMutation.isLoading, selectedDemandSubAccount: demandSubAccount, visible: showCreateDrawerForm, onClose: toggleCreateDrawerForm, onSubmit: handleCreate })] }));
};

var ChannelCapToaster = createCrudToaster('channel cap');
var UpcomingChannelCapsToaster = createCrudToaster('upcoming channel caps');
var SupplyDemandSubAccountInventoryCapsTab = function (props) {
    var _a;
    var demandSubAccount = props.demandSubAccount, canCreateSupplyDemandCaps = props.canCreateSupplyDemandCaps, canUpdateSupplyDemandCaps = props.canUpdateSupplyDemandCaps, canDeleteSupplyDemandCaps = props.canDeleteSupplyDemandCaps;
    var _b = useState(CapType.DemandSubAccountClickCap), capType = _b[0], setCapType = _b[1];
    var _c = useToggle(false), showCreateDrawerForm = _c[0], toggleCreateDrawerForm = _c[1];
    var supplyDemandSubAccountInventoryCapsQuery = useQuery(queries.inventory.supplyDemandSubAccountInventoryCaps({
        demandSubAccountId: demandSubAccount.id,
    }));
    var createBulkSupplyDemandSubAccountInventoryCapMutation = useMutation(createBulkSupplyDemandSubAccountInventoryCap);
    var updateSupplyDemandSubAccountInventoryCapMutation = useMutation(updateSupplyDemandSubAccountInventoryCap);
    var deleteBulkSupplySubAccountInventoryCapsMutation = useMutation(deleteBulkSupplyDemandSubAccountInventoryCap);
    var _d = filterInventoryCapsByStatus((_a = supplyDemandSubAccountInventoryCapsQuery.data) !== null && _a !== void 0 ? _a : []), activeInventoryCaps = _d.activeInventoryCaps, upcomingInventoryCaps = _d.upcomingInventoryCaps, previousInventoryCaps = _d.previousInventoryCaps;
    var handleToggleCreateClicksCap = function () {
        setCapType(CapType.DemandSubAccountClickCap);
        toggleCreateDrawerForm();
    };
    var handleToggleCreateRequestCap = function () {
        setCapType(CapType.LeadCap);
        toggleCreateDrawerForm();
    };
    var handleEndActiveCap = function (id) {
        var deleteData = {
            ids: [id],
        };
        ChannelCapToaster.endLoading();
        deleteBulkSupplySubAccountInventoryCapsMutation.mutate(deleteData, {
            onError: function () {
                ChannelCapToaster.endFailure();
            },
            onSuccess: function () {
                ChannelCapToaster.endSuccess();
                supplyDemandSubAccountInventoryCapsQuery.refetch();
            },
        });
    };
    var handleCreate = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
        var createData;
        return __generator(this, function (_a) {
            createData = toSupplyDemandSubAccountInventoryCapCreateData(formData);
            toggleCreateDrawerForm();
            ChannelCapToaster.createLoading();
            createBulkSupplyDemandSubAccountInventoryCapMutation.mutate(createData, {
                onError: function () {
                    ChannelCapToaster.createFailure();
                },
                onSuccess: function () {
                    ChannelCapToaster.createSuccess();
                    supplyDemandSubAccountInventoryCapsQuery.refetch();
                },
            });
            return [2 /*return*/];
        });
    }); };
    var handleUpdate = function (capData) { return __awaiter(void 0, void 0, void 0, function () {
        var updateData;
        return __generator(this, function (_a) {
            updateData = toSupplyDemandSubAccountInventoryCapUpdateData(capData);
            ChannelCapToaster.updateLoading();
            updateSupplyDemandSubAccountInventoryCapMutation.mutate(updateData, {
                onError: function () {
                    ChannelCapToaster.updateFailure();
                },
                onSuccess: function () {
                    ChannelCapToaster.updateSuccess();
                    supplyDemandSubAccountInventoryCapsQuery.refetch();
                },
            });
            return [2 /*return*/];
        });
    }); };
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var deleteData;
        return __generator(this, function (_a) {
            deleteData = {
                ids: [id],
            };
            ChannelCapToaster.deleteLoading();
            deleteBulkSupplySubAccountInventoryCapsMutation.mutate(deleteData, {
                onError: function () {
                    ChannelCapToaster.deleteFailure();
                },
                onSuccess: function () {
                    ChannelCapToaster.deleteSuccess();
                    supplyDemandSubAccountInventoryCapsQuery.refetch();
                },
            });
            return [2 /*return*/];
        });
    }); };
    var handleDeleteAllUpcoming = function () {
        var deleteData = {
            ids: upcomingInventoryCaps.map(function (_a) {
                var id = _a.id;
                return id;
            }),
        };
        UpcomingChannelCapsToaster.deleteLoading();
        deleteBulkSupplySubAccountInventoryCapsMutation.mutate(deleteData, {
            onError: function () {
                UpcomingChannelCapsToaster.deleteFailure();
            },
            onSuccess: function () {
                UpcomingChannelCapsToaster.deleteSuccess();
                supplyDemandSubAccountInventoryCapsQuery.refetch();
            },
        });
    };
    var disabledDatesBySupplySubAccountId = getDisabledDatesBySupplySubAccountId(activeInventoryCaps.concat(upcomingInventoryCaps));
    if (supplyDemandSubAccountInventoryCapsQuery.isLoading &&
        !supplyDemandSubAccountInventoryCapsQuery.data) {
        return jsx(Spinner, {});
    }
    return (jsxs(Fragment, { children: [jsx(ActiveInventoryCapsCard, { showChannelColumn: true, canCreateCap: canCreateSupplyDemandCaps, canUpdateCap: canUpdateSupplyDemandCaps, endCapMessage: "This action will end the active channel cap immediately. Note that this will have no impact on upcoming caps. If you would like to end this as well as upcoming caps, after ending the active cap please delete all upcoming caps. To proceed with ending this active cap, please confirm.", inventoryCaps: activeInventoryCaps, onCreateClicksCap: handleToggleCreateClicksCap, onCreateRequestCap: handleToggleCreateRequestCap, onEndActiveCap: handleEndActiveCap }), jsx(UpcomingInventoryCapsCard, { showChannelColumn: true, canDeleteCap: canDeleteSupplyDemandCaps, canUpdateCap: canUpdateSupplyDemandCaps, inventoryCaps: upcomingInventoryCaps, onDelete: handleDelete, onDeleteAll: handleDeleteAllUpcoming, onUpdate: handleUpdate }), jsx(PreviousInventoryCapsCard, { showChannelColumn: true, inventoryCaps: previousInventoryCaps }), jsx(CreateInventoryCapDrawerForm, { showDemandSubAccountDropdown: true, showSupplySubAccountDropdown: true, capType: capType, disabledDatesBySupplySubAccountId: disabledDatesBySupplySubAccountId, isSubmitting: createBulkSupplyDemandSubAccountInventoryCapMutation.isLoading, selectedDemandSubAccount: demandSubAccount, visible: showCreateDrawerForm, onClose: toggleCreateDrawerForm, onSubmit: handleCreate })] }));
};

var StaticOffersTab = function (_a) {
    var 
    // refObj,
    productType = _a.productType;
    console.log(productType);
    return jsx("p", __assign({ style: { textAlign: 'center' } }, { children: "Coming soon" }));
};

var OfferCatalogContext = createContext(undefined);
/**
 * OfferCatalogProvider provides a single source for the Offer Catalog data that needs properties no currently in the GET "/ews/offer-catalog/offers" response
 * It's a workaround solution and should be removed as soon as possible
 * @readonly
 */
var OfferCatalogProvider = function (_a) {
    var _b;
    var _c = _a.canReadOfferCatalogOffers, canReadOfferCatalogOffers = _c === void 0 ? true : _c, children = _a.children, _d = _a.productType, productType = _d === void 0 ? '' : _d;
    var _e = useGetOffersCatalogOffers(productType ? { productTypes: [productType] } : {}, { enabled: canReadOfferCatalogOffers, refetchOnMount: true }), dataOffersQuery = _e.data, isSuccessOffersQuery = _e.isSuccess, refetchOffersQuery = _e.refetch, isLoadingOffersQuery = _e.isLoading;
    var _f = useGetFinanceAccountsQuery({}, {
        cacheTime: 30 * 60 * 1000,
        enabled: canReadOfferCatalogOffers,
        staleTime: 10 * 60 * 1000, // 10 minutes
    }), dataAllFinanceAccounts = _f.data, isSuccessAllFinanceAccountsQuery = _f.isSuccess, refetchAllFinanceAccounts = _f.refetch;
    var _g = useGetSubAccountsQuery({
        subAccountTypeKey: SubAccountType.DemandSource,
    }, {
        cacheTime: 30 * 60 * 1000,
        enabled: canReadOfferCatalogOffers &&
            isSuccessOffersQuery &&
            isSuccessAllFinanceAccountsQuery,
        staleTime: 10 * 60 * 1000, // 10 minutes
    }), dataDemandSubAccounts = _g.data, isLoadingSubAccountsQuery = _g.isLoading, refetchSubAccounts = _g.refetch;
    var data = (_b = useMemo(function () {
        return dataOffersQuery && dataDemandSubAccounts && dataAllFinanceAccounts
            ? dataOffersQuery === null || dataOffersQuery === void 0 ? void 0 : dataOffersQuery.map(function (offer) {
                var _a, _b, _c;
                var demandSubAccount = (_a = dataDemandSubAccounts === null || dataDemandSubAccounts === void 0 ? void 0 : dataDemandSubAccounts.find(function (subAccount) { return subAccount.uuid === offer.demandSubAccountUuid; })) !== null && _a !== void 0 ? _a : null;
                var parentAccount = dataAllFinanceAccounts === null || dataAllFinanceAccounts === void 0 ? void 0 : dataAllFinanceAccounts.find(function (financeAccount) {
                    return (demandSubAccount === null || demandSubAccount === void 0 ? void 0 : demandSubAccount.accountUuid) === financeAccount.uuid;
                });
                return __assign(__assign({}, offer), { accountDisplayName: (_b = parentAccount === null || parentAccount === void 0 ? void 0 : parentAccount.name) !== null && _b !== void 0 ? _b : '', accountUuid: (_c = parentAccount === null || parentAccount === void 0 ? void 0 : parentAccount.uuid) !== null && _c !== void 0 ? _c : '' });
            })
            : [];
    }, [dataOffersQuery, dataDemandSubAccounts, dataAllFinanceAccounts])) !== null && _b !== void 0 ? _b : [];
    var isLoading = isLoadingOffersQuery || isLoadingSubAccountsQuery;
    var refetchAll = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, refetchOffersQuery()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, refetchAllFinanceAccounts()];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, refetchSubAccounts()];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var value = useMemo(function () { return ({ data: data, isLoading: isLoading, refetchAll: refetchAll }); }, [data, isLoading, refetchAll]);
    return (jsx(OfferCatalogContext.Provider, __assign({ value: value }, { children: children })));
};
/**
 * useOfferCatalogWithAccountData
 * @summary Hook that returns Offer Catalog Offers with account data included
 * This is meant to be a work-around solution until the BE response for "/ews/offer-catalog/offers" is updated to include account data and eventually a single touch point when those updates happen
 * @return {OfferCatalogOffer[]}
 */
var useOfferCatalogWithAccountData = function () {
    var context = useContext(OfferCatalogContext);
    if (!context) {
        throw new Error('useOfferCatalogWithAccountData must be used within an OfferCatalogProvider');
    }
    return context;
};

var removeEmptyFields = function (obj) {
    return omitBy(obj, function (value) { return value === undefined || value === '' || value === null; });
};

var toCreateProductOfferVariables = function (data) {
    var keywords = data.keywords.map(function (_a) {
        var value = _a.value;
        return value;
    });
    var tags = data.tags.reduce(function (accum, _a) {
        var key = _a.key, value = _a.value;
        accum[key] = value;
        return accum;
    }, {});
    var createData = __assign(__assign({}, omit(data, ['demandSubAccount', 'keywords', 'product', 'tags'])), { demandSubAccountUuid: data.demandSubAccount.uuid, keywords: keywords, tags: tags, unmonetizedUrl: data.unmonetizedUrl });
    var sanitizedCreateData = removeEmptyFields(createData);
    var variables = {
        createData: sanitizedCreateData,
        type: data.product.type,
    };
    return variables;
};

var PRODUCT_OFFER$1 = 'product offer';
var OfferCatalogOffersPage = function (props) {
    var canReadOfferCatalogOffers = props.canReadOfferCatalogOffers, canManageOfferCatalogOffers = props.canManageOfferCatalogOffers;
    var push = useRouter().push;
    var gridRef = useRef();
    var _a = useToggle(false), showCreateForm = _a[0], toggleCreateForm = _a[1];
    var createProductOfferMutation = useMutation(createOfferCatalogProductOffer);
    var _b = useOfferCatalogWithAccountData(), dataOffersQuery = _b.data, refetchAll = _b.refetchAll, isLoading = _b.isLoading;
    var handleCreateProductOffer = function (data) {
        var variables = toCreateProductOfferVariables(data);
        var options = {
            onFailure: function () {
                CrudToaster.createFailure(PRODUCT_OFFER$1);
            },
            onSettled: function () {
                toggleCreateForm();
            },
            onSuccess: function (data) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, refetchAll()];
                        case 1:
                            _a.sent();
                            push({
                                pathname: InternalRoutes.OfferCatalog.OffersDetail,
                                query: {
                                    productType: data.productType,
                                    productVersion: Math.max.apply(Math, data.productVersions),
                                    uuid: data.uuid,
                                    version: data.version,
                                },
                            });
                            CrudToaster.createSuccess(PRODUCT_OFFER$1);
                            return [2 /*return*/];
                    }
                });
            }); },
        };
        CrudToaster.createLoading(PRODUCT_OFFER$1);
        createProductOfferMutation.mutate(variables, options);
    };
    if (!canReadOfferCatalogOffers) {
        return null;
    }
    return (jsxs(TableLayout, __assign({ showClearAllButton: true, showExportButton: true, gridRef: gridRef, isLoading: isLoading || !dataOffersQuery, showCreateButton: canManageOfferCatalogOffers, title: "Offers", onCreate: toggleCreateForm }, { children: [jsx(OffersTable, { gridRef: gridRef, rowData: dataOffersQuery !== null && dataOffersQuery !== void 0 ? dataOffersQuery : [] }), jsx(OfferCreateFormDrawer, { isSubmitting: createProductOfferMutation.isLoading, visible: showCreateForm, onClose: toggleCreateForm, onSubmit: handleCreateProductOffer })] })));
};

var OfferCatalogHistoryTab = function (_a) {
    var product = _a.product;
    var maxVersion = product.maxVersion, minVersion = product.minVersion, type = product.type;
    var versions = Array.from({ length: maxVersion - minVersion + 1 }, function (_, i) { return i + minVersion; });
    var productVersionsQueries = queries.ews.offerCatalog.productVersions(type, versions);
    var jsonDisplayCards = productVersionsQueries.map(function (productVersionQuery, idx) {
        var data = productVersionQuery.data, isLoading = productVersionQuery.isLoading, isError = productVersionQuery.isError;
        var currentVersion = versions[idx];
        if (isLoading) {
            return jsx(LoadingState, {});
        }
        if (isError) {
            return jsx(ErrorState, {});
        }
        if (!data) {
            return jsx(NoData, {});
        }
        var schema = data.schema;
        return (jsx(CollapseCard, __assign({ isOpen: true, expandButtonLabel: "Schema" }, { children: jsx("div", { children: jsx(Field, __assign({ label: "Version v".concat(currentVersion), layout: FieldLayout.Vertical, postfix: jsx(PortalClipboard, { alterText: JSON.stringify(schema), text: 'Export', type: PortalClipboardType.TextIcon }) }, { children: jsx(JsonDisplayCard, { schema: schema }) })) }) }), "offer-catealog-history-tab-json-".concat(idx)));
    });
    return jsx(Fragment, { children: jsonDisplayCards });
};

var PRODUCT_OFFER = 'product offer';
var OfferCatalogOffersTab = function (props) {
    var canManageOfferCatalogOffers = props.canManageOfferCatalogOffers, productType = props.productType;
    var _a = useToggle(false), showCreateForm = _a[0], toggleCreateForm = _a[1];
    var push = useRouter().push;
    var createProductOfferMutation = useMutation(createOfferCatalogProductOffer);
    var _b = useOfferCatalogWithAccountData(), dataOffersQuery = _b.data, refetchAll = _b.refetchAll, isLoading = _b.isLoading;
    var handleCreateProductOffer = function (data) {
        var variables = toCreateProductOfferVariables(data);
        var options = {
            onFailure: function () {
                CrudToaster.createFailure(PRODUCT_OFFER);
            },
            onSettled: function () {
                toggleCreateForm();
            },
            onSuccess: function (data) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, refetchAll()];
                        case 1:
                            _a.sent();
                            push({
                                pathname: InternalRoutes.OfferCatalog.OffersDetail,
                                query: {
                                    productType: data.productType,
                                    productVersion: Math.max.apply(Math, data.productVersions),
                                    uuid: data.uuid,
                                    version: data.version,
                                },
                            });
                            CrudToaster.createSuccess(PRODUCT_OFFER);
                            return [2 /*return*/];
                    }
                });
            }); },
        };
        CrudToaster.createLoading(PRODUCT_OFFER);
        createProductOfferMutation.mutate(variables, options);
    };
    var renderHeaderContent = function () {
        return (jsx(EvenCreateNewButton, __assign({ onClick: toggleCreateForm }, { children: "Create" })));
    };
    return (jsxs(Fragment, { children: [jsx(RoundedCard, __assign({ headerContent: canManageOfferCatalogOffers && renderHeaderContent(), title: "Offers" }, { children: jsx(RoundedCard.Content, { children: isLoading ? (jsx(LoadingState, {})) : (jsx(OffersTable, { rowData: dataOffersQuery !== null && dataOffersQuery !== void 0 ? dataOffersQuery : [], showProductTypeColumn: false })) }) })), jsx(OfferCreateFormDrawer, { isSubmitting: createProductOfferMutation.isLoading, productType: productType, visible: showCreateForm, onClose: toggleCreateForm, onSubmit: handleCreateProductOffer })] }));
};

var formatTimestamp = function (timestamp) {
    return DateTime.fromJSDate(new Date(timestamp)).toFormat('MM.dd.yyyy');
};
var OfferCatalogSettingsTab = function (_a) {
    var canUpdateProductTypeSchema = _a.canUpdateProductTypeSchema, product = _a.product, productVersion = _a.productVersion;
    var keywords = product.keywords, maxVersion = product.maxVersion, maxVersionCreatedAt = product.maxVersionCreatedAt, minVersion = product.minVersion, minVersionCreatedAt = product.minVersionCreatedAt, tags = product.tags, type = product.type, uuid = product.uuid;
    var displayName = productVersion.displayName, schema = productVersion.schema;
    var _b = useToggle(false), showModifySchemaDrawer = _b[0], toggleModifySchemaDrawer = _b[1];
    var updateProductTypeMutation = useMutation(updateProduct, {
        onError: function () { return CrudToaster.updateFailure('product'); },
        onMutate: function () { return CrudToaster.updateLoading('product'); },
        onSuccess: function () { return CrudToaster.updateSuccess('product'); },
    });
    var handleUpdateKeywords = function (keywords) {
        if (keywords === void 0) { keywords = []; }
        var updateData = {
            displayName: displayName,
            keywords: keywords,
            schema: schema,
            tags: tags !== null && tags !== void 0 ? tags : {},
            type: type,
        };
        updateProductTypeMutation.mutate({
            currentVersion: maxVersion,
            type: type,
            updateData: updateData,
        });
    };
    var handleUpdateTags = function (tags) {
        var updateData = {
            displayName: displayName,
            keywords: keywords !== null && keywords !== void 0 ? keywords : [],
            schema: schema,
            tags: tags,
            type: type,
        };
        updateProductTypeMutation.mutate({
            currentVersion: maxVersion,
            type: type,
            updateData: updateData,
        });
    };
    return (jsxs(Fragment, { children: [jsx(RoundedCard, __assign({ title: "Details" }, { children: jsx(RoundedCard.Content, { children: jsxs("div", __assign({ className: "details-form left-align" }, { children: [jsx(Field, __assign({ label: "Product type display name", layout: FieldLayout.Vertical }, { children: jsx("input", { disabled: true, className: Classes.INPUT, defaultValue: displayName }) })), jsx(Field, __assign({ label: "Product UUID", layout: FieldLayout.Vertical }, { children: jsx("input", { disabled: true, className: Classes.INPUT, defaultValue: uuid }) })), jsx(Field, __assign({ label: "Product Type Key", layout: FieldLayout.Vertical }, { children: jsx("input", { disabled: true, className: Classes.INPUT, defaultValue: type }) })), jsx(Field, __assign({ label: "Created at", layout: FieldLayout.Vertical }, { children: jsx("input", { disabled: true, className: Classes.INPUT, defaultValue: formatTimestamp(minVersionCreatedAt) }) })), jsx(Field, __assign({ label: "Updated at", layout: FieldLayout.Vertical }, { children: jsx("input", { disabled: true, className: Classes.INPUT, defaultValue: formatTimestamp(maxVersionCreatedAt) }) })), jsx(Field, __assign({ label: "Latest Version", layout: FieldLayout.Vertical }, { children: jsx("input", { disabled: true, className: Classes.INPUT, defaultValue: maxVersion }) })), jsx(Field, __assign({ label: "Min Support Version", layout: FieldLayout.Vertical }, { children: jsx("input", { disabled: true, className: Classes.INPUT, defaultValue: minVersion }) }))] })) }) })), jsx(KeywordsCard, { existingKeywords: keywords !== null && keywords !== void 0 ? keywords : [], onSubmit: handleUpdateKeywords }), jsx(TagsCard, { existingTags: tags !== null && tags !== void 0 ? tags : {}, onSubmit: handleUpdateTags }), jsx(RoundedCard, __assign({ headerContent: jsx(EditButton, __assign({ disabled: !canUpdateProductTypeSchema, onClick: toggleModifySchemaDrawer }, { children: "Modify Schema" })), title: "Schema" }, { children: jsx(RoundedCard.Content, { children: jsx(Field, __assign({ label: "JSON", postfix: jsx(PortalClipboard, { alterText: JSON.stringify(schema), text: 'Copy', type: PortalClipboardType.TextIcon }) }, { children: jsx(JsonDisplayCard, { schema: schema }) })) }) })), jsx(ProductTypeModifySchemaDrawer, { existingProduct: product, existingSchema: schema, visible: showModifySchemaDrawer, onClose: toggleModifySchemaDrawer })] }));
};

var TabIds;
(function (TabIds) {
    TabIds["History"] = "history";
    TabIds["Offers"] = "offers";
    TabIds["Settings"] = "settings";
})(TabIds || (TabIds = {}));
var OfferCatalogProductTypesDetailsPage = function (props) {
    var _a = useState(TabIds.Settings), selectedTabId = _a[0], setSelectedTabId = _a[1];
    var canUpdateProductTypeSchema = props.canUpdateProductTypeSchema, canManageOfferCatalogOffers = props.canManageOfferCatalogOffers, product = props.product, productVersion = props.productVersion;
    var handleTabChange = function (newTabId) { return setSelectedTabId(newTabId); };
    return (jsxs(Fragment, { children: [jsx(DetailHeader, { className: "is-borderless title", title: "Product Type Details" }), jsxs(Tabs, __assign({ selectedTabId: selectedTabId, onChange: handleTabChange }, { children: [jsx(Tab, { id: TabIds.Settings, panel: jsx(OfferCatalogSettingsTab, { canUpdateProductTypeSchema: canUpdateProductTypeSchema, product: product, productVersion: productVersion }), title: "Settings" }), jsx(Tab, { id: TabIds.History, panel: jsx(OfferCatalogHistoryTab, { product: product }), title: "History" }), jsx(Tab, { id: TabIds.Offers, panel: jsx(OfferCatalogOffersTab, { canManageOfferCatalogOffers: canManageOfferCatalogOffers, productType: product.type }), title: "Offers" })] }))] }));
};

var displayNameCellRenderer = function (_a) {
    var value = _a.value, data = _a.data;
    return (jsx(Link, __assign({ href: "product-types/".concat(data.type, "/").concat(data.maxVersion) }, { children: value })));
};
var simpleCellRenderer = function (_a) {
    var value = _a.value;
    return value;
};
var versionCellRenderer = function (params) { return "v".concat(params.value); };
var OfferCatalogProductTypesPage = function (props) {
    var gridRef = useRef(null);
    var _a = useToggle(false), showCreateDrawer = _a[0], toggleCreateDrawer = _a[1];
    var productsQuery = useQuery(queries.ews.offerCatalog.products());
    var gridOptions = usePortalAgGridOptions({
        defaultColDef: {
            flex: 3,
        },
    });
    var columnDefs = useMemo(function () {
        var defs = [
            {
                cellRenderer: displayNameCellRenderer,
                field: 'displayName',
                filter: 'simpleTextFilter',
                headerName: 'Product Type Display Name',
            },
            {
                cellRenderer: simpleCellRenderer,
                field: 'type',
                filter: 'simpleTextFilter',
                headerName: 'Product Type Key',
            },
            {
                cellRenderer: simpleCellRenderer,
                field: 'uuid',
                filter: 'simpleTextFilter',
                headerName: 'Product UUID',
            },
            {
                cellRenderer: versionCellRenderer,
                field: 'minVersion',
                filter: 'agSetColumnFilter',
                headerName: 'Minimum supported Version',
            },
            {
                cellRenderer: versionCellRenderer,
                field: 'maxVersion',
                filter: 'agSetColumnFilter',
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Latest Version',
            },
            {
                cellRenderer: dateTimeShortCellRenderer,
                field: 'maxVersionCreatedAt',
                filter: 'dateRangeFilter',
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Created At',
                sort: 'desc',
            },
        ];
        return defs;
    }, []);
    var canManageOfferCatalogProductTypes = props.canManageOfferCatalogProductTypes, canReadOfferCatalogProductTypes = props.canReadOfferCatalogProductTypes, canUpdateProductTypeSchema = props.canUpdateProductTypeSchema;
    if (!canReadOfferCatalogProductTypes) {
        return null;
    }
    if (productsQuery.isError) {
        return jsx(ErrorState, {});
    }
    return (jsxs(Fragment, { children: [jsxs(HeaderWithActions, __assign({ className: "title", title: "Product Types Index Page" }, { children: [jsx(ExportCSVButton, { gridRef: gridRef }), jsx(ClearAllButton, { gridRef: gridRef }), canManageOfferCatalogProductTypes && canUpdateProductTypeSchema && (jsx(EvenCreateNewButton, __assign({ onClick: toggleCreateDrawer }, { children: "Create New" })))] })), jsx("div", __assign({ className: "ag-theme-alpine", style: { height: 600 } }, { children: jsx(AgGridReact, { ref: gridRef, pagination: true, className: "demand-inclusion-template-table", columnDefs: columnDefs, getRowId: function (_a) {
                        var data = _a.data;
                        return data.uuid;
                    }, gridOptions: gridOptions, paginationPageSize: 25, rowData: productsQuery.data }) })), jsx(ProductTypeCreateFormDrawer, { visible: showCreateDrawer, onClose: function () { return toggleCreateDrawer(false); }, onSubmitted: function () {
                    toggleCreateDrawer(false);
                    productsQuery.refetch();
                } })] }));
};

var actionsCellRenderer = function (props) {
    var data = props.data, onDelete = props.onDelete, onDuplicate = props.onDuplicate, onEdit = props.onEdit, canCreateOfferRules = props.canCreateOfferRules;
    if (!canCreateOfferRules) {
        return jsx(Fragment, {});
    }
    return (jsxs(ActionMenu, { children: [jsx(ActionMenu.Item, { preset: "edit", onClick: function () { return onEdit(data); } }), jsx(ActionMenu.Item, { preset: "duplicate", onClick: function () { return onDuplicate(data); } }), jsx(ActionMenu.Item, { preset: "delete", onClick: function () { return onDelete(data); } })] }));
};
var currencyRangeCellRenderer = function (_a) {
    var value = _a.value;
    if (!value) {
        return '';
    }
    var end = value.end, start = value.start;
    if (isNil(value.start) || isNil(value.end)) {
        return '';
    }
    var startCurrency = start.toLocaleString('en-US', {
        currency: 'USD',
        maximumFractionDigits: 0,
        style: 'currency',
    });
    var endCurrency = end.toLocaleString('en-US', {
        currency: 'USD',
        maximumFractionDigits: 0,
        style: 'currency',
    });
    return (jsxs(Fragment, { children: [jsx("span", { children: startCurrency }), " - ", jsx("span", { children: endCurrency })] }));
};
var onEditCellRenderer = function (props) {
    var onEdit = props.onEdit, data = props.data, value = props.value;
    return (jsx("a", __assign({ className: "clickable-edit", onClick: function () { return onEdit(data); }, onKeyDown: function (e) {
            if (e.key === 'Enter') {
                onEdit(data);
            }
        } }, { children: value })));
};
var tagCellRenderer = function (_a) {
    var enumType = _a.enumType, value = _a.value;
    var isAllSelected = enumType && (value === null || value === void 0 ? void 0 : value.length) === Object.keys(enumType).length;
    var tags = isAllSelected ? (jsx(Tag, { children: "All" }, "all-selected")) : (value === null || value === void 0 ? void 0 : value.map(function (tag) { return (jsx(Tag, __assign({ minimal: true }, { children: startCase(tag) }), tag)); }));
    return jsx("div", __assign({ className: "tag-container" }, { children: tags }));
};

var useOfferRuleTabColumnDefs = function (options, canCreateOfferRules // Temporary Feature Flag
) {
    var onDelete = options.onDelete, onDuplicate = options.onDuplicate, onEdit = options.onEdit, productType = options.productType;
    var showDepositAmount = productType === 'SavingsAccount';
    var colDefs = __spreadArray(__spreadArray([
        {
            cellRenderer: onEditCellRenderer,
            cellRendererParams: {
                onEdit: onEdit,
            },
            field: 'rootId',
            filter: 'agSetColumnFilter',
            headerName: 'ID',
            minWidth: 100,
        },
        {
            cellRenderer: currencyRangeCellRenderer,
            field: 'loanAmountRange',
            filter: 'agSetColumnFilter',
            filterValueGetter: function (params) {
                var _a;
                var range = (_a = params.data) === null || _a === void 0 ? void 0 : _a.loanAmountRange;
                return (range === null || range === void 0 ? void 0 : range.start) && (range === null || range === void 0 ? void 0 : range.end)
                    ? "".concat(range.start, " - ").concat(range.end)
                    : '';
            },
            headerName: 'Loan Amount Range',
            minWidth: 150,
        },
        {
            cellRenderer: currencyRangeCellRenderer,
            field: 'annualIncomeRange',
            filter: 'agSetColumnFilter',
            filterValueGetter: function (params) {
                var _a;
                var range = (_a = params.data) === null || _a === void 0 ? void 0 : _a.annualIncomeRange;
                return (range === null || range === void 0 ? void 0 : range.start) && (range === null || range === void 0 ? void 0 : range.end)
                    ? "".concat(range.start, " - ").concat(range.end)
                    : '';
            },
            headerName: 'Income Range',
            minWidth: 100,
        },
        {
            cellRenderer: tagCellRenderer,
            cellRendererParams: {
                enumType: 'CreditScore',
            },
            cellStyle: {
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
            },
            field: 'selfAssessedCreditScoreKeys',
            filter: 'agSetColumnFilter',
            headerName: 'Credit Scores',
            minWidth: 175,
        },
        {
            field: 'stateAbbreviations',
            filter: 'agSetColumnFilter',
            headerName: 'Number of States enabled',
            minWidth: 100,
            valueFormatter: function (params) {
                var _a;
                var states = params.value;
                return (_a = states === null || states === void 0 ? void 0 : states.length) !== null && _a !== void 0 ? _a : 0;
            },
        },
        {
            field: 'loanPurposeKeys',
            filter: 'agSetColumnFilter',
            headerName: 'Number of Loan Purposes',
            minWidth: 100,
            valueFormatter: function (params) {
                var _a;
                var purposes = params.value;
                return (_a = purposes === null || purposes === void 0 ? void 0 : purposes.length) !== null && _a !== void 0 ? _a : 0;
            },
        },
        {
            field: 'cardPurposes',
            filter: 'agSetColumnFilter',
            headerName: 'Number of Card Purposes',
            minWidth: 100,
            valueFormatter: function (params) {
                var _a;
                var purposes = params.value;
                return (_a = purposes === null || purposes === void 0 ? void 0 : purposes.length) !== null && _a !== void 0 ? _a : 0;
            },
        },
        {
            field: 'supplySubAccountIds',
            filter: 'agSetColumnFilter',
            headerName: 'Num of Supply Sub Acc enabled',
            minWidth: 100,
            valueFormatter: function (params) {
                var supplySubAccounts = params.value;
                return supplySubAccounts.length;
            },
        }
    ], (showDepositAmount
        ? [
            {
                field: 'minDepositAmount',
                hide: true,
            },
            {
                field: 'maxDepositAmount',
                hide: true,
            },
            {
                cellRenderer: currencyRangeCellRenderer,
                field: 'depositAmountRange',
                filter: 'agSetColumnFilter',
                filterValueGetter: function (params) {
                    var _a, _b;
                    var min = (_a = params.data) === null || _a === void 0 ? void 0 : _a.minDepositAmount;
                    var max = (_b = params.data) === null || _b === void 0 ? void 0 : _b.maxDepositAmount;
                    return { max: max, min: min };
                },
                headerName: 'Deposit Amount Range',
                minWidth: 150,
            },
        ]
        : []), true), [
        {
            cellRenderer: tagCellRenderer,
            cellRendererParams: {
                enumType: EmploymentStatus,
            },
            cellStyle: {
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
            },
            field: 'employmentStatuses',
            filter: 'agSetColumnFilter',
            headerName: 'Employment Status',
            minWidth: 175,
        },
        {
            cellRenderer: tagCellRenderer,
            cellRendererParams: {
                enumType: EmploymentPayFrequency,
            },
            cellStyle: {
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
            },
            field: 'payFrequencies',
            filter: 'agSetColumnFilter',
            headerName: 'Employment Pay Frequencies',
            minWidth: 175,
        },
        {
            field: 'createdByUuid',
            filter: 'agSetColumnFilter',
            headerName: 'Created By',
            minWidth: 150,
        },
        {
            cellRenderer: dateShortCellRenderer,
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            headerName: 'Created At',
            minWidth: 150,
        },
        {
            cellRenderer: function (_a) {
                var value = _a.value;
                return createElement(Truncate, { text: value });
            },
            field: 'memo',
            filter: 'agSetColumnFilter',
            headerName: 'Memo',
            minWidth: 150,
        },
        {
            cellRenderer: actionsCellRenderer,
            cellRendererParams: {
                canCreateOfferRules: canCreateOfferRules,
                onDelete: onDelete,
                onDuplicate: onDuplicate,
                onEdit: onEdit,
            },
            field: 'actionType',
            filter: 'agSetColumnFilter',
            filterParams: {
                suppressMiniFilter: true,
            },
            headerComponentParams: {
                filterIcon: FilterIcon.FILTER,
            },
            headerName: 'Action',
            minWidth: 120,
            type: ColumnDefs.TEXT,
        },
    ], false);
    return colDefs;
};
var useOfferRuleHistoryColumnDefs = function (options) {
    var onEdit = options.onEdit, productType = options.productType;
    var showDepositAmount = productType === 'SavingsAccount';
    var colDefs = __spreadArray(__spreadArray([
        {
            cellRenderer: onEditCellRenderer,
            cellRendererParams: {
                onEdit: onEdit,
            },
            field: 'id',
            filter: 'agSetColumnFilter',
            headerName: 'Version',
            minWidth: 100,
        },
        {
            cellRenderer: onEditCellRenderer,
            cellRendererParams: {
                onEdit: onEdit,
            },
            field: 'rootId',
            filter: 'agSetColumnFilter',
            headerName: 'ID',
            minWidth: 100,
        },
        {
            cellRenderer: currencyRangeCellRenderer,
            field: 'loanAmountRange',
            filter: 'agSetColumnFilter',
            headerName: 'Loan Amount Range',
            minWidth: 150,
        },
        {
            cellRenderer: currencyRangeCellRenderer,
            field: 'annualIncomeRange',
            filter: 'agSetColumnFilter',
            headerName: 'Income Range',
            minWidth: 150,
        },
        {
            cellRenderer: tagCellRenderer,
            cellRendererParams: {
                enumType: CreditScoreOptions,
            },
            cellStyle: {
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
            },
            field: 'selfAssessedCreditScoreKeys',
            filter: 'agSetColumnFilter',
            headerName: 'Credit Scores',
            minWidth: 175,
        },
        {
            field: 'stateAbbreviations',
            filter: 'agSetColumnFilter',
            headerName: 'Number of States enabled',
            minWidth: 100,
            valueFormatter: function (params) {
                var _a;
                var states = params.value;
                return (_a = states === null || states === void 0 ? void 0 : states.length) !== null && _a !== void 0 ? _a : 0;
            },
        },
        {
            field: 'loanPurposeKeys',
            filter: 'agSetColumnFilter',
            headerName: 'Number of Loan Purposes',
            minWidth: 100,
            valueFormatter: function (params) {
                var _a;
                var purposes = params.value;
                return (_a = purposes === null || purposes === void 0 ? void 0 : purposes.length) !== null && _a !== void 0 ? _a : 0;
            },
        },
        {
            field: 'cardPurposes',
            filter: 'agSetColumnFilter',
            headerName: 'Number of Card Purposes',
            minWidth: 100,
            valueFormatter: function (params) {
                var _a;
                var purposes = params.value;
                return (_a = purposes === null || purposes === void 0 ? void 0 : purposes.length) !== null && _a !== void 0 ? _a : 0;
            },
        },
        {
            field: 'supplySubAccountIds',
            filter: 'agSetColumnFilter',
            headerName: 'Num of Supply Sub Acc enabled',
            minWidth: 100,
            valueFormatter: function (params) {
                var supplySubAccounts = params.value;
                return supplySubAccounts.length;
            },
        }
    ], (showDepositAmount
        ? [
            {
                cellRenderer: currencyRangeCellRenderer,
                field: 'depositAmountRange',
                filter: 'agSetColumnFilter',
                headerName: 'Deposit Amount Range',
                minWidth: 150,
            },
        ]
        : []), true), [
        {
            cellRenderer: tagCellRenderer,
            cellRendererParams: {
                enumType: EmploymentStatus,
            },
            cellStyle: {
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
            },
            field: 'employmentStatuses',
            filter: 'agSetColumnFilter',
            headerName: 'Employment Status',
            minWidth: 175,
        },
        {
            cellRenderer: tagCellRenderer,
            cellRendererParams: {
                enumType: EmploymentPayFrequency,
            },
            cellStyle: {
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
            },
            field: 'payFrequencies',
            filter: 'agSetColumnFilter',
            headerName: 'Employment Pay Frequencies',
            minWidth: 175,
        },
        {
            field: 'createdByUuid',
            filter: 'agSetColumnFilter',
            headerName: 'Updated By',
            minWidth: 150,
            // cellRenderer: userCellRenderer // Need to query for user data
        },
        {
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            filterParams: { placeHolder: 'Search by Updated At Date' },
            headerName: 'Updated At',
            minWidth: 150,
            type: ColumnDefs.DATE_TIME,
            valueFormatter: function (params) {
                return params.value ? new Date(params.value).toLocaleString() : '';
            },
        },
    ], false);
    return colDefs;
};

var OfferRulesHistory = function (_a) {
    var offerRules = _a.offerRules, setOfferRuleToEdit = _a.setOfferRuleToEdit, toggleOfferRuleForm = _a.toggleOfferRuleForm, productType = _a.productType;
    var gridRef = useRef(null);
    useEffect(function () {
        var _a, _b;
        (_b = (_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.api) === null || _b === void 0 ? void 0 : _b.sizeColumnsToFit();
    }, [offerRules]);
    var gridOptions = usePortalAgGridOptions({
        defaultColDef: {
            flex: 3,
        },
    });
    var offerRuleHistoryColumnDefs = useOfferRuleHistoryColumnDefs({
        onEdit: function (offerRule) {
            setOfferRuleToEdit(offerRule);
            toggleOfferRuleForm();
        },
        productType: productType,
    });
    return (jsxs(Fragment, { children: [jsx(HeaderWithActions, { className: "subtitle" }), jsx("div", __assign({ className: "ag-theme-alpine" }, { children: jsx(AgGridReact, { ref: gridRef, pagination: true, columnDefs: offerRuleHistoryColumnDefs, getRowId: function (_a) {
                        var id = _a.data.id;
                        return id;
                    }, gridOptions: gridOptions, paginationPageSize: 25, rowData: offerRules }) }))] }));
};

var MultiSelectDropdown = function (_a) {
    var control = _a.control, itemType = _a.itemType, name = _a.name, _b = _a.labelFormatter, labelFormatter = _b === void 0 ? startCase$1 : _b;
    var items = Object.values(itemType);
    var label = labelFormatter(name);
    return (jsx(Controller, { control: control, name: name, render: function (_a) {
            var _b = _a.field, value = _b.value, onChange = _b.onChange;
            var isAllSelected = (value === null || value === void 0 ? void 0 : value.length) === items.length;
            return (jsx(Field, __assign({ label: label }, { children: jsx(MultiSelect, { itemRemoveFilter: function (item, targetItem) { return item !== targetItem; }, itemRenderer: function (item, props) { return (jsx(SelectItem, __assign({ text: startCase$1(item) }, props), item)); }, items: items, placeholder: 'All (Default)', selectedItems: isAllSelected ? [] : value, tagRenderer: function (item) { return startCase$1(item); }, onChange: onChange }) })));
        } }));
};

var requiredFields = ['ID', 'Name'];
var sampleCsvData = "\"ID\",\"Name\"\n\"1\",\"Sub Account Name 1\"\n\"2\",\"Sub Account Name 2\"\n\"3\",\"Sub Account Name 3\"";
var sanitizeString = function (str) {
    return str === null || str === void 0 ? void 0 : str.trim().replace(/^0+/, '').normalize().toLowerCase();
};
var UploadCsv = function (props) {
    var disabled = props.disabled, setSelectedItems = props.setSelectedItems, supplySubAccounts = props.supplySubAccounts;
    var _a = useSet(), csvErrorMsgs = _a[0], _b = _a[1], add = _b.add, reset = _b.reset;
    var handleCsvUpload = useCallback(function (data) {
        var file = data === null || data === void 0 ? void 0 : data[0];
        if (file && file.type === 'text/csv') {
            Papa.parse(file, {
                complete: function (results) {
                    reset();
                    var parsedData = results.data.map(function (result) { return ({
                        ID: result.ID,
                        Name: result.Name,
                    }); });
                    var parsedDataMap = new Map(parsedData.map(function (item) { return [Number(item.ID), item.Name]; }));
                    var subaccountMap = new Map(supplySubAccounts.map(function (subaccount) { return [subaccount.id, subaccount]; }));
                    var parsedSubaccountIds = Array.from(parsedDataMap.keys());
                    var firstRow = parsedData[0];
                    var missingColumns = requiredFields.filter(function (col) { return !(col in firstRow); });
                    if (missingColumns.length > 0) {
                        add("Missing columns: ".concat(missingColumns.join(', ')));
                    }
                    else {
                        var filteredSupplySubAccounts = parsedSubaccountIds
                            .filter(function (id) {
                            var _a;
                            return subaccountMap.has(id) &&
                                ((_a = subaccountMap.get(id)) === null || _a === void 0 ? void 0 : _a.name) === parsedDataMap.get(id);
                        })
                            .map(function (id) { return subaccountMap.get(id); });
                        var missingIds = parsedSubaccountIds.filter(function (id) { return !subaccountMap.has(id); });
                        if (missingIds.length > 0) {
                            add("Invalid IDs: ".concat(missingIds.join(', ')));
                        }
                        var mismatchedIds = parsedSubaccountIds.filter(function (id) {
                            var _a;
                            return subaccountMap.has(id) &&
                                sanitizeString((_a = subaccountMap.get(id)) === null || _a === void 0 ? void 0 : _a.name) !==
                                    sanitizeString(parsedDataMap.get(id));
                        });
                        if (mismatchedIds.length > 0) {
                            add("Mismatched ID with Name: ".concat(mismatchedIds.join(', ')));
                        }
                        setSelectedItems(filteredSupplySubAccounts);
                    }
                },
                dynamicTyping: false,
                error: function (error) {
                    add("Error parsing CSV:, ".concat(error.message));
                },
                header: true,
                skipEmptyLines: true,
            });
        }
        else {
            add('Invalid file type. Please upload a CSV file.');
        }
    }, []);
    return (jsxs("div", __assign({ className: "upload-container" }, { children: [jsx("div", __assign({ className: "or-container" }, { children: "OR" })), jsx(Upload, { disabled: disabled, handleChange: handleCsvUpload, large: false, multiple: false, tooltip: "Upload a CSV file with list of supply sub accounts that you want to enable for the offer rule. The CSV should include the supply sub account ID (ID) and sub account name (Name) columns." }), disabled && (jsx("div", __assign({ className: "info-message" }, { children: "Clear Sub Account dropdown to use CSV upload" }))), jsxs("div", { children: ["Download", ' ', jsx("a", __assign({ download: "sample.csv", href: "data:text/csv;charset=utf-8,".concat(encodeURIComponent(sampleCsvData)) }, { children: "sample CSV" }))] }), jsx("div", { children: csvErrorMsgs.size > 0 && (jsx("div", __assign({ className: "error-message-container" }, { children: Array.from(csvErrorMsgs).map(function (msg, index) { return (jsx("div", __assign({ className: "error-message" }, { children: msg }), "csv-error-".concat(index))); }) }))) })] })));
};

var SupplySubAccountMultiSelect = function (_a) {
    var control = _a.control, supplySubAccounts = _a.supplySubAccounts;
    var name = 'sourceSupplySubAccounts';
    var label = startCase(name);
    return (jsx(Controller, { control: control, name: name, render: function (_a) {
            var _b = _a.field, value = _b.value, onChange = _b.onChange;
            return (jsxs(Field, __assign({ label: label }, { children: [jsx(SubAccountMultiSelect, { showOnlySupplySubAccounts: true, placeholder: "None", selectedItems: value, subAccounts: supplySubAccounts, onChange: onChange }), jsx(UploadCsv, { disabled: (value === null || value === void 0 ? void 0 : value.length) > 0, setSelectedItems: onChange, supplySubAccounts: supplySubAccounts })] })));
        } }));
};

var toOfferRuleFormData = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var maxAnnualAmount = (_c = (_b = (_a = data.annualIncomeRange) === null || _a === void 0 ? void 0 : _a.end) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '';
    var minAnnualAmount = (_f = (_e = (_d = data.annualIncomeRange) === null || _d === void 0 ? void 0 : _d.start) === null || _e === void 0 ? void 0 : _e.toString()) !== null && _f !== void 0 ? _f : '';
    var maxLoanAmount = (_j = (_h = (_g = data.loanAmountRange) === null || _g === void 0 ? void 0 : _g.end) === null || _h === void 0 ? void 0 : _h.toString()) !== null && _j !== void 0 ? _j : '';
    var minLoanAmount = (_m = (_l = (_k = data.loanAmountRange) === null || _k === void 0 ? void 0 : _k.start) === null || _l === void 0 ? void 0 : _l.toString()) !== null && _m !== void 0 ? _m : '';
    var offerRuleRequestBody = {
        creditScore: data.selfAssessedCreditScoreKeys,
        employmentPayFrequency: data.payFrequencies,
        employmentStatus: data.employmentStatuses,
        loanAmountRange: data.loanAmountRange,
        loanPurposes: data.loanPurposeKeys,
        maxAnnualAmount: maxAnnualAmount,
        maxLoanAmount: maxLoanAmount,
        memo: (_o = data.memo) !== null && _o !== void 0 ? _o : '',
        militaryStatus: data.militaryStatusKeys,
        minAnnualAmount: minAnnualAmount,
        minLoanAmount: minLoanAmount,
        sourceSupplySubAccounts: data.supplySubAccountIds,
        usStates: (_p = data.stateAbbreviations) === null || _p === void 0 ? void 0 : _p.map(function (usState) { return UsStatesEnum[usState]; }),
    };
    return offerRuleRequestBody;
};

var validateLoanAmountFields = function (min, max) {
    return validateAmountFields(min, max, 'Loan Amount');
};
var validateAnnualAmountFields = function (min, max) {
    return validateAmountFields(min, max, 'Annual Income');
};
var validateAmountFields = function (min, max, fieldName) {
    var minAmount = parseFloat(min);
    var maxAmount = parseFloat(max);
    var isMinValid = !isNaN(minAmount);
    var isMaxValid = !isNaN(maxAmount);
    if ((isMinValid && !isMaxValid) || (!isMinValid && isMaxValid)) {
        return "Both Min and Max ".concat(fieldName, " should have a value or be blank.");
    }
    if (isMinValid && isMaxValid) {
        if (maxAmount <= minAmount) {
            return "Max ".concat(fieldName, " should be greater than Min ").concat(fieldName, ".");
        }
        if (minAmount < 0 || maxAmount < 0) {
            return "Both Min and Max ".concat(fieldName, " should be positive values.");
        }
        if (minAmount < -2147483648 || maxAmount > 2147483647) {
            return "".concat(fieldName, " values should be within PostgreSQL INTEGER range (-2,147,483,648 to 2,147,483,647).");
        }
    }
    return true;
};

var defaultValues = {
    creditScore: [],
    employmentPayFrequency: [],
    employmentStatus: [],
    loanPurposes: [],
    maxAnnualAmount: '',
    maxLoanAmount: '',
    memo: '',
    militaryStatus: [],
    minAnnualAmount: '',
    minLoanAmount: '',
    sourceSupplySubAccounts: [],
    usStates: [],
};
var OfferRuleCreateFormDrawer = function (props) {
    var visible = props.visible, isSubmitting = props.isSubmitting, offer = props.offer, offerRuleToDuplicate = props.offerRuleToDuplicate, offerRuleToEdit = props.offerRuleToEdit, supplySubAccounts = props.supplySubAccounts, onClose = props.onClose, onCreate = props.onCreate, onUpdate = props.onUpdate;
    var form = useForm();
    var control = form.control, handleSubmit = form.handleSubmit, watch = form.watch, reset = form.reset;
    var minLoanAmount = watch('minLoanAmount');
    var maxLoanAmount = watch('maxLoanAmount');
    var minAnnualAmount = watch('minAnnualAmount');
    var maxAnnualAmount = watch('maxAnnualAmount');
    var title = offerRuleToEdit ? 'Update Offer Rule' : 'New Offer Rule';
    var handleCreateOrUpdate = function (data) {
        if (offerRuleToEdit) {
            onUpdate(data);
        }
        else {
            onCreate(data);
        }
    };
    useUpdateEffect(function () {
        if (offerRuleToEdit) {
            reset(toOfferRuleFormData(offerRuleToEdit));
        }
        else if (offerRuleToDuplicate) {
            reset(toOfferRuleFormData(offerRuleToDuplicate));
        }
        else {
            reset(defaultValues);
        }
    }, [offerRuleToDuplicate, offerRuleToEdit]);
    return (jsxs(DrawerForm, __assign({ disableCloseOnMouseDown: true, isSubmitting: isSubmitting, title: title, visible: visible, onClose: onClose, onSubmit: handleSubmit(handleCreateOrUpdate) }, { children: [jsx(StringField, { disabled: true, control: control, defaultValue: offer.uuid, label: 'Offer UUID', name: 'offerUuid' }), jsx(StringField, { disabled: true, control: control, defaultValue: offer.demandSubAccountDisplayName, label: 'Demand Sub Account', name: 'demandSubAccountName' }), jsx(SupplySubAccountMultiSelect, { control: control, supplySubAccounts: supplySubAccounts !== null && supplySubAccounts !== void 0 ? supplySubAccounts : [] }), jsx(MultiSelectDropdown, { control: control, itemType: UsStatesEnum, labelFormatter: function () { return 'US States'; }, name: 'usStates' }), jsx(StringField, { control: control, label: 'Memo', name: 'memo' }), jsx(MoneyField, { control: control, label: 'Min Loan Amount', name: 'minLoanAmount', rules: {
                    validate: function (value) { return validateLoanAmountFields(value, maxLoanAmount); },
                } }), jsx(MoneyField, { control: control, label: 'Max Loan Amount', name: 'maxLoanAmount', rules: {
                    validate: function (value) { return validateLoanAmountFields(minLoanAmount, value); },
                } }), jsx(MoneyField, { control: control, label: 'Min Annual Income', name: 'minAnnualAmount', rules: {
                    validate: function (value) {
                        return validateAnnualAmountFields(value, maxAnnualAmount);
                    },
                } }), jsx(MoneyField, { control: control, label: 'Max Annual Income', name: 'maxAnnualAmount', rules: {
                    validate: function (value) {
                        return validateAnnualAmountFields(minAnnualAmount, value);
                    },
                } }), jsx(MultiSelectDropdown, { control: control, itemType: LoanPurpose, name: 'loanPurposes' }), jsx(MultiSelectDropdown, { control: control, itemType: ProvidedCreditRating, name: 'creditScore' }), jsx(MultiSelectDropdown, { control: control, itemType: MilitaryStatus, name: 'militaryStatus' }), jsx(MultiSelectDropdown, { control: control, itemType: EmploymentStatus, name: 'employmentStatus' }), jsx(MultiSelectDropdown, { control: control, itemType: EmploymentPayFrequency, name: 'employmentPayFrequency' })] })));
};

var getOfferRuleWriteRequestBody = function (offer, data) {
    var _a;
    var offerUuid = offer.uuid, demandSubAccountUuid = offer.demandSubAccountUuid;
    var creditScore = data.creditScore, employmentPayFrequency = data.employmentPayFrequency, employmentStatus = data.employmentStatus, loanPurposes = data.loanPurposes, maxAnnualAmount = data.maxAnnualAmount, maxLoanAmount = data.maxLoanAmount, memo = data.memo, militaryStatus = data.militaryStatus, minAnnualAmount = data.minAnnualAmount, minLoanAmount = data.minLoanAmount, sourceSupplySubAccounts = data.sourceSupplySubAccounts, usStates = data.usStates;
    var loanAmountRange = minLoanAmount && maxLoanAmount
        ? {
            end: parseInt(maxLoanAmount, 10),
            start: parseInt(minLoanAmount, 10),
        }
        : undefined;
    var loanPurposeKeys = (loanPurposes === null || loanPurposes === void 0 ? void 0 : loanPurposes.length)
        ? Object.values(loanPurposes)
        : Object.values(LoanPurpose);
    var selfAssessedCreditScoreKeys = (creditScore === null || creditScore === void 0 ? void 0 : creditScore.length)
        ? Object.values(creditScore)
        : Object.values(ProvidedCreditRating);
    var annualIncomeRange = maxAnnualAmount && minAnnualAmount
        ? {
            end: parseInt(maxAnnualAmount, 10),
            start: parseInt(minAnnualAmount, 10),
        }
        : undefined;
    var supplySubAccountIds = (_a = sourceSupplySubAccounts === null || sourceSupplySubAccounts === void 0 ? void 0 : sourceSupplySubAccounts.map(function (subaccount) { return subaccount.id; })) !== null && _a !== void 0 ? _a : [];
    var stateAbbreviations = (usStates === null || usStates === void 0 ? void 0 : usStates.length)
        ? usStates.map(function (usState) { return stateNameToAbbreviation[usState]; })
        : Object.keys(UsStatesEnum);
    var militaryStatusKeys = (militaryStatus === null || militaryStatus === void 0 ? void 0 : militaryStatus.length)
        ? militaryStatus
        : Object.values(MilitaryStatus);
    var employmentStatusKeys = (employmentStatus === null || employmentStatus === void 0 ? void 0 : employmentStatus.length)
        ? employmentStatus
        : Object.values(EmploymentStatus);
    var payFrequencyKeys = (employmentPayFrequency === null || employmentPayFrequency === void 0 ? void 0 : employmentPayFrequency.length)
        ? employmentPayFrequency
        : Object.values(EmploymentPayFrequency);
    var offerRuleWriteData = {
        annualIncomeRange: annualIncomeRange,
        demandSubAccountUuid: demandSubAccountUuid,
        employmentStatusKeys: employmentStatusKeys,
        loanAmountRange: loanAmountRange,
        loanPurposeKeys: loanPurposeKeys,
        memo: memo,
        militaryStatusKeys: militaryStatusKeys,
        offerUuid: offerUuid,
        payFrequencyKeys: payFrequencyKeys,
        selfAssessedCreditScoreKeys: selfAssessedCreditScoreKeys,
        stateAbbreviations: stateAbbreviations,
        supplySubAccountIds: supplySubAccountIds,
    };
    return offerRuleWriteData;
};

var OfferRuleToaster = createCrudToaster('offer rule');
var OfferRulesTable = function (_a) {
    var offer = _a.offer, offerRuleToEdit = _a.offerRuleToEdit, offerRules = _a.offerRules, setOfferRuleToEdit = _a.setOfferRuleToEdit, showOfferRuleForm = _a.showOfferRuleForm, supplySubAccounts = _a.supplySubAccounts, toggleOfferRuleForm = _a.toggleOfferRuleForm, canCreateOfferRules = _a.canCreateOfferRules;
    var gridRef = useRef(null);
    var queryClient = useQueryClient();
    var _b = useState(), offerRuleToDuplicate = _b[0], setOfferRuleToDuplicate = _b[1];
    var _c = useState(), offerRuleToDelete = _c[0], setOfferRuleToDelete = _c[1];
    var _d = useToggle(false), showDeleteConfirmation = _d[0], toggleShowDeleteConfirmation = _d[1];
    var gridOptions = usePortalAgGridOptions({
        defaultColDef: {
            flex: 3,
        },
    });
    var offerRuleTabColumnDefs = useOfferRuleTabColumnDefs({
        onDelete: function (offerRule) {
            setOfferRuleToDelete(offerRule);
            toggleShowDeleteConfirmation();
        },
        onDuplicate: function (offerRule) {
            setOfferRuleToDuplicate(offerRule);
            toggleOfferRuleForm(false);
        },
        onEdit: function (offerRule) {
            setOfferRuleToEdit(offerRule);
            toggleOfferRuleForm(false);
        },
        productType: offer.productType,
    }, canCreateOfferRules);
    var createOfferRuleMutation = useMutation(createOfferRule, {
        onError: function () {
            OfferRuleToaster.createFailure();
        },
        onMutate: function () {
            OfferRuleToaster.createLoading();
        },
        onSuccess: function () {
            OfferRuleToaster.createSuccess();
            toggleOfferRuleForm(false);
            queryClient.refetchQueries('originatorStaticOffersWithRules');
        },
    });
    var updateOfferRuleMutation = useMutation(updateOfferRule, {
        onError: function () {
            OfferRuleToaster.updateFailure();
        },
        onMutate: function () {
            OfferRuleToaster.updateLoading();
        },
        onSuccess: function () {
            OfferRuleToaster.updateSuccess();
            toggleOfferRuleForm(false);
            queryClient.refetchQueries('originatorStaticOffersWithRules');
        },
    });
    var deleteOfferRuleMutation = useMutation(deleteOfferRule, {
        onError: function () {
            OfferRuleToaster.deleteFailure();
        },
        onMutate: function () {
            OfferRuleToaster.deleteLoading();
        },
        onSuccess: function () {
            OfferRuleToaster.deleteSuccess();
            toggleShowDeleteConfirmation();
            queryClient.refetchQueries('originatorStaticOffersWithRules');
        },
    });
    var handleCreateOfferRule = function (data) {
        var offerRuleWriteData = getOfferRuleWriteRequestBody(offer, data);
        createOfferRuleMutation.mutate({ offerRuleWriteData: offerRuleWriteData });
    };
    var handleUpdateOfferRule = function (data) {
        var rootId = offerRuleToEdit === null || offerRuleToEdit === void 0 ? void 0 : offerRuleToEdit.rootId;
        var updateData = getOfferRuleWriteRequestBody(offer, data);
        if (!rootId) {
            return OfferRuleToaster.updateFailure();
        }
        updateOfferRuleMutation.mutate({ rootId: rootId, updateData: updateData });
    };
    var handleDeleteOfferRule = function (data) {
        var rootId = data.rootId;
        deleteOfferRuleMutation.mutate({ rootId: rootId });
    };
    var handleClose = function () {
        toggleOfferRuleForm(false);
        setOfferRuleToDuplicate(undefined);
        setOfferRuleToEdit(undefined);
    };
    return (jsxs(Fragment, { children: [jsx("div", __assign({ className: "ag-theme-alpine" }, { children: jsx(AgGridReact, { ref: gridRef, columnDefs: offerRuleTabColumnDefs, getRowId: function (_a) {
                        var id = _a.data.id;
                        return id;
                    }, gridOptions: gridOptions, rowData: offerRules }) })), jsx(OfferRuleCreateFormDrawer, { isSubmitting: createOfferRuleMutation.isLoading || updateOfferRuleMutation.isLoading, offer: offer, offerRuleToDuplicate: offerRuleToDuplicate, offerRuleToEdit: offerRuleToEdit, supplySubAccounts: supplySubAccounts, visible: showOfferRuleForm, onClose: handleClose, onCreate: handleCreateOfferRule, onUpdate: handleUpdateOfferRule }), jsx(EvenDialog, { cancelText: "No - Dont delete the offer rule", message: "Deleting the offer rule means you are removing the criteria that was set for when the offer should be shown to a lead. Are you sure you want to delete the offer rule?", okText: "Yes - Delete the offer rule", visible: showDeleteConfirmation, onCancel: toggleShowDeleteConfirmation, onOk: function () {
                    return offerRuleToDelete && handleDeleteOfferRule(offerRuleToDelete);
                } })] }));
};

var OfferRulesTab = function (_a) {
    var _b;
    var canCreateOfferRules = _a.canCreateOfferRules, offerCatalog = _a.offerCatalog, offerRules = _a.offerRules, originatorOffer = _a.originatorOffer, supplySubAccounts = _a.supplySubAccounts;
    var _c = useToggle(false), showOfferRuleForm = _c[0], toggleOfferRuleForm = _c[1];
    var _d = useState(), offerRuleToEdit = _d[0], setOfferRuleToEdit = _d[1];
    var activeOfferRules = (_b = originatorOffer === null || originatorOffer === void 0 ? void 0 : originatorOffer.offerRules) !== null && _b !== void 0 ? _b : [];
    var activeOfferRuleIdsSet = useMemo(function () { return new Set(activeOfferRules === null || activeOfferRules === void 0 ? void 0 : activeOfferRules.map(function (_a) {
        var rootId = _a.rootId;
        return rootId;
    })); }, [activeOfferRules]);
    var inactiveOfferRules = useMemo(function () { return offerRules.filter(function (_a) {
        var deletedAt = _a.deletedAt;
        return deletedAt;
    }); }, [offerRules]);
    var historicalActiveOfferRules = useMemo(function () {
        return inactiveOfferRules.filter(function (_a) {
            var rootId = _a.rootId;
            return activeOfferRuleIdsSet.has(rootId);
        });
    }, [activeOfferRuleIdsSet, inactiveOfferRules]);
    var deactivatedOfferRules = useMemo(function () {
        return inactiveOfferRules.filter(function (_a) {
            var rootId = _a.rootId;
            return !activeOfferRuleIdsSet.has(rootId);
        });
    }, [activeOfferRuleIdsSet, inactiveOfferRules]);
    if (!originatorOffer) {
        return (jsx(RoundedCard, __assign({ title: "Offer Rules" }, { children: jsx(RoundedCard.Content, { children: jsx(NoData, { description: "This Offer Catalog does not have an associated Originator Static Offer. If this Offer Catalog was created recently please try again later." }) }) })));
    }
    // TODO: offerCatalog will need to provide a Date field to ensure the sync transaction was successful
    // if (originatorOffer.createdAt < new Date(offerCatalog.updatedAt)) {
    //   return (
    //     <RoundedCard title="Offer Rules">
    //       <RoundedCard.Content>
    //         <NoData description="The Offer Catalog was recently updated and the Offer Rules are still syncing changes." />
    //       </RoundedCard.Content>
    //     </RoundedCard>
    //   );
    // }
    return (jsxs(Fragment, { children: [jsx(RoundedCard, __assign({ headerContent: jsx(EvenCreateNewButton, __assign({ disabled: !canCreateOfferRules, onClick: function () {
                        return toggleOfferRuleForm(canCreateOfferRules ? undefined : false);
                    } }, { children: "Create New" })), title: "Offer Rules" }, { children: jsx(RoundedCard.Content, { children: jsx(OfferRulesTable, { canCreateOfferRules: canCreateOfferRules, offer: offerCatalog, offerRuleToEdit: offerRuleToEdit, offerRules: activeOfferRules, setOfferRuleToEdit: setOfferRuleToEdit, showOfferRuleForm: showOfferRuleForm, supplySubAccounts: supplySubAccounts, toggleOfferRuleForm: function () {
                            return toggleOfferRuleForm(canCreateOfferRules ? undefined : false);
                        } }) }) })), jsx(RoundedCard, __assign({ title: "History" }, { children: jsx(RoundedCard.Content, { children: jsx(OfferRulesHistory, { offerRules: historicalActiveOfferRules, productType: offerCatalog.productType, setOfferRuleToEdit: setOfferRuleToEdit, toggleOfferRuleForm: function () {
                            return toggleOfferRuleForm(canCreateOfferRules ? undefined : false);
                        } }) }) })), jsx(RoundedCard, __assign({ title: "Deleted Offer Rules" }, { children: jsx(RoundedCard.Content, { children: jsx(OfferRulesHistory, { offerRules: deactivatedOfferRules, productType: offerCatalog.productType, setOfferRuleToEdit: setOfferRuleToEdit, toggleOfferRuleForm: function () {
                            return toggleOfferRuleForm(canCreateOfferRules ? undefined : false);
                        } }) }) }))] }));
};

var OfferVersionsTab = function (_a) {
    var offer = _a.offer;
    var uuid = offer.uuid, productType = offer.productType;
    var offerVersions = Array(offer.currentVersion)
        .fill('')
        .map(function (_, index) { return index + 1; });
    var productVersion = Math.max.apply(Math, offer.productVersions);
    return (jsx(RoundedCard, __assign({ title: "Versions" }, { children: jsx(RoundedCard.Content, { children: offerVersions.map(function (version) { return (jsx("div", __assign({ className: "offer-version" }, { children: jsx(Link, __assign({ href: "/offers/".concat(uuid, "/").concat(version, "?productVersion=").concat(productVersion, "&productType=").concat(productType) }, { children: jsxs("a", __assign({ target: "_blank" }, { children: [window.location.origin, "/", uuid, "/", version] })) })) }), version)); }) }) })));
};

var safeEncodeURIComponent = function (inputValue) {
    try {
        var decodedUrl = safeDecodeURIComponent(inputValue);
        var url_1 = new URL(decodedUrl);
        url_1.searchParams.forEach(function (value, key) {
            url_1.searchParams.set(key, safeDecodeURIComponent(encodeURIComponent(value)));
        });
        return decodedUrl;
    }
    catch (error) {
        console.error('Encoding Invalid URL:', error);
        return undefined;
    }
};
var safeDecodeURIComponent = function (inputValue) {
    if (!inputValue) {
        return '';
    }
    try {
        return decodeURIComponent(inputValue);
    }
    catch (error) {
        console.error('Decoding URL error:', error);
        return inputValue;
    }
};

var getOfferFields = function (offer, currentProductVersion, writeProductVersion) {
    var _a, _b;
    if (!writeProductVersion) {
        return { editableFields: [], legacyFields: [], readOnlyFields: [] };
    }
    var excludedFields = new Set([
        'createdAt',
        'demandSubAccountName',
        'demandSubAccountDisplayName',
        'demandSubAccountImageUrl',
        'demandSubAccountUuid',
        'monetizedUrl',
        'productType',
        'unmonetizedUrl',
        'updatedAt',
        'tags',
        'keywords',
        'version',
        'uuid',
    ]);
    var readOnlyFieldsSet = new Map();
    var legacyFieldsSet = new Map();
    var editableFieldsSet = new Map();
    var legacyFieldsRecord = getLegacyFields((_a = writeProductVersion === null || writeProductVersion === void 0 ? void 0 : writeProductVersion.schema.properties) !== null && _a !== void 0 ? _a : {}, (_b = currentProductVersion === null || currentProductVersion === void 0 ? void 0 : currentProductVersion.schema.properties) !== null && _b !== void 0 ? _b : {});
    Object.entries(writeProductVersion.schema.properties).forEach(function (_a) {
        var key = _a[0], property = _a[1];
        if (excludedFields.has(key)) {
            return;
        }
        if (legacyFieldsRecord[key]) {
            legacyFieldsSet.set(key, property);
        }
        else if (property.readOnly) {
            readOnlyFieldsSet.set(key, property);
        }
        else {
            editableFieldsSet.set(key, property);
        }
    });
    var readOnlyFields = Array.from(readOnlyFieldsSet)
        .map(function (_a) {
        var key = _a[0], property = _a[1];
        return ({
            key: key,
            property: property,
            value: offer[key],
        });
    })
        .sort(function (a, b) { return a.key.localeCompare(b.key); });
    var editableFields = Array.from(editableFieldsSet)
        .map(function (_a) {
        var key = _a[0], property = _a[1];
        return ({
            key: key,
            property: property,
            value: offer[key],
        });
    })
        .sort(function (a, b) { return a.key.localeCompare(b.key); });
    var legacyFields = Array.from(legacyFieldsSet)
        .map(function (_a) {
        var key = _a[0], property = _a[1];
        return ({
            key: key,
            property: property,
            value: offer[key],
        });
    })
        .sort(function (a, b) { return a.key.localeCompare(b.key); });
    return { editableFields: editableFields, legacyFields: legacyFields, readOnlyFields: readOnlyFields };
};
var omitReadOnlyFields = function (offer, productVersion) {
    var knownReadOnlyArr = ['currentVersion', 'demandSubAccountName'];
    var readOnlyArr = Object.entries(productVersion.schema.properties)
        .filter(function (_a) {
        var readOnly = _a[1].readOnly;
        return readOnly;
    })
        .map(function (_a) {
        var key = _a[0];
        return key;
    });
    return omit(offer, __spreadArray(__spreadArray([], knownReadOnlyArr, true), readOnlyArr, true));
};
var isRecordType = function (value) {
    return typeof value === 'object' && !Array.isArray(value) && value !== null;
};
var getLegacyFields = function (writeProductPropertyRecord, maxProductPropertyRecord) {
    var missingKeys = {};
    var findMissingKeys = function (writeObject, maxObject) {
        Object.keys(writeObject).forEach(function (key) {
            if (!has(maxObject, key)) {
                missingKeys[key] = writeObject[key];
            }
            else if (isRecordType(writeObject[key])) {
                findMissingKeys(writeObject[key], maxObject[key]);
            }
        });
    };
    findMissingKeys(writeProductPropertyRecord, maxProductPropertyRecord);
    return missingKeys;
};

var layout = FieldLayout.Horizontal;
var DetailsCard = function (props) {
    var form = useForm();
    var offer = props.offer, onSubmit = props.onSubmit;
    var handleSubmit = form.handleSubmit, setValue = form.setValue;
    var productVersionQuery = useQuery(queries.ews.offerCatalog.productVersion({
        type: offer.productType,
        version: 'write',
    }));
    var currentProductVersionQuery = useQuery(queries.ews.offerCatalog.productVersion({
        type: offer.productType,
        version: Math.max.apply(Math, offer.productVersions),
    }));
    var writeProductVersion = productVersionQuery.data;
    var currentProductVersion = currentProductVersionQuery.data;
    var _a = useMemo(function () { return getOfferFields(offer, currentProductVersion, writeProductVersion); }, [
        offer.uuid,
        offer.version,
        currentProductVersion === null || currentProductVersion === void 0 ? void 0 : currentProductVersion.type,
        currentProductVersion === null || currentProductVersion === void 0 ? void 0 : currentProductVersion.versions,
        writeProductVersion === null || writeProductVersion === void 0 ? void 0 : writeProductVersion.type,
        writeProductVersion === null || writeProductVersion === void 0 ? void 0 : writeProductVersion.versions,
    ]), readOnlyFields = _a.readOnlyFields, editableFields = _a.editableFields, legacyFields = _a.legacyFields;
    useEffect(function () {
        editableFields.forEach(function (_a) {
            var key = _a.key;
            setValue(key, offer[key]);
        });
    }, [editableFields]);
    return (jsxs(RoundedCard, __assign({ title: "Details" }, { children: [jsxs(RoundedCard.Content, { children: [jsx(Field, __assign({ label: "Product Type", layout: layout }, { children: jsx(Input, { disabled: true, value: offer.productType }) })), jsx(Field, __assign({ label: "Demand Sub Account Display Name", layout: layout }, { children: jsx(Input, { disabled: true, value: offer.demandSubAccountDisplayName }) })), jsx(Field, __assign({ label: "Demand Sub Account Image URL", layout: layout }, { children: jsx(Input, { disabled: true, value: offer.demandSubAccountImageUrl }) })), readOnlyFields.map(function (_a) {
                        var key = _a.key, value = _a.value;
                        return (jsx(Field, __assign({ label: startCase(key), layout: layout }, { children: jsx(Input, { disabled: true, value: value !== null && value !== void 0 ? value : '' }) }), key));
                    }), jsx(FormProvider, __assign({}, form, { children: editableFields.map(function (_a) {
                            var key = _a.key, property = _a.property;
                            return (jsx(OfferPropertyHandler, { layout: layout, property: property, propertyKey: key, requiredProperties: new Set() }, key));
                        }) })), jsx(FormProvider, __assign({}, form, { children: legacyFields.map(function (_a) {
                            var key = _a.key, value = _a.value;
                            return (jsx(Field, __assign({ label: startCase(key), layout: layout, show: false }, { children: jsx(Input, { disabled: true, value: value !== null && value !== void 0 ? value : '' }) }), key));
                        }) }))] }), jsx(RoundedCard.Footer, { showSaveChangesButton: true, onSaveChanges: handleSubmit(onSubmit) })] })));
};

var UrlsCard = function (_a) {
    var _b, _c, _d;
    var offer = _a.offer, onSubmit = _a.onSubmit, readOnly = _a.readOnly;
    var _e = useForm(), control = _e.control, handleSubmit = _e.handleSubmit, reset = _e.reset;
    useEffect(function () {
        if (offer) {
            reset({
                monetizedUrl: offer.monetizedUrl,
                unmonetizedUrl: offer.unmonetizedUrl,
            });
        }
    }, [offer]);
    var productVersionQuery = useQuery(queries.ews.offerCatalog.productVersion({
        type: offer.productType,
        version: 'write',
    }));
    var requiredFields = (_d = (_c = (_b = productVersionQuery.data) === null || _b === void 0 ? void 0 : _b.schema) === null || _c === void 0 ? void 0 : _c.required) !== null && _d !== void 0 ? _d : [];
    var getRulesByFieldName = function (field) {
        return requiredFields.includes(field)
            ? { required: 'This field is required' }
            : undefined;
    };
    return (jsx(RoundedCard, __assign({ title: "URL's" }, { children: jsxs(RoundedCard.Content, { children: [jsx(InputController, { control: control, disabled: readOnly, label: "Unmonetized URL", layout: FieldLayout.Horizontal, name: "unmonetizedUrl", rules: getRulesByFieldName('unmonetizedUrl') }), jsx(InputController, { control: control, disabled: readOnly, label: "Monetized URL", layout: FieldLayout.Horizontal, name: "monetizedUrl", rules: getRulesByFieldName('monetizedUrl') }), !readOnly ? (jsx("div", __assign({ style: { display: 'flex', justifyContent: 'flex-end' } }, { children: jsx(Button, __assign({ intent: "primary", onClick: handleSubmit(onSubmit) }, { children: "Save Changes" })) }))) : null] }) })));
};

var AffiliateLinkCard = function (_a) {
    var offer = _a.offer;
    var _b = useForm({
        defaultValues: {
            affiliateLinkUrl: '',
            supplySubAccount: {},
        },
    }), control = _b.control, isDirty = _b.formState.isDirty, reset = _b.reset, setValue = _b.setValue, watch = _b.watch;
    var supplySubAccount = watch('supplySubAccount');
    useUpdateEffect(function () {
        if (!supplySubAccount.uuid) {
            return;
        }
        setValue('affiliateLinkUrl', "https://offers.moneylion.com/channelTrackingOfferRedirect/".concat(supplySubAccount.uuid, "/").concat(offer.uuid));
    }, [supplySubAccount === null || supplySubAccount === void 0 ? void 0 : supplySubAccount.uuid]);
    return (jsx(RoundedCard, __assign({ headerContent: isDirty ? (jsx(EvenButton, __assign({ outlined: true, onClick: function () { return reset(); } }, { children: "Reset" }))) : null, title: "Affiliate Link" }, { children: jsxs(RoundedCard.Content, { children: [jsx(SubAccountSuggestController, { showOnlySupplySubAccounts: true, control: control, label: "Channel Partner", layout: FieldLayout.Horizontal, name: "supplySubAccount" }), jsx(InputController, { copyable: true, disabled: true, control: control, label: "Affiliate Link URL", layout: FieldLayout.Horizontal, name: "affiliateLinkUrl", onCopy: function () {
                        return Toaster.success('Affiliate URL has been copied to the clipboard!');
                    } })] }) })));
};

var LegacyCard = function (_a) {
    var offer = _a.offer;
    var productVersionQuery = useQuery(queries.ews.offerCatalog.productVersion({
        type: offer.productType,
        version: 'write',
    }));
    var currentProductVersionQuery = useQuery(queries.ews.offerCatalog.productVersion({
        type: offer.productType,
        version: Math.max.apply(Math, offer.productVersions),
    }));
    var writeProductVersion = productVersionQuery.data;
    var currentProductVersion = currentProductVersionQuery.data;
    var legacyFields = useMemo(function () { return getOfferFields(offer, currentProductVersion, writeProductVersion); }, [
        offer.uuid,
        offer.version,
        currentProductVersion === null || currentProductVersion === void 0 ? void 0 : currentProductVersion.type,
        currentProductVersion === null || currentProductVersion === void 0 ? void 0 : currentProductVersion.versions,
        writeProductVersion === null || writeProductVersion === void 0 ? void 0 : writeProductVersion.type,
        writeProductVersion === null || writeProductVersion === void 0 ? void 0 : writeProductVersion.versions,
    ]).legacyFields;
    if (!legacyFields.length) {
        return jsx(Fragment, {});
    }
    return (jsx(RoundedCard, __assign({ title: "Legacy Fields" }, { children: jsx(RoundedCard.Content, { children: legacyFields.map(function (_a) {
                var key = _a.key, value = _a.value;
                return (jsx(Field, __assign({ label: startCase(key), layout: FieldLayout.Horizontal }, { children: jsx(Input, { disabled: true, value: value !== null && value !== void 0 ? value : '' }) }), key));
            }) }) })));
};

var OFFER = 'offer';
var SettingsTab = function (props) {
    var _a, _b;
    var offer = props.offer, _c = props.offer, uuid = _c.uuid, version = _c.version, currentVersion = _c.currentVersion, onUpdate = props.onUpdate;
    var readOnly = currentVersion !== version;
    var updateOfferMutation = useMutation(updateOffer);
    var productVersionQuery = useQuery(queries.ews.offerCatalog.productVersion({
        type: offer.productType,
        version: Math.max.apply(Math, offer.productVersions),
    }));
    var handleUpdateOffer = function (partialData) {
        if (!productVersionQuery.data) {
            return;
        }
        var updateData = __assign(__assign({}, omitReadOnlyFields(offer, productVersionQuery.data)), partialData);
        var monetizedUrl = updateData.monetizedUrl, unmonetizedUrl = updateData.unmonetizedUrl;
        if (monetizedUrl && !safeEncodeURIComponent(monetizedUrl)) {
            Toaster.error('Failed to process the Monetized URL. Please ensure it meets RFC 3986 URI syntax formatting and try again.');
            return;
        }
        if (unmonetizedUrl && !safeEncodeURIComponent(unmonetizedUrl)) {
            Toaster.error('Failed to process the Unmonetized URL. Please ensure it meets RFC 3986 URI syntax formatting and try again.');
            return;
        }
        var safeEncodedUrl = monetizedUrl
            ? safeEncodeURIComponent(monetizedUrl)
            : undefined;
        var safeEncodedUnmonetizedUrl = unmonetizedUrl
            ? safeEncodeURIComponent(unmonetizedUrl)
            : undefined;
        updateData.monetizedUrl = safeEncodedUrl;
        updateData.unmonetizedUrl = safeEncodedUnmonetizedUrl;
        var sanitizedData = removeEmptyFields(updateData);
        var options = {
            onError: function () {
                CrudToaster.updateFailure(OFFER);
            },
            onSuccess: function (newOffer) {
                CrudToaster.updateSuccess(OFFER);
                onUpdate(newOffer);
            },
        };
        updateOfferMutation.mutate({
            currentVersion: currentVersion !== null && currentVersion !== void 0 ? currentVersion : version,
            updateData: sanitizedData,
            uuid: uuid,
        }, options);
    };
    useEffect(function () {
        if (readOnly) {
            Toaster.warn('You are viewing a previous version of this offer so all fields are read only.');
        }
    }, [readOnly]);
    return (jsxs(Fragment, { children: [jsx(DetailsCard, { offer: offer, onSubmit: handleUpdateOffer }), jsx(LegacyCard, { offer: offer }), jsx(UrlsCard, { offer: offer, readOnly: readOnly, onSubmit: handleUpdateOffer }), jsx(KeywordsCard, { existingKeywords: (_a = offer === null || offer === void 0 ? void 0 : offer.keywords) !== null && _a !== void 0 ? _a : [], readOnly: readOnly, onSubmit: function (keywords) { return handleUpdateOffer({ keywords: keywords }); } }), jsx(TagsCard, { existingTags: (_b = offer === null || offer === void 0 ? void 0 : offer.tags) !== null && _b !== void 0 ? _b : {}, readOnly: readOnly, onSubmit: function (tags) { return handleUpdateOffer({ tags: tags }); } }), jsx(AffiliateLinkCard, { offer: offer })] }));
};

var OfferDetail = function (props) {
    var _a;
    var canCreateOfferRules = props.canCreateOfferRules, offerCatalog = props.offerCatalog, offerRules = props.offerRules, onUpdate = props.onUpdate, originatorOffer = props.originatorOffer, supplySubAccounts = props.supplySubAccounts;
    var router = useRouter();
    var aboveTitleTopRightContent = (jsx(StatusIndicator, { type: offerCatalog === null || offerCatalog === void 0 ? void 0 : offerCatalog.status }));
    var activeSupplySubaccounts = useMemo(function () { return supplySubAccounts === null || supplySubAccounts === void 0 ? void 0 : supplySubAccounts.filter(function (subaccount) { return !subaccount.deactivatedBy; }); }, [supplySubAccounts]);
    var propertyItems = useMemo(function () {
        var _a, _b, _c, _d, _e;
        return [
            { title: 'UUID', value: (_a = offerCatalog === null || offerCatalog === void 0 ? void 0 : offerCatalog.uuid) !== null && _a !== void 0 ? _a : '' },
            {
                renderValue: function () { return (jsx("a", __assign({ href: "/demand-sub-accounts/".concat(offerCatalog.demandSubAccountUuid) }, { children: offerCatalog === null || offerCatalog === void 0 ? void 0 : offerCatalog.demandSubAccountName }))); },
                title: 'Demand Sub Account Name',
                value: (_b = offerCatalog === null || offerCatalog === void 0 ? void 0 : offerCatalog.demandSubAccountName) !== null && _b !== void 0 ? _b : '',
            },
            {
                title: 'Created At',
                value: (_c = formatDateTimeShort(offerCatalog === null || offerCatalog === void 0 ? void 0 : offerCatalog.createdAt)) !== null && _c !== void 0 ? _c : '',
            },
            {
                title: 'Updated At',
                value: (_d = formatDateTimeShort(offerCatalog === null || offerCatalog === void 0 ? void 0 : offerCatalog.updatedAt)) !== null && _d !== void 0 ? _d : '',
            },
            { title: 'Version', value: (_e = offerCatalog === null || offerCatalog === void 0 ? void 0 : offerCatalog.version) !== null && _e !== void 0 ? _e : '' },
        ];
    }, [offerCatalog]);
    var renderSidebarContent = useCallback(function () {
        return propertyItems.map(function (propertyItem) { return (jsx(PropertyItem, { renderValue: propertyItem === null || propertyItem === void 0 ? void 0 : propertyItem.renderValue, title: propertyItem.title, value: propertyItem.value }, propertyItem.title)); });
    }, [propertyItems]);
    var tabs = [
        {
            id: 'settings',
            panel: jsx(SettingsTab, { offer: offerCatalog, onUpdate: onUpdate }),
            title: 'Settings',
        },
        {
            id: 'offer-versions',
            panel: jsx(OfferVersionsTab, { offer: offerCatalog }),
            title: 'Offer Versions',
        },
        {
            id: 'offer-rules',
            panel: (jsx(OfferRulesTab, { canCreateOfferRules: canCreateOfferRules, offerCatalog: offerCatalog, offerRules: offerRules, originatorOffer: originatorOffer, supplySubAccounts: activeSupplySubaccounts })),
            title: 'Offer Rules',
        },
    ];
    return (jsx(DetailLayout, { enableFullWidthHeader: true, className: "portal-details-wrapper", headerProps: {
            aboveTitleTopRightContent: aboveTitleTopRightContent,
            title: (_a = offerCatalog.internalName) !== null && _a !== void 0 ? _a : '[No Name Specified]',
        }, sidebarContent: renderSidebarContent(), tabs: tabs, topBarProps: {
            onBack: router.back,
        } }));
};

var PerformanceSummarySplashScreen = function (_a) {
    var children = _a.children, _b = _a.text, text = _b === void 0 ? 'To see the revenue reporting visualization, please select a sub account.' : _b, _c = _a.title, title = _c === void 0 ? 'Welcome to Revenue Reporting' : _c, image = _a.image;
    return (jsxs("div", __assign({ className: "performance-summary-splash-screen" }, { children: [jsx(Empty, { className: "logo", description: null, image: image }), jsx("div", __assign({ className: "title" }, { children: title })), jsx("div", __assign({ className: "body" }, { children: text })), children] })));
};

var Items = [
    { label: 'Demand Sub Account Name', value: 'demandSubAccountName' },
    { label: 'Supply Partner', value: 'supplyPartner' },
    { label: 'Loan Purpose', value: 'loanPurpose' },
    { label: 'Credit Bucket', value: 'creditRating' },
    { label: 'Date', value: 'date' },
];
var BreakdownBy = function (_a) {
    var toggleGroup = _a.toggleGroup;
    var items = useMemo(function () { return Items; }, []);
    var _b = useState(null), filteredItems = _b[0], setFilteredItems = _b[1];
    var _c = useState([Items[0]]), selectedItems = _c[0], setSelectedItems = _c[1];
    var getIndexOfItem = function (item) {
        return selectedItems.indexOf(item);
    };
    var itemsContainsItem = function (item) {
        return getIndexOfItem(item) !== -1;
    };
    var itemRenderer = function (item, _a) {
        var handleClick = _a.handleClick, modifiers = _a.modifiers;
        if (!modifiers.matchesPredicate) {
            return null;
        }
        return (jsx(MenuItem$1, { active: modifiers.active, disabled: modifiers.disabled, icon: itemsContainsItem(item) ? 'tick' : 'blank', text: item.label, onClick: handleClick }, item.value));
    };
    var deselectItem = function (indexOfItem) {
        // cannot deselect Demand SubAccount which is always first:
        if (indexOfItem === 0) {
            return;
        }
        var newItems = selectedItems.filter(function (_item, i) { return i !== indexOfItem; });
        setSelectedItems(newItems);
    };
    var onItemSelect = function (selectedItem) {
        if (itemsContainsItem(selectedItem)) {
            // unselect
            deselectItem(getIndexOfItem(selectedItem));
        }
        else {
            // add the selected Item
            setSelectedItems(__spreadArray(__spreadArray([], selectedItems, true), [selectedItem], false));
        }
        if (getIndexOfItem(selectedItem) !== 0) {
            toggleGroup(selectedItem.value);
        } // cannot deselect Demand Sub Account
    };
    var tagRenderer = function (item) { return item.label; };
    var handleTagRemove = function (_tag, index) {
        if (index !== 0) {
            toggleGroup(selectedItems[index].value);
        } // cannot deselect Demand Sub Account
        deselectItem(index);
    };
    var handleQueryChange = function (query) {
        if (query === '') {
            setFilteredItems(null);
        }
        else {
            var newItems = items.filter(function (item) {
                var regex = new RegExp(query, 'i');
                return (item.label + item.value).match(regex);
            });
            setFilteredItems(newItems);
        }
    };
    return (jsx(MultiSelect$1, { className: "blue-print-multiselect", itemRenderer: itemRenderer, items: filteredItems || items, selectedItems: selectedItems, tagInputProps: {
            onRemove: handleTagRemove,
        }, tagRenderer: tagRenderer, onItemSelect: onItemSelect, onQueryChange: handleQueryChange }));
};

function getMonthToDateRange(minDate) {
    var today = DateTime.now().toJSDate();
    var lastMonth = DateTime.now().minus({ months: 1 }).toJSDate();
    if (minDate && minDate.getTime() > lastMonth.getTime()) {
        return [minDate, today];
    }
    return [lastMonth, today];
}
var DateFilter = function (_a) {
    var dateRange = _a.dateRange, setDateRange = _a.setDateRange, minDate = _a.minDate, props = __rest(_a, ["dateRange", "setDateRange", "minDate"]);
    var formatter = useMemo(function () {
        return {
            formatDate: function (date) { return DateTime.fromJSDate(date).toISODate(); },
            parseDate: function (date) { return DateTime.fromISO(date).toJSDate(); },
            placeholder: 'YYYY-MM-DD',
        };
    }, []);
    return (jsx(DateRangeInput, __assign({}, props, formatter, { maxDate: new Date(), minDate: minDate, shortcuts: false, value: dateRange, onChange: setDateRange })));
};

function withCommas(num) {
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
function dollar(num) {
    var floated = Number.parseFloat(num).toFixed(2);
    var _a = floated.toString().split('.'), ints = _a[0], decimals = _a[1];
    return "$".concat(withCommas(ints), ".").concat(decimals);
}
function capitalizeFirstLetter(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
}
function unsnakeAndCapitalize(snakedString) {
    return snakedString
        .split('_')
        .map(function (word) { return capitalizeFirstLetter(word); })
        .join(' ');
}
function snakeAndLowercase(formattedString) {
    return formattedString.replace(/\s/g, '_').toLowerCase();
}

var getInitialColumnDefs = function () {
    var groupDefaultProps = {
        enableRowGroup: true,
        hide: true,
        rowGroup: false, // default is no group
    };
    var nonGroupDefaultProps = {
        sortable: false,
        suppressMenu: true,
    };
    var undefinedValue = function (params) { return params.value === undefined; };
    var Description;
    (function (Description) {
        Description["ApprovalRate"] = "Percentage of requests that resulted in an approval";
        Description["Approvals"] = "Count of requests with one or more pre-approved or pre-qualified offers";
        Description["ClickRate"] = "Percentage of leads who clicked into one or more of your offers";
        Description["ClickToFund"] = "Percentage of clicks that resulted in fundings";
        Description["Clicks"] = "Count of unique clicks into one of your offers (unique per lead)";
        Description["FundedLoans"] = "Number of loans originated that you reported to us (by lead created date)";
        Description["Requests"] = "Count of API requests made to your API for offer eligibility";
        Description["TotalOriginations"] = "Total amount in dollars of loans funded that you reported to us";
    })(Description || (Description = {}));
    var HeaderWithInfo = function (info) {
        return function (props) {
            return (jsx("div", __assign({ className: "column-header-wrapper" }, { children: jsx("div", __assign({ className: "column-header" }, { children: jsxs("span", __assign({ className: "column-header-title" }, { children: [props.displayName, " ", jsx(InfoToolTip, { content: info })] })) })) })));
        };
    };
    return [
        __assign(__assign({ field: 'demandSubAccountName', headerName: 'Demand Subaccount Name' }, groupDefaultProps), { rowGroup: true }),
        __assign({ field: 'supplyPartner', headerName: 'Supply Partner' }, groupDefaultProps),
        __assign({ field: 'loanPurpose' }, groupDefaultProps),
        __assign({ field: 'creditRating', headerName: 'Credit Bucket' }, groupDefaultProps),
        __assign({ field: 'date' }, groupDefaultProps),
        __assign(__assign({ field: 'totalRequests' }, nonGroupDefaultProps), { headerComponentFramework: HeaderWithInfo(Description.Requests), valueFormatter: function (params) {
                if (undefinedValue(params)) {
                    return 'ERROR';
                }
                var data = params.data;
                return withCommas(data.totalRequests.toString());
            } }),
        __assign(__assign({ field: 'totalApprovals' }, nonGroupDefaultProps), { headerComponentFramework: HeaderWithInfo(Description.Approvals), valueFormatter: function (params) {
                if (undefinedValue(params)) {
                    return 'ERROR';
                }
                var data = params.data;
                return withCommas(data.totalApprovals.toString());
            } }),
        __assign(__assign({ field: 'totalApprovalRate', headerName: 'Approval Rate' }, nonGroupDefaultProps), { headerComponentFramework: HeaderWithInfo(Description.ApprovalRate), valueFormatter: function (params) {
                if (undefinedValue(params)) {
                    return 'ERROR';
                }
                var data = params.data;
                return data.totalApprovalRate
                    ? formatPercentWithPrecision(data.totalApprovalRate, true)
                    : '';
            } }),
        __assign(__assign({ field: 'totalClicks' }, nonGroupDefaultProps), { headerComponentFramework: HeaderWithInfo(Description.Clicks), valueFormatter: function (params) {
                if (undefinedValue(params)) {
                    return 'ERROR';
                }
                var data = params.data;
                return withCommas(data.totalClicks.toString());
            } }),
        __assign(__assign({ field: 'totalClickRate', headerName: 'Click Rate' }, nonGroupDefaultProps), { headerComponentFramework: HeaderWithInfo(Description.ClickRate), valueFormatter: function (params) {
                if (undefinedValue(params)) {
                    return 'ERROR';
                }
                var data = params.data;
                return data.totalClickRate
                    ? formatPercentWithPrecision(data.totalClickRate, true)
                    : '';
            } }),
        __assign(__assign({ field: 'fundedLoans' }, nonGroupDefaultProps), { headerComponentFramework: HeaderWithInfo(Description.FundedLoans), valueFormatter: function (params) {
                if (undefinedValue(params)) {
                    return 'ERROR';
                }
                var data = params.data;
                return withCommas(data.fundedLoans.toString());
            } }),
        __assign(__assign({ field: 'totalClicksToFund', headerName: 'Click to Fund' }, nonGroupDefaultProps), { headerComponentFramework: HeaderWithInfo(Description.ClickToFund), valueFormatter: function (params) {
                if (undefinedValue(params)) {
                    return 'ERROR';
                }
                var data = params.data;
                return data.totalClicksToFund
                    ? formatPercentWithPrecision(data.totalClicksToFund, true)
                    : '';
            } }),
        __assign(__assign({ field: 'totalOrigination' }, nonGroupDefaultProps), { headerComponentFramework: HeaderWithInfo(Description.TotalOriginations), valueFormatter: function (params) {
                if (undefinedValue(params)) {
                    return 'ERROR';
                }
                var data = params.data;
                return dollar(data.totalOrigination);
            } }),
    ];
};

var PersonalLoansStore = /** @class */ (function () {
    function PersonalLoansStore() {
        this.agGridFilterPrefix = 'ag-Grid-AutoColumn-';
        this.data = {};
        this.expandedRowGroups = [];
    }
    PersonalLoansStore.prototype.getDataObject = function () {
        return this.data;
    };
    PersonalLoansStore.prototype.getExpandedRowGroups = function () {
        return this.expandedRowGroups;
    };
    PersonalLoansStore.prototype.addExpandedRowGroup = function (route) {
        this.expandedRowGroups.push(route);
    };
    PersonalLoansStore.prototype.removeExpandedRowGroup = function (route) {
        var index = this.expandedRowGroups.indexOf(route);
        if (index !== -1) {
            this.expandedRowGroups.splice(index, 1);
        }
    };
    PersonalLoansStore.prototype.getWhereParts = function (request) {
        var whereParts = [];
        if (request.groupKeys) {
            request.groupKeys.forEach(function (key) {
                whereParts.push(key);
            });
        }
        return whereParts;
    };
    PersonalLoansStore.prototype.getRowGroupColOrder = function (_a) {
        var rowGroupCols = _a.rowGroupCols;
        return rowGroupCols.map(function (col) { return col.id; });
    };
    PersonalLoansStore.prototype.spliceWhereParts = function (whereParts) {
        if (whereParts.length < 2) {
            return whereParts;
        }
        var spliced = [];
        var rowSelectorsAdded = 0;
        for (var index = 0; index < whereParts.length * 2 - 1; index++) {
            if (index % 2 !== 0) {
                // odd
                rowSelectorsAdded++;
                spliced.push('rows');
            }
            else {
                // even
                spliced.push(whereParts[index - rowSelectorsAdded]);
            }
        }
        return spliced;
    };
    PersonalLoansStore.prototype.rowObjectToRowArray = function (obj) {
        return Object.values(obj).map(function (value) {
            return value.data;
        });
    };
    PersonalLoansStore.prototype.sortRows = function (request, rows) {
        var _a;
        if (!((_a = request.sortModel) === null || _a === void 0 ? void 0 : _a.length)) {
            return rows;
        }
        var rowKeys = Object.keys(rows[0]);
        var currentSortModel = request.sortModel.find(function (model) { return rowKeys.includes(model.colId); });
        if (currentSortModel) {
            var sortArg = void 0;
            (function (sortArg) {
                sortArg[sortArg["asc"] = -1] = "asc";
                sortArg[sortArg["desc"] = 1] = "desc";
            })(sortArg || (sortArg = {}));
            var currentCol_1 = currentSortModel.colId;
            var sortCB = function (sort) { return function (rowA, rowB) {
                var valA = rowA[currentCol_1];
                var valB = rowB[currentCol_1];
                if (valA === valB) {
                    return 0;
                }
                if (valA < valB) {
                    return Number(sort);
                }
                return -1 * sort;
            }; };
            var sort = sortArg[currentSortModel.sort];
            return rows.sort(sortCB(sort));
        }
        return rows;
    };
    PersonalLoansStore.prototype.getFilteredRows = function (request) {
        var filteredData = this.getFilteredData(request);
        var heirarchy = this.getWhereParts(request);
        var rowObject;
        if (!heirarchy.length) {
            rowObject = filteredData;
        }
        else {
            var heirarchySelector = this.spliceWhereParts(heirarchy);
            rowObject = _.get(filteredData, __spreadArray(__spreadArray([], heirarchySelector, true), ['rows'], false));
        }
        var rowData = this.sortRows(request, this.rowObjectToRowArray(rowObject));
        var rowCount = this.getLastRowIndex(request, rowData);
        return { rowCount: rowCount, rowData: rowData };
    };
    PersonalLoansStore.prototype.requestIsCached = function (request) {
        var heirarchy = this.getWhereParts(request);
        if (!heirarchy.length) {
            // for initial request;
            if (Object.keys(this.data).length) {
                return true;
            }
        }
        var heirarchySelector = this.spliceWhereParts(heirarchy);
        var rows = _.get(this.data, __spreadArray(__spreadArray([], heirarchySelector, true), ['rows'], false)) || {};
        return Boolean(Object.keys(rows).length); // if there are sub rows it means the data was fetched
    };
    PersonalLoansStore.prototype.add = function (request, rows) {
        var _this = this;
        if (this.requestIsCached(request)) {
            return;
        }
        var heirarchy = this.getWhereParts(request);
        var heirarchySelector = this.spliceWhereParts(heirarchy);
        var groupOrder = this.getRowGroupColOrder(request);
        // @const selectedSubObj
        // pointer to the slot where the new data will go.
        rows.forEach(function (row) {
            var groupColId = groupOrder[heirarchy.length];
            // @const rowId
            // if the three group orders are selected but you're only expanding the first
            // then the last in heirarchy will indicate which group column to use as the selector
            var rowId = row[groupColId];
            var newData = {
                columnName: groupColId,
                data: row,
                rows: {},
            };
            var setPath = heirarchySelector.length
                ? __spreadArray(__spreadArray([], heirarchySelector, true), ['rows', rowId], false) : [rowId];
            _.set(_this.data, setPath, newData);
        });
    };
    PersonalLoansStore.prototype.recursiveFilter = function (data, filterModel) {
        var _this = this;
        if (!Object.keys(data).length) {
            // end recursion
            return data;
        }
        var filteredCache = {};
        Object.keys(data).forEach(function (key) {
            var _a;
            var cacheItem = data[key];
            var filterSelector = _this.agGridFilterPrefix + cacheItem.columnName;
            var filterValues = (_a = filterModel[filterSelector]) === null || _a === void 0 ? void 0 : _a.values;
            var filterVal = key;
            if (!filterValues || filterValues.includes(filterVal)) {
                // if theres no filteres applied for this column
                // or if there are filters applied make sure the filter matches
                filteredCache[key] = {
                    columnName: cacheItem.columnName,
                    data: cacheItem.data,
                    rows: _this.recursiveFilter(cacheItem.rows, filterModel),
                };
            }
        });
        return filteredCache;
    };
    PersonalLoansStore.prototype.getLastRowIndex = function (request, results) {
        if (!results || results.length === 0) {
            return 0;
        }
        if (request.endRow == null || request.startRow == null) {
            return results.length;
        }
        var currentLastRow = request.startRow + results.length;
        return currentLastRow <= request.endRow ? currentLastRow : -1;
    };
    PersonalLoansStore.prototype.recursiveFilterValueSearch = function (data, colId) {
        var _this = this;
        var columnVal = Object.values(data)[0];
        if (!columnVal) {
            return [];
        }
        if (columnVal.columnName === colId) {
            return Object.keys(data);
        }
        var dataKeys = Object.keys(data);
        return dataKeys.flatMap(function (key) {
            return _this.recursiveFilterValueSearch(data[key].rows, colId);
        });
    };
    PersonalLoansStore.prototype.getFilteredData = function (request) {
        if (!request.filterModel) {
            return this.data;
        }
        return this.recursiveFilter(__assign({}, this.data), request.filterModel);
    };
    PersonalLoansStore.prototype.getFilterValues = function (colId) {
        return this.recursiveFilterValueSearch(this.data, colId);
    };
    PersonalLoansStore.prototype.applyToCacheLayer = function (request, rows) {
        this.add(request, rows);
        return this.getFilteredRows(request);
    };
    PersonalLoansStore.prototype.revertGroupKeys = function (gridGroupKeys, revertMap, currentData) {
        if (currentData === void 0) { currentData = this.data; }
        if (!gridGroupKeys.length) {
            return [];
        }
        var currentLookup = gridGroupKeys[0];
        var shiftedGroupKeys = gridGroupKeys.slice(1);
        var childData = currentData[currentLookup];
        var currentColumn = childData.columnName;
        var toRevert = revertMap[currentColumn];
        if (toRevert) {
            return [childData.data[toRevert]].concat(this.revertGroupKeys(shiftedGroupKeys, revertMap, childData.rows));
        }
        return [currentLookup].concat(this.revertGroupKeys(shiftedGroupKeys, revertMap, childData.rows));
    };
    PersonalLoansStore.prototype.clear = function () {
        this.data = {};
        this.expandedRowGroups = [];
    };
    return PersonalLoansStore;
}());

function safeFormat(row, formatFunction, keys) {
    // ensures that the property is available on the row before it tries to add/format it
    var newRow = __assign({}, row);
    keys.forEach(function (key) {
        var val = newRow[key];
        if (val) {
            newRow[key] = formatFunction(val);
        }
    });
    return newRow;
}
// rows that will be formatted on the way in
// and need to be reverted on the way out
var formatRows = ['loanPurpose', 'creditRating'];
var colRevertMap = {
    demandSubAccountName: 'demandSubAccountUuid',
    supplyPartner: 'supplySubAccountUuid',
};
var createSupplyPartner = function (row) {
    var supplyAccountName = row.supplyAccountName, supplySubAccountUuid = row.supplySubAccountUuid;
    if (!supplyAccountName || !supplySubAccountUuid) {
        throw new Error("can not create supply partner from undefined or empty string");
    }
    return "".concat(supplyAccountName, " : ").concat(supplySubAccountUuid);
};
var addSupplyPartner = function (rows) {
    return rows.map(function (row) {
        // synthetically creating supplySubAccountName
        if (row.supplySubAccountName && row.supplySubAccountUuid) {
            return __assign(__assign({}, row), { supplyPartner: createSupplyPartner(row) });
        }
        return row;
    });
};
var requestUtilities = {
    create: function (rows) {
        // formatting incoming data so we don't have to deal with it
        // in AG-Grid
        return addSupplyPartner(rows).map(function (row) {
            return safeFormat(row, unsnakeAndCapitalize, formatRows);
        });
    },
    revertRequest: function (request, store) {
        // reverting data that goes back to the server as a request
        var newRowGroupCols = request.rowGroupCols.map(function (col) {
            var newCol = col;
            // frontend is displaying the names but we need to request based on the Uuid
            if (Object.keys(colRevertMap).includes(col.id)) {
                var revertTo = colRevertMap[col.id];
                newCol = __assign(__assign({}, col), { field: revertTo, id: revertTo });
            }
            return newCol;
        });
        return __assign(__assign({}, request), { groupKeys: store
                .revertGroupKeys(request.groupKeys, colRevertMap)
                .map(function (key) { return snakeAndLowercase(key); }), rowGroupCols: newRowGroupCols });
    },
};
var getServerSideDatasource = function (controller, dateRange, storeCache, demandSubAccount) {
    return {
        getRows: function (params) {
            return __awaiter(this, void 0, void 0, function () {
                var request, revertedRequest, rows, data, rows;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            request = params.request;
                            revertedRequest = requestUtilities.revertRequest(request, storeCache);
                            if (!storeCache.requestIsCached(request)) return [3 /*break*/, 1];
                            rows = storeCache.getFilteredRows(request);
                            params.success(rows);
                            return [3 /*break*/, 3];
                        case 1: return [4 /*yield*/, controller.getData(revertedRequest, dateRange, demandSubAccount)];
                        case 2:
                            data = (_a.sent()).data;
                            if (!data) {
                                // inform the grid request failed
                                params.fail();
                            }
                            else {
                                rows = storeCache.applyToCacheLayer(request, requestUtilities.create(data));
                                params.success(rows);
                            }
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
    };
};

var ControllerWrapper = /** @class */ (function () {
    function ControllerWrapper(client) {
        this.client = client;
    }
    ControllerWrapper.prototype.getWhereParts = function (_a) {
        var rowGroupCols = _a.rowGroupCols, groupKeys = _a.groupKeys;
        var whereParts = {};
        if (groupKeys) {
            groupKeys.forEach(function (key, i) {
                var whereKey = rowGroupCols[i].id;
                whereParts[whereKey] = key;
            });
        }
        return whereParts;
    };
    ControllerWrapper.prototype.getGroupBy = function (_a) {
        var rowGroupCols = _a.rowGroupCols, groupKeys = _a.groupKeys;
        var rowGroupCol = rowGroupCols[groupKeys.length];
        if (rowGroupCol.id === 'date') {
            return ['day'];
        }
        var id = rowGroupCol.id.replace('AccountUuid', 'AccountId');
        // api expects an array though we will only ever be grouping by one thing at a time
        return [id];
    };
    ControllerWrapper.prototype.formatDate = function (date) {
        if (!date) {
            throw new Error("A Date must be selected: ".concat(date, " is not a valid date"));
        }
        var format = 'YYYY-MM-DD';
        return moment(date).format(format);
    };
    ControllerWrapper.prototype.getData = function (agGridRequest, date, demandSubAccount) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var where, group, params;
            return __generator(this, function (_b) {
                where = this.getWhereParts(agGridRequest);
                group = this.getGroupBy(agGridRequest);
                params = {
                    creditRating: where.creditRating,
                    demandSubAccountUuid: (_a = demandSubAccount === null || demandSubAccount === void 0 ? void 0 : demandSubAccount.uuid) !== null && _a !== void 0 ? _a : where.demandSubAccountUuid,
                    endDate: this.formatDate(date[1]),
                    groupingKey: group,
                    loanPurpose: where.loanPurpose,
                    startDate: this.formatDate(date[0]),
                    supplySubAccountUuid: where.supplySubAccountUuid,
                };
                return [2 /*return*/, this.client.get('/demandReporting/personalLoanSummaries/dashboard', {
                        params: params,
                    })];
            });
        });
    };
    return ControllerWrapper;
}());

// Demand MVP data backfill is only going back 10/01/2020
// We would like to prevent users from selecting dates on
// the date picker for which we know no data will be
// available (pre-backfilled dates)
var DEFAULT_MIN_DATE = DateTime.fromISO('2020-10-01').toJSDate();
var PersonalLoansPage = function (_a) {
    var controller = _a.controller, demandSubAccounts = _a.demandSubAccounts, initialDateRange = _a.initialDateRange, _b = _a.showSubAccountDropdown, showSubAccountDropdown = _b === void 0 ? false : _b, _c = _a.minDate, minDate = _c === void 0 ? DEFAULT_MIN_DATE : _c;
    var gridRef = useRef(null);
    var columnDefs = useMemo(getInitialColumnDefs, []);
    var _d = useState(initialDateRange), dateRange = _d[0], setDateRange = _d[1];
    var _e = useState(), selectedDemandSubAccount = _e[0], setSelectedDemandSubAccount = _e[1];
    var storeCache = useMemo(function () { return new PersonalLoansStore(); }, []);
    var toggleGroup = useCallback(function (columnFieldName) {
        var _a;
        var newDefs = columnDefs.map(function (def) {
            if (def.field === columnFieldName) {
                def.rowGroup = !def.rowGroup;
            }
            return def;
        });
        storeCache.clear();
        (_a = gridRef === null || gridRef === void 0 ? void 0 : gridRef.current) === null || _a === void 0 ? void 0 : _a.api.setColumnDefs(newDefs);
    }, []);
    var getDataSource = function (range, demandSubAccount) {
        // create datasource with a reference to the client
        return getServerSideDatasource(controller, range, storeCache, demandSubAccount);
    };
    var onGridReady = useCallback(function (params) {
        // register the datasource with the grid
        if (!showSubAccountDropdown) {
            params.api.setServerSideDatasource(getDataSource(dateRange));
        }
    }, []);
    var handleDemandSubAccountChange = function (demandSubAccount) {
        var _a;
        setSelectedDemandSubAccount(demandSubAccount);
        storeCache.clear();
        (_a = gridRef === null || gridRef === void 0 ? void 0 : gridRef.current) === null || _a === void 0 ? void 0 : _a.api.setServerSideDatasource(getDataSource(dateRange, demandSubAccount));
    };
    useEffect(function () {
        setDateRange(initialDateRange);
    }, [initialDateRange]);
    var handleUpdateDateRange = function (range) {
        var _a;
        setDateRange(range);
        storeCache.clear();
        // must be updated with new date range
        (_a = gridRef === null || gridRef === void 0 ? void 0 : gridRef.current) === null || _a === void 0 ? void 0 : _a.api.setServerSideDatasource(getDataSource(range, selectedDemandSubAccount));
    };
    var getRoute = function (node) {
        var route = node.getRoute();
        if (!route) {
            return null;
        }
        return route.join(',');
    };
    var isServerSideGroupOpenByDefault = function (params) {
        var route = getRoute(params.rowNode);
        if (!route) {
            return false;
        }
        var expandedRowGroups = storeCache.getExpandedRowGroups();
        return expandedRowGroups.includes(route);
    };
    var onRowGroupOpened = function (params) {
        var route = getRoute(params.node);
        //expanding a row group node - add to list of expanded nodes
        var expandedRowGroups = storeCache.getExpandedRowGroups();
        if (params.expanded && !expandedRowGroups.includes(route)) {
            storeCache.addExpandedRowGroup(route);
        }
        //collapsing a row group node - add to list of expanded nodes
        else if (!params.expanded && expandedRowGroups.includes(route)) {
            storeCache.removeExpandedRowGroup(route);
        }
    };
    var gridOptions = usePortalAgGridOptions({
        autoGroupColumnDef: {
            cellClass: function (params) {
                var columnDefs = params.api.getColumnDefs();
                var groupedDefs = columnDefs === null || columnDefs === void 0 ? void 0 : columnDefs.filter(function (def) { return Boolean(def.rowGroup); }).sort(function (a, b) {
                    var aIndex = a.rowGroupIndex;
                    var bIndex = b.rowGroupIndex;
                    // not sorted by default
                    if (typeof aIndex === 'number' && typeof bIndex === 'number') {
                        return aIndex > bIndex ? 1 : -1;
                    }
                    return 0;
                });
                var lastGroup = groupedDefs
                    ? groupedDefs[groupedDefs.length - 1]
                    : undefined;
                var lastGroupedFieldName = (lastGroup === null || lastGroup === void 0 ? void 0 : lastGroup.field)
                    ? lastGroup.field
                    : '';
                var isNewToTheGroupList = params.node.field === lastGroupedFieldName;
                if (isNewToTheGroupList) {
                    // we want to hide the dropdown arrows
                    // for the last grouped column so that
                    // the individual records are never shown
                    // only the aggregates.
                    return 'grouped-elements hide-expand-arrow';
                }
                // .grouped-elements colors the background of
                // the grouped columns.
                return 'grouped-elements';
            },
            filter: 'agSetColumnFilter',
            filterParams: {
                refreshValuesOnOpen: true,
                suppressSorting: true,
                values: function (params) {
                    // get the filter values from the cache based on the colId
                    // it's prefixed so need to strip the prefix off.
                    var colId = params.column.colId.split('ag-Grid-AutoColumn-')[1];
                    var vals = storeCache.getFilterValues(colId);
                    params.success(vals);
                },
            },
            filterValueGetter: function () {
                // This does nothing but when removed the filter shows no values...
            },
            minWidth: 200,
        },
        columnDefs: columnDefs,
        defaultColDef: {
            filter: false,
            flex: 1,
            headerComponentParams: {
                filterIcon: FilterIcon.FILTER,
            },
            menuTabs: ['filterMenuTab'],
            minWidth: 150,
            suppressMovable: true,
        },
        domLayout: 'autoHeight',
        isServerSideGroupOpenByDefault: isServerSideGroupOpenByDefault,
        onGridReady: onGridReady,
        onRowGroupOpened: onRowGroupOpened,
        rowModelType: 'serverSide',
        suppressAggFuncInHeader: true,
        suppressMenuHide: true,
    });
    return (jsxs("div", __assign({ className: "ag-theme-alpine custom", style: { height: '90vh' } }, { children: [jsxs("div", __assign({ className: "header-section" }, { children: [jsx(H3, { children: "Dashboard - Personal Loans" }), jsxs("div", __assign({ className: "button-group" }, { children: [jsx(ExportCSVButton, { csvExportParams: {
                                    fileName: 'personal-loans-data',
                                }, gridRef: gridRef }), jsx(ClearAllButton, { gridRef: gridRef })] }))] })), jsxs("div", __assign({ className: "selectors" }, { children: [showSubAccountDropdown && (jsxs("section", { children: [jsx("label", __assign({ className: "field-label" }, { children: "Select Demand Sub Account" })), jsx(Select, { activeItem: selectedDemandSubAccount, itemKey: function (_a) {
                                    var uuid = _a.uuid;
                                    return uuid;
                                }, itemLabel: function (_a) {
                                    var name = _a.name;
                                    return name;
                                }, items: demandSubAccounts, onItemSelect: handleDemandSubAccountChange })] })), jsxs("section", { children: [jsx("label", __assign({ className: "field-label" }, { children: "Select Date" })), jsx(DateFilter, { dateRange: dateRange, minDate: minDate, setDateRange: handleUpdateDateRange })] }), jsxs("section", { children: [jsx("label", __assign({ className: "field-label" }, { children: "Breakdown By" })), jsx(BreakdownBy, { toggleGroup: toggleGroup })] })] })), jsx(AgGridReact, { ref: gridRef, cacheBlockSize: 500, gridOptions: gridOptions, groupDisplayType: "multipleColumns", serverSideStoreType: "partial" })] })));
};

var UserAccountsFieldGroup = function (_a) {
    var accountOptions = _a.accountOptions, layout = _a.layout, showAllAccountsDropdown = _a.showAllAccountsDropdown, subAccountOptions = _a.subAccountOptions;
    var _b = useFormContext(), errors = _b.formState.errors, control = _b.control, resetField = _b.resetField, setValue = _b.setValue, watch = _b.watch, getFieldState = _b.getFieldState;
    var account = watch(UserField$1.Account);
    var allAccounts = watch(UserField$1.AllAccounts);
    var accountFieldState = getFieldState(UserField$1.Account);
    // Default UserField.AllAccounts to false when showAllAccountsDropdown changes.
    useEffect(function () {
        resetField(UserField$1.AllAccounts);
    }, [showAllAccountsDropdown]);
    // Clear sub account value if the account field changes.
    useEffect(function () {
        // default the AllAccounts switch to be on if there's no account on the user.
        if (account) {
            setValue(UserField$1.AllAccounts, false);
        }
        if (accountFieldState.isDirty && account) {
            setValue(UserField$1.SubAccounts, []);
        }
    }, [account === null || account === void 0 ? void 0 : account.uuid]);
    // Clear account and sub account values if a user is being granted
    // access to all accounts.
    useEffect(function () {
        if (allAccounts) {
            setValue(UserField$1.Account, null);
            setValue(UserField$1.SubAccounts, []);
        }
    }, [allAccounts]);
    return (jsxs(Fragment, { children: [jsx(Controller, { control: control, defaultValue: false, name: UserField$1.AllAccounts, render: function (_a) {
                    var _b;
                    var _c = _a.field, onChange = _c.onChange, value = _c.value;
                    return (jsx(Field, __assign({ error: (_b = errors.allAccounts) === null || _b === void 0 ? void 0 : _b.message, layout: layout, show: showAllAccountsDropdown }, { children: jsx(Switch, { "aria-label": "all-accounts", checked: value, label: "All Accounts", onChange: onChange }) })));
                } }), !allAccounts && (jsxs(Fragment, { children: [jsx(Controller, { control: control, name: UserField$1.Account, render: function (_a) {
                            var _b;
                            var _c = _a.field, value = _c.value, onChange = _c.onChange;
                            return (jsx(Field, __assign({ error: (_b = errors.account) === null || _b === void 0 ? void 0 : _b.message, label: "Account", layout: layout }, { children: jsx(AccountSuggest, { accounts: accountOptions, inputProps: {
                                        placeholder: 'Search Accounts for Internal User...',
                                    }, selectedItem: value, onChange: onChange }) })));
                        } }), jsx(Controller, { control: control, name: UserField$1.SubAccounts, render: function (_a) {
                            var _b = _a.field, value = _b.value, onChange = _b.onChange;
                            return (jsx(Field, __assign({ label: "Sub accounts", layout: layout }, { children: jsx(SubAccountMultiSelect, { accounts: account ? [account] : [], placeholder: "Search Sub Accounts for Internal User...", selectedItems: value, subAccounts: subAccountOptions, onChange: onChange }) })));
                        } })] }))] }));
};

var _a$1;
var userAccountsFieldGroupSchema = object((_a$1 = {},
    _a$1[UserField$1.Account] = mixed().when(UserField$1.AllAccounts, {
        is: function (value) { return value === undefined || value === 'false'; },
        then: function (schema) { return schema.required(); },
    }),
    _a$1.allAccounts = boolean().default(false),
    _a$1.subAccounts = array()
        .ensure()
        .when(UserField$1.AllAccounts, {
        is: function (value) { return value === undefined || value === 'false'; },
        then: function (schema) { return schema.required(); },
    }),
    _a$1));

var userCreateFormSchema = object({
    // account is required when allAccounts has not been set to true.
    account: object()
        .nullable()
        .when('allAccounts', {
        is: function (value) { return value !== true; },
        then: function (schema) { return schema.required(); },
    }),
    // demandRole is required if the partnerType is Demand or Multi.
    demandRole: object().when('partnerType', {
        is: function (value) { return value === 'Demand' || value === 'Multi'; },
        then: function (schema) {
            return schema.required('Demand User Role is required for Partner Types Demand and Multi.');
        },
    }),
    emailAddress: string().required().email('Must be a valid email'),
    firstName: string().required(),
    lastName: string().required(),
    // partnerType is required if the email is external
    partnerType: string().when('emailAddress', function (_a, schema) {
        var emailAddress = _a[0];
        return isInternalUserType(emailAddress)
            ? schema
            : schema.required().oneOf(['Demand', 'Multi', 'Supply']);
    }),
    // roleObject is now only used for internal users.
    // External users have their roleObjects split amongst supplyRole and demandRole.
    roleObject: object().when('emailAddress', function (_a, schema) {
        var emailAddress = _a[0];
        return isInternalUserType(emailAddress) ? schema.required() : schema;
    }),
    // supplyRole is required if the partnerType is Supply or Multi.
    supplyRole: object().when('partnerType', {
        is: function (value) { return value === 'Supply' || value === 'Multi'; },
        then: function (schema) {
            return schema.required('Supply User Role is required for Partner Types Supply and Multi.');
        },
    }),
}).when('emailAddress', function (_a, schema) {
    var emailAddress = _a[0];
    return isInternalUserType(emailAddress)
        ? schema.concat(userAccountsFieldGroupSchema)
        : schema;
});
var userCreateFormExternalSchema = object({
    emailAddress: string().required().email('Must be a valid email'),
    firstName: string().required(),
    lastName: string().required(),
});

var UserCreateForm = function (_a) {
    var _b, _c, _d;
    var accounts = _a.accounts, onCancel = _a.onCancel, onError = _a.onError, onSubmit = _a.onSubmit, _e = _a.permissions, canManageAllAccounts = _e.canManageAllAccounts, canManageUserRoles = _e.canManageUserRoles, subAccounts = _a.subAccounts, visible = _a.visible, _f = _a.isExternalUserCreateForm, isExternalUserCreateForm = _f === void 0 ? false : _f;
    var form = useForm({
        resolver: yupResolver(isExternalUserCreateForm
            ? userCreateFormExternalSchema
            : userCreateFormSchema),
    });
    var control = form.control, resetField = form.resetField, register = form.register, errors = form.formState.errors, watch = form.watch, handleSubmit = form.handleSubmit, reset = form.reset, setValue = form.setValue;
    var emailAddress = watch(UserField$1.EmailAddress);
    var roleObject = watch(UserField$1.RoleObject);
    var selectedPartnerType = watch(UserField$1.PartnerType);
    var account = watch(UserField$1.Account);
    var selectAllDemandSubaccounts = watch(UserField$1.AllSupplySubAccounts);
    var selectAllSupplySubaccounts = watch(UserField$1.AllSupplySubAccounts);
    var isEmailInternal = isInternalUserType(emailAddress);
    var showAccountsFieldGroup = Boolean(emailAddress) && Boolean(roleObject) && isEmailInternal;
    var showAllAccountsDropdown = canManageAllAccounts &&
        (roleObject === null || roleObject === void 0 ? void 0 : roleObject.flatRole) &&
        UserRolesWithAllAccountAccess.has(roleObject.flatRole);
    var showAccountSelect = !isEmailInternal && emailAddress !== undefined && !isExternalUserCreateForm;
    var partnerTypeArray = Object.values(PartnerType);
    var showSupplySection = selectedPartnerType === 'Multi' || selectedPartnerType === 'Supply';
    var showDemandSection = selectedPartnerType === 'Multi' || selectedPartnerType === 'Demand';
    var isMultiSelected = selectedPartnerType === 'Multi';
    var handleSelectAllSubAccounts = function (userField) {
        var filteredSubAccounts = subAccounts === null || subAccounts === void 0 ? void 0 : subAccounts.filter(function (_a) {
            var accountId = _a.accountId, subAccountTypeKey = _a.subAccountTypeKey;
            var accountFilter = accountId === (account === null || account === void 0 ? void 0 : account.id);
            var supplyFilter = userField === UserField$1.SupplySubAccounts
                ? subAccountTypeKey == SubAccountType.SupplySource
                : true;
            var demandFilter = userField === UserField$1.DemandSubAccounts
                ? subAccountTypeKey === SubAccountType.DemandSource
                : true;
            return accountFilter && supplyFilter && demandFilter;
        });
        var nextState = userField === UserField$1.SupplySubAccounts
            ? !selectAllSupplySubaccounts
            : !selectAllDemandSubaccounts;
        if (nextState) {
            setValue(userField, filteredSubAccounts);
        }
        else {
            setValue(userField, []);
        }
    };
    useEffect(function () {
        reset();
    }, [visible]);
    useEffect(function () {
        if (!emailAddress) {
            return;
        }
        resetField(UserField$1.PartnerType);
        if (isEmailInternal) {
            setValue(UserField$1.RoleObject, internalRoleObjectArray[0]);
            // In case they had any values in the demand or supply subaccount fields, clear them.
            setValue(UserField$1.DemandSubAccounts, []);
            setValue(UserField$1.SupplySubAccounts, []);
            setValue(UserField$1.SubAccounts, []);
        }
        else {
            resetField(UserField$1.AllAccounts);
            resetField(UserField$1.RoleObject);
        }
    }, [isEmailInternal]);
    // Reset the subaccount selections if account selection is changed.
    useEffect(function () {
        if (account !== undefined) {
            setValue(UserField$1.DemandSubAccounts, []);
            setValue(UserField$1.SupplySubAccounts, []);
            setValue(UserField$1.SubAccounts, []);
        }
    }, [account]);
    useEffect(function () {
        // Reset the supply and demand role fields if partner type is changed
        resetField(UserField$1.SupplyRole);
        resetField(UserField$1.DemandRole);
        // Also reset the subaccounts
        setValue(UserField$1.DemandSubAccounts, []);
        setValue(UserField$1.SupplySubAccounts, []);
        setValue(UserField$1.SubAccounts, []);
    }, [selectedPartnerType]);
    return (jsx(DrawerForm, __assign({ disableCloseOnMouseDown: true, submitText: "Create", title: "New User", visible: visible, onClose: onCancel, onSubmit: handleSubmit(onSubmit, onError) }, { children: jsxs(FormProvider, __assign({}, form, { children: [jsx(Field, __assign({ error: (_b = errors.firstName) === null || _b === void 0 ? void 0 : _b.message, label: "First Name" }, { children: jsx("input", __assign({ "aria-label": UserField$1.FirstName, "data-testid": UserField$1.FirstName, type: "text" }, register(UserField$1.FirstName))) })), jsx(Field, __assign({ error: (_c = errors.lastName) === null || _c === void 0 ? void 0 : _c.message, label: "Last Name" }, { children: jsx("input", __assign({ "aria-label": UserField$1.LastName, "data-testid": UserField$1.LastName, type: "text" }, register(UserField$1.LastName))) })), jsx(Field, __assign({ error: (_d = errors.emailAddress) === null || _d === void 0 ? void 0 : _d.message, label: "Email Address" }, { children: jsx("input", __assign({ "aria-label": UserField$1.EmailAddress, "data-testid": UserField$1.EmailAddress, type: "email" }, register(UserField$1.EmailAddress))) })), !isEmailInternal && (jsx(Controller, { control: control, name: UserField$1.PartnerType, render: function (_a) {
                        var _b;
                        var onChange = _a.field.onChange;
                        return (jsx(Field, __assign({ error: (_b = errors.partnerType) === null || _b === void 0 ? void 0 : _b.message, label: "Partner Type", show: canManageUserRoles && Boolean(emailAddress) }, { children: jsx(PartnerTypeSelect
                            //activeItem={value}
                            , { "data-testid": UserField$1.PartnerType, partnerTypeArray: partnerTypeArray, onItemSelect: onChange }) })));
                    } })), isEmailInternal && (jsxs(Fragment, { children: [jsx(Controller, { control: control, name: UserField$1.RoleObject, render: function (_a) {
                                var _b = _a.field, value = _b.value, onChange = _b.onChange;
                                return (jsx(Field, __assign({ label: "User Type", show: canManageUserRoles && Boolean(emailAddress) }, { children: jsx(RoleSelect, { activeItem: value, "data-testid": UserField$1.RoleObject, showExternalRoleOptions: !isEmailInternal, showInternalRoleOptions: isEmailInternal, onItemSelect: onChange }) })));
                            } }), showAccountsFieldGroup && (jsx(UserAccountsFieldGroup, { accountOptions: accounts, showAllAccountsDropdown: Boolean(showAllAccountsDropdown), subAccountOptions: subAccounts }))] })), showDemandSection && (jsx(Controller, { control: control, name: UserField$1.DemandRole, render: function (_a) {
                        var _b;
                        var _c = _a.field, value = _c.value, onChange = _c.onChange;
                        return (jsx(Field, __assign({ error: (_b = errors.demandRole) === null || _b === void 0 ? void 0 : _b.message, label: "Demand User Role", show: canManageUserRoles && Boolean(emailAddress) }, { children: jsx(RoleSelect, { showDemandRoles: true, activeItem: value, ariaLabel: "demandUserRole", "data-testid": UserField$1.DemandRole, isMultiSelected: isMultiSelected, showExternalRoleOptions: !isEmailInternal, showInternalRoleOptions: isEmailInternal, showSupplyRoles: false, onItemSelect: onChange }) })));
                    } })), showSupplySection && (jsx(Controller, { control: control, name: UserField$1.SupplyRole, render: function (_a) {
                        var _b;
                        var _c = _a.field, value = _c.value, onChange = _c.onChange;
                        return (jsx(Field, __assign({ error: (_b = errors.supplyRole) === null || _b === void 0 ? void 0 : _b.message, label: "Supply User Role", show: canManageUserRoles && Boolean(emailAddress) }, { children: jsx(RoleSelect, { showSupplyRoles: true, activeItem: value, ariaLabel: "supplyUserRole", "data-testid": UserField$1.SupplyRole, isMultiSelected: isMultiSelected, showDemandRoles: false, showExternalRoleOptions: !isEmailInternal, showInternalRoleOptions: isEmailInternal, onItemSelect: onChange }) })));
                    } })), showAccountSelect && (jsx(Controller, { control: control, 
                    //defaultValue={null}
                    name: UserField$1.Account, render: function (_a) {
                        var _b;
                        var _c = _a.field, value = _c.value, onChange = _c.onChange;
                        return (jsx(Field, __assign({ error: (_b = errors.account) === null || _b === void 0 ? void 0 : _b.message, label: "Account" }, { children: jsx(AccountSuggest, { accounts: accounts, inputProps: {
                                    placeholder: 'Search Accounts for External User...',
                                }, selectedItem: value, onChange: onChange }) })));
                    } })), showDemandSection && (jsxs("div", { children: [jsx(Controller, { control: control, name: UserField$1.DemandSubAccounts, render: function (_a) {
                                var _b = _a.field, value = _b.value, onChange = _b.onChange;
                                return (jsx(Field, __assign({ label: "Demand Sub Accounts" }, { children: jsx(SubAccountMultiSelect, { showOnlyDemandSubAccounts: true, accounts: account ? [account] : [], placeholder: "Search Demand Sub Accounts...", selectedItems: value, showOnlySupplySubAccounts: false, subAccounts: subAccounts, onChange: function (e) {
                                            setValue(UserField$1.AllDemandSubAccounts, false);
                                            onChange(e);
                                        } }) })));
                            } }), jsx(Controller, { control: control, defaultValue: false, name: UserField$1.AllDemandSubAccounts, render: function (_a) {
                                var _b;
                                var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                return (jsx(Field, __assign({ error: (_b = errors.allDemandSubAccounts) === null || _b === void 0 ? void 0 : _b.message }, { children: jsx(Switch, { "aria-label": "all-demand-subaccounts", checked: value, label: "All Sub Accounts", onChange: onChange, onClick: function () {
                                            handleSelectAllSubAccounts(UserField$1.DemandSubAccounts);
                                        } }) })));
                            } })] })), showSupplySection && (jsxs("div", { children: [jsx(Controller, { control: control, name: UserField$1.SupplySubAccounts, render: function (_a) {
                                var _b = _a.field, value = _b.value, onChange = _b.onChange;
                                return (jsx(Field, __assign({ label: "Supply Sub Accounts" }, { children: jsx(SubAccountMultiSelect, { showOnlySupplySubAccounts: true, accounts: account ? [account] : [], placeholder: "Search Supply Sub Accounts...", selectedItems: value, showOnlyDemandSubAccounts: false, subAccounts: subAccounts, onChange: function (e) {
                                            setValue(UserField$1.AllSupplySubAccounts, false);
                                            onChange(e);
                                        } }) })));
                            } }), jsx(Controller, { control: control, defaultValue: false, name: UserField$1.AllSupplySubAccounts, render: function (_a) {
                                var _b;
                                var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                return (jsx(Field, __assign({ error: (_b = errors.allSupplySubAccounts) === null || _b === void 0 ? void 0 : _b.message }, { children: jsx(Switch, { "aria-label": "all-subaccounts", checked: value, label: "All Sub Accounts", onChange: onChange, onClick: function () {
                                            handleSelectAllSubAccounts(UserField$1.SupplySubAccounts);
                                        } }) })));
                            } })] }))] })) })));
};

var UserCreationLimitReachedModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, onSubmit = _a.onSubmit;
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            onSubmit();
            return [2 /*return*/];
        });
    }); };
    return (jsxs(Dialog, __assign({ isOpen: isOpen, onClose: onClose }, { children: [jsxs("div", __assign({ className: Classes.DIALOG_BODY }, { children: [jsx("h4", { children: "User creation limit reached" }), jsx("p", { children: "You have reached the limit on the number of seats for your plan. If you would like to purchase additional seats please submit your request." })] })), jsx("div", __assign({ className: Classes.DIALOG_FOOTER }, { children: jsxs("div", __assign({ className: Classes.DIALOG_FOOTER_ACTIONS }, { children: [jsx(EvenButton, __assign({ outlined: true, intent: Intent.NONE, onClick: onClose }, { children: "Cancel" })), jsx(EvenButton, __assign({ intent: Intent.PRIMARY, outlined: false, onClick: handleSubmit }, { children: "Submit Request" }))] })) }))] })));
};

var ScaleUsersTable = function (_a) {
    var rowData = _a.rowData, onCreate = _a.onCreate, showCreateNewButton = _a.showCreateNewButton, userLimit = _a.userLimit, onUserCreationLimitChangeRequest = _a.onUserCreationLimitChangeRequest;
    var _b = useState(false), showUserLimitModal = _b[0], setShowUserLimitModal = _b[1];
    var gridRef = useRef(null);
    useEffect(function () {
        var _a;
        if ((_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.api) {
            gridRef.current.api.setRowData(rowData);
        }
    }, [rowData, gridRef]);
    var csvExportParams = {
        processCellCallback: function (param) {
            var _a, _b;
            if (param.column.getColId() === 'accounts') {
                return (_b = (_a = param.value) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.name;
            }
            if (param.column.getColId() === 'isActive') {
                return param.value ? 'Active' : 'Inactive';
            }
            return param.value;
        },
    };
    var handleCreate = function () {
        var activeUsers = rowData.filter(function (row) { return row.isActive; });
        if (activeUsers.length >= userLimit) {
            setShowUserLimitModal(true);
        }
        else {
            onCreate();
        }
    };
    var handleModalClose = function () {
        setShowUserLimitModal(false);
    };
    var handleCreationLimitModalSubmit = function () {
        onUserCreationLimitChangeRequest();
        handleModalClose();
    };
    var columnDefs = [
        {
            cellRenderer: function (params) { return (jsx("a", __assign({ href: "/users/".concat(params.data.uuid) }, { children: params.data.completeName }))); },
            field: 'completeName',
            filter: 'simpleTextFilter',
            filterParams: {
                placeHolder: 'Search by Name',
            },
            flex: 5,
            headerName: 'Name',
            sortable: true,
        },
        {
            field: 'emailAddress',
            filter: 'simpleTextFilter',
            filterParams: {
                placeHolder: 'Search by Email',
            },
            flex: 5,
            headerName: 'Email',
        },
        {
            field: 'createdAt',
            flex: 3,
            headerName: 'Created At',
            type: ColumnDefs.DATE,
        },
        {
            cellRenderer: function (params) {
                var _a;
                var intent = ((_a = params.data) === null || _a === void 0 ? void 0 : _a.isActive) ? Intent.SUCCESS : Intent.NONE;
                return (jsx(StatusDot, __assign({ important: true, status: intent }, { children: params.data.isActiveDisplay })));
            },
            field: 'isActive',
            flex: 3,
            headerName: 'Status',
            suppressMenu: true,
        },
    ];
    var gridOptions = usePortalAgGridOptions({
        columnDefs: columnDefs,
        getRowId: function (_a) {
            var data = _a.data;
            return data.id;
        },
        getRowNodeId: function (_a) {
            var uuid = _a.uuid;
            return uuid;
        },
        rowData: rowData,
    });
    return (jsxs(Fragment, { children: [jsx(UserCreationLimitReachedModal, { isOpen: showUserLimitModal, onClose: handleModalClose, onSubmit: handleCreationLimitModalSubmit }), jsxs(HeaderWithActions, __assign({ className: "title" }, { children: [jsx(ClearAllButton, { gridRef: gridRef }), jsx(ExportCSVButton, { csvExportParams: csvExportParams, gridRef: gridRef }), showCreateNewButton ? (jsx(EvenCreateNewButton, { onClick: handleCreate })) : null] })), jsx(AgGridReact, { ref: gridRef, gridOptions: gridOptions })] }));
};

var ScaleUsersPage = function (_a) {
    var onUserCreateSubmit = _a.onUserCreateSubmit, onUserCreationLimitChangeRequest = _a.onUserCreationLimitChangeRequest, accounts = _a.accounts, subAccounts = _a.subAccounts, permissions = _a.permissions, users = _a.users, toggleDrawer = _a.toggleDrawer, createDrawerVisible = _a.createDrawerVisible, showCreateNewButton = _a.showCreateNewButton, userLimit = _a.userLimit;
    return (jsxs(Fragment, { children: [jsx(UserCreateForm, { isExternalUserCreateForm: true, accounts: accounts, permissions: permissions, subAccounts: subAccounts, visible: createDrawerVisible, onCancel: toggleDrawer, onSubmit: onUserCreateSubmit }), jsx("div", __assign({ className: "ag-theme-alpine", style: { height: 600, minWidth: 400, width: 'auto' } }, { children: jsx(ScaleUsersTable, { rowData: users, showCreateNewButton: showCreateNewButton, userLimit: userLimit, onCreate: toggleDrawer, onUserCreationLimitChangeRequest: onUserCreationLimitChangeRequest }) }))] }));
};

var SignInPage = function (_a) {
    var onSignIn = _a.onSignIn;
    return (jsx("div", __assign({ className: "sign-in-page" }, { children: jsxs("div", __assign({ className: "sign-in-box" }, { children: [jsx("div", __assign({ className: "logo" }, { children: jsx(FontAwesomeKitIcon, { icon: KitIconNames.CompanyLogoHorizontal, size: "4x" }) })), jsx("p", __assign({ className: "welcome-text" }, { children: "Welcome" })), jsx(Button, { className: "okta-sign-in-button", text: "Sign In with Okta", onClick: onSignIn }), jsxs("div", __assign({ className: "footer" }, { children: [jsx("p", { children: "Are you a B2B interested in starting a partnership with Engine?" }), jsxs("p", { children: ["To register your own account, please", ' ', jsx("a", __assign({ href: "https://engine.tech/about/contact", rel: "noreferrer", target: "_blank" }, { children: "contact us" })), "."] })] }))] })) })));
};

var offerManagementBaseUrlByProductType = new Map([
    [ProductType$1.Savings, 'offer-management/savings'],
    [ProductType$1.CreditCard, 'offer-management/credit-cards'],
]);

var StaticCappingPage = function (props) {
    var _a;
    var productType = props.productType, title = props.title;
    var inventoryCapsQuery = useQuery(queries.inventory.staticOfferInventoryCaps({
        productType: productType,
    }));
    var offerBaseUrl = offerManagementBaseUrlByProductType.get(productType);
    return (jsx(TableLayout, __assign({ isLoading: inventoryCapsQuery.isLoading, title: title }, { children: jsx(InventoryCapsTable, { showConfigurationColumn: true, showOfferColumn: true, showStatusColumn: true, inventoryCaps: (_a = inventoryCapsQuery.data) !== null && _a !== void 0 ? _a : [], offerBaseUrl: "".concat(offerBaseUrl, "/product-offers"), paginationPageSize: 100 }) })));
};

var TemplateCenterCreate = function (_a) {
    var _b;
    var canSelectProductType = _a.canSelectProductType, demandApis = _a.demandApis, offerData = _a.offerData, offerData2L = _a.offerData2L, onCreate = _a.onCreate, onProductTypeChange = _a.onProductTypeChange, templateData = _a.templateData, templateNames = _a.templateNames;
    var form = useForm({
        defaultValues: (_b = {},
            _b[TemplateField.Name] = '',
            _b[TemplateField.ProductType] = '',
            _b[TemplateField.Description] = '',
            _b),
        mode: 'all',
    });
    var handleSubmit = form.handleSubmit, reset = form.reset, setValue = form.setValue, watch = form.watch;
    var productType = watch(TemplateField.ProductType);
    var _c = React.useReducer(offersReducer, {}), offerState = _c[0], dispatch = _c[1];
    var handleReset = function () {
        reset();
        dispatch(actions.setOffers([]));
    };
    React.useEffect(function () {
        if (templateData) {
            dispatch(actions.setOffers(templateData.offers));
        }
    }, [templateData, offerData]);
    React.useEffect(function () {
        if (productType) {
            setValue(TemplateField.DemandSubAccounts, []);
            dispatch(actions.setOffers([]));
            onProductTypeChange(productType);
        }
    }, [productType]);
    var onSave = function (formState) {
        var offers = Object.values(offerState).map(function (_a) {
            var offerId = _a.offerId, offerRuleIds = _a.offerRuleIds;
            return ({ offerId: offerId, offerRuleIds: offerRuleIds });
        });
        var payload = __assign(__assign({}, formState), { offers: offers, tier: AccountTierType.Scale });
        onCreate(payload);
    };
    var templateCopy = React.useMemo(function () {
        if (templateData) {
            return __assign(__assign({}, templateData), { name: "".concat(templateData.name, "_copy") });
        }
        return undefined;
    }, [templateData]);
    return (jsx(TemplateCenter, { canSelectProductType: canSelectProductType, demandApis: demandApis, dispatch: dispatch, form: form, formButtons: jsxs(Fragment, { children: [jsx(Button, __assign({ intent: Intent.PRIMARY, onClick: handleSubmit(onSave) }, { children: "Create Template" })), jsx(Button, __assign({ onClick: handleReset }, { children: "Undo Changes" }))] }), offerData: offerData, offerData2L: offerData2L, offerState: offerState, readOnly: false, templateData: templateCopy, templateNames: templateNames, title: "Create New Template" }));
};

var TemplateCenterDetails = function (_a) {
    var _b;
    var demandApis = _a.demandApis, hideTemplateDetails = _a.hideTemplateDetails, offerData = _a.offerData, offerData2L = _a.offerData2L, redirectToEdit = _a.redirectToEdit, showEditButton = _a.showEditButton, templateData = _a.templateData;
    var form = useForm({
        defaultValues: (_b = {},
            _b[TemplateField.Name] = '',
            _b),
    });
    var _c = React.useReducer(offersReducer, {}), offerState = _c[0], dispatch = _c[1];
    React.useEffect(function () {
        if (templateData) {
            dispatch(actions.setOffers(templateData.offers));
        }
    }, [templateData]);
    return (jsx(TemplateCenter, { readOnly: true, demandApis: demandApis, dispatch: dispatch, form: form, formButtons: showEditButton ? (jsx(EditButton, __assign({ onClick: redirectToEdit }, { children: "Edit Template" }))) : (jsx(Fragment, {})), hideTemplateDetails: hideTemplateDetails, offerData: offerData, offerData2L: offerData2L, offerState: offerState, templateData: templateData, title: "Template Details" }));
};

var TemplateCenterEdit = function (_a) {
    var _b;
    var demandApis = _a.demandApis, hideTemplateDetails = _a.hideTemplateDetails, offerData = _a.offerData, offerData2L = _a.offerData2L, onLeaveEditMode = _a.onLeaveEditMode, onUpdate = _a.onUpdate, templateData = _a.templateData, templateNames = _a.templateNames;
    var form = useForm({
        defaultValues: (_b = {},
            _b[TemplateField.Name] = '',
            _b),
        mode: 'all',
    });
    var _c = React.useReducer(offersReducer, {}), offerState = _c[0], dispatch = _c[1];
    var handleReset = function () {
        form.reset();
        dispatch(actions.setOffers([]));
    };
    React.useEffect(function () {
        if (templateData) {
            dispatch(actions.setOffers(templateData.offers));
        }
    }, [templateData]);
    var onSave = function (formState) {
        if (templateData) {
            var offers = Object.values(offerState).map(function (_a) {
                var offerId = _a.offerId, offerRuleIds = _a.offerRuleIds;
                return ({ offerId: offerId, offerRuleIds: offerRuleIds });
            });
            var payload = __assign(__assign({}, formState), { id: templateData.id, offers: offers });
            onUpdate(payload);
        }
    };
    return (jsx(TemplateCenter, { demandApis: demandApis, dispatch: dispatch, form: form, formButtons: jsxs(Fragment, { children: [jsx(ConfirmableAction, __assign({ cancelText: "Cancel", message: "Changes made to this template will be lost and you will be returned to the read-only template details page.", okText: "Ok, I understand", title: "Leave Edit Mode", onOk: onLeaveEditMode }, { children: jsx(Button, { children: "Leave Edit Mode" }) })), jsx(Button, __assign({ onClick: handleReset }, { children: "Undo Changes" })), jsx(ConfirmableAction, __assign({ cancelText: "Cancel", message: "Changes to this template will not be automatically applied to sub accounts that have already had this template applied. To update existing sub accounts, you must reapply this template.", okText: "Ok, I understand", title: "Saving Template Changes", onOk: form.handleSubmit(onSave) }, { children: jsx(Button, __assign({ intent: Intent.PRIMARY }, { children: "Save Changes" })) }))] }), hideTemplateDetails: hideTemplateDetails, offerData: offerData, offerData2L: offerData2L, offerState: offerState, readOnly: false, templateData: templateData, templateNames: templateNames, title: "Edit Template" }));
};

var ActiveStatus;
(function (ActiveStatus) {
    ActiveStatus["Active"] = "Active";
    ActiveStatus["Deactivated"] = "Deactivated";
})(ActiveStatus || (ActiveStatus = {}));
var TemplateCenterLandingPage = function (_a) {
    var canCreateDemandInclusionTemplates = _a.canCreateDemandInclusionTemplates, canEditDemandInclusionTemplates = _a.canEditDemandInclusionTemplates, onActivate = _a.onActivate, onDeactivate = _a.onDeactivate, onViewDetails = _a.onViewDetails, onCreateNew = _a.onCreateNew, onCreateNewFromTemplate = _a.onCreateNewFromTemplate, templates = _a.templates, isLoading = _a.isLoading;
    var gridRef = React.useRef(null);
    var RenderStatus = React.useCallback(function (_a) {
        var deactivatedAt = _a.data.deactivatedAt;
        var status = deactivatedAt ? Intent.NONE : Intent.SUCCESS;
        var label = deactivatedAt
            ? ActiveStatus.Deactivated
            : ActiveStatus.Active;
        return jsx(StatusDot, __assign({ status: status }, { children: label }));
    }, []);
    var RenderActionMenu = React.useCallback(function (_a) {
        var data = _a.data;
        var id = data.id, uuid = data.uuid, deactivatedAt = data.deactivatedAt;
        return (jsxs(ActionMenu, { children: [jsx(MenuItem$1, { icon: jsx(FontAwesomeIcon, { color: colors.daphne, icon: faClone$1 }), text: "Create New from Template", onClick: function () { return onCreateNewFromTemplate(uuid); } }), deactivatedAt ? (jsx(MenuItem$1, { icon: jsx(FontAwesomeIcon, { icon: faRotate }), text: "Activate Template", onClick: function () { return onActivate(id); } })) : (jsx(MenuItem$1, { icon: jsx(FontAwesomeIcon, { icon: faBan }), text: "Deactivate Template", onClick: function () { return onDeactivate(id); } }))] }));
    }, [onCreateNewFromTemplate, onDeactivate, onActivate]);
    var columnDefs = React.useMemo(function () {
        var defs = [
            {
                field: 'id',
                filter: 'simpleTextFilter',
                headerName: 'Template ID',
                sort: 'desc',
            },
            {
                cellRenderer: function (_a) {
                    var data = _a.data, value = _a.value;
                    return jsx("a", __assign({ onClick: function () { return onViewDetails(data === null || data === void 0 ? void 0 : data.uuid); } }, { children: value }));
                },
                field: 'name',
                filter: 'simpleTextFilter',
                filterParams: { placeHolder: 'Search for Name' },
                flex: 5,
                headerName: 'Template Name',
                valueGetter: function (_a) {
                    var data = _a.data;
                    return data === null || data === void 0 ? void 0 : data.name;
                },
            },
            {
                cellRenderer: function (_a) {
                    var value = _a.value;
                    return jsx(Tag, { children: value });
                },
                field: 'productType',
                filter: 'agSetColumnFilter',
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Product Type',
                valueGetter: function (_a) {
                    var data = _a.data;
                    return (data === null || data === void 0 ? void 0 : data.productType) && startCase(data.productType);
                },
            },
            {
                cellRenderer: function (_a) {
                    var createdBy = _a.data.createdBy;
                    return (jsx(UserAvatar, { name: createdBy }));
                },
                field: 'createdBy',
                filter: 'agSetColumnFilter',
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Created By',
            },
            {
                cellRenderer: function (_a) {
                    var createdAt = _a.data.createdAt;
                    return formatDate$1(createdAt);
                },
                field: 'createdAt',
                filter: 'dateRangeFilter',
                filterParams: {
                    valueGetter: function (_a) {
                        var data = _a.data;
                        return formatDate$1(data);
                    },
                },
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Created At',
            },
            {
                cellRenderer: RenderStatus,
                field: 'deactivatedAt',
                filter: 'agSetColumnFilter',
                filterParams: {
                    valueGetter: function (_a) {
                        var data = _a.data;
                        var deactivatedAt = data.deactivatedAt;
                        // deactivatedAt should be a deactivated date or undefined
                        return deactivatedAt
                            ? ActiveStatus.Deactivated
                            : ActiveStatus.Active;
                    },
                    values: [ActiveStatus.Active, ActiveStatus.Deactivated],
                },
                headerComponentParams: {
                    filterIcon: FilterIcon.FILTER,
                },
                headerName: 'Status',
            },
        ];
        if (canEditDemandInclusionTemplates) {
            defs.push({
                cellRenderer: RenderActionMenu,
                field: 'actions',
                flex: 1,
                headerName: '',
                sortable: false,
                suppressMenu: true,
                // For some reason AGGrid needs a column def to map to a value or else the
                // state in the cellRenderer will be behind. The field deactivatedAt was
                // chosen a bit arbitrarily.
                valueGetter: function (_a) {
                    var data = _a.data;
                    return data === null || data === void 0 ? void 0 : data.deactivatedAt;
                },
            });
        }
        return defs;
    }, [canEditDemandInclusionTemplates, RenderStatus, RenderActionMenu]);
    var onGridReady = function (_a) {
        var api = _a.api;
        var filterModel = api.getFilterModel();
        api.setFilterModel(__assign(__assign({}, filterModel), { deactivatedAt: {
                type: 'set',
                values: [ActiveStatus.Active],
            } }));
    };
    var gridOptions = usePortalAgGridOptions({
        defaultColDef: {
            flex: 3,
        },
        onGridReady: onGridReady,
    });
    if (isLoading) {
        return jsx(Spinner$1, {});
    }
    if (!(templates === null || templates === void 0 ? void 0 : templates.length)) {
        return (jsxs("div", __assign({ className: "template-center-landing-page-empty" }, { children: [jsx(FontAwesomeKitIcon, { color: colors.cistern, icon: KitIconNames.NullStateEmptyPage, size: "10x" }), jsx("h1", { children: "Create Your First Template" }), jsx(EvenCreateNewButton, __assign({ onClick: onCreateNew }, { children: "Create New Template" }))] })));
    }
    return (jsxs(Fragment, { children: [jsxs(HeaderWithActions, __assign({ className: "title", title: "Demand Inclusion Templates" }, { children: [jsx(ClearAllButton, { gridRef: gridRef }), canCreateDemandInclusionTemplates && (jsx(EvenCreateNewButton, __assign({ onClick: onCreateNew }, { children: "Create New" })))] })), jsx("div", __assign({ className: "ag-theme-alpine", style: { height: 600 } }, { children: jsx(AgGridReact, { ref: gridRef, className: "demand-inclusion-template-table", columnDefs: columnDefs, getRowId: function (_a) {
                        var id = _a.data.id;
                        return id;
                    }, gridOptions: gridOptions, rowData: sortBy(templates, 'id') }) }))] }));
};

var styles$5 = {"cancel-subscription-action":"CancelSubscriptionAction-module_cancel-subscription-action__hjdU1","checkbox":"CancelSubscriptionAction-module_checkbox__SU1Vo","radio-btn":"CancelSubscriptionAction-module_radio-btn__hAC42","progress":"CancelSubscriptionAction-module_progress__89EHl"};

var AgreeOnTerms = function (_a) {
    var children = _a.children, isChecked = _a.isChecked, onChange = _a.onChange;
    return (jsxs("div", __assign({ className: classNames(Classes.DIALOG_BODY, styles$5['cancel-subscription-action']) }, { children: [jsx("h4", { children: "Are you sure?" }), jsx("p", { children: "Upon cancelation, you will be charged the fees for the remainder of your existing subscription and your subscription will not renew." }), jsx("p", { children: "If you would like to proceed with canceling your subscription, please check the box that you have read the terms of cancelation and then select \u201CContinue\u201D button below." }), jsx(Checkbox, { checked: isChecked, className: styles$5.checkbox, label: "Yes, I have read and accept the terms of canceling subscription.", onChange: onChange }), jsx("div", __assign({ className: classNames(styles$5.progress) }, { children: children }))] })));
};

var CancellationReasonString;
(function (CancellationReasonString) {
    CancellationReasonString["EXPECT"] = "Did not meet my expectations";
    CancellationReasonString["OTHER"] = "Other";
    CancellationReasonString["PRICING"] = "Pricing was too high";
    CancellationReasonString["REQUIRE"] = "No longer require this type of product";
    CancellationReasonString["REVENUE"] = "My business was unable to drive sufficient revenue";
})(CancellationReasonString || (CancellationReasonString = {}));

var CancellationReasonOrdered = [
    CancellationReasonString.EXPECT,
    CancellationReasonString.REQUIRE,
    CancellationReasonString.PRICING,
    CancellationReasonString.REVENUE,
    CancellationReasonString.OTHER,
];
var CancellationReason = function (_a) {
    var children = _a.children, defaultSelected = _a.defaultSelected, onChange = _a.onChange;
    var _b = useState(defaultSelected), selectedValue = _b[0], setSelectedValue = _b[1];
    var _c = useState(''), otherReason = _c[0], setOtherReason = _c[1];
    var onOtherReasonChange = function (reason) {
        setOtherReason(reason);
        onChange(reason);
    };
    var onChangeInternal = function (value) {
        setSelectedValue(value);
        if (value !== CancellationReasonString.OTHER) {
            onChange(value);
        }
        else {
            onChange(otherReason);
        }
    };
    return (jsxs("div", __assign({ className: classNames(Classes.DIALOG_BODY, styles$5['cancel-subscription-action']) }, { children: [jsx("h4", { children: "Please select the option that best describes your reason for cancelation:" }), jsxs(RadioGroup, __assign({ selectedValue: selectedValue, onChange: function (evt) {
                    return onChangeInternal(evt.currentTarget.value);
                } }, { children: [CancellationReasonOrdered.map(function (reason, i) { return (jsx(Radio, { className: classNames(styles$5['radio-btn']), label: reason, value: reason }, "reason-".concat(i))); }), jsx(TextAreaWithCharacterLimit, { limit: 250, placeholder: "Tell us your thoughts", onChange: onOtherReasonChange, onFocus: function () { return onChangeInternal(CancellationReasonString.OTHER); } })] })), jsx("div", __assign({ className: classNames(styles$5.progress) }, { children: children }))] })));
};

var ConfirmationInfo = function (_a) {
    var isLoading = _a.isLoading, isError = _a.isError;
    return (jsx("div", __assign({ className: classNames(Classes.DIALOG_BODY, styles$5['cancel-subscription-action']) }, { children: isLoading && !isError ? (jsx(Spinner, {})) : isError ? (jsx(Fragment, { children: "Oops, something went wrong while canceling your subscription." })) : (jsxs(Fragment, { children: [jsx("h4", { children: "Your subscription has been canceled" }), jsx("p", { children: "You will have full access to Control Center until your subscription end date. On your end date, you will lose access to reporting and other features within Control Center and your integrations with Even Financial will be deactivated." }), jsxs("p", { children: ["If this cancellation is an error, please contact", ' ', jsx("a", __assign({ href: "mailto:partnersupport@engine.tech" }, { children: "partnersupport@engine.tech" })), ' ', "to reactivate your account."] })] })) })));
};

var CancellationSteps;
(function (CancellationSteps) {
    CancellationSteps[CancellationSteps["AgreeOnTerms"] = 0] = "AgreeOnTerms";
    CancellationSteps[CancellationSteps["CancellationReason"] = 1] = "CancellationReason";
    CancellationSteps[CancellationSteps["ConfirmationInfo"] = 2] = "ConfirmationInfo";
})(CancellationSteps || (CancellationSteps = {}));
var CancelSubscriptionAction = function (_a) {
    var isOpen = _a.isOpen, isCanceled = _a.isCanceled, isError = _a.isError, cancelSubscription = _a.cancelSubscription, onClose = _a.onClose;
    var _b = useState(false), termsChecked = _b[0], setTermsChecked = _b[1];
    var _c = useState(''), cancelationReason = _c[0], setCancellationReason = _c[1];
    var _d = useState(CancellationSteps.AgreeOnTerms), stepId = _d[0], setStepId = _d[1];
    var onCloseInternal = function () {
        setTermsChecked(false);
        setCancellationReason('');
        setStepId(CancellationSteps.AgreeOnTerms);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var onNextStep = function (newDialogStepId, prevDialogStepId) {
        setStepId(newDialogStepId);
        if (prevDialogStepId === CancellationSteps.CancellationReason &&
            newDialogStepId === CancellationSteps.ConfirmationInfo) {
            cancelSubscription(cancelationReason);
        }
    };
    var getNextButtonProps = useCallback(function () {
        var text = 'Continue';
        var disabled = false;
        switch (stepId) {
            case CancellationSteps.AgreeOnTerms:
                disabled = !termsChecked;
                break;
            case CancellationSteps.CancellationReason:
                disabled = cancelationReason === '';
                text = 'Cancel Subscription';
                break;
        }
        return {
            disabled: disabled,
            text: text,
        };
    }, [stepId, cancelationReason, termsChecked]);
    var dots = jsx(Dots, { activeIndex: stepId, size: 2 });
    return (jsx(Fragment, { children: jsxs(MultistepDialog, __assign({ isCloseButtonShown: true, usePortal: true, canOutsideClickClose: false, className: classNames('bp4-multistep-dialog', {
                'danger-step': stepId === CancellationSteps.CancellationReason,
            }), closeButtonProps: {
                intent: 'primary',
            }, finalButtonProps: {
                className: 'final-button',
                disabled: !isCanceled && !isError,
                intent: 'primary',
                onClick: function () {
                    onCloseInternal();
                },
                text: 'Done',
            }, initialStepIndex: 0, isOpen: isOpen, nextButtonProps: getNextButtonProps(), showCloseButtonInFooter: stepId !== CancellationSteps.ConfirmationInfo, onChange: onNextStep, onClose: onCloseInternal }, { children: [jsx(DialogStep, { id: CancellationSteps.AgreeOnTerms, panel: jsx(AgreeOnTerms, __assign({ isChecked: termsChecked, onChange: function (evt) {
                            return setTermsChecked(evt.target.checked);
                        } }, { children: dots })) }), jsx(DialogStep, { id: CancellationSteps.CancellationReason, panel: jsx(CancellationReason, __assign({ defaultSelected: cancelationReason, onChange: function (reason) { return setCancellationReason(reason); } }, { children: dots })) }), jsx(DialogStep, { id: CancellationSteps.ConfirmationInfo, panel: jsx(ConfirmationInfo, { isError: isError, isLoading: !isCanceled }) })] })) }));
};

var MCIReportsTable = function (_a) {
    var _b;
    var loading = _a.loading, onDownloadReport = _a.onDownloadReport, rowData = _a.rowData;
    var columnDefs = [
        {
            cellRenderer: function (_a) {
                var _b = _a.data, subAccountUuid = _b.subAccountUuid, subAccountName = _b.subAccountName;
                return (jsx("a", __assign({ href: "/demand-sub-accounts/".concat(subAccountUuid) }, { children: subAccountName })));
            },
            field: 'subAccountName',
            filter: 'simpleTextFilter',
            filterParams: {
                placeHolder: 'Search by Demand Sub-Account',
            },
            flex: 4,
            headerName: 'Demand Sub-Account',
        },
        {
            field: 'dateStart',
            flex: 3,
            headerName: 'Start Date',
            type: ColumnDefs.DATE,
        },
        {
            field: 'dateEnd',
            flex: 3,
            headerName: 'End Date',
            type: ColumnDefs.DATE,
        },
        {
            cellRenderer: function (_a) {
                var data = _a.data;
                return (jsx(Button, __assign({ minimal: true, className: "link", "data-testid": "download-report-".concat(data.fileName), icon: jsx(FontAwesomeIcon, { icon: faDownload, size: "sm", transform: { x: 5 } }), onClick: function () { return onDownloadReport(data); } }, { children: "Download Report" })));
            },
            field: 'fileName',
            flex: 3,
            headerName: 'Download Report',
            sortable: false,
            suppressMenu: true,
        },
    ];
    var gridOptions = usePortalAgGridOptions({ columnDefs: columnDefs });
    return (jsx(AgGridReact, { className: classNames((_b = {}, _b[Classes.SKELETON] = loading, _b)), getRowId: function (_a) {
            var data = _a.data;
            return data.fileName;
        }, gridOptions: gridOptions, rowData: rowData }));
};

var MCIReportsCard = function (_a) {
    var loading = _a.loading, onDownloadReport = _a.onDownloadReport, onViewMoreClick = _a.onViewMoreClick, rowData = _a.rowData, title = _a.title;
    return (jsx(RoundedCard, __assign({ headerContent: jsx(ViewMoreButton, { onClick: onViewMoreClick }), loading: loading, title: title }, { children: jsx("div", __assign({ className: "ag-theme-alpine", style: { height: 226 } }, { children: jsx(MCIReportsTable, { loading: loading, rowData: rowData, onDownloadReport: onDownloadReport }) })) })));
};

var styles$4 = {"demand-contract-rd":"index-module_demand-contract-rd__OpPzh","demand-contract-rd-title":"index-module_demand-contract-rd-title__bVtQ7","demand-contract-rd-label":"index-module_demand-contract-rd-label__wrpU5","demand-contract-rd-content-grid":"index-module_demand-contract-rd-content-grid__AsjRi","demand-contract-rd-row":"index-module_demand-contract-rd-row__SPCfC","demand-contract-rd-details":"index-module_demand-contract-rd-details__ma8lR","demand-contract-rd-details-content":"index-module_demand-contract-rd-details-content__iju4P","demand-contract-rd-subgrid":"index-module_demand-contract-rd-subgrid__6kOno","demand-contract-rd-subgrid2":"index-module_demand-contract-rd-subgrid2__o-n7d","demand-contract-rd-not-handled":"index-module_demand-contract-rd-not-handled__oAqQ4"};

var RevenueByAmountDetails = function (_a) {
    var cost = _a.cost, title = _a.title, plan = _a.plan;
    var formattedPlan = getRevenueClauseTypeDisplayText(plan);
    return (jsxs("div", __assign({ className: styles$4['demand-contract-rd'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-title'] }, { children: jsx("h6", { children: title }) })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-content-grid'] }, { children: [jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Pricing Plan" })), jsx("div", __assign({ className: styles$4['demand-contract-rd-tag'] }, { children: jsx(Tag, __assign({ minimal: true }, { children: formattedPlan })) }))] })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Amount" })), jsx("div", { children: moneyFormatter$1(cost, true) })] }))] }))] })));
};

var RevenueByPercentageDetails = function (_a) {
    var title = _a.title, percent = _a.percent, plan = _a.plan;
    var formattedPlan = getRevenueClauseTypeDisplayText(plan);
    var percentage = formatPercentWithPrecision$1(percent);
    return (jsxs("div", __assign({ className: styles$4['demand-contract-rd'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-title'] }, { children: jsx("h6", { children: title }) })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-content-grid'] }, { children: [jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Pricing Plan" })), jsx("div", { children: jsx(Tag, __assign({ minimal: true }, { children: formattedPlan })) })] })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Percent %" })), jsx("div", { children: percentage })] }))] }))] })));
};

var RevenueByPercentageFlatFeeAndThreshold = function (_a) {
    var title = _a.title, percent = _a.percent, plan = _a.plan, threshold = _a.threshold, flatFee = _a.flatFee;
    var formattedPlan = getRevenueClauseTypeDisplayText(plan);
    var percentage = formatPercentWithPrecision$1(percent);
    var thresholdValue = moneyFormatter$1(threshold, true);
    var flatFeeValue = moneyFormatter$1(flatFee, true);
    return (jsxs("div", __assign({ className: styles$4['demand-contract-rd'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-title'] }, { children: jsx("h6", { children: title }) })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-content-grid'] }, { children: [jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Pricing Plan" })), jsx("div", { children: jsx(Tag, __assign({ minimal: true }, { children: formattedPlan })) })] })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Default Percent %" })), jsx("div", { children: percentage })] })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Flat Fee" })), jsx("div", { children: flatFeeValue })] })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Threshold" })), jsx("div", { children: thresholdValue })] }))] }))] })));
};

var RevenueByPercentageOfFundedByLoanSize = function (_a) {
    var title = _a.title, maxPercent = _a.maxPercent, plan = _a.plan, percentByFundedLoanAmount = _a.percentByFundedLoanAmount;
    var formattedPlan = getRevenueClauseTypeDisplayText(plan);
    var maxPercentage = formatPercentWithPrecision$1(maxPercent);
    return (jsxs("div", __assign({ className: styles$4['demand-contract-rd'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-title'] }, { children: jsx("h6", { children: title }) })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-content-grid'] }, { children: [jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Pricing Plan" })), jsx("div", { children: jsx(Tag, __assign({ minimal: true }, { children: formattedPlan })) })] })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Max Percent %" })), jsx("div", { children: maxPercentage })] })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'], style: { rowGap: '8px' } }, { children: [jsxs("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: ["Funded Loan Size ", jsx("br", {}), " (upper bound)"] })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: ["Percentage ", jsx("br", {}), " (paid for each tier)"] })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-subgrid'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Tier" })), jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Value" }))] })), jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "%" })), percentByFundedLoanAmount.map(function (_a, i) {
                                var key = _a.key, value = _a.value;
                                var paddedKey = formatWithPadding('000', i + 1);
                                var formattedValue = moneyFormatter$1(key, true);
                                var formattedPercentage = formatPercentWithPrecision$1(value);
                                return (jsxs(Fragment$1, { children: [jsxs("div", __assign({ style: {
                                                display: 'grid',
                                                gridTemplateColumns: '1fr 1fr',
                                            } }, { children: [jsx("div", { children: paddedKey }), jsx("div", { children: formattedValue })] })), jsx("div", { children: formattedPercentage })] }, key));
                            })] }))] }))] })));
};

var RevenueByPercentageOfFundedLoanAmountBySupply = function (_a) {
    var title = _a.title, plan = _a.plan, basePercentage = _a.basePercentage, percentBySupplySubAccountId = _a.percentBySupplySubAccountId, supplySubAccounts = _a.supplySubAccounts;
    var formattedPlan = getRevenueClauseTypeDisplayText(plan);
    var formattedBasePercentage = formatPercentWithPrecision$1(basePercentage);
    return (jsxs("div", __assign({ className: styles$4['demand-contract-rd'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-title'] }, { children: jsx("h6", { children: title }) })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-content-grid'] }, { children: [jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Pricing Plan" })), jsx("div", { children: jsx(Tag, __assign({ minimal: true }, { children: formattedPlan })) })] })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Default Percent %" })), jsx("div", { children: formattedBasePercentage })] })), jsxs("div", __assign({ className: styles$4['demand-contract-rd-subgrid2'] }, { children: [jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Supply Sub Account" })), jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Percentage" }))] })), percentBySupplySubAccountId.map(function (_a) {
                                var _b;
                                var key = _a.key, value = _a.value;
                                var subAccount = supplySubAccounts === null || supplySubAccounts === void 0 ? void 0 : supplySubAccounts.find(function (ssa) { return (ssa === null || ssa === void 0 ? void 0 : ssa.id) === key; });
                                var percentage = formatPercentWithPrecision$1(value);
                                return (jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'] }, { children: [jsx("div", { children: (_b = subAccount === null || subAccount === void 0 ? void 0 : subAccount.displayName) !== null && _b !== void 0 ? _b : 'N/A' }), jsx("div", { children: percentage })] }), key));
                            })] }))] }))] })));
};

var RevenueNotHandled = function () {
    return (jsx("div", __assign({ className: styles$4['demand-contract-rd'] }, { children: jsx("div", __assign({ className: classNames(styles$4['demand-contract-rd-title'], styles$4['demand-contract-rd-not-handled']) }, { children: jsx("h6", { children: "Revenue Not Handled" }) })) })));
};

var ContractDetailsCard = function (_a) {
    var effectiveAt = _a.effectiveAt, id = _a.id;
    return (jsxs("div", __assign({ className: styles$4['demand-contract-rd'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-title'] }, { children: jsx("h6", { children: "Contract Details" }) })), jsxs("div", __assign({ className: classNames(styles$4['demand-contract-rd-content-grid'], styles$4['demand-contract-rd-details']) }, { children: [jsxs("div", __assign({ className: styles$4['demand-contract-rd-row'] }, { children: [jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Contract ID" })), jsx("div", __assign({ className: styles$4['demand-contract-rd-label'] }, { children: "Dates Active" }))] })), jsxs("div", __assign({ className: classNames(styles$4['demand-contract-rd-row'], styles$4['demand-contract-rd-details-content']) }, { children: [jsxs("div", { children: ["#", id] }), jsxs("div", { children: [effectiveAt, " - present"] })] }))] }))] })));
};

var styles$3 = {"container":"DemandUserSettingsForm-module_container__H9aMS","submit":"DemandUserSettingsForm-module_submit__0Ai11"};

var DemandUserSettingsForm = function (_a) {
    var _b, _c, _d;
    var emailAddress = _a.emailAddress, firstName = _a.firstName, lastName = _a.lastName, isDisabled = _a.isDisabled, onSubmit = _a.onSubmit, onResetPassword = _a.onResetPassword;
    var form = useForm();
    var register = form.register, handleSubmit = form.handleSubmit, errors = form.formState.errors, reset = form.reset;
    useEffect(function () {
        reset({
            emailAddress: emailAddress,
            firstName: firstName,
            lastName: lastName,
        });
    }, [emailAddress, firstName, lastName]);
    return (jsx(FormProvider, __assign({}, form, { children: jsxs("form", __assign({ className: styles$3.container }, { children: [jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.firstName) === null || _b === void 0 ? void 0 : _b.message, label: "First Name", layout: FieldLayout.Horizontal }, { children: jsx("input", __assign({ disabled: isDisabled }, register('firstName', { required: 'First name is required' }))) })), jsx(Field, __assign({ error: (_c = errors === null || errors === void 0 ? void 0 : errors.lastName) === null || _c === void 0 ? void 0 : _c.message, label: "Last Name", layout: FieldLayout.Horizontal }, { children: jsx("input", __assign({ disabled: isDisabled }, register('lastName', { required: 'Last name is required' }))) })), jsx(Field, __assign({ error: (_d = errors === null || errors === void 0 ? void 0 : errors.emailAddress) === null || _d === void 0 ? void 0 : _d.message, label: "Email Address", layout: FieldLayout.Horizontal }, { children: jsx("input", __assign({ disabled: true }, register('emailAddress', {
                        required: 'Email address is required',
                    }))) })), jsx(Field, __assign({ label: "Password", layout: FieldLayout.Horizontal }, { children: jsx("a", __assign({ "aria-disabled": isDisabled, onClick: onResetPassword }, { children: "Reset Password" })) })), jsx("div", __assign({ className: styles$3.submit }, { children: jsx(EvenButton, __assign({ disabled: isDisabled, onClick: handleSubmit(onSubmit) }, { children: "Save changes" })) }))] })) })));
};

var styles$2 = {"container":"DemandUserDetailsTab-module_container__nI-pB","form-container":"DemandUserDetailsTab-module_form-container__DQF6p","header":"DemandUserDetailsTab-module_header__8i0xI"};

var DemandUserDetailsTab = function (_a) {
    var demandUserSettingsFormProps = _a.demandUserSettingsFormProps;
    return (jsxs("div", __assign({ className: styles$2.container }, { children: [jsx("div", __assign({ className: styles$2.header }, { children: "Settings" })), jsx("div", __assign({ className: styles$2['form-container'] }, { children: jsx(DemandUserSettingsForm, __assign({}, demandUserSettingsFormProps)) }))] })));
};

var styles$1 = {"first-integration-card":"FirstIntegrationCard-module_first-integration-card__q5JNa","first-integration-card-content":"FirstIntegrationCard-module_first-integration-card-content__8ygDa","first-integration-card-button":"FirstIntegrationCard-module_first-integration-card-button__-FiAL","first-integration-card-message":"FirstIntegrationCard-module_first-integration-card-message__aiU9K"};

var FirstIntegrationCard = function (_a) {
    var onCreateIntegration = _a.onCreateIntegration, title = _a.title;
    return (jsx(RoundedCard, __assign({ className: styles$1['first-integration-card'], title: "Create Your First ".concat(title, " Integration") }, { children: jsxs("div", __assign({ className: styles$1['first-integration-card-content'] }, { children: [jsxs("p", __assign({ className: styles$1['first-integration-card-message'] }, { children: ["To start providing ", title, " offers to your users, get started with your first ", startCase$1(title), " integration."] })), jsx(EvenButton, __assign({ className: styles$1['first-integration-card-button'], "data-testid": "first-integration-create-btn", intent: "success", onClick: function () { return onCreateIntegration(); } }, { children: "Create Integration" }))] })) })));
};

var FieldArrayContext = createContext(null);
var useFieldArrayContext = function () { return useContext(FieldArrayContext); };
var FieldArrayContextProvider = function (props) {
    var children = props.children, data = __rest(props, ["children"]);
    return (jsx(FieldArrayContext.Provider, __assign({ value: data }, { children: children })));
};

var AmountMode;
(function (AmountMode) {
    AmountMode["Add"] = "add";
    AmountMode["Deduct"] = "deduct";
})(AmountMode || (AmountMode = {}));
var AmountField = function (_a) {
    var _b, _c, _d;
    var index = _a.index;
    var _e = useState(AmountMode.Add), amountMode = _e[0], setAmountMode = _e[1];
    var _f = useFormContext(), control = _f.control, setValue = _f.setValue, errors = _f.formState.errors, register = _f.register;
    var watchedAmount = useWatch({
        control: control,
        name: "adjustments.".concat(index, ".amount"),
    });
    useEffect(function () {
        if (watchedAmount < 0 && amountMode === AmountMode.Add) {
            setAmountMode(AmountMode.Deduct);
        }
        if (watchedAmount > 0 && amountMode === AmountMode.Deduct) {
            setAmountMode(AmountMode.Add);
        }
    }, [watchedAmount]);
    var handleAmountModeChange = function (mode) {
        setAmountMode(function () { return mode; });
        var modifiedAmount;
        if (mode === AmountMode.Deduct) {
            if (watchedAmount < 0) {
                modifiedAmount = watchedAmount;
            }
            else {
                modifiedAmount = watchedAmount * -1;
            }
        }
        if (mode === AmountMode.Add) {
            modifiedAmount = Math.abs(watchedAmount);
        }
        setValue("adjustments.".concat(index, ".amount"), modifiedAmount);
    };
    return (jsx(Field, __assign({ error: (_d = (_c = (_b = errors === null || errors === void 0 ? void 0 : errors.adjustments) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.amount) === null || _d === void 0 ? void 0 : _d.message, label: "Adjustment Amount", layout: FieldLayout.Vertical }, { children: jsxs("div", __assign({ className: "adjustment-form-amount" }, { children: [jsx("span", { children: "$" }), jsx("input", __assign({ type: "number" }, register("adjustments.".concat(index, ".amount"), {
                    valueAsNumber: true,
                }))), jsxs(ButtonGroup, { children: [jsx(EvenButton, __assign({ outlined: true, active: amountMode === AmountMode.Add, onClick: function () {
                                handleAmountModeChange(AmountMode.Add);
                            } }, { children: "Add" })), jsx(EvenButton, __assign({ outlined: true, active: amountMode === AmountMode.Deduct, onClick: function () { return handleAmountModeChange(AmountMode.Deduct); } }, { children: "Deduct" }))] })] })) })));
};

var TotalAmountField = function (_a) {
    var _b;
    var summary = _a.summary;
    var control = useFormContext().control;
    var result = useWatch({
        control: control,
        name: 'adjustments',
    });
    var total = result.reduce(function (acc, curr) {
        return acc + (curr === null || curr === void 0 ? void 0 : curr.amount) || 0;
    }, 0);
    return (jsx(Field, __assign({ className: "adjustment-form-new-total-wrapper", label: "New Total", layout: FieldLayout.Horizontal }, { children: jsxs("div", __assign({ className: "adjustment-form-new-total" }, { children: [jsx("span", { children: "$" }), jsx("input", { disabled: true, type: "number", value: total + ((_b = summary === null || summary === void 0 ? void 0 : summary.calculatedPayout) !== null && _b !== void 0 ? _b : 0) })] })) })));
};

var BaseLedgerItemDropdownField = function (_a) {
    var _b;
    var children = _a.children, rest = __rest(_a, ["children"]);
    var _c = useFormContext(), errors = _c.formState.errors, register = _c.register;
    return (jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.ledgerItemId) === null || _b === void 0 ? void 0 : _b.message, layout: FieldLayout.Vertical }, rest, { children: jsx("select", __assign({ disabled: true }, register('ledgerItemId', { valueAsNumber: true }), { children: children })) })));
};
var LedgerItemDropdown = function (_a) {
    var type = _a.type, _b = _a.data, data = _b === void 0 ? [] : _b, ledgerItemId = _a.ledgerItemId;
    if (!data.length) {
        return (jsx(BaseLedgerItemDropdownField, __assign({ label: "Ledger Item" }, { children: jsx("option", __assign({ value: ledgerItemId }, { children: ledgerItemId })) })));
    }
    return (jsx(BaseLedgerItemDropdownField, __assign({ label: type }, { children: data.map(function (item) { return (jsx("option", __assign({ value: item.id }, { children: "".concat(type, " ").concat(item.id, " - $").concat(item.calculatedPayout) }), item.id)); }) })));
};

var AdjustmentConfigurationForm = function (_a) {
    var _b, _c, _d;
    var index = _a.index;
    var _e = useFieldArrayContext(), fields = _e.fields, remove = _e.remove;
    var _f = useFormContext(), register = _f.register, errors = _f.formState.errors, control = _f.control;
    return (jsxs("section", __assign({ className: "adjustment-form-adjustment-configuration" }, { children: [jsxs("header", __assign({ className: "adjustment-form-header" }, { children: [jsxs(H3, { children: ["Adjustment ", index + 1] }), fields.length !== 1 && (jsx(EvenButton, { minimal: true, icon: jsx(FontAwesomeIcon, { fontSize: 16, icon: faTrash$1 }), onClick: function () { return remove(index); } }))] })), jsx(Field, __assign({ error: (_d = (_c = (_b = errors === null || errors === void 0 ? void 0 : errors.adjustments) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.adjustmentReason) === null || _d === void 0 ? void 0 : _d.message, label: "Reason", layout: FieldLayout.Vertical }, { children: jsxs("select", __assign({}, register("adjustments.".concat(index, ".adjustmentReason")), { children: [jsx("option", __assign({ value: AdjustmentReason.MonthlyTenPercent }, { children: "Monthly 10%" })), jsx("option", __assign({ value: AdjustmentReason.CustomerReporting }, { children: "Customer Reporting" })), jsx("option", __assign({ value: AdjustmentReason.SavingsRevenue }, { children: "Savings Revenue" })), jsx("option", __assign({ value: AdjustmentReason.CreditCardRevenue }, { children: "Credit Card Revenue" })), jsx("option", __assign({ value: AdjustmentReason.EmailRevenue }, { children: "Email Revenue" })), jsx("option", __assign({ value: AdjustmentReason.PreReported }, { children: "Pre-Reported" })), jsx("option", __assign({ value: AdjustmentReason.Promotional }, { children: "Promotional" })), jsx("option", __assign({ value: AdjustmentReason.LeadTestingAdjustment }, { children: "Lead Testing Adjustment" })), jsx("option", __assign({ value: AdjustmentReason.Other }, { children: "Other" }))] })) })), jsx(Field, __assign({ label: "Notes", layout: FieldLayout.Vertical }, { children: jsx(Controller, { control: control, name: "adjustments.".concat(index, ".memo"), render: function (_a) {
                        var onChange = _a.field.onChange;
                        return (jsx(TextAreaWithCharacterLimit, { limit: 30, onChange: onChange }));
                    } }) })), jsx(AmountField, { index: index })] })));
};

var REQUIRED_FIELD = 'This field is required.';
var schema$2 = yup
    .object({
    accountId: yup.number().required(REQUIRED_FIELD),
    adjustments: yup.array().of(yup.object().shape({
        adjustmentReason: yup
            .mixed()
            .oneOf([
            AdjustmentReason.CreditCardRevenue,
            AdjustmentReason.CustomerReporting,
            AdjustmentReason.EmailRevenue,
            AdjustmentReason.LeadTestingAdjustment,
            AdjustmentReason.MonthlyTenPercent,
            AdjustmentReason.Other,
            AdjustmentReason.PreReported,
            AdjustmentReason.Promotional,
            AdjustmentReason.Promotional,
            AdjustmentReason.SavingsRevenue,
        ])
            .required(REQUIRED_FIELD),
        amount: yup
            .number()
            .typeError('Please input an amount.')
            .required(REQUIRED_FIELD),
        memo: yup.string(),
    })),
    ledgerItemId: yup.number().required(REQUIRED_FIELD),
})
    .required();
var AdjustmentsForm = function (_a) {
    var _b;
    var account = _a.account, onSubmit = _a.onSubmit, ledgerItemId = _a.ledgerItemId, _c = _a.data, data = _c === void 0 ? [] : _c, type = _a.type, visible = _a.visible, onClose = _a.onClose, onUpdate = _a.onUpdate;
    var _d = useState(function () {
        return data.find(function (li) { return li.id === ledgerItemId; });
    }), summary = _d[0], setSummary = _d[1];
    var form = useForm({
        defaultValues: {
            accountId: account === null || account === void 0 ? void 0 : account.id,
            adjustments: [
                {
                    adjustmentReason: AdjustmentReason.MonthlyTenPercent,
                    amount: 0,
                    memo: '',
                },
            ],
            ledgerItemId: ledgerItemId,
        },
        resolver: yupResolver(schema$2),
    });
    var handleSubmit = form.handleSubmit, control = form.control, register = form.register, setValue = form.setValue, errors = form.formState.errors;
    var fieldArray = useFieldArray({
        control: control,
        name: 'adjustments',
    });
    var fields = fieldArray.fields, append = fieldArray.append;
    var ledgerItemIdChanged = useWatch({
        control: control,
        name: 'ledgerItemId',
    });
    var accountIdChanged = useWatch({
        control: control,
        name: 'accountId',
    });
    useEffect(function () {
        if (account === null || account === void 0 ? void 0 : account.id) {
            setValue('accountId', account.id);
        }
        if (ledgerItemId) {
            setValue('ledgerItemId', ledgerItemId);
        }
    }, [account === null || account === void 0 ? void 0 : account.id, ledgerItemId]);
    useEffect(function () {
        setSummary(data.find(function (li) { return li.id === ledgerItemIdChanged; }));
    }, [ledgerItemIdChanged]);
    useEffect(function () {
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
            accountId: accountIdChanged,
            ledgerItemId: ledgerItemIdChanged,
        });
    }, [ledgerItemIdChanged, accountIdChanged]);
    return (jsx(DrawerForm, __assign({ disableCloseOnMouseDown: true, cancelText: "Cancel", submitText: "Create", title: "Create Adjustments", visible: visible, onClose: onClose, onSubmit: handleSubmit(onSubmit) }, { children: jsx(FieldArrayContextProvider, __assign({}, fieldArray, { children: jsxs(FormProvider, __assign({}, form, { children: [jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.accountId) === null || _b === void 0 ? void 0 : _b.message, label: "Account", layout: FieldLayout.Vertical }, { children: jsx("select", __assign({ disabled: true }, register('accountId', {
                            valueAsNumber: true,
                        }), { children: jsx("option", __assign({ value: account === null || account === void 0 ? void 0 : account.id }, { children: account === null || account === void 0 ? void 0 : account.name })) })) })), jsx(LedgerItemDropdown, { data: data, ledgerItemId: ledgerItemId, type: type }), fields.map(function (item, index) {
                        return jsx(AdjustmentConfigurationForm, { index: index }, item.id);
                    }), jsx(EvenButton, __assign({ minimal: true, outlined: true, className: "adjustment-form-append", onClick: function () {
                            return append({
                                adjustmentReason: AdjustmentReason.MonthlyTenPercent,
                                amount: 0,
                                memo: '',
                            });
                        } }, { children: "Add New Adjustment" })), jsx(TotalAmountField, { summary: summary })] })) })) })));
};

var ScopeSelectField = function (_a) {
    var availableScopes = _a.availableScopes;
    var _b = useFormContext(), errors = _b.formState.errors, resetField = _b.resetField, control = _b.control;
    var _c = useState(false), showField = _c[0], setShowField = _c[1];
    var tokenTypes = useWatch({ control: control, name: 'tokenTypes' });
    useEffect(function () {
        if ((tokenTypes === null || tokenTypes === void 0 ? void 0 : tokenTypes.length) && (tokenTypes === null || tokenTypes === void 0 ? void 0 : tokenTypes.includes('custom'))) {
            setShowField(true);
        }
        else {
            setShowField(false);
            resetField('scopes', { defaultValue: undefined });
        }
    }, [tokenTypes]);
    return (jsx(Controller, { control: control, name: "customScopes", render: function (_a) {
            var _b;
            var onChange = _a.field.onChange;
            return (jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.scopes) === null || _b === void 0 ? void 0 : _b.message, layout: FieldLayout.Vertical, show: showField }, { children: jsxs("label", { children: [jsx("span", __assign({ className: "field-label" }, { children: "Scopes" })), jsx(MultiSelect, { className: "scope-multi-select", itemRemoveFilter: function (item, targetItem) { return item === targetItem; }, itemRenderer: function (item, props) { return (jsx(SelectItem, __assign({ text: item }, props), item)); }, items: availableScopes, tagRenderer: function (item) { return item; }, onChange: onChange })] }) })));
        }, rules: { required: showField && 'Custom Scopes are required.' } }));
};

var ApplicationTokenCreateForm = function (_a) {
    var _b, _c;
    var visible = _a.visible, application = _a.application, subAccountUuid = _a.subAccountUuid, availableScopes = _a.availableScopes, onSubmit = _a.onSubmit, onError = _a.onError, onCancel = _a.onCancel;
    var form = useForm({
        defaultValues: {
            application: application,
            customScopes: undefined,
            subAccountUuid: subAccountUuid,
            tokenTypes: undefined,
        },
    });
    var register = form.register, handleSubmit = form.handleSubmit, errors = form.formState.errors, reset = form.reset;
    return (jsx(DrawerForm, __assign({ disableCloseOnMouseDown: true, submitText: "Submit", title: "New Access Token", visible: visible, onClose: onCancel, onSubmit: handleSubmit(function (data) {
            onSubmit(data);
            reset();
        }, onError) }, { children: jsx(FormProvider, __assign({}, form, { children: jsxs("div", __assign({ className: "access-token-create-form" }, { children: [jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.application) === null || _b === void 0 ? void 0 : _b.message, label: "Application", layout: FieldLayout.Vertical }, { children: jsx("input", __assign({ disabled: true }, register('application'))) })), jsxs(Field, __assign({ className: "access-token-create-form-token-types", error: (_c = errors === null || errors === void 0 ? void 0 : errors.tokenTypes) === null || _c === void 0 ? void 0 : _c.message, label: "Token Types", layout: FieldLayout.Vertical }, { children: [jsxs("label", { children: [jsx("input", __assign({ type: "checkbox" }, register('tokenTypes'), { value: "test" })), jsx("span", { children: "Test Leads" })] }), jsxs("label", { children: [jsx("input", __assign({ type: "checkbox" }, register('tokenTypes'), { value: "production" })), jsx("span", { children: "Production" })] }), jsxs("label", { children: [jsx("input", __assign({ type: "checkbox" }, register('tokenTypes'), { value: "production_plus_analytics" })), jsx("span", { children: "Production Plus Analytics" })] }), jsxs("label", { children: [jsx("input", __assign({ type: "checkbox" }, register('tokenTypes'), { value: "analytics" })), jsx("span", { children: "Analytics Only" })] }), jsxs("label", __assign({ "data-testid": "token-type-custom" }, { children: [jsx("input", __assign({ type: "checkbox" }, register('tokenTypes', {
                                        required: 'Must select at least one Token Type',
                                    }), { value: "custom" })), jsx("span", { children: "Custom Scopes" })] }))] })), jsx(ScopeSelectField, { availableScopes: availableScopes })] })) })) })));
};

var CustomOfferContactUsForm = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var onSubmit = _a.onSubmit;
    var form = useForm();
    var register = form.register, handleSubmit = form.handleSubmit, formState = form.formState, errors = form.formState.errors, reset = form.reset;
    useEffect(function () {
        if (formState.isSubmitSuccessful) {
            reset();
        }
    }, [formState, reset]);
    return (jsx(FormProvider, __assign({}, form, { children: jsxs("form", __assign({ className: "custom-offer-form" }, { children: [jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.firstName) === null || _b === void 0 ? void 0 : _b.message, label: "First Name", layout: FieldLayout.Horizontal }, { children: jsx("input", __assign({ className: Classes.INPUT, placeholder: "First Name" }, register('firstName', { required: 'Please enter your name' }))) })), jsx(Field, __assign({ error: (_c = errors === null || errors === void 0 ? void 0 : errors.lastName) === null || _c === void 0 ? void 0 : _c.message, label: "Last Name", layout: FieldLayout.Horizontal }, { children: jsx("input", __assign({ className: Classes.INPUT, placeholder: "Last Name" }, register('lastName', {
                        required: 'Please enter your last name',
                    }))) })), jsx(Field, __assign({ error: (_d = errors === null || errors === void 0 ? void 0 : errors.jobTitle) === null || _d === void 0 ? void 0 : _d.message, label: "Job Title", layout: FieldLayout.Horizontal }, { children: jsx("input", __assign({ className: Classes.INPUT, placeholder: "Job Title" }, register('jobTitle', {
                        required: 'Please enter your job title',
                    }))) })), jsx(Field, __assign({ error: (_e = errors === null || errors === void 0 ? void 0 : errors.companyName) === null || _e === void 0 ? void 0 : _e.message, label: "Company Name", layout: FieldLayout.Horizontal }, { children: jsx("input", __assign({ className: Classes.INPUT, placeholder: "Company Name" }, register('companyName', {
                        required: 'Please enter your company name',
                    }))) })), jsx(Field, __assign({ error: (_f = errors === null || errors === void 0 ? void 0 : errors.companyWebsite) === null || _f === void 0 ? void 0 : _f.message, label: "Company Website", layout: FieldLayout.Horizontal }, { children: jsx("input", __assign({ className: Classes.INPUT, placeholder: "Company Website" }, register('companyWebsite', {
                        required: 'Please enter your company website',
                    }))) })), jsx(Field, __assign({ error: (_g = errors === null || errors === void 0 ? void 0 : errors.emailAddress) === null || _g === void 0 ? void 0 : _g.message, label: "Email Address", layout: FieldLayout.Horizontal }, { children: jsx("input", __assign({ className: Classes.INPUT, placeholder: "Email" }, register('emailAddress', {
                        required: 'Please enter your email',
                    }))) })), jsx(Field, __assign({ error: (_h = errors === null || errors === void 0 ? void 0 : errors.tellUsMore) === null || _h === void 0 ? void 0 : _h.message, label: "Question", layout: FieldLayout.Horizontal }, { children: jsx("textarea", __assign({ className: classNames(Classes.INPUT, Classes.FILL), placeholder: "What Product Verticals would you like to enable Custom Offers for?" }, register('tellUsMore', {
                        required: 'Please enter your question',
                    }))) })), jsx("div", __assign({ className: "submit" }, { children: jsx(EvenButton, __assign({ onClick: handleSubmit(onSubmit) }, { children: "Send" })) }))] })) })));
};

var schema$1 = yup
    .object({
    share: yup
        .number()
        .typeError('Share is a required field.')
        .min(0, 'Please enter a number between 0 and 1.')
        .max(1, 'Please enter a number between 0 and 1'),
})
    .required();
var ExpectedEarningsShareForm = function (_a) {
    var _b;
    var onSubmit = _a.onSubmit, currentShare = _a.currentShare;
    var form = useForm({
        defaultValues: {
            share: currentShare,
        },
        resolver: yupResolver(schema$1),
    });
    var register = form.register, handleSubmit = form.handleSubmit, errors = form.formState.errors;
    return (jsx(FormProvider, __assign({}, form, { children: jsxs("form", __assign({ className: "expected-earnings-share-form" }, { children: [jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.share) === null || _b === void 0 ? void 0 : _b.message, label: "Share", layout: FieldLayout.Horizontal, tooltip: "Expected Earnings Share is always applied to the recommended score but has impact on payout only when the pricing modal is Bidder." }, { children: jsx("input", __assign({ className: Classes.NUMERIC_INPUT, step: 0.1, type: "number" }, register('share', {
                        required: 'Share is a required field.',
                        valueAsNumber: true,
                    }))) })), jsx("div", __assign({ className: "submit text-right" }, { children: jsx(EvenButton, __assign({ onClick: handleSubmit(onSubmit) }, { children: "Save Changes" })) }))] })) })));
};

var RoleOptions = [
    Roles.SuperAdministrator,
    Roles.Manager,
    Roles.Reporter,
    Roles.Scale,
    Roles.Growth,
    Roles.Starter,
    Roles.SupplyUser,
    Roles.DemandUser,
    Roles.InternalUser,
    Roles.ExternalUser,
    Roles.SelfService,
];
var FeatureFlagForm = function (_a) {
    var _b;
    var subAccounts = _a.subAccounts, users = _a.users, onSubmit = _a.onSubmit, drawerForm = _a.drawerForm, featureFlag = _a.featureFlag;
    var formFromHook = useForm({
        defaultValues: {
            enabled: featureFlag === null || featureFlag === void 0 ? void 0 : featureFlag.enabled,
            enabledStaging: featureFlag === null || featureFlag === void 0 ? void 0 : featureFlag.enabledStaging,
            name: featureFlag === null || featureFlag === void 0 ? void 0 : featureFlag.name,
            roles: featureFlag === null || featureFlag === void 0 ? void 0 : featureFlag.roles,
            subAccountUuids: featureFlag === null || featureFlag === void 0 ? void 0 : featureFlag.subAccountUuids,
            userUuids: featureFlag === null || featureFlag === void 0 ? void 0 : featureFlag.userUuids,
        },
    });
    var form = drawerForm !== null && drawerForm !== void 0 ? drawerForm : formFromHook;
    var handleSubmit = form.handleSubmit, control = form.control, register = form.register, errors = form.formState.errors;
    var layout = drawerForm ? FieldLayout.Vertical : FieldLayout.Horizontal;
    return (jsxs(FormProvider, __assign({}, form, { children: [jsx(Controller, { control: control, name: 'enabled', render: function (_a) {
                    var _b;
                    var _c = _a.field, onChange = _c.onChange, value = _c.value;
                    return (jsx(Field, __assign({ error: (_b = errors.enabled) === null || _b === void 0 ? void 0 : _b.message }, { children: jsx(Switch, { checked: value, label: "Enabled (production)", value: String(value), onChange: onChange }) })));
                } }), jsx(Controller, { control: control, name: 'enabledStaging', render: function (_a) {
                    var _b;
                    var _c = _a.field, onChange = _c.onChange, value = _c.value;
                    return (jsx(Field, __assign({ error: (_b = errors.enabledStaging) === null || _b === void 0 ? void 0 : _b.message }, { children: jsx(Switch, { checked: value, label: "Enabled (stage)", value: String(value), onChange: onChange }) })));
                } }), jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.name) === null || _b === void 0 ? void 0 : _b.message, label: "Name", layout: layout }, { children: jsx("input", __assign({ className: Classes.INPUT, placeholder: "Name" }, register('name', {
                    required: 'Please input a name',
                }))) })), jsx(Controller, { control: control, name: 'roles', render: function (_a) {
                    var _b = _a.field, value = _b.value, onChange = _b.onChange;
                    return (jsx(Field, __assign({ label: "Roles", layout: layout }, { children: jsx(MultiSelect, { itemRemoveFilter: function (item, targetItem) { return item !== targetItem; }, itemRenderer: function (item, props) { return (jsx(SelectItem, __assign({ text: item }, props), item)); }, items: RoleOptions, selectedItems: value, tagRenderer: function (item) { return item; }, onChange: onChange }) })));
                } }), jsx(Controller, { control: control, name: 'subAccountUuids', render: function (_a) {
                    var _b = _a.field, value = _b.value, onChange = _b.onChange;
                    return (jsx(Field, __assign({ label: "Sub Accounts", layout: layout }, { children: jsx(SubAccountMultiSelect, { selectedValues: value, subAccounts: subAccounts, valueKey: 'uuid', onValueKeyChange: onChange }) })));
                } }), jsx(Controller, { control: control, name: 'userUuids', render: function (_a) {
                    var _b = _a.field, value = _b.value, onChange = _b.onChange;
                    return (jsx(Field, __assign({ label: "Users", layout: layout }, { children: jsx(UserMultiSelect, { selectedValues: value, users: users, valueKey: 'uuid', onValueKeyChange: onChange }) })));
                } }), !drawerForm && (jsx(ConfirmableAction, __assign({ cancelText: "Cancel", message: "Updating the feature flag settings will expose new functionality. Are you sure you want to continue?", okText: "Confirm", title: "Are you sure you want to update this feature flag?", onOk: handleSubmit(onSubmit) }, { children: jsx("div", __assign({ className: "submit text-right" }, { children: jsx(EvenButton, { children: "Save Changes" }) })) })))] })));
};

var FeatureFlagDrawerForm = function (_a) {
    var subAccounts = _a.subAccounts, users = _a.users, onSubmit = _a.onSubmit, onClose = _a.onClose, visible = _a.visible;
    var form = useForm({
        defaultValues: {
            enabled: false,
            enabledStaging: false,
            name: '',
            roles: [],
        },
    });
    var handleSubmit = form.handleSubmit;
    return (jsx(DrawerForm, __assign({ cancelText: "Cancel", submitText: "Create", title: "Create New Feature Flag", visible: visible, onClose: onClose, onSubmit: handleSubmit(onSubmit) }, { children: jsx(FeatureFlagForm, { drawerForm: form, subAccounts: subAccounts, users: users, onSubmit: function () { } }) })));
};

var partnerErrMessage = 'Integration Key is required and must be shorter than 30 characters';
var FirstIntegrationForm = function (_a) {
    var _b, _c, _d;
    var isDisabled = _a.isDisabled, onCancel = _a.onCancel, onSubmit = _a.onSubmit, validateKey = _a.validateKey, handlePurchasePlan = _a.handlePurchasePlan;
    var schema = yup.object().shape({
        partner: yup
            .string()
            .required(partnerErrMessage)
            .matches(/^[a-z0-9-]{1,30}$/, {
            message: partnerErrMessage,
        })
            .test('partner', 'That name is already taken. Please try another one.', function (value) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!value) return [3 /*break*/, 2];
                        return [4 /*yield*/, validateKey(value)];
                    case 1:
                        _a = (_b = (_c.sent())) !== null && _b !== void 0 ? _b : true;
                        return [3 /*break*/, 3];
                    case 2:
                        _a = true;
                        _c.label = 3;
                    case 3: return [2 /*return*/, _a];
                }
            });
        }); }),
        partnerLocationUrl: yup
            .string()
            .required('Please input a link.')
            .test('partnerLocationUrl', 'Link must be a valid URL', function (value) {
            return isURL(value, {
                require_host: false,
                require_protocol: false,
                require_valid_protocol: false,
            });
        }),
        partnerLogo: yup
            .mixed()
            .test('partnerLogo', 'You must upload an image', function (value) {
            return (value === null || value === void 0 ? void 0 : value.length) === 1;
        }),
    });
    var form = useForm({
        defaultValues: { productType: ProductType$2.Loan },
        resolver: yupResolver(schema),
    });
    var control = form.control, register = form.register, handleSubmit = form.handleSubmit, errors = form.formState.errors, watch = form.watch, setValue = form.setValue;
    return (jsx(FormProvider, __assign({}, form, { children: jsxs("form", __assign({ className: "first-integration-form-container" }, { children: [jsxs("div", __assign({ className: "form-row" }, { children: [jsx(Field, __assign({ className: "form-field", error: (_b = errors === null || errors === void 0 ? void 0 : errors.partner) === null || _b === void 0 ? void 0 : _b.message, extra: "".concat(((_c = watch('partner')) === null || _c === void 0 ? void 0 : _c.length) || 0, "/30 characters"), label: "Integration Key", layout: FieldLayout.Vertical, tooltip: "This is used to prefix all your integration urls, eg. for the integration key \u2018apple\u2019, your url would be fiona.com/partner/apple/loans" }, { children: jsx("input", __assign({ disabled: isDisabled, maxLength: 30, placeholder: "This will be the channel name" }, register('partner'), { onChange: function (event) {
                                    setValue('partner', event.currentTarget.value
                                        .toLowerCase()
                                        .replace(/[^a-z0-9]/g, '-')
                                        .replace(/-+/g, '-'));
                                } })) })), jsx(Field, __assign({ className: "form-field", error: (_d = errors === null || errors === void 0 ? void 0 : errors.partnerLocationUrl) === null || _d === void 0 ? void 0 : _d.message, label: "Where will you share your Partner Page?", layout: FieldLayout.Vertical, tooltip: "The web page or blog URL that links to the Partner Page" }, { children: jsx("input", __assign({ disabled: isDisabled, placeholder: "Link to your website or blog" }, register('partnerLocationUrl'))) }))] })), jsx(Controller, { control: control, name: "partnerLogo", render: function (_a) {
                        var _b;
                        var field = _a.field;
                        return (jsx(Field, __assign({ className: "form-field", error: (_b = errors === null || errors === void 0 ? void 0 : errors.partnerLogo) === null || _b === void 0 ? void 0 : _b.message, extra: "Max 3MB. Up to 200x200px. Format: .jpg, .png", label: "Upload your logo", layout: FieldLayout.Vertical, tooltip: "Logo image that appears on the Partner Page header. Image should be 90px high, width is flexible. Supported formats are jpeg, png or gif." }, { children: jsx(Upload, __assign({ accept: "image/png, image/jpeg, image/gif, image/svg+xml", disabled: isDisabled, handleChange: function (files) {
                                    return setValue('partnerLogo', files);
                                }, multiple: false }, field)) })));
                    } }), jsx(Controller, { control: control, name: "productType", render: function (_a) {
                        var _b;
                        var field = _a.field;
                        return (jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.productType) === null || _b === void 0 ? void 0 : _b.message, label: "Select Your Financial Product", layout: FieldLayout.Vertical }, { children: jsx(ProductTypeCardSelect, __assign({ handlePurchasePlan: handlePurchasePlan, size: "small" }, field)) })));
                    } }), jsxs("div", __assign({ className: "actions" }, { children: [jsxs(EvenButton, __assign({ large: true, className: "action-button", disabled: isDisabled, onClick: handleSubmit(onSubmit) }, { children: ["Create Partner Page", ' ', jsx(FontAwesomeIcon, { className: "icon", icon: faPlus })] })), jsx(EvenButton, __assign({ large: true, minimal: true, className: "action-button", disabled: isDisabled, onClick: function () { return onCancel(); } }, { children: "Cancel" }))] }))] })) })));
};

var schema = yup
    .object({
    durationMinutes: yup
        .number()
        .typeError('Duration must be number of minutes.'),
})
    .required();
var LeadDeduplicationForm = function (_a) {
    var _b;
    var onSubmit = _a.onSubmit, currentDurationMinutes = _a.currentDurationMinutes;
    var form = useForm({
        defaultValues: {
            durationMinutes: currentDurationMinutes,
        },
        resolver: yupResolver(schema),
    });
    var register = form.register, handleSubmit = form.handleSubmit, errors = form.formState.errors;
    return (jsx(FormProvider, __assign({}, form, { children: jsxs("form", __assign({ className: "lead-deduplication-form" }, { children: [jsx(Field, __assign({ error: (_b = errors === null || errors === void 0 ? void 0 : errors.durationMinutes) === null || _b === void 0 ? void 0 : _b.message, label: "Duration Minutes", layout: FieldLayout.Horizontal }, { children: jsx("input", __assign({ className: Classes.NUMERIC_INPUT, type: "number" }, register('durationMinutes', {
                        valueAsNumber: true,
                    }))) })), jsx("div", __assign({ className: "submit text-right" }, { children: jsx(EvenButton, __assign({ onClick: handleSubmit(onSubmit) }, { children: "Save Changes" })) }))] })) })));
};

var styles = {"container":"UserAccessForm-module_container__ec-K1","submit":"UserAccessForm-module_submit__RLXAn"};

var UserAccessForm = function (_a) {
    var _b, _c, _d;
    var accounts = _a.accounts, _e = _a.defaultValues, defaultValues = _e === void 0 ? {} : _e, onSubmit = _a.onSubmit, _f = _a.permissions, canManageAllAccounts = _f.canManageAllAccounts, canManageUserRoles = _f.canManageUserRoles, subAccounts = _a.subAccounts;
    var form = useForm({
        defaultValues: {},
    });
    var control = form.control, handleSubmit = form.handleSubmit, setValue = form.setValue, reset = form.reset, watch = form.watch, getFieldState = form.getFieldState;
    var roleObject = watch(UserField$1.RoleObject);
    var selectedPartnerType = watch(UserField$1.PartnerType);
    var account = watch(UserField$1.Account);
    var accountFieldState = getFieldState(UserField$1.Account);
    var userToEditIsInternal = ((_b = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.roleObject) === null || _b === void 0 ? void 0 : _b.roles.includes(Roles.InternalViewer)) ||
        ((_c = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.roleObject) === null || _c === void 0 ? void 0 : _c.roles.includes(Roles.InternalUser)) ||
        ((_d = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.roleObject) === null || _d === void 0 ? void 0 : _d.roles.includes(Roles.Manager));
    var internalUserTypeOptions = ['Internal'];
    var partnerTypeArray = Object.values(PartnerType);
    var showSupplySection = selectedPartnerType === 'Multi' || selectedPartnerType === 'Supply';
    var showDemandSection = selectedPartnerType === 'Multi' || selectedPartnerType === 'Demand';
    var isMultiSelected = selectedPartnerType === 'Multi';
    var showAllAccountsDropdown = canManageAllAccounts &&
        Boolean(roleObject) &&
        UserRolesWithAllAccountAccess.has(roleObject.flatRole);
    var defaultValuesStr = JSON.stringify(defaultValues);
    // Reset the subaccount selections if account selection is changed.
    useEffect(function () {
        if (accountFieldState.isDirty && account) {
            setValue(UserField$1.DemandSubAccounts, []);
            setValue(UserField$1.SupplySubAccounts, []);
            setValue(UserField$1.SubAccounts, []);
        }
    }, [account === null || account === void 0 ? void 0 : account.id]);
    // Prepopulate the form with the values already on the user.
    useEffect(function () {
        if (defaultValues) {
            reset(defaultValues);
        }
    }, [defaultValuesStr]);
    var _g = useState(false), allowSubmission = _g[0], setAllowSubmission = _g[1];
    var watchAllFields = watch(); // when pass nothing as argument, you are watching everything
    // useEffect for deciding allowSubmission
    useEffect(function () {
        if (userToEditIsInternal) {
            // If allAccounts is checked, allow submission
            if (watchAllFields.allAccounts) {
                setAllowSubmission(true);
            }
            // If not, if account has a value,  allow submission.
            if (!watchAllFields.allAccounts) {
                if (watchAllFields.account) {
                    setAllowSubmission(true);
                }
                else {
                    setAllowSubmission(false);
                }
            }
        }
        if (isMultiSelected) {
            var temp = watchAllFields.account &&
                watchAllFields.demandRole &&
                watchAllFields.supplyRole;
            setAllowSubmission(Boolean(temp));
        }
        if (selectedPartnerType === PartnerType.Supply) {
            var temp = watchAllFields.account && watchAllFields.supplyRole;
            setAllowSubmission(Boolean(temp));
        }
        if (selectedPartnerType === PartnerType.Demand) {
            var temp = watchAllFields.account && watchAllFields.demandRole;
            setAllowSubmission(Boolean(temp));
        }
    }, [watchAllFields]);
    var supplyRole = watch(UserField$1.SupplyRole);
    // When multi selected, and the supply  role is not a valid multi option (eg Growth), reset it.
    useEffect(function () {
        if (selectedPartnerType === PartnerType.Multi) {
            var selectedSupplyRoleIsValidForMulti = Object.keys(SupplyFlatRolesForMulti).includes(supplyRole === null || supplyRole === void 0 ? void 0 : supplyRole.flatRole);
            if (!selectedSupplyRoleIsValidForMulti) {
                setValue(UserField$1.SupplyRole, null);
            }
        }
    }, [selectedPartnerType]);
    if (userToEditIsInternal) {
        return (jsx(FormProvider, __assign({}, form, { children: jsxs("form", __assign({ className: styles.container }, { children: [jsx(Controller, { name: internalUserTypeOptions[0], render: function () { return (jsx(Field, __assign({ label: "User Type", layout: FieldLayout.Horizontal }, { children: jsx(Select, { disabled: true, activeItem: internalUserTypeOptions[0], itemKey: function (val) { return val; }, itemLabel: function (val) { return val; }, items: internalUserTypeOptions, onItemSelect: function () { } }) }))); } }), jsx(Controller, { control: control, name: UserField$1.RoleObject, render: function (_a) {
                            var _b = _a.field, value = _b.value, onChange = _b.onChange;
                            return (jsx(Field, __assign({ label: "User Role", layout: FieldLayout.Horizontal, show: canManageUserRoles }, { children: jsx(RoleSelect, { showInternalRoleOptions: true, activeItem: value, "data-testid": UserField$1.RoleObject, showExternalRoleOptions: false, onItemSelect: onChange }) })));
                        } }), jsx(UserAccountsFieldGroup, { accountOptions: accounts, layout: FieldLayout.Horizontal, showAllAccountsDropdown: showAllAccountsDropdown, subAccountOptions: subAccounts }), jsx(ConfirmableAction, __assign({ disabled: !allowSubmission, message: "After changing the account rights settings, there may be users who cannot access the portal. Are you sure you want to continue?", okText: "Confirm", title: "Are you sure you want to change the access rights?", onOk: handleSubmit(onSubmit) }, { children: jsx(EvenButton, __assign({ className: styles.submit, disabled: !allowSubmission }, { children: "Save changes" })) }))] })) })));
    }
    // if external...
    return (jsx(FormProvider, __assign({}, form, { children: jsxs("form", __assign({ className: styles.container }, { children: [jsx(Controller, { control: control, name: UserField$1.PartnerType, render: function (_a) {
                        var _b = _a.field, value = _b.value, onChange = _b.onChange;
                        return (jsx(Field, __assign({ label: "Partner Type", show: canManageUserRoles }, { children: jsx(PartnerTypeSelect, { activeItem: value, "data-testid": UserField$1.PartnerType, partnerTypeArray: partnerTypeArray, onItemSelect: onChange }) })));
                    } }), showDemandSection && (jsx(Controller, { control: control, name: UserField$1.DemandRole, render: function (_a) {
                        var _b = _a.field, value = _b.value, onChange = _b.onChange;
                        return (jsx(Field, __assign({ label: "Demand User Role", show: canManageUserRoles }, { children: jsx(RoleSelect, { showDemandRoles: true, activeItem: value, ariaLabel: "demandUserRole", "data-testid": UserField$1.DemandRole, isMultiSelected: isMultiSelected, showExternalRoleOptions: !userToEditIsInternal, showInternalRoleOptions: userToEditIsInternal, showSupplyRoles: false, onItemSelect: onChange }) })));
                    } })), showSupplySection && (jsx(Controller, { control: control, name: UserField$1.SupplyRole, render: function (_a) {
                        var _b = _a.field, value = _b.value, onChange = _b.onChange;
                        return (jsx(Field, __assign({ label: "Supply User Role", show: canManageUserRoles }, { children: jsx(RoleSelect, { showSupplyRoles: true, activeItem: value, ariaLabel: "supplyUserRole", "data-testid": UserField$1.SupplyRole, isMultiSelected: isMultiSelected, showDemandRoles: false, showExternalRoleOptions: !userToEditIsInternal, showInternalRoleOptions: userToEditIsInternal, onItemSelect: onChange }) })));
                    } })), jsx(Controller, { control: control, defaultValue: defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.account, name: UserField$1.Account, render: function (_a) {
                        var _b = _a.field, value = _b.value, onChange = _b.onChange;
                        return (jsx(Field, __assign({ label: "Account" }, { children: jsx(AccountSuggest, { accounts: accounts, inputProps: {
                                    placeholder: 'Search Accounts for External User...',
                                }, selectedItem: value, onChange: onChange }) })));
                    } }), showDemandSection && (jsx(Controller, { control: control, name: UserField$1.DemandSubAccounts, render: function (_a) {
                        var _b = _a.field, value = _b.value, onChange = _b.onChange;
                        return (jsx(Field, __assign({ label: "Demand Sub Accounts" }, { children: jsx(SubAccountMultiSelect, { showOnlyDemandSubAccounts: true, accounts: account ? [account] : [], placeholder: "Search Demand Sub Accounts...", selectedItems: value, showOnlySupplySubAccounts: false, subAccounts: subAccounts, onChange: onChange }) })));
                    } })), showSupplySection && (jsx(Controller, { control: control, name: UserField$1.SupplySubAccounts, render: function (_a) {
                        var _b = _a.field, value = _b.value, onChange = _b.onChange;
                        return (jsx(Field, __assign({ label: "Supply Sub Accounts" }, { children: jsx(SubAccountMultiSelect, { showOnlySupplySubAccounts: true, accounts: account ? [account] : [], placeholder: "Search Supply Sub Accounts...", selectedItems: value, showOnlyDemandSubAccounts: false, subAccounts: subAccounts, onChange: onChange }) })));
                    } })), jsx(ConfirmableAction, __assign({ disabled: !allowSubmission, message: "After changing the account rights settings, there may be users who cannot access the portal. Are you sure you want to continue?", okText: "Confirm", title: "Are you sure you want to change the access rights?", onOk: handleSubmit(onSubmit) }, { children: jsx(EvenButton, __assign({ className: styles.submit, disabled: !allowSubmission }, { children: "Save changes" })) }))] })) })));
};

var states = Object.keys(UsStatesEnum).map(function (stateCode) {
    return { code: stateCode, label: UsStatesEnum[stateCode] };
});
var USStatesForm = function (_a) {
    var onSubmit = _a.onSubmit, _b = _a.currentStateExclusions, currentStateExclusions = _b === void 0 ? [] : _b;
    var _c = React.useState(states.filter(function (stateCode) { return !currentStateExclusions.includes(stateCode.code); })), availableStates = _c[0], setAvailableStates = _c[1];
    var form = useForm({
        defaultValues: {
            stateExclusions: currentStateExclusions,
        },
    });
    var handleSubmit = form.handleSubmit, control = form.control, getValues = form.getValues, reset = form.reset;
    var selectedStateExclusions = getValues().stateExclusions;
    useEffect(function () {
        setAvailableStates(states.filter(function (stateCode) { return !selectedStateExclusions.includes(stateCode.code); }));
    }, [selectedStateExclusions]);
    var onChangeInternal = function (props) {
        setAvailableStates(states.filter(function (stateCode) { return !props.includes(stateCode.code); }));
    };
    var onDelete = function (stateCode) {
        var selectedStateExclusionsUpdated = getValues().stateExclusions;
        selectedStateExclusionsUpdated.push(stateCode);
        reset({
            stateExclusions: selectedStateExclusionsUpdated,
        });
    };
    var copiedText = function () { return availableStates.map(function (code) { return code.label; }).join('\n'); };
    return (jsx(FormProvider, __assign({}, form, { children: jsxs("form", __assign({ className: "us-states-form" }, { children: [jsx(Controller, { control: control, name: "stateExclusions", render: function (_a) {
                        var _b = _a.field, value = _b.value, onChange = _b.onChange;
                        return (jsx(Field, __assign({ label: "Excluded States", layout: FieldLayout.Horizontal, tooltip: "All included by default" }, { children: jsx(MultiSelect, { className: "states-multi-select", itemPredicate: function (query, item) {
                                    return serialize$2(item.label).includes(serialize$2(query));
                                }, itemRemoveFilter: function (item, targetItem) {
                                    return item.code !== targetItem.code;
                                }, itemRenderer: function (item, props) { return (jsx(SelectItem, __assign({ text: item.label }, props), item.code)); }, items: states, noResults: 'No states available', placeholder: "", selectedValues: value, tagRenderer: function (item) { return item.label; }, valueKey: "code", onValueKeyChange: function (props) {
                                    onChange(props);
                                    onChangeInternal(props);
                                } }) })));
                    } }), jsx("div", __assign({ className: "submit text-right" }, { children: jsx(EvenButton, __assign({ onClick: handleSubmit(onSubmit) }, { children: "Save Changes" })) })), jsxs("div", __assign({ className: "enabled-states-list" }, { children: [jsxs("div", __assign({ className: "enabled-states-list-total" }, { children: [jsx("div", __assign({ className: "enabled-states-list-total-label" }, { children: "Total Enabled States" })), jsx("div", __assign({ className: "enabled-states-list-total" }, { children: availableStates.length }))] })), jsxs("div", __assign({ className: "enabled-states-list-items" }, { children: [jsxs("div", __assign({ className: "clipboard" }, { children: [jsx("span", __assign({ className: "enabled-states-list-items-label" }, { children: "Enabled States" })), jsx(PortalClipboard, { alterText: copiedText(), text: "", type: PortalClipboardType.BlueTextIcon })] })), jsx("div", { children: availableStates.map(function (stateCode) {
                                        return (jsx(Tag, __assign({ className: "enabled-state-tag", onRemove: function () { return onDelete(stateCode.code); } }, { children: UsStatesEnum[stateCode.code] }), stateCode.code));
                                    }) })] }))] }))] })) })));
};

var ComplianceSubmissionSuccessModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose;
    return (jsxs(Dialog, __assign({ canEscapeKeyClose: false, canOutsideClickClose: false, isOpen: isOpen, onClose: onClose }, { children: [jsxs("div", __assign({ className: Classes.DIALOG_BODY }, { children: [jsx("h4", { children: "Integration submitted successfully" }), jsx("p", { children: "Your Partner Page will be saved as a draft and can be reviewed from the Integrations module or Homepage." }), jsxs("p", { children: ["The website where you will share the integration URL needs to be reviewed and confirmed that it follows all our partners guidelines. This usually takes ", jsx("strong", { children: "3-5 workdays" }), ". You will receive an email confirmation once your Partner Page is compliance approved."] })] })), jsx("div", __assign({ className: Classes.DIALOG_FOOTER }, { children: jsx("div", __assign({ className: Classes.DIALOG_FOOTER_ACTIONS }, { children: jsx(EvenButton, __assign({ intent: Intent.PRIMARY, outlined: false, onClick: onClose }, { children: "Done" })) })) }))] })));
};

var FeatureKey;
(function (FeatureKey) {
    FeatureKey["dedicatedPartnerManager"] = "dedicatedPartnerManager";
})(FeatureKey || (FeatureKey = {}));
var ActionButtonType;
(function (ActionButtonType) {
    ActionButtonType["DASHED"] = "dashed";
    ActionButtonType["OUTLINED"] = "outlined";
    ActionButtonType["PRIMARY"] = "primary";
})(ActionButtonType || (ActionButtonType = {}));

var _a;
var renderFeatureBoolean = function (showCheck) {
    return (jsx(FontAwesomeIcon, { icon: showCheck ? faCheck : faXmark, style: {
            height: 'auto',
            width: 8,
        } }));
};
var planIconStyle = {
    height: 'auto',
    width: 24,
};
var icons = (_a = {},
    _a[AccountTierType$1.Starter] = (jsx(FontAwesomeIcon, { icon: faRocket, style: planIconStyle })),
    _a[AccountTierType$1.Growth] = (jsx(FontAwesomeIcon, { icon: faSeedling, style: planIconStyle })),
    _a[AccountTierType$1.Scale] = (jsx(FontAwesomeKitIcon, { icon: KitIconNames.Signal, style: planIconStyle })),
    _a);
var SubscriptionPlanCard = function (_a) {
    var plan = _a.plan;
    return (jsx(Fragment, { children: jsx("article", { children: jsxs("div", __assign({ className: classNames('subscription-plan', plan.id, plan.cardClassName) }, { children: [jsxs("header", __assign({ className: classNames('subscription-plan-header', plan.cardClassName) }, { children: [jsxs("span", __assign({ className: classNames('fa-layers', 'fa-fw', 'fa-4x', 'subscription-plan-header-icon') }, { children: [jsx(FontAwesomeIcon, { color: colors.white, icon: faCircle, style: { height: 'auto', width: 58 } }), icons[plan.id]] })), jsx("h1", __assign({ className: "subscription-plan-name", role: "plan-name" }, { children: plan.name }))] })), jsx("svg", __assign({ className: "subscription-plan-triangle", viewBox: "0 0 280 20", xmlns: "http://www.w3.org/2000/svg" }, { children: jsx("path", { d: "M140 20L0 0h280z" }) })), jsxs("section", __assign({ className: "subscription-plan-subheader" }, { children: [jsxs("article", __assign({ className: "subscription-plan-info" }, { children: [jsx("p", __assign({ className: "subscription-plan-value" }, { children: plan.planFee })), jsx("h6", __assign({ className: "subscription-plan-label" }, { children: "Monthly Platform Fee" }))] })), jsxs("article", __assign({ className: "subscription-plan-info" }, { children: [jsx("p", __assign({ className: classNames('subscription-plan-subvalue', 'two-lines'), role: "seat-numbers" }, { children: plan.pricing })), jsxs("h6", __assign({ className: "subscription-plan-label" }, { children: ["Dynamic Real Time Pricing (Personal Loans Only)", jsx("sup", { children: jsx("strong", { children: "1" }) })] }))] })), jsxs("article", __assign({ className: "subscription-plan-info" }, { children: [jsxs("p", __assign({ className: "subscription-plan-subvalue-small" }, { children: [jsx("strong", { children: plan.productOffersLevel }), " Product Offers Available"] })), jsx("div", __assign({ className: "subscription-plan-icons", role: "tooltip" }, { children: plan.integrations.map(function (_a, index) {
                                            var icon = _a.icon, title = _a.title;
                                            return (jsx(Tooltip2, __assign({ content: title, position: "right" }, { children: jsx(FontAwesomeIcon, { icon: icon, style: planIconStyle }) }), index));
                                        }) })), jsxs("h6", __assign({ className: "subscription-plan-label" }, { children: ["Available Integrations", jsx("sup", { children: jsx("strong", { children: "2" }) })] }))] })), jsxs("div", __assign({ className: "subscription-plan-info" }, { children: [jsx("p", __assign({ className: "subscription-plan-subvalue", role: "seat-number" }, { children: plan.seatsNumber })), jsxs("h6", __assign({ className: "subscription-plan-label" }, { children: ["Even Tools Seats Included", jsx("sup", { children: jsx("strong", { children: "3" }) })] }))] }))] })), jsx("ul", __assign({ className: "subscription-plan-features" }, { children: jsxs("li", { children: [jsx("p", __assign({ className: "value" }, { children: renderFeatureBoolean(plan.features[FeatureKey.dedicatedPartnerManager]) })), jsx("h6", __assign({ className: "label" }, { children: jsx("span", { children: "Dedicated Partner Manager" }) }))] }) })), jsx(EvenButton, __assign({ large: true, className: "subscription-plan-activate-button", disabled: plan === null || plan === void 0 ? void 0 : plan.isDisabled, outlined: plan.actionButtonType === 'outlined', role: "button", tertiary: plan.actionButtonTertiary, onClick: plan.onActionButtonClick }, { children: plan.actionButtonTitle }))] })) }) }));
};

var InvoicesTable = function (_a) {
    var rowData = _a.rowData;
    var gridRef = useRef(null);
    var columnDefs = [
        {
            cellRenderer: function (_a) {
                var value = _a.value;
                return (jsx("a", __assign({ href: "/billing/receivables/".concat(value) }, { children: value })));
            },
            field: 'accountId',
            type: ColumnDefs.ID,
        },
        {
            cellRenderer: function (params) { return (jsx("a", __assign({ href: "/accounts/".concat(params.data.accountUuid) }, { children: params.value }))); },
            field: 'accountName',
            filter: 'simpleTextFilter',
            filterParams: { placeHolder: 'Search by Account' },
            flex: 5,
            headerName: 'Account',
        },
        {
            field: 'activityPeriod',
            flex: 5,
            headerName: 'Activity Period',
            type: ColumnDefs.DATE_RANGE,
        },
        {
            field: 'totalPayout',
            flex: 3,
            headerName: 'Amount Due',
            suppressMenu: true,
            type: ColumnDefs.DOLLAR,
        },
        {
            field: 'dueDate',
            flex: 3,
            headerName: 'Due Date',
            type: ColumnDefs.DATE,
        },
        {
            field: 'createdAt',
            flex: 3,
            headerName: 'Created At',
            type: ColumnDefs.DATE,
        },
    ];
    var gridOptions = usePortalAgGridOptions({
        columnDefs: columnDefs,
        rowData: rowData,
    });
    return (jsxs(Fragment, { children: [jsxs(HeaderWithActions, __assign({ className: "title" }, { children: [jsx(ClearAllButton, { gridRef: gridRef }), jsx(ExportCSVButton, { gridRef: gridRef })] })), jsx(AgGridReact, { gridOptions: gridOptions })] }));
};

var ContractsSubsectionTable = function (_a) {
    var rowData = _a.rowData, demandSubAccountUuid = _a.demandSubAccountUuid;
    var columnDefs = [
        {
            field: 'id',
            type: ColumnDefs.ID,
        },
        {
            cellRenderer: function (params) { return (jsxs("a", __assign({ href: "/demand-sub-accounts/".concat(demandSubAccountUuid, "/contracts/").concat(params.value) }, { children: [jsx(FontAwesomeIcon, { icon: faExternalLink }), " View Contract"] }))); },
            field: 'id',
            headerName: 'Contract Details',
            suppressMenu: true,
        },
        {
            cellRenderer: function (params) {
                return params.value.map(function (_a) {
                    var key = _a.key;
                    return (jsx(Tag, __assign({ minimal: true, style: { marginRight: 10 } }, { children: startCase$1(key) }), key));
                });
            },
            field: 'revenueClauses',
            flex: 5,
            headerName: 'Pricing Plan',
            suppressMenu: true,
        },
        {
            cellRenderer: function (_a) {
                var value = _a.value;
                return value && "".concat(makeSimpleDate(value), " - present");
            },
            field: 'effectiveAt',
            flex: 5,
            headerName: 'Dates Active',
            suppressMenu: true,
        },
    ];
    var gridOptions = usePortalAgGridOptions();
    return (jsx(AgGridReact, { className: "ag-disable-last-row-border", columnDefs: columnDefs, gridOptions: gridOptions, rowData: rowData }));
};

var InternalAccountsTableActionsMenu = function (props) {
    var data = props.data, onActivate = props.onActivate, onDeactivate = props.onDeactivate, onDuplicate = props.onDuplicate, popoverProps = props.popoverProps;
    return (jsxs(ActionMenu, __assign({ popoverProps: popoverProps }, { children: [jsx(ActionMenu.Item, { href: "/accounts/".concat(data === null || data === void 0 ? void 0 : data.uuid), preset: "view" }), jsx(ActionMenu.Item, { href: "/accounts/".concat(data === null || data === void 0 ? void 0 : data.uuid, "/settings"), preset: "edit" }), jsx(ActionMenu.Item, { preset: "duplicate", onClick: onDuplicate }), (data === null || data === void 0 ? void 0 : data.isActive) ? (jsx(ActionMenu.Item, { preset: "deactivate", onClick: function () { return onDeactivate(data === null || data === void 0 ? void 0 : data.uuid); } })) : (jsx(ActionMenu.Item, { preset: "activate", onClick: function () { return onActivate(data === null || data === void 0 ? void 0 : data.uuid); } }))] })));
};

var InternalAccountsTable = function (_a) {
    var rowData = _a.rowData, onDuplicate = _a.onDuplicate, showCreateNewButton = _a.showCreateNewButton, enabledSelection = _a.enabledSelection, onActivate = _a.onActivate, onDeactivate = _a.onDeactivate, onCreate = _a.onCreate;
    var gridRef = useRef(null);
    var csvExportParams = {
        columnKeys: [
            'id',
            'name',
            'demandSubCount',
            'supplySubCount',
            'billingSetup',
            'isActive',
        ],
        processCellCallback: function (param) {
            if (param.column.getColId() === 'billingSetup') {
                return param.value ? 'Complete' : 'Incomplete';
            }
            if (param.column.getColId() === 'isActive') {
                return param.value ? 'Active' : 'Inactive';
            }
            return param.value;
        },
    };
    var columnDefs = [
        {
            checkboxSelection: Boolean(enabledSelection),
            field: 'id',
            headerCheckboxSelection: Boolean(enabledSelection),
            headerCheckboxSelectionFilteredOnly: true,
            type: ColumnDefs.ID,
        },
        {
            cellRenderer: function (params) { return (jsx("a", __assign({ href: "/accounts/".concat(params.data.uuid) }, { children: params.value }))); },
            field: 'name',
            filter: 'simpleTextFilter',
            filterParams: {
                placeHolder: 'Search by Name',
            },
            headerName: 'Name',
            sortable: true,
            width: 350,
        },
        {
            field: 'supplySubCount',
            headerName: 'Supply Sub Accounts',
            suppressMenu: true,
        },
        {
            cellStyle: {
                display: 'flex',
            },
            field: 'demandSubCount',
            headerName: 'Demand Sub Accounts',
            suppressMenu: true,
        },
        {
            cellRendererParams: {
                activeText: StatusType.Complete,
                inactiveText: StatusType.Incomplete,
                isActive: function (_a) {
                    var data = _a.data;
                    return data.billingSetup;
                },
            },
            field: 'billingSetup',
            headerName: 'Billing Setup',
            type: ColumnDefs.ACTIVE_STATUS,
        },
        {
            cellRendererParams: {
                isActive: function (_a) {
                    var data = _a.data;
                    return data.isActive;
                },
            },
            field: 'isActive',
            headerName: 'Status',
            type: ColumnDefs.ACTIVE_STATUS,
        },
        {
            cellClass: 'ag-cell-action',
            cellRenderer: 'actionsMenu',
            cellRendererParams: {
                onActivate: onActivate,
                onDeactivate: onDeactivate,
                onDuplicate: onDuplicate,
            },
            field: 'actions',
            headerName: '',
            minWidth: 0,
            sortable: false,
            suppressMenu: true,
            type: ColumnDefs.CENTERED,
            width: 64,
        },
    ];
    var gridOptions = usePortalAgGridOptions({
        frameworkComponents: {
            actionsMenu: InternalAccountsTableActionsMenu,
        },
    });
    return (jsxs(Fragment, { children: [jsxs(HeaderWithActions, __assign({ className: "title" }, { children: [jsx(ClearAllButton, { gridRef: gridRef }), jsx(ExportCSVButton, { csvExportParams: csvExportParams, gridRef: gridRef }), showCreateNewButton && jsx(EvenCreateNewButton, { onClick: onCreate })] })), jsx(AgGridReact, { suppressRowClickSelection: true, columnDefs: columnDefs, getRowId: function (_a) {
                    var data = _a.data;
                    return data.uuid;
                }, gridOptions: gridOptions, rowData: rowData, tooltipShowDelay: 50 })] }));
};

var DemandUsersTable = function (_a) {
    var rowData = _a.rowData;
    var gridRef = useRef(null);
    var csvExportParams = {
        processCellCallback: function (param) {
            var _a, _b;
            if (param.column.getColId() === 'accounts') {
                return (_b = (_a = param.value) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.name;
            }
            if (param.column.getColId() === 'isActive') {
                return param.value ? 'Active' : 'Inactive';
            }
            return param.value;
        },
    };
    var columnDefs = [
        {
            cellRenderer: function (params) { return (jsx("a", __assign({ href: "/users/".concat(params.data.uuid) }, { children: params.data.completeName }))); },
            field: 'completeName',
            filter: 'simpleTextFilter',
            filterParams: {
                placeHolder: 'Search by Name',
            },
            flex: 5,
            headerName: 'Name',
        },
        {
            field: 'emailAddress',
            filter: 'simpleTextFilter',
            filterParams: {
                placeHolder: 'Search by Email',
            },
            flex: 5,
            headerName: 'Email',
        },
        {
            field: 'createdAt',
            flex: 3,
            headerName: 'Created At',
            type: ColumnDefs.DATE,
        },
        {
            cellRendererParams: {
                isActive: function (_a) {
                    var data = _a.data;
                    return data.isActive;
                },
            },
            field: 'isActive',
            flex: 3,
            type: ColumnDefs.ACTIVE_STATUS,
        },
    ];
    var gridOptions = usePortalAgGridOptions({
        columnDefs: columnDefs,
        getRowNodeId: function (data) { return data.uuid; },
    });
    return (jsxs(Fragment, { children: [jsxs(HeaderWithActions, __assign({ className: "title" }, { children: [jsx(ClearAllButton, { gridRef: gridRef }), jsx(ExportCSVButton, { csvExportParams: csvExportParams, gridRef: gridRef })] })), jsx(AgGridReact, { ref: gridRef, gridOptions: gridOptions, rowData: rowData })] }));
};

export { AccountMetadataCard, AccountMultiSelect, AccountSuggest, ActionButtonType, ActionMenu, ActiveContractCard, ActiveInventoryCapsCard, AdjustmentsForm, ApplicationTokenCreateForm, ApplicationsIcon, BasicNav, BenchmarkReportCard, BenchmarkReports, BillingActivity, CancelButton, CancelSubscriptionAction, CappingPage, ChannelCappingPage, ClearAllButton, ClicksIcon, CollapseCard, ComingSoon, CommunicationEligibilitiesPage, ComplianceSubmissionSuccessModal, ConfirmableAction, ContractDetailsCard, ContractTermsTab, ContractsSubsectionTable, ControllerWrapper, CopyToClipboardButton, CreateInventoryCapDrawerForm, CrudToaster, CustomOfferContactUsForm, DeleteCell, DemandContractFormDrawer, DemandCustomOffers, DemandInclusionTemplateModal, DemandInclusionTemplatesListItem, DemandInvoices, DemandOfferManagementItemGroup, DemandSubAccountInventoryCapsTab, DemandUserDetailsTab, DemandUserSettingsForm, DemandUsersTable, DetailHeader, DetailLayout, DetailTopBar, Dots, DrawerForm, EditButton, EnablementSection, ErrorState, EvenAnchorButton, EvenButton, EvenCreateNewButton, EvenLogo, ExpectedEarningsShareForm, ExportButton, ExportCSVButton, ExternalHomeLayout, FeatureFlagDrawerForm, FeatureFlagForm, FeatureKey, Field, FieldLayout, FinancialServicesProduct, FirstIntegrationCard, FirstIntegrationForm, FontAwesomeKitIcon, FreeTrialBanner, FundedIcon, HeaderWithActions, HistoryActionType, HistoryTable, IconNames, IconTypes, ImportantIntentColors, InfoToolTip, IntentColors, InternalAccountsTable, InternalDevelopmentItemGroup, InternalOfferCatalogItemGroup, InternalOfferManagementItemGroup, InventoryCapsTable, InvoicesTable, JsonDisplayCard, KeywordsCard, KitIconNames, LeadDeduplicationForm, LeadsIcon, LoadingState, MCIReportsCard, MenuItem, MoneyInput, MultiSelect, NoData, NonIdealLayout, NonIdealLayoutWithAction, OfferCatalogHistoryTab, OfferCatalogOffersPage, OfferCatalogPanel, OfferCatalogProductTypesDetailsPage, OfferCatalogProductTypesPage, OfferCatalogProvider, OfferCatalogSettingsTab, OfferCreateFormDrawer, OfferDetail, OfferPropertyHandler, OffersTable, OtherContractsCard, PartnerTypeSelect, PerformanceReportCard, PerformanceSummarySplashScreen, PersonalLoansPage, PortalClipboard, PortalClipboardType, PreApprovedIcon, PreviousInventoryCapsCard, ProductTypeCardSelect, ProductTypeCreateFormDrawer, ProductTypeModifySchemaDrawer, PropertyItem, QuickLinks, Repeater, RepeaterController, RevenueByAmountDetails, RevenueByPercentageDetails, RevenueByPercentageFlatFeeAndThreshold, RevenueByPercentageOfFundedByLoanSize, RevenueByPercentageOfFundedLoanAmountBySupply, RevenueNotHandled, RoleOptions, RoleSelect, RoundedCard, ScaleUsersPage, SecondLookOfferConfigurationCard, SectionLearnMore, SectionQuickLinks, SectionResources, SectionSupport, Select, SelectItem, SideNav, SideNavContext, SidebarIcon, SidebarIconPlaceholder, SignInPage, SinglePayable, SiteHeader, Spinner, StarterNavbar, StaticCappingPage, StaticOffersTab, StatusDot, StatusIndicator, StatusToIntent, StatusType, SubMenu, SubscriptionPlanCard, Suggest, SupplyContractFormDrawer, SupplyContractsList, SupplyDemandSubAccountInventoryCapsTab, SupplySubAccountCreateForm, TabIds$1 as TabIds, TableLayout, TagHeader, TagsCard, TemplateCenter, TemplateCenterCreate, TemplateCenterDemandApisPanel, TemplateCenterDetails, TemplateCenterEdit, TemplateCenterLandingPage, TemplateCenterOffersPanel, TemplateField, TextAreaWithCharacterLimit, TextIcon, Toaster, Totaller, TrialBar, Truncate, USStatesForm, UpcomingInventoryCapsCard, UpgradeBanner, Upload, UserAccessForm, UserAccountsFieldGroup, UserAvatar, UserCreateForm, UserMultiSelect, UserSettingsForm, ViewMoreButton, createCrudToaster, dateShortCellRenderer, dateTimeShortCellRenderer, demandSubAccountCellRenderer, generateColor, getInitials, getMonthToDateRange, actions as offerActions, offersReducer, staticOffersInitialState, staticOffersReducer, supplySubAccountCellRenderer, useOfferCatalogWithAccountData, useSideNavContext, userAvatarRenderer, userCellRenderer, userCreateFormExternalSchema, userCreateFormSchema };
//# sourceMappingURL=index.js.map
